var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 675,
    viewBox: "0 0 750 675",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4961 599.632H749.389",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M151.03 606.992C151.03 612.128 127.241 616.284 97.8549 616.284C68.4686 616.284 44.6797 612.086 44.6797 606.992C44.6797 601.899 68.4686 597.687 97.8549 597.687C127.241 597.687 151.03 601.857 151.03 606.992Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.523 118.746C131.523 118.746 131.523 107.845 116.256 92.5779C100.989 77.311 91.1655 68.537 91.1655 68.537C91.1655 68.537 83.5251 93.7253 97.7005 108.936C111.876 124.147 131.523 138.323 131.523 138.323V118.746Z",
    fill: "url(#paint0_linear_2204_11443)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.357 186.88C109.357 186.88 109.357 175.965 94.0898 160.698C78.823 145.431 68.9995 136.699 68.9995 136.699C68.9995 136.699 61.3591 161.79 75.5485 177.057C89.7379 192.323 109.357 206.443 109.357 206.443V186.88Z",
    fill: "url(#paint1_linear_2204_11443)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.557 137.329C130.557 137.329 131.719 126.484 148.511 112.91C165.303 99.3367 175.994 91.6963 175.994 91.6963C175.994 91.6963 180.934 117.458 165.219 131.144C149.505 144.83 128.486 156.85 128.486 156.85L130.557 137.329Z",
    fill: "url(#paint2_linear_2204_11443)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.787 217.778C103.787 217.778 106.068 207.115 124.203 195.388C142.339 183.661 153.757 177.196 153.757 177.196C153.757 177.196 155.968 203.322 138.91 215.287C121.852 227.251 99.7285 236.991 99.7285 236.991L103.787 217.778Z",
    fill: "url(#paint3_linear_2204_11443)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.825 305.503C108.825 305.503 108.825 294.588 124.092 279.321C139.359 264.054 149.154 255.322 149.154 255.322C149.154 255.322 156.781 280.412 142.605 295.679C128.43 310.946 108.797 325.136 108.797 325.136L108.825 305.503Z",
    fill: "url(#paint4_linear_2204_11443)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.574 326.913C108.574 326.913 110.127 316.11 97.1831 298.828C84.2391 281.546 75.7591 271.513 75.7591 271.513C75.7591 271.513 64.6343 295.302 76.5007 312.388C88.3672 329.474 105.775 346.35 105.775 346.35L108.574 326.913Z",
    fill: "url(#paint5_linear_2204_11443)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.502 390.387C93.502 390.387 93.502 379.486 108.783 364.219C124.064 348.953 133.859 340.221 133.859 340.221C133.859 340.221 141.5 365.297 127.324 380.578C113.149 395.859 93.502 409.964 93.502 409.964V390.387Z",
    fill: "url(#paint6_linear_2204_11443)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.703 447.886C103.703 447.886 100.905 437.335 111.848 418.696C122.79 400.057 130.039 389.128 130.039 389.128C130.039 389.128 143.781 411.517 133.929 429.835C124.078 448.152 108.671 466.89 108.671 466.89L103.703 447.886Z",
    fill: "url(#paint7_linear_2204_11443)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.907 115.961C132.125 127.317 130.724 138.622 128.709 149.825C122.664 181.017 107.579 201.139 101.548 229.308C95.5164 257.477 112.84 293.776 108.195 329.963C103.549 366.151 89.4712 386.259 93.4874 410.412C97.5035 434.565 118.676 499.97 118.676 499.97",
    stroke: "#41525B",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.402 144.578L146.873 131.956",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.174 130.038L124.289 117.794",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.471 228.063C102.471 228.063 116.254 217.722 130.458 207.394",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.358 206.513C109.358 206.513 97.8831 183.997 84.8691 169.08",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.357 321.022C117.224 306.527 127.151 293.249 138.828 281.602",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.683 336.33C106.683 336.33 99.7842 319.874 91.752 308.008C83.7197 296.141 82.5723 294.616 82.5723 294.616",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.502 410.412C96.9957 401.745 101.145 393.357 105.914 385.322C110.688 377.895 116.066 370.875 121.993 364.331",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M108.671 466.89C108.671 466.89 107.062 453.82 112.869 442.723C118.677 431.626 125.128 417.087 127.801 411.349",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5244 264.446C31.5244 264.446 30.3349 257.603 38.2553 246.38C46.1756 235.157 51.3811 228.609 51.3811 228.609C51.3811 228.609 58.8957 243.512 51.661 254.622C46.2851 262.491 40.261 269.896 33.6514 276.76L31.5244 264.446Z",
    fill: "url(#paint8_linear_2204_11443)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8098 304.789C52.8098 304.789 51.6343 297.946 59.5407 286.71C67.447 275.473 72.6805 268.938 72.6805 268.938C72.6805 268.938 80.181 283.841 72.9464 294.966C67.5732 302.832 61.5538 310.237 54.9508 317.103L52.8098 304.789Z",
    fill: "url(#paint9_linear_2204_11443)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1418 276.018C34.1418 276.018 32.2387 269.344 20.2323 262.655C8.22591 255.966 0.641442 252.341 0.641442 252.341C0.641442 252.341 0.333581 269.022 11.6683 275.907C19.9272 280.661 28.5677 284.719 37.5003 288.039L34.1418 276.018Z",
    fill: "url(#paint10_linear_2204_11443)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6655 323.568C59.6655 323.568 57.0627 317.131 44.4266 311.744C31.7904 306.356 23.9121 303.53 23.9121 303.53C23.9121 303.53 25.3115 320.154 37.3599 325.807C46.073 329.667 55.0927 332.794 64.3253 335.155L59.6655 323.568Z",
    fill: "url(#paint11_linear_2204_11443)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0336 379.192C66.0336 379.192 64.8441 372.35 53.6074 364.429C42.3706 356.509 35.2759 352.101 35.2759 352.101C35.2759 352.101 33.2049 368.669 43.756 376.702C51.4619 382.311 59.6255 387.264 68.1606 391.507L66.0336 379.192Z",
    fill: "url(#paint12_linear_2204_11443)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5088 392.514C68.5088 392.514 66.3678 385.909 72.6089 373.665C78.85 361.421 83.076 354.214 83.076 354.214C83.076 354.214 92.6336 367.9 87.0502 379.934C82.8436 388.476 77.9336 396.653 72.371 404.381L68.5088 392.514Z",
    fill: "url(#paint13_linear_2204_11443)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6816 447.761C87.6816 447.761 88.4652 440.862 99.2402 432.368C110.015 423.874 116.844 419.004 116.844 419.004C116.844 419.004 119.853 435.432 109.847 444.052C102.47 450.085 94.6016 455.492 86.3242 460.215L87.6816 447.761Z",
    fill: "url(#paint14_linear_2204_11443)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7848 430.675C84.7848 430.675 83.6094 423.832 72.3726 415.911C61.1358 407.991 54.0271 403.583 54.0271 403.583C54.0271 403.583 51.9701 420.151 62.5212 428.184C70.2233 433.792 78.3821 438.744 86.9118 442.989L84.7848 430.675Z",
    fill: "url(#paint15_linear_2204_11443)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M84.687 467.855C84.687 467.855 85.2747 460.942 76.4168 450.433C67.559 439.924 61.7936 433.865 61.7936 433.865C61.7936 433.865 55.6085 449.37 63.7807 459.809C69.8155 467.185 76.4577 474.042 83.6375 480.309L84.687 467.855Z",
    fill: "url(#paint16_linear_2204_11443)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3496 262.879C32.062 269.917 34.1642 276.854 36.6467 283.659C43.8113 302.564 55.4679 313.549 62.3107 330.551C69.1535 347.553 62.2268 372.21 69.0696 394.389C75.9124 416.569 86.9253 427.666 87.0232 443.241C87.1212 458.815 80.9641 502.125 80.9641 502.125",
    stroke: "#41525B",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0247 280.552L23.3262 274.423",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9668 271.513L35.9474 263.089",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5967 329.837C61.5967 329.837 51.8013 324.856 41.8379 319.916",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9512 317.103C54.9512 317.103 59.695 301.71 66.2439 290.964",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3768 388.904C60.8666 380.668 53.1978 373.419 44.6094 367.382",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M70.791 398.224C72.3444 391.6 74.4461 385.118 77.0741 378.843C80.8244 370.53 81.3701 369.439 81.3701 369.439",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4922 455.065C86.4922 455.065 94.2306 445.564 99.0863 442.009C101.996 439.867 104.729 437.495 107.259 434.915",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0239 443.241C83.8927 438.185 80.3794 433.375 76.5148 428.855C72.7132 424.702 68.5758 420.869 64.1445 417.395",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6359 480.309C83.2379 475.032 81.4411 469.955 78.4304 465.602C73.6166 459.263 67.9632 450.853 65.6543 447.551",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5332 497.759L59.8055 600.947C59.8055 602.276 60.3333 603.55 61.2728 604.49C62.2123 605.429 63.4865 605.957 64.8152 605.957H128.555C129.215 605.959 129.867 605.831 130.477 605.58C131.086 605.329 131.64 604.96 132.107 604.495C132.574 604.029 132.944 603.476 133.196 602.868C133.449 602.259 133.579 601.606 133.579 600.947L145.837 497.759H47.5332Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.927952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M638.785 222.877C679.656 182.005 679.656 115.74 638.785 74.8689C597.914 33.9977 531.649 33.9977 490.777 74.8689C449.906 115.74 449.906 182.005 490.777 222.877C531.649 263.748 597.914 263.748 638.785 222.877Z",
    stroke: "#658696",
    strokeWidth: 0.853454,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M572.931 148.874C572.934 150.484 572.459 152.059 571.567 153.399C570.675 154.74 569.406 155.786 567.92 156.405C566.433 157.024 564.797 157.189 563.217 156.879C561.637 156.569 560.184 155.797 559.043 154.661C557.901 153.526 557.122 152.077 556.804 150.499C556.485 148.92 556.641 147.283 557.253 145.793C557.865 144.304 558.904 143.029 560.24 142.13C561.576 141.232 563.149 140.749 564.759 140.743C565.829 140.74 566.89 140.947 567.881 141.354C568.871 141.761 569.772 142.359 570.531 143.114C571.29 143.869 571.893 144.766 572.304 145.755C572.716 146.743 572.929 147.803 572.931 148.874Z",
    stroke: "#658696",
    strokeWidth: 0.853454,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M564.786 241.902C616.165 241.902 657.815 200.252 657.815 148.874C657.815 97.4952 616.165 55.8448 564.786 55.8448C513.408 55.8448 471.758 97.4952 471.758 148.874C471.758 200.252 513.408 241.902 564.786 241.902Z",
    stroke: "#658696",
    strokeWidth: 0.853454,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M573.07 147.11L603.058 144.34",
    stroke: "#658696",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M557.525 152.106L522.541 199.306",
    stroke: "#658696",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M330.242 674.455C450.156 674.455 547.365 659.043 547.365 640.031C547.365 621.019 450.156 605.607 330.242 605.607C210.328 605.607 113.119 621.019 113.119 640.031C113.119 659.043 210.328 674.455 330.242 674.455Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M222.758 421.173L243.44 578.642C243.58 579.798 244.139 580.863 245.01 581.637C245.881 582.41 247.005 582.838 248.17 582.84H409.557C410.723 582.841 411.848 582.414 412.72 581.64C413.592 580.866 414.149 579.799 414.287 578.642L434.969 421.173H222.758ZM405.877 575.283H251.85L232.595 428.645H425.132L405.877 575.283Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M304.382 199.11H353.36C358.607 199.11 363.64 201.195 367.351 204.906C371.062 208.616 373.146 213.649 373.146 218.897V262.347H284.596V218.897C284.596 213.649 286.68 208.616 290.391 204.906C294.102 201.195 299.135 199.11 304.382 199.11Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M249.473 586.982H408.271V604.488C408.271 604.707 408.184 604.917 408.029 605.071C407.874 605.226 407.664 605.313 407.445 605.313H250.285C250.066 605.313 249.856 605.226 249.701 605.071C249.546 604.917 249.459 604.707 249.459 604.488V586.982H249.473Z",
    fill: "#858585",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M222.758 426.77L243.44 584.239C243.577 585.397 244.135 586.464 245.007 587.238C245.879 588.011 247.004 588.438 248.17 588.437H409.557C410.723 588.441 411.851 588.016 412.723 587.241C413.596 586.467 414.152 585.398 414.287 584.239L434.969 426.77H222.758ZM405.877 580.895H251.85L232.595 434.271H425.132L405.877 580.895Z",
    fill: "#858585",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M537.556 214.573H120.172V526.558H537.556V214.573Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M327.793 215.986C330.9 215.986 333.419 213.468 333.419 210.361C333.419 207.254 330.9 204.736 327.793 204.736C324.687 204.736 322.168 207.254 322.168 210.361C322.168 213.468 324.687 215.986 327.793 215.986Z",
    fill: "#37474F",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M522.513 225.81H135.215V515.307H522.513V225.81Z",
    fill: "#37474F",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M145.697 238.194C145.697 237.344 146.035 236.529 146.636 235.928C147.237 235.327 148.052 234.99 148.902 234.99C149.752 234.99 150.567 235.327 151.168 235.928C151.769 236.529 152.106 237.344 152.106 238.194V245.191C152.106 246.041 151.769 246.856 151.168 247.457C150.567 248.058 149.752 248.395 148.902 248.395C148.052 248.395 147.237 248.058 146.636 247.457C146.035 246.856 145.697 246.041 145.697 245.191V238.194ZM147.81 245.303C147.81 246.268 148.23 246.702 148.902 246.702C149.573 246.702 149.993 246.338 149.993 245.303V238.054C149.993 237.103 149.573 236.739 148.902 236.739C148.23 236.739 147.81 237.103 147.81 238.054V245.303Z",
    fill: "url(#paint17_linear_2204_11443)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M153.351 238.194C153.322 237.756 153.383 237.317 153.531 236.904C153.678 236.491 153.909 236.113 154.209 235.793C154.508 235.472 154.871 235.217 155.273 235.042C155.676 234.868 156.11 234.778 156.548 234.778C156.987 234.778 157.421 234.868 157.823 235.042C158.226 235.217 158.588 235.472 158.888 235.793C159.188 236.113 159.418 236.491 159.566 236.904C159.714 237.317 159.775 237.756 159.746 238.194V245.191C159.775 245.628 159.714 246.067 159.566 246.481C159.418 246.894 159.188 247.272 158.888 247.592C158.588 247.913 158.226 248.168 157.823 248.342C157.421 248.517 156.987 248.607 156.548 248.607C156.11 248.607 155.676 248.517 155.273 248.342C154.871 248.168 154.508 247.913 154.209 247.592C153.909 247.272 153.678 246.894 153.531 246.481C153.383 246.067 153.322 245.628 153.351 245.191V238.194ZM155.45 245.303C155.45 246.268 155.884 246.702 156.555 246.702C157.227 246.702 157.647 246.338 157.647 245.303V238.054C157.647 237.103 157.213 236.739 156.555 236.739C155.898 236.739 155.45 237.103 155.45 238.054V245.303Z",
    fill: "url(#paint18_linear_2204_11443)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M160.879 238.194C160.879 237.344 161.217 236.529 161.817 235.928C162.418 235.327 163.234 234.99 164.083 234.99C164.933 234.99 165.748 235.327 166.349 235.928C166.95 236.529 167.288 237.344 167.288 238.194V245.191C167.288 246.041 166.95 246.856 166.349 247.457C165.748 248.058 164.933 248.395 164.083 248.395C163.234 248.395 162.418 248.058 161.817 247.457C161.217 246.856 160.879 246.041 160.879 245.191V238.194ZM162.992 245.303C162.992 246.268 163.412 246.702 164.083 246.702C164.755 246.702 165.175 246.338 165.175 245.303V238.054C165.175 237.103 164.755 236.739 164.083 236.739C163.412 236.739 162.992 237.103 162.992 238.054V245.303Z",
    fill: "url(#paint19_linear_2204_11443)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M169.946 236.655C170.475 236.725 171.01 236.59 171.442 236.278C171.874 235.965 172.17 235.499 172.269 234.976H173.669V248.395H171.542V238.152H169.904L169.946 236.655Z",
    fill: "url(#paint20_linear_2204_11443)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M180.51 236.655C181.039 236.725 181.574 236.59 182.006 236.278C182.438 235.965 182.734 235.499 182.833 234.976H184.233V248.395H182.12V238.152H180.482L180.51 236.655Z",
    fill: "url(#paint21_linear_2204_11443)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M188.111 236.655C188.639 236.721 189.173 236.585 189.604 236.273C190.035 235.962 190.332 235.498 190.434 234.976H191.834V248.395H189.735V238.152H188.111V236.655Z",
    fill: "url(#paint22_linear_2204_11443)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M195.71 236.655C196.236 236.725 196.77 236.589 197.2 236.277C197.629 235.964 197.923 235.498 198.019 234.976H199.418V248.395H197.305V238.152H195.682L195.71 236.655Z",
    fill: "url(#paint23_linear_2204_11443)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M203.293 236.655C203.822 236.725 204.357 236.59 204.789 236.278C205.221 235.965 205.517 235.499 205.616 234.976H207.016V248.395H204.917V238.152H203.279L203.293 236.655Z",
    fill: "url(#paint24_linear_2204_11443)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M210.893 236.655C211.421 236.721 211.954 236.585 212.386 236.273C212.817 235.962 213.114 235.498 213.216 234.976H214.615V248.395H212.502V238.152H210.879L210.893 236.655Z",
    fill: "url(#paint25_linear_2204_11443)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M219.973 238.194C219.973 237.344 220.31 236.529 220.911 235.928C221.512 235.327 222.327 234.99 223.177 234.99C224.027 234.99 224.842 235.327 225.443 235.928C226.044 236.529 226.382 237.344 226.382 238.194V245.191C226.382 246.041 226.044 246.856 225.443 247.457C224.842 248.058 224.027 248.395 223.177 248.395C222.327 248.395 221.512 248.058 220.911 247.457C220.31 246.856 219.973 246.041 219.973 245.191V238.194ZM222.086 245.303C222.086 246.268 222.505 246.702 223.177 246.702C223.849 246.702 224.269 246.338 224.269 245.303V238.054C224.269 237.103 223.849 236.739 223.177 236.739C222.505 236.739 222.086 237.103 222.086 238.054V245.303Z",
    fill: "url(#paint26_linear_2204_11443)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M227.517 238.194C227.488 237.756 227.549 237.317 227.697 236.904C227.844 236.491 228.075 236.113 228.375 235.793C228.674 235.472 229.037 235.217 229.439 235.042C229.842 234.868 230.276 234.778 230.714 234.778C231.153 234.778 231.587 234.868 231.989 235.042C232.392 235.217 232.754 235.472 233.054 235.793C233.354 236.113 233.584 236.491 233.732 236.904C233.88 237.317 233.941 237.756 233.912 238.194V245.191C233.941 245.628 233.88 246.067 233.732 246.481C233.584 246.894 233.354 247.272 233.054 247.592C232.754 247.913 232.392 248.168 231.989 248.342C231.587 248.517 231.153 248.607 230.714 248.607C230.276 248.607 229.842 248.517 229.439 248.342C229.037 248.168 228.674 247.913 228.375 247.592C228.075 247.272 227.844 246.894 227.697 246.481C227.549 246.067 227.488 245.628 227.517 245.191V238.194ZM229.616 245.303C229.616 246.268 230.05 246.702 230.721 246.702C231.393 246.702 231.813 246.338 231.813 245.303V238.054C231.813 237.103 231.393 236.739 230.721 236.739C230.05 236.739 229.616 237.103 229.616 238.054V245.303Z",
    fill: "url(#paint27_linear_2204_11443)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M235.156 238.194C235.156 237.344 235.494 236.529 236.095 235.928C236.696 235.327 237.511 234.99 238.361 234.99C239.211 234.99 240.026 235.327 240.627 235.928C241.228 236.529 241.565 237.344 241.565 238.194V245.191C241.565 246.041 241.228 246.856 240.627 247.457C240.026 248.058 239.211 248.395 238.361 248.395C237.511 248.395 236.696 248.058 236.095 247.457C235.494 246.856 235.156 246.041 235.156 245.191V238.194ZM237.269 245.303C237.269 246.268 237.689 246.702 238.361 246.702C239.032 246.702 239.452 246.338 239.452 245.303V238.054C239.452 237.103 239.032 236.739 238.361 236.739C237.689 236.739 237.269 237.103 237.269 238.054V245.303Z",
    fill: "url(#paint28_linear_2204_11443)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M242.756 238.194C242.756 237.344 243.093 236.529 243.694 235.928C244.295 235.327 245.11 234.99 245.96 234.99C246.81 234.99 247.625 235.327 248.226 235.928C248.827 236.529 249.165 237.344 249.165 238.194V245.191C249.165 246.041 248.827 246.856 248.226 247.457C247.625 248.058 246.81 248.395 245.96 248.395C245.11 248.395 244.295 248.058 243.694 247.457C243.093 246.856 242.756 246.041 242.756 245.191V238.194ZM244.869 245.303C244.869 246.268 245.289 246.702 245.96 246.702C246.632 246.702 247.052 246.338 247.052 245.303V238.054C247.052 237.103 246.632 236.739 245.96 236.739C245.289 236.739 244.869 237.103 244.869 238.054V245.303Z",
    fill: "url(#paint29_linear_2204_11443)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M250.353 238.194C250.324 237.756 250.385 237.317 250.532 236.904C250.68 236.491 250.911 236.113 251.211 235.793C251.51 235.472 251.873 235.217 252.275 235.042C252.678 234.868 253.112 234.778 253.55 234.778C253.989 234.778 254.423 234.868 254.825 235.042C255.228 235.217 255.59 235.472 255.89 235.793C256.19 236.113 256.42 236.491 256.568 236.904C256.715 237.317 256.777 237.756 256.748 238.194V245.191C256.777 245.628 256.715 246.067 256.568 246.481C256.42 246.894 256.19 247.272 255.89 247.592C255.59 247.913 255.228 248.168 254.825 248.342C254.423 248.517 253.989 248.607 253.55 248.607C253.112 248.607 252.678 248.517 252.275 248.342C251.873 248.168 251.51 247.913 251.211 247.592C250.911 247.272 250.68 246.894 250.532 246.481C250.385 246.067 250.324 245.628 250.353 245.191V238.194ZM252.452 245.303C252.452 246.268 252.872 246.702 253.543 246.702C254.215 246.702 254.635 246.338 254.635 245.303V238.054C254.635 237.103 254.215 236.739 253.543 236.739C252.872 236.739 252.452 237.103 252.452 238.054V245.303Z",
    fill: "url(#paint30_linear_2204_11443)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M265.299 236.655C265.827 236.725 266.363 236.59 266.795 236.278C267.227 235.965 267.523 235.499 267.622 234.976H269.021V248.395H266.908V238.152H265.299V236.655Z",
    fill: "url(#paint31_linear_2204_11443)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M272.952 236.655C273.479 236.721 274.013 236.585 274.444 236.273C274.875 235.962 275.172 235.498 275.274 234.976H276.674V248.395H274.561V238.152H272.938L272.952 236.655Z",
    fill: "url(#paint32_linear_2204_11443)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M280.553 236.655C281.08 236.725 281.613 236.589 282.043 236.277C282.473 235.964 282.766 235.498 282.862 234.976H284.261V248.395H282.148V238.152H280.553V236.655Z",
    fill: "url(#paint33_linear_2204_11443)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M288.137 236.655C288.666 236.725 289.201 236.59 289.633 236.278C290.065 235.965 290.361 235.499 290.46 234.976H291.859V248.395H289.76V238.152H288.123L288.137 236.655Z",
    fill: "url(#paint34_linear_2204_11443)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M295.735 236.655C296.263 236.721 296.796 236.585 297.227 236.273C297.659 235.962 297.955 235.498 298.058 234.976H299.457V248.395H297.344V238.152H295.721L295.735 236.655Z",
    fill: "url(#paint35_linear_2204_11443)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M303.319 236.655C303.847 236.725 304.382 236.59 304.814 236.278C305.246 235.965 305.542 235.499 305.642 234.976H307.041V248.395H304.942V238.152H303.305L303.319 236.655Z",
    fill: "url(#paint36_linear_2204_11443)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M309.434 238.194C309.434 237.344 309.771 236.529 310.372 235.928C310.973 235.327 311.788 234.99 312.638 234.99C313.488 234.99 314.303 235.327 314.904 235.928C315.505 236.529 315.843 237.344 315.843 238.194V245.191C315.843 246.041 315.505 246.856 314.904 247.457C314.303 248.058 313.488 248.395 312.638 248.395C311.788 248.395 310.973 248.058 310.372 247.457C309.771 246.856 309.434 246.041 309.434 245.191V238.194ZM311.547 245.303C311.547 246.268 311.966 246.702 312.638 246.702C313.31 246.702 313.73 246.338 313.73 245.303V238.054C313.73 237.103 313.31 236.739 312.638 236.739C311.966 236.739 311.547 237.103 311.547 238.054V245.303Z",
    fill: "url(#paint37_linear_2204_11443)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M317.074 238.194C317.074 237.344 317.412 236.529 318.013 235.928C318.614 235.327 319.429 234.99 320.279 234.99C321.129 234.99 321.944 235.327 322.545 235.928C323.146 236.529 323.483 237.344 323.483 238.194V245.191C323.483 246.041 323.146 246.856 322.545 247.457C321.944 248.058 321.129 248.395 320.279 248.395C319.429 248.395 318.614 248.058 318.013 247.457C317.412 246.856 317.074 246.041 317.074 245.191V238.194ZM319.187 245.303C319.187 246.268 319.607 246.702 320.279 246.702C320.95 246.702 321.37 246.338 321.37 245.303V238.054C321.37 237.103 320.95 236.739 320.279 236.739C319.607 236.739 319.187 237.103 319.187 238.054V245.303Z",
    fill: "url(#paint38_linear_2204_11443)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M324.63 238.194C324.601 237.756 324.662 237.317 324.81 236.904C324.957 236.491 325.188 236.113 325.488 235.793C325.788 235.472 326.15 235.217 326.552 235.042C326.955 234.868 327.389 234.778 327.828 234.778C328.266 234.778 328.7 234.868 329.103 235.042C329.505 235.217 329.867 235.472 330.167 235.793C330.467 236.113 330.698 236.491 330.845 236.904C330.993 237.317 331.054 237.756 331.025 238.194V245.191C331.054 245.628 330.993 246.067 330.845 246.481C330.698 246.894 330.467 247.272 330.167 247.592C329.867 247.913 329.505 248.168 329.103 248.342C328.7 248.517 328.266 248.607 327.828 248.607C327.389 248.607 326.955 248.517 326.552 248.342C326.15 248.168 325.788 247.913 325.488 247.592C325.188 247.272 324.957 246.894 324.81 246.481C324.662 246.067 324.601 245.628 324.63 245.191V238.194ZM326.729 245.303C326.729 246.268 327.149 246.702 327.821 246.702C328.492 246.702 328.912 246.338 328.912 245.303V238.054C328.912 237.103 328.492 236.739 327.821 236.739C327.149 236.739 326.729 237.103 326.729 238.054V245.303Z",
    fill: "url(#paint39_linear_2204_11443)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M332.215 238.194C332.215 237.344 332.552 236.529 333.153 235.928C333.754 235.327 334.569 234.99 335.419 234.99C336.269 234.99 337.084 235.327 337.685 235.928C338.286 236.529 338.624 237.344 338.624 238.194V245.191C338.624 246.041 338.286 246.856 337.685 247.457C337.084 248.058 336.269 248.395 335.419 248.395C334.569 248.395 333.754 248.058 333.153 247.457C332.552 246.856 332.215 246.041 332.215 245.191V238.194ZM334.328 245.303C334.328 246.268 334.748 246.702 335.419 246.702C336.091 246.702 336.511 246.338 336.511 245.303V238.054C336.511 237.103 336.091 236.739 335.419 236.739C334.748 236.739 334.328 237.103 334.328 238.054V245.303Z",
    fill: "url(#paint40_linear_2204_11443)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M339.814 238.194C339.785 237.756 339.846 237.317 339.993 236.904C340.141 236.491 340.372 236.113 340.672 235.793C340.971 235.472 341.334 235.217 341.736 235.042C342.139 234.868 342.573 234.778 343.011 234.778C343.45 234.778 343.884 234.868 344.286 235.042C344.689 235.217 345.051 235.472 345.351 235.793C345.65 236.113 345.881 236.491 346.029 236.904C346.176 237.317 346.238 237.756 346.209 238.194V245.191C346.238 245.628 346.176 246.067 346.029 246.481C345.881 246.894 345.65 247.272 345.351 247.592C345.051 247.913 344.689 248.168 344.286 248.342C343.884 248.517 343.45 248.607 343.011 248.607C342.573 248.607 342.139 248.517 341.736 248.342C341.334 248.168 340.971 247.913 340.672 247.592C340.372 247.272 340.141 246.894 339.993 246.481C339.846 246.067 339.785 245.628 339.814 245.191V238.194ZM341.913 245.303C341.913 246.268 342.346 246.702 343.018 246.702C343.69 246.702 344.11 246.338 344.11 245.303V238.054C344.11 237.103 343.676 236.739 343.018 236.739C342.36 236.739 341.913 237.103 341.913 238.054V245.303Z",
    fill: "url(#paint41_linear_2204_11443)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M347.398 238.194C347.398 237.344 347.736 236.529 348.337 235.928C348.938 235.327 349.753 234.99 350.603 234.99C351.453 234.99 352.268 235.327 352.869 235.928C353.47 236.529 353.807 237.344 353.807 238.194V245.191C353.807 246.041 353.47 246.856 352.869 247.457C352.268 248.058 351.453 248.395 350.603 248.395C349.753 248.395 348.938 248.058 348.337 247.457C347.736 246.856 347.398 246.041 347.398 245.191V238.194ZM349.511 245.303C349.511 246.268 349.931 246.702 350.603 246.702C351.275 246.702 351.694 246.338 351.694 245.303V238.054C351.694 237.103 351.275 236.739 350.603 236.739C349.931 236.739 349.511 237.103 349.511 238.054V245.303Z",
    fill: "url(#paint42_linear_2204_11443)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M354.997 238.194C354.968 237.756 355.029 237.317 355.177 236.904C355.325 236.491 355.555 236.113 355.855 235.793C356.155 235.472 356.517 235.217 356.92 235.042C357.322 234.868 357.756 234.778 358.195 234.778C358.633 234.778 359.067 234.868 359.47 235.042C359.872 235.217 360.235 235.472 360.534 235.793C360.834 236.113 361.065 236.491 361.212 236.904C361.36 237.317 361.421 237.756 361.392 238.194V245.191C361.421 245.628 361.36 246.067 361.212 246.481C361.065 246.894 360.834 247.272 360.534 247.592C360.235 247.913 359.872 248.168 359.47 248.342C359.067 248.517 358.633 248.607 358.195 248.607C357.756 248.607 357.322 248.517 356.92 248.342C356.517 248.168 356.155 247.913 355.855 247.592C355.555 247.272 355.325 246.894 355.177 246.481C355.029 246.067 354.968 245.628 354.997 245.191V238.194ZM357.11 245.303C357.11 246.268 357.53 246.702 358.202 246.702C358.873 246.702 359.293 246.338 359.293 245.303V238.054C359.293 237.103 358.873 236.739 358.202 236.739C357.53 236.739 357.11 237.103 357.11 238.054V245.303Z",
    fill: "url(#paint43_linear_2204_11443)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M367.031 236.655C367.56 236.725 368.095 236.59 368.527 236.278C368.959 235.965 369.255 235.499 369.354 234.976H370.753V248.395H368.64V238.152H367.031V236.655Z",
    fill: "url(#paint44_linear_2204_11443)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M374.629 236.655C375.157 236.721 375.691 236.585 376.122 236.273C376.553 235.962 376.85 235.498 376.952 234.976H378.352V248.395H376.238V238.152H374.615L374.629 236.655Z",
    fill: "url(#paint45_linear_2204_11443)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M382.227 236.655C382.754 236.725 383.287 236.589 383.717 236.277C384.147 235.964 384.44 235.498 384.536 234.976H385.935V248.395H383.822V238.152H382.199L382.227 236.655Z",
    fill: "url(#paint46_linear_2204_11443)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M389.84 236.655C390.368 236.725 390.904 236.59 391.336 236.278C391.768 235.965 392.064 235.499 392.163 234.976H393.562V248.395H391.463V238.152H389.84V236.655Z",
    fill: "url(#paint47_linear_2204_11443)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M397.41 236.655C397.938 236.721 398.472 236.585 398.903 236.273C399.334 235.962 399.631 235.498 399.733 234.976H401.133V248.395H399.02V238.152H397.396L397.41 236.655Z",
    fill: "url(#paint48_linear_2204_11443)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M409.431 238.194C409.402 237.756 409.463 237.317 409.611 236.904C409.758 236.491 409.989 236.113 410.289 235.793C410.589 235.472 410.951 235.217 411.353 235.042C411.756 234.868 412.19 234.778 412.628 234.778C413.067 234.778 413.501 234.868 413.903 235.042C414.306 235.217 414.668 235.472 414.968 235.793C415.268 236.113 415.498 236.491 415.646 236.904C415.794 237.317 415.855 237.756 415.826 238.194V245.191C415.855 245.628 415.794 246.067 415.646 246.481C415.498 246.894 415.268 247.272 414.968 247.592C414.668 247.913 414.306 248.168 413.903 248.342C413.501 248.517 413.067 248.607 412.628 248.607C412.19 248.607 411.756 248.517 411.353 248.342C410.951 248.168 410.589 247.913 410.289 247.592C409.989 247.272 409.758 246.894 409.611 246.481C409.463 246.067 409.402 245.628 409.431 245.191V238.194ZM411.53 245.303C411.53 246.268 411.95 246.702 412.621 246.702C413.293 246.702 413.713 246.338 413.713 245.303V238.054C413.713 237.103 413.293 236.739 412.621 236.739C411.95 236.739 411.53 237.103 411.53 238.054V245.303Z",
    fill: "url(#paint49_linear_2204_11443)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M417.057 238.194C417.057 237.344 417.394 236.529 417.995 235.928C418.596 235.327 419.411 234.99 420.261 234.99C421.111 234.99 421.926 235.327 422.527 235.928C423.128 236.529 423.466 237.344 423.466 238.194V245.191C423.466 246.041 423.128 246.856 422.527 247.457C421.926 248.058 421.111 248.395 420.261 248.395C419.411 248.395 418.596 248.058 417.995 247.457C417.394 246.856 417.057 246.041 417.057 245.191V238.194ZM419.17 245.303C419.17 246.268 419.589 246.702 420.261 246.702C420.933 246.702 421.353 246.338 421.353 245.303V238.054C421.353 237.103 420.933 236.739 420.261 236.739C419.589 236.739 419.17 237.103 419.17 238.054V245.303Z",
    fill: "url(#paint50_linear_2204_11443)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M424.657 238.194C424.628 237.756 424.69 237.317 424.837 236.904C424.985 236.491 425.216 236.113 425.515 235.793C425.815 235.472 426.177 235.217 426.58 235.042C426.982 234.868 427.416 234.778 427.855 234.778C428.294 234.778 428.728 234.868 429.13 235.042C429.532 235.217 429.895 235.472 430.194 235.793C430.494 236.113 430.725 236.491 430.873 236.904C431.02 237.317 431.081 237.756 431.052 238.194V245.191C431.081 245.628 431.02 246.067 430.873 246.481C430.725 246.894 430.494 247.272 430.194 247.592C429.895 247.913 429.532 248.168 429.13 248.342C428.728 248.517 428.294 248.607 427.855 248.607C427.416 248.607 426.982 248.517 426.58 248.342C426.177 248.168 425.815 247.913 425.515 247.592C425.216 247.272 424.985 246.894 424.837 246.481C424.69 246.067 424.628 245.628 424.657 245.191V238.194ZM426.756 245.303C426.756 246.268 427.19 246.702 427.862 246.702C428.534 246.702 428.953 246.338 428.953 245.303V238.054C428.953 237.103 428.52 236.739 427.862 236.739C427.204 236.739 426.756 237.103 426.756 238.054V245.303Z",
    fill: "url(#paint51_linear_2204_11443)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M432.24 238.194C432.24 237.344 432.578 236.529 433.179 235.928C433.78 235.327 434.595 234.99 435.445 234.99C436.295 234.99 437.11 235.327 437.711 235.928C438.312 236.529 438.649 237.344 438.649 238.194V245.191C438.649 246.041 438.312 246.856 437.711 247.457C437.11 248.058 436.295 248.395 435.445 248.395C434.595 248.395 433.78 248.058 433.179 247.457C432.578 246.856 432.24 246.041 432.24 245.191V238.194ZM434.353 245.303C434.353 246.268 434.773 246.702 435.445 246.702C436.116 246.702 436.536 246.338 436.536 245.303V238.054C436.536 237.103 436.116 236.739 435.445 236.739C434.773 236.739 434.353 237.103 434.353 238.054V245.303Z",
    fill: "url(#paint52_linear_2204_11443)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M439.838 238.194C439.838 237.773 439.921 237.357 440.082 236.968C440.243 236.579 440.479 236.226 440.776 235.928C441.074 235.631 441.427 235.395 441.816 235.233C442.205 235.072 442.622 234.99 443.042 234.99C443.463 234.99 443.88 235.072 444.269 235.233C444.657 235.395 445.011 235.631 445.308 235.928C445.606 236.226 445.842 236.579 446.003 236.968C446.164 237.357 446.247 237.773 446.247 238.194V245.191C446.247 245.612 446.164 246.028 446.003 246.417C445.842 246.806 445.606 247.159 445.308 247.457C445.011 247.754 444.657 247.99 444.269 248.151C443.88 248.312 443.463 248.395 443.042 248.395C442.622 248.395 442.205 248.312 441.816 248.151C441.427 247.99 441.074 247.754 440.776 247.457C440.479 247.159 440.243 246.806 440.082 246.417C439.921 246.028 439.838 245.612 439.838 245.191V238.194ZM441.951 245.303C441.951 246.268 442.371 246.702 443.042 246.702C443.714 246.702 444.134 246.338 444.134 245.303V238.054C444.134 237.103 443.714 236.739 443.042 236.739C442.371 236.739 441.951 237.103 441.951 238.054V245.303Z",
    fill: "url(#paint53_linear_2204_11443)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M447.437 238.194C447.408 237.756 447.469 237.317 447.616 236.904C447.764 236.491 447.995 236.113 448.295 235.793C448.594 235.472 448.957 235.217 449.359 235.042C449.762 234.868 450.196 234.778 450.634 234.778C451.073 234.778 451.507 234.868 451.909 235.042C452.312 235.217 452.674 235.472 452.974 235.793C453.273 236.113 453.504 236.491 453.652 236.904C453.799 237.317 453.861 237.756 453.832 238.194V245.191C453.861 245.628 453.799 246.067 453.652 246.481C453.504 246.894 453.273 247.272 452.974 247.592C452.674 247.913 452.312 248.168 451.909 248.342C451.507 248.517 451.073 248.607 450.634 248.607C450.196 248.607 449.762 248.517 449.359 248.342C448.957 248.168 448.594 247.913 448.295 247.592C447.995 247.272 447.764 246.894 447.616 246.481C447.469 246.067 447.408 245.628 447.437 245.191V238.194ZM449.536 245.303C449.536 246.268 449.956 246.702 450.627 246.702C451.299 246.702 451.719 246.338 451.719 245.303V238.054C451.719 237.103 451.299 236.739 450.627 236.739C449.956 236.739 449.536 237.103 449.536 238.054V245.303Z",
    fill: "url(#paint54_linear_2204_11443)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M460.969 238.194C460.969 237.344 461.306 236.529 461.907 235.928C462.508 235.327 463.323 234.99 464.173 234.99C465.023 234.99 465.838 235.327 466.439 235.928C467.04 236.529 467.378 237.344 467.378 238.194V245.191C467.378 246.041 467.04 246.856 466.439 247.457C465.838 248.058 465.023 248.395 464.173 248.395C463.323 248.395 462.508 248.058 461.907 247.457C461.306 246.856 460.969 246.041 460.969 245.191V238.194ZM463.082 245.303C463.082 246.268 463.502 246.702 464.173 246.702C464.845 246.702 465.265 246.338 465.265 245.303V238.054C465.265 237.103 464.845 236.739 464.173 236.739C463.502 236.739 463.082 237.103 463.082 238.054V245.303Z",
    fill: "url(#paint55_linear_2204_11443)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M470.037 236.655C470.565 236.721 471.099 236.585 471.53 236.273C471.961 235.962 472.258 235.498 472.36 234.976H473.76V248.395H471.647V238.152H470.023L470.037 236.655Z",
    fill: "url(#paint56_linear_2204_11443)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M476.152 238.194C476.152 237.344 476.49 236.529 477.091 235.928C477.692 235.327 478.507 234.99 479.357 234.99C480.207 234.99 481.022 235.327 481.623 235.928C482.224 236.529 482.561 237.344 482.561 238.194V245.191C482.561 246.041 482.224 246.856 481.623 247.457C481.022 248.058 480.207 248.395 479.357 248.395C478.507 248.395 477.692 248.058 477.091 247.457C476.49 246.856 476.152 246.041 476.152 245.191V238.194ZM478.265 245.303C478.265 246.268 478.685 246.702 479.357 246.702C480.029 246.702 480.448 246.338 480.448 245.303V238.054C480.448 237.103 480.029 236.739 479.357 236.739C478.685 236.739 478.265 237.103 478.265 238.054V245.303Z",
    fill: "url(#paint57_linear_2204_11443)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M485.219 236.655C485.748 236.725 486.283 236.59 486.715 236.278C487.147 235.965 487.443 235.499 487.542 234.976H488.941V248.395H486.842V238.152H485.205L485.219 236.655Z",
    fill: "url(#paint58_linear_2204_11443)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M491.336 238.194C491.336 237.344 491.674 236.529 492.275 235.928C492.875 235.327 493.691 234.99 494.54 234.99C495.39 234.99 496.205 235.327 496.806 235.928C497.407 236.529 497.745 237.344 497.745 238.194V245.191C497.745 246.041 497.407 246.856 496.806 247.457C496.205 248.058 495.39 248.395 494.54 248.395C493.691 248.395 492.875 248.058 492.275 247.457C491.674 246.856 491.336 246.041 491.336 245.191V238.194ZM493.449 245.303C493.449 246.268 493.869 246.702 494.54 246.702C495.212 246.702 495.632 246.338 495.632 245.303V238.054C495.632 237.103 495.212 236.739 494.54 236.739C493.869 236.739 493.449 237.103 493.449 238.054V245.303Z",
    fill: "url(#paint59_linear_2204_11443)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M500.389 236.655C500.917 236.725 501.452 236.59 501.884 236.278C502.316 235.965 502.612 235.499 502.712 234.976H504.111V248.395H502.012V238.152H500.389V236.655Z",
    fill: "url(#paint60_linear_2204_11443)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M506.518 238.194C506.518 237.344 506.855 236.529 507.456 235.928C508.057 235.327 508.872 234.99 509.722 234.99C510.572 234.99 511.387 235.327 511.988 235.928C512.589 236.529 512.927 237.344 512.927 238.194V245.191C512.927 246.041 512.589 246.856 511.988 247.457C511.387 248.058 510.572 248.395 509.722 248.395C508.872 248.395 508.057 248.058 507.456 247.457C506.855 246.856 506.518 246.041 506.518 245.191V238.194ZM508.631 245.303C508.631 246.268 509.05 246.702 509.722 246.702C510.394 246.702 510.814 246.338 510.814 245.303V238.054C510.814 237.103 510.394 236.739 509.722 236.739C509.05 236.739 508.631 237.103 508.631 238.054V245.303Z",
    fill: "url(#paint61_linear_2204_11443)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M145.697 261.199C145.697 260.349 146.035 259.534 146.636 258.933C147.237 258.332 148.052 257.995 148.902 257.995C149.752 257.995 150.567 258.332 151.168 258.933C151.769 259.534 152.106 260.349 152.106 261.199V268.196C152.106 269.046 151.769 269.861 151.168 270.462C150.567 271.063 149.752 271.401 148.902 271.401C148.052 271.401 147.237 271.063 146.636 270.462C146.035 269.861 145.697 269.046 145.697 268.196V261.199ZM147.81 268.308C147.81 269.274 148.23 269.707 148.902 269.707C149.573 269.707 149.993 269.344 149.993 268.308V261.073C149.993 260.108 149.573 259.674 148.902 259.674C148.23 259.674 147.81 260.038 147.81 261.073V268.308Z",
    fill: "url(#paint62_linear_2204_11443)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M154.75 259.674C155.28 259.74 155.815 259.602 156.247 259.288C156.678 258.973 156.974 258.506 157.073 257.981H158.472V271.443H156.373V261.199H154.75V259.674Z",
    fill: "url(#paint63_linear_2204_11443)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M160.879 261.199C160.879 260.349 161.217 259.534 161.817 258.933C162.418 258.332 163.234 257.995 164.083 257.995C164.933 257.995 165.748 258.332 166.349 258.933C166.95 259.534 167.288 260.349 167.288 261.199V268.196C167.288 269.046 166.95 269.861 166.349 270.462C165.748 271.063 164.933 271.401 164.083 271.401C163.234 271.401 162.418 271.063 161.817 270.462C161.217 269.861 160.879 269.046 160.879 268.196V261.199ZM162.992 268.308C162.992 269.274 163.412 269.707 164.083 269.707C164.755 269.707 165.175 269.344 165.175 268.308V261.073C165.175 260.108 164.755 259.674 164.083 259.674C163.412 259.674 162.992 260.038 162.992 261.073V268.308Z",
    fill: "url(#paint64_linear_2204_11443)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M169.946 259.674C170.476 259.74 171.011 259.602 171.443 259.288C171.875 258.973 172.17 258.506 172.269 257.981H173.669V271.443H171.542V261.199H169.904L169.946 259.674Z",
    fill: "url(#paint65_linear_2204_11443)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M176.077 261.199C176.048 260.762 176.11 260.323 176.257 259.91C176.405 259.497 176.635 259.118 176.935 258.798C177.235 258.478 177.597 258.222 178 258.048C178.402 257.873 178.836 257.783 179.275 257.783C179.713 257.783 180.147 257.873 180.55 258.048C180.952 258.222 181.315 258.478 181.614 258.798C181.914 259.118 182.145 259.497 182.293 259.91C182.44 260.323 182.501 260.762 182.472 261.199V268.196C182.501 268.634 182.44 269.073 182.293 269.486C182.145 269.899 181.914 270.277 181.614 270.598C181.315 270.918 180.952 271.173 180.55 271.348C180.147 271.522 179.713 271.612 179.275 271.612C178.836 271.612 178.402 271.522 178 271.348C177.597 271.173 177.235 270.918 176.935 270.598C176.635 270.277 176.405 269.899 176.257 269.486C176.11 269.073 176.048 268.634 176.077 268.196V261.199ZM178.176 268.308C178.176 269.274 178.596 269.707 179.268 269.707C179.94 269.707 180.359 269.344 180.359 268.308V261.073C180.359 260.108 179.94 259.674 179.268 259.674C178.596 259.674 178.176 260.038 178.176 261.073V268.308Z",
    fill: "url(#paint66_linear_2204_11443)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M185.143 259.674C185.672 259.74 186.205 259.601 186.634 259.286C187.064 258.972 187.356 258.505 187.452 257.981H188.851V271.443H186.738V261.199H185.115L185.143 259.674Z",
    fill: "url(#paint67_linear_2204_11443)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M192.729 259.674C193.259 259.74 193.794 259.602 194.226 259.288C194.657 258.973 194.953 258.506 195.052 257.981H196.451V271.443H194.352V261.199H192.715L192.729 259.674Z",
    fill: "url(#paint68_linear_2204_11443)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M200.327 259.674C200.856 259.737 201.389 259.597 201.82 259.283C202.251 258.969 202.547 258.504 202.649 257.981H204.049V271.443H201.936V261.199H200.312L200.327 259.674Z",
    fill: "url(#paint69_linear_2204_11443)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M207.926 259.674C208.456 259.74 208.991 259.602 209.423 259.288C209.854 258.973 210.15 258.506 210.249 257.981H211.648V271.443H209.535V261.199H207.926V259.674Z",
    fill: "url(#paint70_linear_2204_11443)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M215.51 259.674C216.039 259.737 216.573 259.597 217.004 259.283C217.435 258.969 217.731 258.504 217.833 257.981H219.232V271.443H217.119V261.199H215.496L215.51 259.674Z",
    fill: "url(#paint71_linear_2204_11443)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M223.108 259.674C223.636 259.74 224.169 259.601 224.599 259.286C225.028 258.972 225.321 258.505 225.417 257.981H226.816V271.443H224.717V261.199H223.094L223.108 259.674Z",
    fill: "url(#paint72_linear_2204_11443)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M230.692 259.674C231.222 259.74 231.757 259.602 232.189 259.288C232.62 258.973 232.916 258.506 233.015 257.981H234.414V271.443H232.315V261.199H230.678L230.692 259.674Z",
    fill: "url(#paint73_linear_2204_11443)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M236.807 261.199C236.807 260.349 237.144 259.534 237.745 258.933C238.346 258.332 239.161 257.995 240.011 257.995C240.861 257.995 241.676 258.332 242.277 258.933C242.878 259.534 243.216 260.349 243.216 261.199V268.196C243.216 269.046 242.878 269.861 242.277 270.462C241.676 271.063 240.861 271.401 240.011 271.401C239.161 271.401 238.346 271.063 237.745 270.462C237.144 269.861 236.807 269.046 236.807 268.196V261.199ZM238.92 268.308C238.92 269.274 239.339 269.707 240.011 269.707C240.683 269.707 241.103 269.344 241.103 268.308V261.073C241.103 260.108 240.683 259.674 240.011 259.674C239.339 259.674 238.92 260.038 238.92 261.073V268.308Z",
    fill: "url(#paint74_linear_2204_11443)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M245.875 259.674C246.405 259.74 246.941 259.602 247.372 259.288C247.804 258.973 248.099 258.506 248.198 257.981H249.598V271.443H247.499V261.199H245.861L245.875 259.674Z",
    fill: "url(#paint75_linear_2204_11443)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M256.442 259.674C256.972 259.74 257.507 259.602 257.938 259.288C258.37 258.973 258.665 258.506 258.765 257.981H260.164V271.443H258.065V261.199H256.428L256.442 259.674Z",
    fill: "url(#paint76_linear_2204_11443)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M262.5 261.199C262.5 260.349 262.838 259.534 263.439 258.933C264.04 258.332 264.855 257.995 265.705 257.995C266.554 257.995 267.369 258.332 267.97 258.933C268.571 259.534 268.909 260.349 268.909 261.199V268.196C268.909 269.046 268.571 269.861 267.97 270.462C267.369 271.063 266.554 271.401 265.705 271.401C264.855 271.401 264.04 271.063 263.439 270.462C262.838 269.861 262.5 269.046 262.5 268.196V261.199ZM264.613 268.308C264.613 269.274 265.033 269.707 265.705 269.707C266.376 269.707 266.796 269.344 266.796 268.308V261.073C266.796 260.108 266.376 259.674 265.705 259.674C265.033 259.674 264.613 260.038 264.613 261.073V268.308Z",
    fill: "url(#paint77_linear_2204_11443)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M271.624 259.674C272.154 259.74 272.689 259.602 273.12 259.288C273.552 258.973 273.847 258.506 273.947 257.981H275.346V271.443H273.233V261.199H271.596L271.624 259.674Z",
    fill: "url(#paint78_linear_2204_11443)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M282.188 259.674C282.718 259.74 283.253 259.602 283.685 259.288C284.117 258.973 284.412 258.506 284.511 257.981H285.91V271.443H283.797V261.199H282.16L282.188 259.674Z",
    fill: "url(#paint79_linear_2204_11443)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M291.284 261.199C291.255 260.762 291.317 260.323 291.464 259.91C291.612 259.497 291.843 259.118 292.142 258.798C292.442 258.478 292.804 258.222 293.207 258.048C293.609 257.873 294.043 257.783 294.482 257.783C294.921 257.783 295.354 257.873 295.757 258.048C296.159 258.222 296.522 258.478 296.821 258.798C297.121 259.118 297.352 259.497 297.5 259.91C297.647 260.323 297.708 260.762 297.679 261.199V268.196C297.708 268.634 297.647 269.073 297.5 269.486C297.352 269.899 297.121 270.277 296.821 270.598C296.522 270.918 296.159 271.173 295.757 271.348C295.354 271.522 294.921 271.612 294.482 271.612C294.043 271.612 293.609 271.522 293.207 271.348C292.804 271.173 292.442 270.918 292.142 270.598C291.843 270.277 291.612 269.899 291.464 269.486C291.317 269.073 291.255 268.634 291.284 268.196V261.199ZM293.397 268.308C293.397 269.274 293.817 269.707 294.489 269.707C295.161 269.707 295.58 269.344 295.58 268.308V261.073C295.58 260.108 295.161 259.674 294.489 259.674C293.817 259.674 293.397 260.038 293.397 261.073V268.308Z",
    fill: "url(#paint80_linear_2204_11443)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M300.352 259.674C300.881 259.737 301.415 259.597 301.846 259.283C302.276 258.969 302.573 258.504 302.675 257.981H304.074V271.443H301.961V261.199H300.338L300.352 259.674Z",
    fill: "url(#paint81_linear_2204_11443)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M307.95 259.674C308.478 259.74 309.012 259.601 309.441 259.286C309.87 258.972 310.163 258.505 310.259 257.981H311.658V271.443H309.545V261.199H307.922L307.95 259.674Z",
    fill: "url(#paint82_linear_2204_11443)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M315.535 259.674C316.065 259.74 316.6 259.602 317.032 259.288C317.464 258.973 317.759 258.506 317.858 257.981H319.257V271.443H317.158V261.199H315.535V259.674Z",
    fill: "url(#paint83_linear_2204_11443)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M323.133 259.674C323.662 259.74 324.195 259.601 324.625 259.286C325.054 258.972 325.346 258.505 325.442 257.981H326.842V271.443H324.729V261.199H323.105L323.133 259.674Z",
    fill: "url(#paint84_linear_2204_11443)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M330.717 259.674C331.247 259.74 331.782 259.602 332.214 259.288C332.645 258.973 332.941 258.506 333.04 257.981H334.439V271.443H332.34V261.199H330.703L330.717 259.674Z",
    fill: "url(#paint85_linear_2204_11443)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M336.832 261.199C336.832 260.779 336.915 260.362 337.076 259.973C337.237 259.584 337.473 259.231 337.771 258.933C338.068 258.636 338.421 258.4 338.81 258.239C339.199 258.078 339.616 257.995 340.037 257.995C340.457 257.995 340.874 258.078 341.263 258.239C341.652 258.4 342.005 258.636 342.302 258.933C342.6 259.231 342.836 259.584 342.997 259.973C343.158 260.362 343.241 260.779 343.241 261.199V268.196C343.241 268.617 343.158 269.034 342.997 269.422C342.836 269.811 342.6 270.164 342.302 270.462C342.005 270.76 341.652 270.996 341.263 271.157C340.874 271.318 340.457 271.401 340.037 271.401C339.616 271.401 339.199 271.318 338.81 271.157C338.421 270.996 338.068 270.76 337.771 270.462C337.473 270.164 337.237 269.811 337.076 269.422C336.915 269.034 336.832 268.617 336.832 268.196V261.199ZM338.945 268.308C338.945 269.274 339.365 269.707 340.037 269.707C340.708 269.707 341.128 269.344 341.128 268.308V261.073C341.128 260.108 340.708 259.674 340.037 259.674C339.365 259.674 338.945 260.038 338.945 261.073V268.308Z",
    fill: "url(#paint86_linear_2204_11443)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M345.9 259.674C346.43 259.74 346.966 259.602 347.397 259.288C347.829 258.973 348.124 258.506 348.223 257.981H349.623V271.443H347.51V261.199H345.9V259.674Z",
    fill: "url(#paint87_linear_2204_11443)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M352.058 261.199C352.029 260.762 352.09 260.323 352.238 259.91C352.385 259.497 352.616 259.118 352.916 258.798C353.215 258.478 353.578 258.222 353.98 258.048C354.383 257.873 354.817 257.783 355.255 257.783C355.694 257.783 356.128 257.873 356.53 258.048C356.933 258.222 357.295 258.478 357.595 258.798C357.895 259.118 358.125 259.497 358.273 259.91C358.421 260.323 358.482 260.762 358.453 261.199V268.196C358.482 268.634 358.421 269.073 358.273 269.486C358.125 269.899 357.895 270.277 357.595 270.598C357.295 270.918 356.933 271.173 356.53 271.348C356.128 271.522 355.694 271.612 355.255 271.612C354.817 271.612 354.383 271.522 353.98 271.348C353.578 271.173 353.215 270.918 352.916 270.598C352.616 270.277 352.385 269.899 352.238 269.486C352.09 269.073 352.029 268.634 352.058 268.196V261.199ZM354.157 268.308C354.157 269.274 354.577 269.707 355.248 269.707C355.92 269.707 356.34 269.344 356.34 268.308V261.073C356.34 260.108 355.92 259.674 355.248 259.674C354.577 259.674 354.157 260.038 354.157 261.073V268.308Z",
    fill: "url(#paint88_linear_2204_11443)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M361.098 259.674C361.627 259.74 362.16 259.601 362.589 259.286C363.019 258.972 363.311 258.505 363.407 257.981H364.807V271.443H362.694V261.199H361.07L361.098 259.674Z",
    fill: "url(#paint89_linear_2204_11443)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M367.212 261.199C367.183 260.762 367.244 260.323 367.392 259.91C367.539 259.497 367.77 259.118 368.07 258.798C368.37 258.478 368.732 258.222 369.135 258.048C369.537 257.873 369.971 257.783 370.41 257.783C370.848 257.783 371.282 257.873 371.685 258.048C372.087 258.222 372.449 258.478 372.749 258.798C373.049 259.118 373.28 259.497 373.427 259.91C373.575 260.323 373.636 260.762 373.607 261.199V268.196C373.636 268.634 373.575 269.073 373.427 269.486C373.28 269.899 373.049 270.277 372.749 270.598C372.449 270.918 372.087 271.173 371.685 271.348C371.282 271.522 370.848 271.612 370.41 271.612C369.971 271.612 369.537 271.522 369.135 271.348C368.732 271.173 368.37 270.918 368.07 270.598C367.77 270.277 367.539 269.899 367.392 269.486C367.244 269.073 367.183 268.634 367.212 268.196V261.199ZM369.311 268.308C369.311 269.274 369.745 269.707 370.417 269.707C371.088 269.707 371.508 269.344 371.508 268.308V261.073C371.508 260.108 371.074 259.674 370.417 259.674C369.759 259.674 369.311 260.038 369.311 261.073V268.308Z",
    fill: "url(#paint90_linear_2204_11443)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M376.28 259.674C376.809 259.737 377.343 259.597 377.773 259.283C378.204 258.969 378.5 258.504 378.603 257.981H380.002V271.443H377.889V261.199H376.266L376.28 259.674Z",
    fill: "url(#paint91_linear_2204_11443)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M391.311 261.199C391.311 260.349 391.648 259.534 392.249 258.933C392.85 258.332 393.665 257.995 394.515 257.995C395.365 257.995 396.18 258.332 396.781 258.933C397.382 259.534 397.72 260.349 397.72 261.199V268.196C397.72 269.046 397.382 269.861 396.781 270.462C396.18 271.063 395.365 271.401 394.515 271.401C393.665 271.401 392.85 271.063 392.249 270.462C391.648 269.861 391.311 269.046 391.311 268.196V261.199ZM393.424 268.308C393.424 269.274 393.843 269.707 394.515 269.707C395.187 269.707 395.607 269.344 395.607 268.308V261.073C395.607 260.108 395.187 259.674 394.515 259.674C393.843 259.674 393.424 260.038 393.424 261.073V268.308Z",
    fill: "url(#paint92_linear_2204_11443)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M400.377 259.674C400.907 259.74 401.442 259.602 401.874 259.288C402.306 258.973 402.601 258.506 402.7 257.981H404.1V271.443H402.001V261.199H400.363L400.377 259.674Z",
    fill: "url(#paint93_linear_2204_11443)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M406.492 261.199C406.492 260.349 406.83 259.534 407.431 258.933C408.032 258.332 408.847 257.995 409.697 257.995C410.547 257.995 411.362 258.332 411.963 258.933C412.564 259.534 412.901 260.349 412.901 261.199V268.196C412.901 269.046 412.564 269.861 411.963 270.462C411.362 271.063 410.547 271.401 409.697 271.401C408.847 271.401 408.032 271.063 407.431 270.462C406.83 269.861 406.492 269.046 406.492 268.196V261.199ZM408.605 268.308C408.605 269.274 409.025 269.707 409.697 269.707C410.368 269.707 410.788 269.344 410.788 268.308V261.073C410.788 260.108 410.368 259.674 409.697 259.674C409.025 259.674 408.605 260.038 408.605 261.073V268.308Z",
    fill: "url(#paint94_linear_2204_11443)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M415.559 259.674C416.089 259.74 416.624 259.602 417.056 259.288C417.487 258.973 417.783 258.506 417.882 257.981H419.281V271.443H417.182V261.199H415.545L415.559 259.674Z",
    fill: "url(#paint95_linear_2204_11443)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M423.16 259.674C423.69 259.737 424.223 259.597 424.654 259.283C425.085 258.969 425.381 258.504 425.483 257.981H426.882V271.443H424.825V261.199H423.202L423.16 259.674Z",
    fill: "url(#paint96_linear_2204_11443)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M430.744 259.674C431.274 259.74 431.809 259.602 432.241 259.288C432.672 258.973 432.968 258.506 433.067 257.981H434.466V271.443H432.381V261.199H430.744V259.674Z",
    fill: "url(#paint97_linear_2204_11443)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M436.872 261.199C436.843 260.762 436.904 260.323 437.052 259.91C437.2 259.497 437.43 259.118 437.73 258.798C438.03 258.478 438.392 258.222 438.795 258.048C439.197 257.873 439.631 257.783 440.07 257.783C440.508 257.783 440.942 257.873 441.345 258.048C441.747 258.222 442.11 258.478 442.409 258.798C442.709 259.118 442.94 259.497 443.087 259.91C443.235 260.323 443.296 260.762 443.267 261.199V268.196C443.296 268.634 443.235 269.073 443.087 269.486C442.94 269.899 442.709 270.277 442.409 270.598C442.11 270.918 441.747 271.173 441.345 271.348C440.942 271.522 440.508 271.612 440.07 271.612C439.631 271.612 439.197 271.522 438.795 271.348C438.392 271.173 438.03 270.918 437.73 270.598C437.43 270.277 437.2 269.899 437.052 269.486C436.904 269.073 436.843 268.634 436.872 268.196V261.199ZM438.971 268.308C438.971 269.274 439.391 269.707 440.063 269.707C440.734 269.707 441.154 269.344 441.154 268.308V261.073C441.154 260.108 440.734 259.674 440.063 259.674C439.391 259.674 438.971 260.038 438.971 261.073V268.308Z",
    fill: "url(#paint98_linear_2204_11443)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M445.94 259.674C446.468 259.74 447.002 259.601 447.431 259.286C447.86 258.972 448.153 258.505 448.249 257.981H449.648V271.443H447.535V261.199H445.912L445.94 259.674Z",
    fill: "url(#paint99_linear_2204_11443)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M453.524 259.674C454.054 259.74 454.589 259.602 455.021 259.288C455.452 258.973 455.748 258.506 455.847 257.981H457.246V271.443H455.133V261.199H453.496L453.524 259.674Z",
    fill: "url(#paint100_linear_2204_11443)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M461.123 259.674C461.652 259.737 462.186 259.597 462.617 259.283C463.048 258.969 463.344 258.504 463.446 257.981H464.845V271.443H462.746V261.199H461.123V259.674Z",
    fill: "url(#paint101_linear_2204_11443)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M468.708 259.674C469.238 259.74 469.773 259.602 470.204 259.288C470.636 258.973 470.931 258.506 471.031 257.981H472.43V271.443H470.317V261.199H468.68L468.708 259.674Z",
    fill: "url(#paint102_linear_2204_11443)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M476.307 259.674C476.836 259.737 477.37 259.597 477.8 259.283C478.231 258.969 478.527 258.504 478.63 257.981H480.029V271.443H478V261.199H476.377L476.307 259.674Z",
    fill: "url(#paint103_linear_2204_11443)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M483.905 259.674C484.433 259.74 484.967 259.601 485.396 259.286C485.825 258.972 486.118 258.505 486.214 257.981H487.613V271.443H485.5V261.199H483.877L483.905 259.674Z",
    fill: "url(#paint104_linear_2204_11443)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M492.986 261.199C492.986 260.349 493.324 259.534 493.925 258.933C494.526 258.332 495.341 257.995 496.191 257.995C497.041 257.995 497.856 258.332 498.457 258.933C499.058 259.534 499.395 260.349 499.395 261.199V268.196C499.395 269.046 499.058 269.861 498.457 270.462C497.856 271.063 497.041 271.401 496.191 271.401C495.341 271.401 494.526 271.063 493.925 270.462C493.324 269.861 492.986 269.046 492.986 268.196V261.199ZM495.099 268.308C495.099 269.274 495.519 269.707 496.191 269.707C496.863 269.707 497.282 269.344 497.282 268.308V261.073C497.282 260.108 496.863 259.674 496.191 259.674C495.519 259.674 495.099 260.038 495.099 261.073V268.308Z",
    fill: "url(#paint105_linear_2204_11443)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M502.055 259.674C502.585 259.74 503.12 259.602 503.552 259.288C503.983 258.973 504.279 258.506 504.378 257.981H505.777V271.443H503.678V261.199H502.041L502.055 259.674Z",
    fill: "url(#paint106_linear_2204_11443)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M509.653 259.674C510.181 259.74 510.715 259.601 511.144 259.286C511.573 258.972 511.866 258.505 511.962 257.981H513.361V271.443H511.248V261.199H509.625L509.653 259.674Z",
    fill: "url(#paint107_linear_2204_11443)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M145.697 284.834C145.697 283.984 146.035 283.169 146.636 282.568C147.237 281.967 148.052 281.63 148.902 281.63C149.752 281.63 150.567 281.967 151.168 282.568C151.769 283.169 152.106 283.984 152.106 284.834V291.831C152.106 292.681 151.769 293.496 151.168 294.097C150.567 294.698 149.752 295.036 148.902 295.036C148.052 295.036 147.237 294.698 146.636 294.097C146.035 293.496 145.697 292.681 145.697 291.831V284.834ZM147.81 291.943C147.81 292.909 148.23 293.272 148.902 293.272C149.573 293.272 149.993 292.909 149.993 291.943V284.708C149.993 283.743 149.573 283.379 148.902 283.379C148.23 283.379 147.81 283.743 147.81 284.708V291.943Z",
    fill: "url(#paint108_linear_2204_11443)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M153.351 284.834C153.322 284.397 153.383 283.958 153.531 283.545C153.678 283.131 153.909 282.753 154.209 282.433C154.508 282.113 154.871 281.857 155.273 281.683C155.676 281.508 156.11 281.418 156.548 281.418C156.987 281.418 157.421 281.508 157.823 281.683C158.226 281.857 158.588 282.113 158.888 282.433C159.188 282.753 159.418 283.131 159.566 283.545C159.714 283.958 159.775 284.397 159.746 284.834V291.831C159.775 292.269 159.714 292.708 159.566 293.121C159.418 293.534 159.188 293.912 158.888 294.233C158.588 294.553 158.226 294.808 157.823 294.983C157.421 295.157 156.987 295.247 156.548 295.247C156.11 295.247 155.676 295.157 155.273 294.983C154.871 294.808 154.508 294.553 154.209 294.233C153.909 293.912 153.678 293.534 153.531 293.121C153.383 292.708 153.322 292.269 153.351 291.831V284.834ZM155.45 291.943C155.45 292.909 155.884 293.272 156.555 293.272C157.227 293.272 157.647 292.909 157.647 291.943V284.708C157.647 283.743 157.213 283.379 156.555 283.379C155.898 283.379 155.45 283.743 155.45 284.708V291.943Z",
    fill: "url(#paint109_linear_2204_11443)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M160.879 284.834C160.879 283.984 161.217 283.169 161.817 282.568C162.418 281.967 163.234 281.63 164.083 281.63C164.933 281.63 165.748 281.967 166.349 282.568C166.95 283.169 167.288 283.984 167.288 284.834V291.831C167.288 292.681 166.95 293.496 166.349 294.097C165.748 294.698 164.933 295.036 164.083 295.036C163.234 295.036 162.418 294.698 161.817 294.097C161.217 293.496 160.879 292.681 160.879 291.831V284.834ZM162.992 291.943C162.992 292.909 163.412 293.272 164.083 293.272C164.755 293.272 165.175 292.909 165.175 291.943V284.708C165.175 283.743 164.755 283.379 164.083 283.379C163.412 283.379 162.992 283.743 162.992 284.708V291.943Z",
    fill: "url(#paint110_linear_2204_11443)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M169.946 283.309C170.476 283.375 171.011 283.237 171.443 282.923C171.875 282.608 172.17 282.141 172.269 281.616H173.669V295.036H171.542V284.792H169.904L169.946 283.309Z",
    fill: "url(#paint111_linear_2204_11443)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M180.51 283.309C181.04 283.375 181.576 283.237 182.007 282.923C182.439 282.608 182.734 282.141 182.833 281.616H184.233V295.036H182.12V284.792H180.482L180.51 283.309Z",
    fill: "url(#paint112_linear_2204_11443)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M188.111 283.309C188.641 283.372 189.174 283.232 189.605 282.918C190.036 282.604 190.332 282.139 190.434 281.616H191.834V295.036H189.735V284.792H188.111V283.309Z",
    fill: "url(#paint113_linear_2204_11443)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M195.71 283.309C196.238 283.375 196.771 283.236 197.201 282.921C197.63 282.607 197.923 282.14 198.019 281.616H199.418V295.036H197.305V284.792H195.682L195.71 283.309Z",
    fill: "url(#paint114_linear_2204_11443)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M203.293 283.309C203.823 283.375 204.359 283.237 204.79 282.923C205.222 282.608 205.517 282.141 205.616 281.616H207.016V295.036H204.917V284.792H203.279L203.293 283.309Z",
    fill: "url(#paint115_linear_2204_11443)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M210.893 283.309C211.422 283.372 211.956 283.232 212.387 282.918C212.817 282.604 213.114 282.139 213.216 281.616H214.615V295.036H212.502V284.792H210.879L210.893 283.309Z",
    fill: "url(#paint116_linear_2204_11443)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M219.973 284.834C219.973 283.984 220.31 283.169 220.911 282.568C221.512 281.967 222.327 281.63 223.177 281.63C224.027 281.63 224.842 281.967 225.443 282.568C226.044 283.169 226.382 283.984 226.382 284.834V291.831C226.382 292.681 226.044 293.496 225.443 294.097C224.842 294.698 224.027 295.036 223.177 295.036C222.327 295.036 221.512 294.698 220.911 294.097C220.31 293.496 219.973 292.681 219.973 291.831V284.834ZM222.086 291.943C222.086 292.909 222.505 293.272 223.177 293.272C223.849 293.272 224.269 292.909 224.269 291.943V284.708C224.269 283.743 223.849 283.379 223.177 283.379C222.505 283.379 222.086 283.743 222.086 284.708V291.943Z",
    fill: "url(#paint117_linear_2204_11443)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M227.517 284.834C227.488 284.397 227.549 283.958 227.697 283.545C227.844 283.131 228.075 282.753 228.375 282.433C228.674 282.113 229.037 281.857 229.439 281.683C229.842 281.508 230.276 281.418 230.714 281.418C231.153 281.418 231.587 281.508 231.989 281.683C232.392 281.857 232.754 282.113 233.054 282.433C233.354 282.753 233.584 283.131 233.732 283.545C233.88 283.958 233.941 284.397 233.912 284.834V291.831C233.941 292.269 233.88 292.708 233.732 293.121C233.584 293.534 233.354 293.912 233.054 294.233C232.754 294.553 232.392 294.808 231.989 294.983C231.587 295.157 231.153 295.247 230.714 295.247C230.276 295.247 229.842 295.157 229.439 294.983C229.037 294.808 228.674 294.553 228.375 294.233C228.075 293.912 227.844 293.534 227.697 293.121C227.549 292.708 227.488 292.269 227.517 291.831V284.834ZM229.616 291.943C229.616 292.909 230.05 293.272 230.721 293.272C231.393 293.272 231.813 292.909 231.813 291.943V284.708C231.813 283.743 231.393 283.379 230.721 283.379C230.05 283.379 229.616 283.743 229.616 284.708V291.943Z",
    fill: "url(#paint118_linear_2204_11443)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M235.156 284.834C235.156 283.984 235.494 283.169 236.095 282.568C236.696 281.967 237.511 281.63 238.361 281.63C239.211 281.63 240.026 281.967 240.627 282.568C241.228 283.169 241.565 283.984 241.565 284.834V291.831C241.565 292.681 241.228 293.496 240.627 294.097C240.026 294.698 239.211 295.036 238.361 295.036C237.511 295.036 236.696 294.698 236.095 294.097C235.494 293.496 235.156 292.681 235.156 291.831V284.834ZM237.269 291.943C237.269 292.909 237.689 293.272 238.361 293.272C239.032 293.272 239.452 292.909 239.452 291.943V284.708C239.452 283.743 239.032 283.379 238.361 283.379C237.689 283.379 237.269 283.743 237.269 284.708V291.943Z",
    fill: "url(#paint119_linear_2204_11443)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M242.756 284.834C242.756 283.984 243.093 283.169 243.694 282.568C244.295 281.967 245.11 281.63 245.96 281.63C246.81 281.63 247.625 281.967 248.226 282.568C248.827 283.169 249.165 283.984 249.165 284.834V291.831C249.165 292.681 248.827 293.496 248.226 294.097C247.625 294.698 246.81 295.036 245.96 295.036C245.11 295.036 244.295 294.698 243.694 294.097C243.093 293.496 242.756 292.681 242.756 291.831V284.834ZM244.869 291.943C244.869 292.909 245.289 293.272 245.96 293.272C246.632 293.272 247.052 292.909 247.052 291.943V284.708C247.052 283.743 246.632 283.379 245.96 283.379C245.289 283.379 244.869 283.743 244.869 284.708V291.943Z",
    fill: "url(#paint120_linear_2204_11443)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M250.353 284.834C250.324 284.397 250.385 283.958 250.532 283.545C250.68 283.131 250.911 282.753 251.211 282.433C251.51 282.113 251.873 281.857 252.275 281.683C252.678 281.508 253.112 281.418 253.55 281.418C253.989 281.418 254.423 281.508 254.825 281.683C255.228 281.857 255.59 282.113 255.89 282.433C256.19 282.753 256.42 283.131 256.568 283.545C256.715 283.958 256.777 284.397 256.748 284.834V291.831C256.777 292.269 256.715 292.708 256.568 293.121C256.42 293.534 256.19 293.912 255.89 294.233C255.59 294.553 255.228 294.808 254.825 294.983C254.423 295.157 253.989 295.247 253.55 295.247C253.112 295.247 252.678 295.157 252.275 294.983C251.873 294.808 251.51 294.553 251.211 294.233C250.911 293.912 250.68 293.534 250.532 293.121C250.385 292.708 250.324 292.269 250.353 291.831V284.834ZM252.452 291.943C252.452 292.909 252.872 293.272 253.543 293.272C254.215 293.272 254.635 292.909 254.635 291.943V284.708C254.635 283.743 254.215 283.379 253.543 283.379C252.872 283.379 252.452 283.743 252.452 284.708V291.943Z",
    fill: "url(#paint121_linear_2204_11443)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M265.299 283.309C265.829 283.375 266.364 283.237 266.796 282.923C267.227 282.608 267.523 282.141 267.622 281.616H269.021V295.036H266.908V284.792H265.299V283.309Z",
    fill: "url(#paint122_linear_2204_11443)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M272.952 283.309C273.481 283.372 274.014 283.232 274.445 282.918C274.876 282.604 275.172 282.139 275.274 281.616H276.674V295.036H274.561V284.792H272.938L272.952 283.309Z",
    fill: "url(#paint123_linear_2204_11443)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M280.553 283.309C281.081 283.375 281.615 283.236 282.044 282.921C282.473 282.607 282.766 282.14 282.862 281.616H284.261V295.036H282.148V284.792H280.553V283.309Z",
    fill: "url(#paint124_linear_2204_11443)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M288.137 283.309C288.667 283.375 289.202 283.237 289.634 282.923C290.065 282.608 290.361 282.141 290.46 281.616H291.859V295.036H289.76V284.792H288.123L288.137 283.309Z",
    fill: "url(#paint125_linear_2204_11443)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M295.735 283.309C296.264 283.372 296.798 283.232 297.228 282.918C297.659 282.604 297.955 282.139 298.058 281.616H299.457V295.036H297.344V284.792H295.721L295.735 283.309Z",
    fill: "url(#paint126_linear_2204_11443)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M303.319 283.309C303.849 283.375 304.384 283.237 304.815 282.923C305.247 282.608 305.542 282.141 305.642 281.616H307.041V295.036H304.942V284.792H303.305L303.319 283.309Z",
    fill: "url(#paint127_linear_2204_11443)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M309.434 284.834C309.434 283.984 309.771 283.169 310.372 282.568C310.973 281.967 311.788 281.63 312.638 281.63C313.488 281.63 314.303 281.967 314.904 282.568C315.505 283.169 315.843 283.984 315.843 284.834V291.831C315.843 292.681 315.505 293.496 314.904 294.097C314.303 294.698 313.488 295.036 312.638 295.036C311.788 295.036 310.973 294.698 310.372 294.097C309.771 293.496 309.434 292.681 309.434 291.831V284.834ZM311.547 291.943C311.547 292.909 311.966 293.272 312.638 293.272C313.31 293.272 313.73 292.909 313.73 291.943V284.708C313.73 283.743 313.31 283.379 312.638 283.379C311.966 283.379 311.547 283.743 311.547 284.708V291.943Z",
    fill: "url(#paint128_linear_2204_11443)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M317.074 284.834C317.074 283.984 317.412 283.169 318.013 282.568C318.614 281.967 319.429 281.63 320.279 281.63C321.129 281.63 321.944 281.967 322.545 282.568C323.146 283.169 323.483 283.984 323.483 284.834V291.831C323.483 292.681 323.146 293.496 322.545 294.097C321.944 294.698 321.129 295.036 320.279 295.036C319.429 295.036 318.614 294.698 318.013 294.097C317.412 293.496 317.074 292.681 317.074 291.831V284.834ZM319.187 291.943C319.187 292.909 319.607 293.272 320.279 293.272C320.95 293.272 321.37 292.909 321.37 291.943V284.708C321.37 283.743 320.95 283.379 320.279 283.379C319.607 283.379 319.187 283.743 319.187 284.708V291.943Z",
    fill: "url(#paint129_linear_2204_11443)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M324.63 284.834C324.601 284.397 324.662 283.958 324.81 283.545C324.957 283.131 325.188 282.753 325.488 282.433C325.788 282.113 326.15 281.857 326.552 281.683C326.955 281.508 327.389 281.418 327.828 281.418C328.266 281.418 328.7 281.508 329.103 281.683C329.505 281.857 329.867 282.113 330.167 282.433C330.467 282.753 330.698 283.131 330.845 283.545C330.993 283.958 331.054 284.397 331.025 284.834V291.831C331.054 292.269 330.993 292.708 330.845 293.121C330.698 293.534 330.467 293.912 330.167 294.233C329.867 294.553 329.505 294.808 329.103 294.983C328.7 295.157 328.266 295.247 327.828 295.247C327.389 295.247 326.955 295.157 326.552 294.983C326.15 294.808 325.788 294.553 325.488 294.233C325.188 293.912 324.957 293.534 324.81 293.121C324.662 292.708 324.601 292.269 324.63 291.831V284.834ZM326.729 291.943C326.729 292.909 327.149 293.272 327.821 293.272C328.492 293.272 328.912 292.909 328.912 291.943V284.708C328.912 283.743 328.492 283.379 327.821 283.379C327.149 283.379 326.729 283.743 326.729 284.708V291.943Z",
    fill: "url(#paint130_linear_2204_11443)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M332.215 284.834C332.215 283.984 332.552 283.169 333.153 282.568C333.754 281.967 334.569 281.63 335.419 281.63C336.269 281.63 337.084 281.967 337.685 282.568C338.286 283.169 338.624 283.984 338.624 284.834V291.831C338.624 292.681 338.286 293.496 337.685 294.097C337.084 294.698 336.269 295.036 335.419 295.036C334.569 295.036 333.754 294.698 333.153 294.097C332.552 293.496 332.215 292.681 332.215 291.831V284.834ZM334.328 291.943C334.328 292.909 334.748 293.272 335.419 293.272C336.091 293.272 336.511 292.909 336.511 291.943V284.708C336.511 283.743 336.091 283.379 335.419 283.379C334.748 283.379 334.328 283.743 334.328 284.708V291.943Z",
    fill: "url(#paint131_linear_2204_11443)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M339.814 284.834C339.785 284.397 339.846 283.958 339.993 283.545C340.141 283.131 340.372 282.753 340.672 282.433C340.971 282.113 341.334 281.857 341.736 281.683C342.139 281.508 342.573 281.418 343.011 281.418C343.45 281.418 343.884 281.508 344.286 281.683C344.689 281.857 345.051 282.113 345.351 282.433C345.65 282.753 345.881 283.131 346.029 283.545C346.176 283.958 346.238 284.397 346.209 284.834V291.831C346.238 292.269 346.176 292.708 346.029 293.121C345.881 293.534 345.65 293.912 345.351 294.233C345.051 294.553 344.689 294.808 344.286 294.983C343.884 295.157 343.45 295.247 343.011 295.247C342.573 295.247 342.139 295.157 341.736 294.983C341.334 294.808 340.971 294.553 340.672 294.233C340.372 293.912 340.141 293.534 339.993 293.121C339.846 292.708 339.785 292.269 339.814 291.831V284.834ZM341.913 291.943C341.913 292.909 342.346 293.272 343.018 293.272C343.69 293.272 344.11 292.909 344.11 291.943V284.708C344.11 283.743 343.676 283.379 343.018 283.379C342.36 283.379 341.913 283.743 341.913 284.708V291.943Z",
    fill: "url(#paint132_linear_2204_11443)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M347.398 284.834C347.398 283.984 347.736 283.169 348.337 282.568C348.938 281.967 349.753 281.63 350.603 281.63C351.453 281.63 352.268 281.967 352.869 282.568C353.47 283.169 353.807 283.984 353.807 284.834V291.831C353.807 292.681 353.47 293.496 352.869 294.097C352.268 294.698 351.453 295.036 350.603 295.036C349.753 295.036 348.938 294.698 348.337 294.097C347.736 293.496 347.398 292.681 347.398 291.831V284.834ZM349.511 291.943C349.511 292.909 349.931 293.272 350.603 293.272C351.275 293.272 351.694 292.909 351.694 291.943V284.708C351.694 283.743 351.275 283.379 350.603 283.379C349.931 283.379 349.511 283.743 349.511 284.708V291.943Z",
    fill: "url(#paint133_linear_2204_11443)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M354.997 284.834C354.968 284.397 355.029 283.958 355.177 283.545C355.325 283.131 355.555 282.753 355.855 282.433C356.155 282.113 356.517 281.857 356.92 281.683C357.322 281.508 357.756 281.418 358.195 281.418C358.633 281.418 359.067 281.508 359.47 281.683C359.872 281.857 360.235 282.113 360.534 282.433C360.834 282.753 361.065 283.131 361.212 283.545C361.36 283.958 361.421 284.397 361.392 284.834V291.831C361.421 292.269 361.36 292.708 361.212 293.121C361.065 293.534 360.834 293.912 360.534 294.233C360.235 294.553 359.872 294.808 359.47 294.983C359.067 295.157 358.633 295.247 358.195 295.247C357.756 295.247 357.322 295.157 356.92 294.983C356.517 294.808 356.155 294.553 355.855 294.233C355.555 293.912 355.325 293.534 355.177 293.121C355.029 292.708 354.968 292.269 354.997 291.831V284.834ZM357.11 291.943C357.11 292.909 357.53 293.272 358.202 293.272C358.873 293.272 359.293 292.909 359.293 291.943V284.708C359.293 283.743 358.873 283.379 358.202 283.379C357.53 283.379 357.11 283.743 357.11 284.708V291.943Z",
    fill: "url(#paint134_linear_2204_11443)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M367.031 283.309C367.561 283.375 368.096 283.237 368.528 282.923C368.96 282.608 369.255 282.141 369.354 281.616H370.753V295.036H368.64V284.792H367.031V283.309Z",
    fill: "url(#paint135_linear_2204_11443)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M374.629 283.309C375.159 283.372 375.692 283.232 376.123 282.918C376.554 282.604 376.85 282.139 376.952 281.616H378.352V295.036H376.238V284.792H374.615L374.629 283.309Z",
    fill: "url(#paint136_linear_2204_11443)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M382.227 283.309C382.755 283.375 383.289 283.236 383.718 282.921C384.148 282.607 384.44 282.14 384.536 281.616H385.935V295.036H383.822V284.792H382.199L382.227 283.309Z",
    fill: "url(#paint137_linear_2204_11443)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M389.84 283.309C390.37 283.375 390.905 283.237 391.337 282.923C391.768 282.608 392.064 282.141 392.163 281.616H393.562V295.036H391.463V284.792H389.84V283.309Z",
    fill: "url(#paint138_linear_2204_11443)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M397.41 283.309C397.94 283.372 398.473 283.232 398.904 282.918C399.335 282.604 399.631 282.139 399.733 281.616H401.133V295.036H399.02V284.792H397.396L397.41 283.309Z",
    fill: "url(#paint139_linear_2204_11443)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M409.431 284.834C409.402 284.397 409.463 283.958 409.611 283.545C409.758 283.131 409.989 282.753 410.289 282.433C410.589 282.113 410.951 281.857 411.353 281.683C411.756 281.508 412.19 281.418 412.628 281.418C413.067 281.418 413.501 281.508 413.903 281.683C414.306 281.857 414.668 282.113 414.968 282.433C415.268 282.753 415.498 283.131 415.646 283.545C415.794 283.958 415.855 284.397 415.826 284.834V291.831C415.855 292.269 415.794 292.708 415.646 293.121C415.498 293.534 415.268 293.912 414.968 294.233C414.668 294.553 414.306 294.808 413.903 294.983C413.501 295.157 413.067 295.247 412.628 295.247C412.19 295.247 411.756 295.157 411.353 294.983C410.951 294.808 410.589 294.553 410.289 294.233C409.989 293.912 409.758 293.534 409.611 293.121C409.463 292.708 409.402 292.269 409.431 291.831V284.834ZM411.53 291.943C411.53 292.909 411.95 293.272 412.621 293.272C413.293 293.272 413.713 292.909 413.713 291.943V284.708C413.713 283.743 413.293 283.379 412.621 283.379C411.95 283.379 411.53 283.743 411.53 284.708V291.943Z",
    fill: "url(#paint140_linear_2204_11443)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M417.057 284.834C417.057 283.984 417.394 283.169 417.995 282.568C418.596 281.967 419.411 281.63 420.261 281.63C421.111 281.63 421.926 281.967 422.527 282.568C423.128 283.169 423.466 283.984 423.466 284.834V291.831C423.466 292.681 423.128 293.496 422.527 294.097C421.926 294.698 421.111 295.036 420.261 295.036C419.411 295.036 418.596 294.698 417.995 294.097C417.394 293.496 417.057 292.681 417.057 291.831V284.834ZM419.17 291.943C419.17 292.909 419.589 293.272 420.261 293.272C420.933 293.272 421.353 292.909 421.353 291.943V284.708C421.353 283.743 420.933 283.379 420.261 283.379C419.589 283.379 419.17 283.743 419.17 284.708V291.943Z",
    fill: "url(#paint141_linear_2204_11443)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M424.657 284.834C424.628 284.397 424.69 283.958 424.837 283.545C424.985 283.131 425.216 282.753 425.515 282.433C425.815 282.113 426.177 281.857 426.58 281.683C426.982 281.508 427.416 281.418 427.855 281.418C428.294 281.418 428.728 281.508 429.13 281.683C429.532 281.857 429.895 282.113 430.194 282.433C430.494 282.753 430.725 283.131 430.873 283.545C431.02 283.958 431.081 284.397 431.052 284.834V291.831C431.081 292.269 431.02 292.708 430.873 293.121C430.725 293.534 430.494 293.912 430.194 294.233C429.895 294.553 429.532 294.808 429.13 294.983C428.728 295.157 428.294 295.247 427.855 295.247C427.416 295.247 426.982 295.157 426.58 294.983C426.177 294.808 425.815 294.553 425.515 294.233C425.216 293.912 424.985 293.534 424.837 293.121C424.69 292.708 424.628 292.269 424.657 291.831V284.834ZM426.756 291.943C426.756 292.909 427.19 293.272 427.862 293.272C428.534 293.272 428.953 292.909 428.953 291.943V284.708C428.953 283.743 428.52 283.379 427.862 283.379C427.204 283.379 426.756 283.743 426.756 284.708V291.943Z",
    fill: "url(#paint142_linear_2204_11443)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M432.24 284.834C432.24 283.984 432.578 283.169 433.179 282.568C433.78 281.967 434.595 281.63 435.445 281.63C436.295 281.63 437.11 281.967 437.711 282.568C438.312 283.169 438.649 283.984 438.649 284.834V291.831C438.649 292.681 438.312 293.496 437.711 294.097C437.11 294.698 436.295 295.036 435.445 295.036C434.595 295.036 433.78 294.698 433.179 294.097C432.578 293.496 432.24 292.681 432.24 291.831V284.834ZM434.353 291.943C434.353 292.909 434.773 293.272 435.445 293.272C436.116 293.272 436.536 292.909 436.536 291.943V284.708C436.536 283.743 436.116 283.379 435.445 283.379C434.773 283.379 434.353 283.743 434.353 284.708V291.943Z",
    fill: "url(#paint143_linear_2204_11443)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M439.838 284.834C439.838 284.413 439.921 283.997 440.082 283.608C440.243 283.219 440.479 282.866 440.776 282.568C441.074 282.271 441.427 282.035 441.816 281.874C442.205 281.713 442.622 281.63 443.042 281.63C443.463 281.63 443.88 281.713 444.269 281.874C444.657 282.035 445.011 282.271 445.308 282.568C445.606 282.866 445.842 283.219 446.003 283.608C446.164 283.997 446.247 284.413 446.247 284.834V291.831C446.247 292.252 446.164 292.669 446.003 293.057C445.842 293.446 445.606 293.799 445.308 294.097C445.011 294.395 444.657 294.631 444.269 294.792C443.88 294.953 443.463 295.036 443.042 295.036C442.622 295.036 442.205 294.953 441.816 294.792C441.427 294.631 441.074 294.395 440.776 294.097C440.479 293.799 440.243 293.446 440.082 293.057C439.921 292.669 439.838 292.252 439.838 291.831V284.834ZM441.951 291.943C441.951 292.909 442.371 293.272 443.042 293.272C443.714 293.272 444.134 292.909 444.134 291.943V284.708C444.134 283.743 443.714 283.379 443.042 283.379C442.371 283.379 441.951 283.743 441.951 284.708V291.943Z",
    fill: "url(#paint144_linear_2204_11443)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M447.437 284.834C447.408 284.397 447.469 283.958 447.616 283.545C447.764 283.131 447.995 282.753 448.295 282.433C448.594 282.113 448.957 281.857 449.359 281.683C449.762 281.508 450.196 281.418 450.634 281.418C451.073 281.418 451.507 281.508 451.909 281.683C452.312 281.857 452.674 282.113 452.974 282.433C453.273 282.753 453.504 283.131 453.652 283.545C453.799 283.958 453.861 284.397 453.832 284.834V291.831C453.861 292.269 453.799 292.708 453.652 293.121C453.504 293.534 453.273 293.912 452.974 294.233C452.674 294.553 452.312 294.808 451.909 294.983C451.507 295.157 451.073 295.247 450.634 295.247C450.196 295.247 449.762 295.157 449.359 294.983C448.957 294.808 448.594 294.553 448.295 294.233C447.995 293.912 447.764 293.534 447.616 293.121C447.469 292.708 447.408 292.269 447.437 291.831V284.834ZM449.536 291.943C449.536 292.909 449.956 293.272 450.627 293.272C451.299 293.272 451.719 292.909 451.719 291.943V284.708C451.719 283.743 451.299 283.379 450.627 283.379C449.956 283.379 449.536 283.743 449.536 284.708V291.943Z",
    fill: "url(#paint145_linear_2204_11443)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M460.969 284.834C460.969 283.984 461.306 283.169 461.907 282.568C462.508 281.967 463.323 281.63 464.173 281.63C465.023 281.63 465.838 281.967 466.439 282.568C467.04 283.169 467.378 283.984 467.378 284.834V291.831C467.378 292.681 467.04 293.496 466.439 294.097C465.838 294.698 465.023 295.036 464.173 295.036C463.323 295.036 462.508 294.698 461.907 294.097C461.306 293.496 460.969 292.681 460.969 291.831V284.834ZM463.082 291.943C463.082 292.909 463.502 293.272 464.173 293.272C464.845 293.272 465.265 292.909 465.265 291.943V284.708C465.265 283.743 464.845 283.379 464.173 283.379C463.502 283.379 463.082 283.743 463.082 284.708V291.943Z",
    fill: "url(#paint146_linear_2204_11443)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M470.037 283.309C470.567 283.372 471.1 283.232 471.531 282.918C471.962 282.604 472.258 282.139 472.36 281.616H473.76V295.036H471.647V284.792H470.023L470.037 283.309Z",
    fill: "url(#paint147_linear_2204_11443)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M476.152 284.834C476.152 283.984 476.49 283.169 477.091 282.568C477.692 281.967 478.507 281.63 479.357 281.63C480.207 281.63 481.022 281.967 481.623 282.568C482.224 283.169 482.561 283.984 482.561 284.834V291.831C482.561 292.681 482.224 293.496 481.623 294.097C481.022 294.698 480.207 295.036 479.357 295.036C478.507 295.036 477.692 294.698 477.091 294.097C476.49 293.496 476.152 292.681 476.152 291.831V284.834ZM478.265 291.943C478.265 292.909 478.685 293.272 479.357 293.272C480.029 293.272 480.448 292.909 480.448 291.943V284.708C480.448 283.743 480.029 283.379 479.357 283.379C478.685 283.379 478.265 283.743 478.265 284.708V291.943Z",
    fill: "url(#paint148_linear_2204_11443)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M485.219 283.309C485.749 283.375 486.284 283.237 486.716 282.923C487.147 282.608 487.443 282.141 487.542 281.616H488.941V295.036H486.842V284.792H485.205L485.219 283.309Z",
    fill: "url(#paint149_linear_2204_11443)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M491.336 284.834C491.336 283.984 491.674 283.169 492.275 282.568C492.875 281.967 493.691 281.63 494.54 281.63C495.39 281.63 496.205 281.967 496.806 282.568C497.407 283.169 497.745 283.984 497.745 284.834V291.831C497.745 292.681 497.407 293.496 496.806 294.097C496.205 294.698 495.39 295.036 494.54 295.036C493.691 295.036 492.875 294.698 492.275 294.097C491.674 293.496 491.336 292.681 491.336 291.831V284.834ZM493.449 291.943C493.449 292.909 493.869 293.272 494.54 293.272C495.212 293.272 495.632 292.909 495.632 291.943V284.708C495.632 283.743 495.212 283.379 494.54 283.379C493.869 283.379 493.449 283.743 493.449 284.708V291.943Z",
    fill: "url(#paint150_linear_2204_11443)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M500.389 283.309C500.919 283.375 501.454 283.237 501.885 282.923C502.317 282.608 502.612 282.141 502.712 281.616H504.111V295.036H502.012V284.792H500.389V283.309Z",
    fill: "url(#paint151_linear_2204_11443)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M506.518 284.834C506.518 283.984 506.855 283.169 507.456 282.568C508.057 281.967 508.872 281.63 509.722 281.63C510.572 281.63 511.387 281.967 511.988 282.568C512.589 283.169 512.927 283.984 512.927 284.834V291.831C512.927 292.681 512.589 293.496 511.988 294.097C511.387 294.698 510.572 295.036 509.722 295.036C508.872 295.036 508.057 294.698 507.456 294.097C506.855 293.496 506.518 292.681 506.518 291.831V284.834ZM508.631 291.943C508.631 292.909 509.05 293.272 509.722 293.272C510.394 293.272 510.814 292.909 510.814 291.943V284.708C510.814 283.743 510.394 283.379 509.722 283.379C509.05 283.379 508.631 283.743 508.631 284.708V291.943Z",
    fill: "url(#paint152_linear_2204_11443)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M145.697 307.826C145.697 306.976 146.035 306.161 146.636 305.56C147.237 304.959 148.052 304.621 148.902 304.621C149.752 304.621 150.567 304.959 151.168 305.56C151.769 306.161 152.106 306.976 152.106 307.826V314.822C152.106 315.672 151.769 316.487 151.168 317.088C150.567 317.689 149.752 318.027 148.902 318.027C148.052 318.027 147.237 317.689 146.636 317.088C146.035 316.487 145.697 315.672 145.697 314.822V307.826ZM147.754 314.962C147.754 315.914 148.174 316.278 148.846 316.278C149.517 316.278 149.937 315.914 149.937 314.962V307.714C149.937 306.748 149.517 306.384 148.846 306.384C148.174 306.384 147.754 306.748 147.754 307.714V314.962Z",
    fill: "url(#paint153_linear_2204_11443)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M154.75 306.314C155.28 306.384 155.817 306.247 156.25 305.932C156.682 305.617 156.977 305.148 157.073 304.621H158.472V318.041H156.373V307.826H154.75V306.314Z",
    fill: "url(#paint154_linear_2204_11443)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M160.879 307.826C160.879 306.976 161.217 306.161 161.817 305.56C162.418 304.959 163.234 304.621 164.083 304.621C164.933 304.621 165.748 304.959 166.349 305.56C166.95 306.161 167.288 306.976 167.288 307.826V314.822C167.288 315.672 166.95 316.487 166.349 317.088C165.748 317.689 164.933 318.027 164.083 318.027C163.234 318.027 162.418 317.689 161.817 317.088C161.217 316.487 160.879 315.672 160.879 314.822V307.826ZM162.992 314.948C162.992 315.9 163.412 316.264 164.083 316.264C164.755 316.264 165.175 315.9 165.175 314.948V307.7C165.175 306.734 164.755 306.37 164.083 306.37C163.412 306.37 162.992 306.734 162.992 307.7V314.948Z",
    fill: "url(#paint155_linear_2204_11443)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M169.946 306.314C170.477 306.384 171.014 306.247 171.446 305.932C171.879 305.617 172.173 305.148 172.269 304.621H173.669V318.041H171.542V307.826H169.904L169.946 306.314Z",
    fill: "url(#paint156_linear_2204_11443)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M176.077 307.826C176.048 307.388 176.11 306.949 176.257 306.536C176.405 306.123 176.635 305.744 176.935 305.424C177.235 305.104 177.597 304.849 178 304.674C178.402 304.499 178.836 304.409 179.275 304.409C179.713 304.409 180.147 304.499 180.55 304.674C180.952 304.849 181.315 305.104 181.614 305.424C181.914 305.744 182.145 306.123 182.293 306.536C182.44 306.949 182.501 307.388 182.472 307.826V314.822C182.501 315.26 182.44 315.699 182.293 316.112C182.145 316.525 181.914 316.904 181.614 317.224C181.315 317.544 180.952 317.799 180.55 317.974C180.147 318.148 179.713 318.238 179.275 318.238C178.836 318.238 178.402 318.148 178 317.974C177.597 317.799 177.235 317.544 176.935 317.224C176.635 316.904 176.405 316.525 176.257 316.112C176.11 315.699 176.048 315.26 176.077 314.822V307.826ZM178.176 314.948C178.176 315.9 178.596 316.264 179.268 316.264C179.94 316.264 180.359 315.9 180.359 314.948V307.7C180.359 306.734 179.94 306.37 179.268 306.37C178.596 306.37 178.176 306.734 178.176 307.7V314.948Z",
    fill: "url(#paint157_linear_2204_11443)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M185.143 306.314C185.672 306.384 186.207 306.246 186.637 305.931C187.068 305.616 187.359 305.146 187.452 304.621H188.851V318.041H186.738V307.826H185.115L185.143 306.314Z",
    fill: "url(#paint158_linear_2204_11443)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M192.729 306.314C193.259 306.384 193.796 306.247 194.229 305.932C194.661 305.617 194.956 305.148 195.052 304.621H196.451V318.041H194.352V307.826H192.715L192.729 306.314Z",
    fill: "url(#paint159_linear_2204_11443)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M200.327 306.314C200.856 306.381 201.392 306.242 201.823 305.928C202.255 305.613 202.55 305.146 202.649 304.621H204.049V318.041H201.936V307.826H200.312L200.327 306.314Z",
    fill: "url(#paint160_linear_2204_11443)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M207.926 306.314C208.456 306.384 208.993 306.247 209.426 305.932C209.858 305.617 210.153 305.148 210.249 304.621H211.648V318.041H209.535V307.826H207.926V306.314Z",
    fill: "url(#paint161_linear_2204_11443)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M215.51 306.314C216.04 306.381 216.575 306.242 217.007 305.928C217.438 305.613 217.734 305.146 217.833 304.621H219.232V318.041H217.119V307.826H215.496L215.51 306.314Z",
    fill: "url(#paint162_linear_2204_11443)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M223.108 306.314C223.637 306.384 224.172 306.246 224.602 305.931C225.032 305.616 225.324 305.146 225.417 304.621H226.816V318.041H224.717V307.826H223.094L223.108 306.314Z",
    fill: "url(#paint163_linear_2204_11443)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M230.692 306.314C231.222 306.384 231.759 306.247 232.192 305.932C232.624 305.617 232.919 305.148 233.015 304.621H234.414V318.041H232.315V307.826H230.678L230.692 306.314Z",
    fill: "url(#paint164_linear_2204_11443)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M236.807 307.826C236.807 306.976 237.144 306.161 237.745 305.56C238.346 304.959 239.161 304.621 240.011 304.621C240.861 304.621 241.676 304.959 242.277 305.56C242.878 306.161 243.216 306.976 243.216 307.826V314.822C243.216 315.672 242.878 316.487 242.277 317.088C241.676 317.689 240.861 318.027 240.011 318.027C239.161 318.027 238.346 317.689 237.745 317.088C237.144 316.487 236.807 315.672 236.807 314.822V307.826ZM238.92 314.948C238.92 315.9 239.339 316.264 240.011 316.264C240.683 316.264 241.103 315.9 241.103 314.948V307.7C241.103 306.734 240.683 306.37 240.011 306.37C239.339 306.37 238.92 306.734 238.92 307.7V314.948Z",
    fill: "url(#paint165_linear_2204_11443)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M245.875 306.314C246.406 306.384 246.943 306.247 247.375 305.932C247.808 305.617 248.102 305.148 248.198 304.621H249.598V318.041H247.499V307.826H245.861L245.875 306.314Z",
    fill: "url(#paint166_linear_2204_11443)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M256.442 306.314C256.972 306.384 257.509 306.247 257.942 305.932C258.374 305.617 258.669 305.148 258.765 304.621H260.164V318.041H258.065V307.826H256.428L256.442 306.314Z",
    fill: "url(#paint167_linear_2204_11443)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M262.5 307.826C262.5 306.976 262.838 306.161 263.439 305.56C264.04 304.959 264.855 304.621 265.705 304.621C266.554 304.621 267.369 304.959 267.97 305.56C268.571 306.161 268.909 306.976 268.909 307.826V314.822C268.909 315.672 268.571 316.487 267.97 317.088C267.369 317.689 266.554 318.027 265.705 318.027C264.855 318.027 264.04 317.689 263.439 317.088C262.838 316.487 262.5 315.672 262.5 314.822V307.826ZM264.613 314.948C264.613 315.9 265.033 316.264 265.705 316.264C266.376 316.264 266.796 315.9 266.796 314.948V307.7C266.796 306.734 266.376 306.37 265.705 306.37C265.033 306.37 264.613 306.734 264.613 307.7V314.948Z",
    fill: "url(#paint168_linear_2204_11443)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M271.624 306.314C272.154 306.384 272.691 306.247 273.124 305.932C273.556 305.617 273.851 305.148 273.947 304.621H275.346V318.041H273.233V307.826H271.596L271.624 306.314Z",
    fill: "url(#paint169_linear_2204_11443)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M282.188 306.314C282.719 306.384 283.256 306.247 283.688 305.932C284.12 305.617 284.415 305.148 284.511 304.621H285.91V318.041H283.797V307.826H282.16L282.188 306.314Z",
    fill: "url(#paint170_linear_2204_11443)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M291.284 307.826C291.255 307.388 291.317 306.949 291.464 306.536C291.612 306.123 291.843 305.744 292.142 305.424C292.442 305.104 292.804 304.849 293.207 304.674C293.609 304.499 294.043 304.409 294.482 304.409C294.921 304.409 295.354 304.499 295.757 304.674C296.159 304.849 296.522 305.104 296.821 305.424C297.121 305.744 297.352 306.123 297.5 306.536C297.647 306.949 297.708 307.388 297.679 307.826V314.822C297.708 315.26 297.647 315.699 297.5 316.112C297.352 316.525 297.121 316.904 296.821 317.224C296.522 317.544 296.159 317.799 295.757 317.974C295.354 318.148 294.921 318.238 294.482 318.238C294.043 318.238 293.609 318.148 293.207 317.974C292.804 317.799 292.442 317.544 292.142 317.224C291.843 316.904 291.612 316.525 291.464 316.112C291.317 315.699 291.255 315.26 291.284 314.822V307.826ZM293.397 314.948C293.397 315.9 293.817 316.264 294.489 316.264C295.161 316.264 295.58 315.9 295.58 314.948V307.7C295.58 306.734 295.161 306.37 294.489 306.37C293.817 306.37 293.397 306.734 293.397 307.7V314.948Z",
    fill: "url(#paint171_linear_2204_11443)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M300.352 306.314C300.882 306.381 301.417 306.242 301.849 305.928C302.28 305.613 302.576 305.146 302.675 304.621H304.074V318.041H301.961V307.826H300.338L300.352 306.314Z",
    fill: "url(#paint172_linear_2204_11443)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M307.95 306.314C308.479 306.384 309.014 306.246 309.444 305.931C309.874 305.616 310.166 305.146 310.259 304.621H311.658V318.041H309.545V307.826H307.922L307.95 306.314Z",
    fill: "url(#paint173_linear_2204_11443)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M315.535 306.314C316.066 306.384 316.603 306.247 317.035 305.932C317.467 305.617 317.762 305.148 317.858 304.621H319.257V318.041H317.158V307.826H315.535V306.314Z",
    fill: "url(#paint174_linear_2204_11443)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M323.133 306.314C323.662 306.384 324.198 306.246 324.628 305.931C325.058 305.616 325.35 305.146 325.442 304.621H326.842V318.041H324.729V307.826H323.105L323.133 306.314Z",
    fill: "url(#paint175_linear_2204_11443)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M330.717 306.314C331.248 306.384 331.785 306.247 332.217 305.932C332.649 305.617 332.944 305.148 333.04 304.621H334.439V318.041H332.34V307.826H330.703L330.717 306.314Z",
    fill: "url(#paint176_linear_2204_11443)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M336.832 307.826C336.832 307.405 336.915 306.988 337.076 306.599C337.237 306.211 337.473 305.857 337.771 305.56C338.068 305.262 338.421 305.026 338.81 304.865C339.199 304.704 339.616 304.621 340.037 304.621C340.457 304.621 340.874 304.704 341.263 304.865C341.652 305.026 342.005 305.262 342.302 305.56C342.6 305.857 342.836 306.211 342.997 306.599C343.158 306.988 343.241 307.405 343.241 307.826V314.822C343.241 315.243 343.158 315.66 342.997 316.049C342.836 316.437 342.6 316.791 342.302 317.088C342.005 317.386 341.652 317.622 341.263 317.783C340.874 317.944 340.457 318.027 340.037 318.027C339.616 318.027 339.199 317.944 338.81 317.783C338.421 317.622 338.068 317.386 337.771 317.088C337.473 316.791 337.237 316.437 337.076 316.049C336.915 315.66 336.832 315.243 336.832 314.822V307.826ZM338.945 314.948C338.945 315.9 339.365 316.264 340.037 316.264C340.708 316.264 341.128 315.9 341.128 314.948V307.7C341.128 306.734 340.708 306.37 340.037 306.37C339.365 306.37 338.945 306.734 338.945 307.7V314.948Z",
    fill: "url(#paint177_linear_2204_11443)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M345.9 306.314C346.431 306.384 346.968 306.247 347.4 305.932C347.833 305.617 348.127 305.148 348.223 304.621H349.623V318.041H347.51V307.826H345.9V306.314Z",
    fill: "url(#paint178_linear_2204_11443)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M352.058 307.826C352.029 307.388 352.09 306.949 352.238 306.536C352.385 306.123 352.616 305.744 352.916 305.424C353.215 305.104 353.578 304.849 353.98 304.674C354.383 304.499 354.817 304.409 355.255 304.409C355.694 304.409 356.128 304.499 356.53 304.674C356.933 304.849 357.295 305.104 357.595 305.424C357.895 305.744 358.125 306.123 358.273 306.536C358.421 306.949 358.482 307.388 358.453 307.826V314.822C358.482 315.26 358.421 315.699 358.273 316.112C358.125 316.525 357.895 316.904 357.595 317.224C357.295 317.544 356.933 317.799 356.53 317.974C356.128 318.148 355.694 318.238 355.255 318.238C354.817 318.238 354.383 318.148 353.98 317.974C353.578 317.799 353.215 317.544 352.916 317.224C352.616 316.904 352.385 316.525 352.238 316.112C352.09 315.699 352.029 315.26 352.058 314.822V307.826ZM354.157 314.948C354.157 315.9 354.577 316.264 355.248 316.264C355.92 316.264 356.34 315.9 356.34 314.948V307.7C356.34 306.734 355.92 306.37 355.248 306.37C354.577 306.37 354.157 306.734 354.157 307.7V314.948Z",
    fill: "url(#paint179_linear_2204_11443)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M361.098 306.314C361.627 306.384 362.162 306.246 362.592 305.931C363.023 305.616 363.314 305.146 363.407 304.621H364.807V318.041H362.694V307.826H361.07L361.098 306.314Z",
    fill: "url(#paint180_linear_2204_11443)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M367.212 307.826C367.183 307.388 367.244 306.949 367.392 306.536C367.539 306.123 367.77 305.744 368.07 305.424C368.37 305.104 368.732 304.849 369.135 304.674C369.537 304.499 369.971 304.409 370.41 304.409C370.848 304.409 371.282 304.499 371.685 304.674C372.087 304.849 372.449 305.104 372.749 305.424C373.049 305.744 373.28 306.123 373.427 306.536C373.575 306.949 373.636 307.388 373.607 307.826V314.822C373.636 315.26 373.575 315.699 373.427 316.112C373.28 316.525 373.049 316.904 372.749 317.224C372.449 317.544 372.087 317.799 371.685 317.974C371.282 318.148 370.848 318.238 370.41 318.238C369.971 318.238 369.537 318.148 369.135 317.974C368.732 317.799 368.37 317.544 368.07 317.224C367.77 316.904 367.539 316.525 367.392 316.112C367.244 315.699 367.183 315.26 367.212 314.822V307.826ZM369.311 314.948C369.311 315.9 369.745 316.264 370.417 316.264C371.088 316.264 371.508 315.9 371.508 314.948V307.7C371.508 306.734 371.074 306.37 370.417 306.37C369.759 306.37 369.311 306.734 369.311 307.7V314.948Z",
    fill: "url(#paint181_linear_2204_11443)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M376.28 306.314C376.81 306.381 377.345 306.242 377.776 305.928C378.208 305.613 378.503 305.146 378.603 304.621H380.002V318.041H377.889V307.826H376.266L376.28 306.314Z",
    fill: "url(#paint182_linear_2204_11443)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M391.311 307.826C391.311 306.976 391.648 306.161 392.249 305.56C392.85 304.959 393.665 304.621 394.515 304.621C395.365 304.621 396.18 304.959 396.781 305.56C397.382 306.161 397.72 306.976 397.72 307.826V314.822C397.72 315.672 397.382 316.487 396.781 317.088C396.18 317.689 395.365 318.027 394.515 318.027C393.665 318.027 392.85 317.689 392.249 317.088C391.648 316.487 391.311 315.672 391.311 314.822V307.826ZM393.424 314.948C393.424 315.9 393.843 316.264 394.515 316.264C395.187 316.264 395.607 315.9 395.607 314.948V307.7C395.607 306.734 395.187 306.37 394.515 306.37C393.843 306.37 393.424 306.734 393.424 307.7V314.948Z",
    fill: "url(#paint183_linear_2204_11443)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M400.377 306.314C400.908 306.384 401.445 306.247 401.877 305.932C402.31 305.617 402.604 305.148 402.7 304.621H404.1V318.041H402.001V307.826H400.363L400.377 306.314Z",
    fill: "url(#paint184_linear_2204_11443)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M406.492 307.826C406.492 306.976 406.83 306.161 407.431 305.56C408.032 304.959 408.847 304.621 409.697 304.621C410.547 304.621 411.362 304.959 411.963 305.56C412.564 306.161 412.901 306.976 412.901 307.826V314.822C412.901 315.672 412.564 316.487 411.963 317.088C411.362 317.689 410.547 318.027 409.697 318.027C408.847 318.027 408.032 317.689 407.431 317.088C406.83 316.487 406.492 315.672 406.492 314.822V307.826ZM408.605 314.948C408.605 315.9 409.025 316.264 409.697 316.264C410.368 316.264 410.788 315.9 410.788 314.948V307.7C410.788 306.734 410.368 306.37 409.697 306.37C409.025 306.37 408.605 306.734 408.605 307.7V314.948Z",
    fill: "url(#paint185_linear_2204_11443)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M415.559 306.314C416.089 306.384 416.626 306.247 417.059 305.932C417.491 305.617 417.786 305.148 417.882 304.621H419.281V318.041H417.182V307.826H415.545L415.559 306.314Z",
    fill: "url(#paint186_linear_2204_11443)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M423.16 306.314C423.69 306.381 424.225 306.242 424.657 305.928C425.089 305.613 425.384 305.146 425.483 304.621H426.882V318.041H424.825V307.826H423.202L423.16 306.314Z",
    fill: "url(#paint187_linear_2204_11443)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M430.744 306.314C431.275 306.384 431.812 306.247 432.244 305.932C432.676 305.617 432.971 305.148 433.067 304.621H434.466V318.041H432.381V307.826H430.744V306.314Z",
    fill: "url(#paint188_linear_2204_11443)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M436.872 307.826C436.843 307.388 436.904 306.949 437.052 306.536C437.2 306.123 437.43 305.744 437.73 305.424C438.03 305.104 438.392 304.849 438.795 304.674C439.197 304.499 439.631 304.409 440.07 304.409C440.508 304.409 440.942 304.499 441.345 304.674C441.747 304.849 442.11 305.104 442.409 305.424C442.709 305.744 442.94 306.123 443.087 306.536C443.235 306.949 443.296 307.388 443.267 307.826V314.822C443.296 315.26 443.235 315.699 443.087 316.112C442.94 316.525 442.709 316.904 442.409 317.224C442.11 317.544 441.747 317.799 441.345 317.974C440.942 318.148 440.508 318.238 440.07 318.238C439.631 318.238 439.197 318.148 438.795 317.974C438.392 317.799 438.03 317.544 437.73 317.224C437.43 316.904 437.2 316.525 437.052 316.112C436.904 315.699 436.843 315.26 436.872 314.822V307.826ZM438.971 314.948C438.971 315.9 439.391 316.264 440.063 316.264C440.734 316.264 441.154 315.9 441.154 314.948V307.7C441.154 306.734 440.734 306.37 440.063 306.37C439.391 306.37 438.971 306.734 438.971 307.7V314.948Z",
    fill: "url(#paint189_linear_2204_11443)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M445.94 306.314C446.469 306.384 447.004 306.246 447.434 305.931C447.864 305.616 448.156 305.146 448.249 304.621H449.648V318.041H447.535V307.826H445.912L445.94 306.314Z",
    fill: "url(#paint190_linear_2204_11443)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M453.524 306.314C454.055 306.384 454.592 306.247 455.024 305.932C455.456 305.617 455.751 305.148 455.847 304.621H457.246V318.041H455.133V307.826H453.496L453.524 306.314Z",
    fill: "url(#paint191_linear_2204_11443)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M461.123 306.314C461.653 306.381 462.188 306.242 462.62 305.928C463.051 305.613 463.347 305.146 463.446 304.621H464.845V318.041H462.746V307.826H461.123V306.314Z",
    fill: "url(#paint192_linear_2204_11443)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M468.708 306.314C469.238 306.384 469.775 306.247 470.208 305.932C470.64 305.617 470.935 305.148 471.031 304.621H472.43V318.041H470.317V307.826H468.68L468.708 306.314Z",
    fill: "url(#paint193_linear_2204_11443)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M476.307 306.314C476.837 306.381 477.372 306.242 477.803 305.928C478.235 305.613 478.53 305.146 478.63 304.621H480.029V318.041H478V307.826H476.377L476.307 306.314Z",
    fill: "url(#paint194_linear_2204_11443)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M483.905 306.314C484.434 306.384 484.969 306.246 485.399 305.931C485.829 305.616 486.121 305.146 486.214 304.621H487.613V318.041H485.5V307.826H483.877L483.905 306.314Z",
    fill: "url(#paint195_linear_2204_11443)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M492.986 307.826C492.986 306.976 493.324 306.161 493.925 305.56C494.526 304.959 495.341 304.621 496.191 304.621C497.041 304.621 497.856 304.959 498.457 305.56C499.058 306.161 499.395 306.976 499.395 307.826V314.822C499.395 315.672 499.058 316.487 498.457 317.088C497.856 317.689 497.041 318.027 496.191 318.027C495.341 318.027 494.526 317.689 493.925 317.088C493.324 316.487 492.986 315.672 492.986 314.822V307.826ZM495.099 314.948C495.099 315.9 495.519 316.264 496.191 316.264C496.863 316.264 497.282 315.9 497.282 314.948V307.7C497.282 306.734 496.863 306.37 496.191 306.37C495.519 306.37 495.099 306.734 495.099 307.7V314.948Z",
    fill: "url(#paint196_linear_2204_11443)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M502.055 306.314C502.586 306.384 503.123 306.247 503.555 305.932C503.987 305.617 504.282 305.148 504.378 304.621H505.777V318.041H503.678V307.826H502.041L502.055 306.314Z",
    fill: "url(#paint197_linear_2204_11443)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M509.653 306.314C510.182 306.384 510.717 306.246 511.147 305.931C511.577 305.616 511.869 305.146 511.962 304.621H513.361V318.041H511.248V307.826H509.625L509.653 306.314Z",
    fill: "url(#paint198_linear_2204_11443)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M145.697 331.475C145.697 330.625 146.035 329.81 146.636 329.209C147.237 328.608 148.052 328.27 148.902 328.27C149.752 328.27 150.567 328.608 151.168 329.209C151.769 329.81 152.106 330.625 152.106 331.475V338.471C152.106 339.321 151.769 340.136 151.168 340.737C150.567 341.338 149.752 341.676 148.902 341.676C148.052 341.676 147.237 341.338 146.636 340.737C146.035 340.136 145.697 339.321 145.697 338.471V331.475ZM147.754 338.611C147.754 339.563 148.174 339.927 148.846 339.927C149.517 339.927 149.937 339.563 149.937 338.611V331.363C149.937 330.397 149.517 330.033 148.846 330.033C148.174 330.033 147.754 330.397 147.754 331.363V338.611Z",
    fill: "url(#paint199_linear_2204_11443)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M153.351 331.475C153.322 331.037 153.383 330.598 153.531 330.185C153.678 329.772 153.909 329.393 154.209 329.073C154.508 328.753 154.871 328.498 155.273 328.323C155.676 328.149 156.11 328.058 156.548 328.058C156.987 328.058 157.421 328.149 157.823 328.323C158.226 328.498 158.588 328.753 158.888 329.073C159.188 329.393 159.418 329.772 159.566 330.185C159.714 330.598 159.775 331.037 159.746 331.475V338.471C159.775 338.909 159.714 339.348 159.566 339.761C159.418 340.174 159.188 340.553 158.888 340.873C158.588 341.193 158.226 341.448 157.823 341.623C157.421 341.797 156.987 341.888 156.548 341.888C156.11 341.888 155.676 341.797 155.273 341.623C154.871 341.448 154.508 341.193 154.209 340.873C153.909 340.553 153.678 340.174 153.531 339.761C153.383 339.348 153.322 338.909 153.351 338.471V331.475ZM155.45 338.597C155.45 339.549 155.884 339.913 156.555 339.913C157.227 339.913 157.647 339.549 157.647 338.597V331.349C157.647 330.383 157.213 330.019 156.555 330.019C155.898 330.019 155.45 330.383 155.45 331.349V338.597Z",
    fill: "url(#paint200_linear_2204_11443)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M160.879 331.475C160.879 330.625 161.217 329.81 161.817 329.209C162.418 328.608 163.234 328.27 164.083 328.27C164.933 328.27 165.748 328.608 166.349 329.209C166.95 329.81 167.288 330.625 167.288 331.475V338.471C167.288 339.321 166.95 340.136 166.349 340.737C165.748 341.338 164.933 341.676 164.083 341.676C163.234 341.676 162.418 341.338 161.817 340.737C161.217 340.136 160.879 339.321 160.879 338.471V331.475ZM162.992 338.597C162.992 339.549 163.412 339.913 164.083 339.913C164.755 339.913 165.175 339.549 165.175 338.597V331.349C165.175 330.383 164.755 330.019 164.083 330.019C163.412 330.019 162.992 330.383 162.992 331.349V338.597Z",
    fill: "url(#paint201_linear_2204_11443)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M169.946 329.949C170.477 330.019 171.014 329.882 171.446 329.567C171.879 329.252 172.173 328.783 172.269 328.256H173.669V341.676H171.542V331.447H169.904L169.946 329.949Z",
    fill: "url(#paint202_linear_2204_11443)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M180.51 329.949C181.041 330.019 181.578 329.882 182.01 329.567C182.443 329.252 182.737 328.783 182.833 328.256H184.233V341.676H182.12V331.447H180.482L180.51 329.949Z",
    fill: "url(#paint203_linear_2204_11443)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M188.111 329.949C188.641 330.016 189.177 329.877 189.608 329.563C190.04 329.248 190.335 328.781 190.434 328.256H191.834V341.676H189.735V331.447H188.111V329.949Z",
    fill: "url(#paint204_linear_2204_11443)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M195.71 329.949C196.238 330.019 196.774 329.881 197.204 329.566C197.634 329.251 197.926 328.781 198.019 328.256H199.418V341.676H197.305V331.447H195.682L195.71 329.949Z",
    fill: "url(#paint205_linear_2204_11443)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M203.293 329.949C203.824 330.019 204.361 329.882 204.793 329.567C205.226 329.252 205.52 328.783 205.616 328.256H207.016V341.676H204.917V331.447H203.279L203.293 329.949Z",
    fill: "url(#paint206_linear_2204_11443)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M210.893 329.949C211.423 330.016 211.958 329.877 212.39 329.563C212.821 329.248 213.117 328.781 213.216 328.256H214.615V341.676H212.502V331.447H210.879L210.893 329.949Z",
    fill: "url(#paint207_linear_2204_11443)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M219.973 331.475C219.973 330.625 220.31 329.81 220.911 329.209C221.512 328.608 222.327 328.27 223.177 328.27C224.027 328.27 224.842 328.608 225.443 329.209C226.044 329.81 226.382 330.625 226.382 331.475V338.471C226.382 339.321 226.044 340.136 225.443 340.737C224.842 341.338 224.027 341.676 223.177 341.676C222.327 341.676 221.512 341.338 220.911 340.737C220.31 340.136 219.973 339.321 219.973 338.471V331.475ZM222.086 338.597C222.086 339.549 222.505 339.913 223.177 339.913C223.849 339.913 224.269 339.549 224.269 338.597V331.349C224.269 330.383 223.849 330.019 223.177 330.019C222.505 330.019 222.086 330.383 222.086 331.349V338.597Z",
    fill: "url(#paint208_linear_2204_11443)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M227.517 331.475C227.488 331.037 227.549 330.598 227.697 330.185C227.844 329.772 228.075 329.393 228.375 329.073C228.674 328.753 229.037 328.498 229.439 328.323C229.842 328.149 230.276 328.058 230.714 328.058C231.153 328.058 231.587 328.149 231.989 328.323C232.392 328.498 232.754 328.753 233.054 329.073C233.354 329.393 233.584 329.772 233.732 330.185C233.88 330.598 233.941 331.037 233.912 331.475V338.471C233.941 338.909 233.88 339.348 233.732 339.761C233.584 340.174 233.354 340.553 233.054 340.873C232.754 341.193 232.392 341.448 231.989 341.623C231.587 341.797 231.153 341.888 230.714 341.888C230.276 341.888 229.842 341.797 229.439 341.623C229.037 341.448 228.674 341.193 228.375 340.873C228.075 340.553 227.844 340.174 227.697 339.761C227.549 339.348 227.488 338.909 227.517 338.471V331.475ZM229.616 338.597C229.616 339.549 230.05 339.913 230.721 339.913C231.393 339.913 231.813 339.549 231.813 338.597V331.349C231.813 330.383 231.393 330.019 230.721 330.019C230.05 330.019 229.616 330.383 229.616 331.349V338.597Z",
    fill: "url(#paint209_linear_2204_11443)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M235.156 331.475C235.156 330.625 235.494 329.81 236.095 329.209C236.696 328.608 237.511 328.27 238.361 328.27C239.211 328.27 240.026 328.608 240.627 329.209C241.228 329.81 241.565 330.625 241.565 331.475V338.471C241.565 339.321 241.228 340.136 240.627 340.737C240.026 341.338 239.211 341.676 238.361 341.676C237.511 341.676 236.696 341.338 236.095 340.737C235.494 340.136 235.156 339.321 235.156 338.471V331.475ZM237.311 338.611C237.311 339.563 237.731 339.927 238.403 339.927C239.074 339.927 239.494 339.563 239.494 338.611V331.363C239.494 330.397 239.074 330.033 238.403 330.033C237.731 330.033 237.311 330.397 237.311 331.363V338.611Z",
    fill: "url(#paint210_linear_2204_11443)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M242.756 331.475C242.756 330.625 243.093 329.81 243.694 329.209C244.295 328.608 245.11 328.27 245.96 328.27C246.81 328.27 247.625 328.608 248.226 329.209C248.827 329.81 249.165 330.625 249.165 331.475V338.471C249.165 339.321 248.827 340.136 248.226 340.737C247.625 341.338 246.81 341.676 245.96 341.676C245.11 341.676 244.295 341.338 243.694 340.737C243.093 340.136 242.756 339.321 242.756 338.471V331.475ZM244.869 338.611C244.869 339.563 245.289 339.927 245.96 339.927C246.632 339.927 247.052 339.563 247.052 338.611V331.363C247.052 330.397 246.632 330.033 245.96 330.033C245.289 330.033 244.869 330.397 244.869 331.363V338.611Z",
    fill: "url(#paint211_linear_2204_11443)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M250.353 331.475C250.324 331.037 250.385 330.598 250.532 330.185C250.68 329.772 250.911 329.393 251.211 329.073C251.51 328.753 251.873 328.498 252.275 328.323C252.678 328.149 253.112 328.058 253.55 328.058C253.989 328.058 254.423 328.149 254.825 328.323C255.228 328.498 255.59 328.753 255.89 329.073C256.19 329.393 256.42 329.772 256.568 330.185C256.715 330.598 256.777 331.037 256.748 331.475V338.471C256.777 338.909 256.715 339.348 256.568 339.761C256.42 340.174 256.19 340.553 255.89 340.873C255.59 341.193 255.228 341.448 254.825 341.623C254.423 341.797 253.989 341.888 253.55 341.888C253.112 341.888 252.678 341.797 252.275 341.623C251.873 341.448 251.51 341.193 251.211 340.873C250.911 340.553 250.68 340.174 250.532 339.761C250.385 339.348 250.324 338.909 250.353 338.471V331.475ZM252.452 338.597C252.452 339.549 252.872 339.913 253.543 339.913C254.215 339.913 254.635 339.549 254.635 338.597V331.349C254.635 330.383 254.215 330.019 253.543 330.019C252.872 330.019 252.452 330.383 252.452 331.349V338.597Z",
    fill: "url(#paint212_linear_2204_11443)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M265.299 329.949C265.829 330.019 266.366 329.882 266.799 329.567C267.231 329.252 267.526 328.783 267.622 328.256H269.021V341.676H266.908V331.447H265.299V329.949Z",
    fill: "url(#paint213_linear_2204_11443)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M272.952 329.949C273.481 330.016 274.017 329.877 274.448 329.563C274.88 329.248 275.175 328.781 275.274 328.256H276.674V341.676H274.561V331.447H272.938L272.952 329.949Z",
    fill: "url(#paint214_linear_2204_11443)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M280.553 329.949C281.082 330.019 281.617 329.881 282.047 329.566C282.477 329.251 282.769 328.781 282.862 328.256H284.261V341.676H282.148V331.447H280.553V329.949Z",
    fill: "url(#paint215_linear_2204_11443)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M288.137 329.949C288.672 330.027 289.216 329.894 289.654 329.578C290.093 329.262 290.392 328.788 290.488 328.256H291.887V341.676H289.788V331.447H288.151L288.137 329.949Z",
    fill: "url(#paint216_linear_2204_11443)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M295.735 329.949C296.265 330.016 296.8 329.877 297.231 329.563C297.663 329.248 297.959 328.781 298.058 328.256H299.457V341.676H297.344V331.447H295.721L295.735 329.949Z",
    fill: "url(#paint217_linear_2204_11443)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M303.319 329.949C303.849 330.019 304.386 329.882 304.819 329.567C305.251 329.252 305.546 328.783 305.642 328.256H307.041V341.676H304.942V331.447H303.305L303.319 329.949Z",
    fill: "url(#paint218_linear_2204_11443)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M309.434 331.475C309.434 330.625 309.771 329.81 310.372 329.209C310.973 328.608 311.788 328.27 312.638 328.27C313.488 328.27 314.303 328.608 314.904 329.209C315.505 329.81 315.843 330.625 315.843 331.475V338.471C315.843 339.321 315.505 340.136 314.904 340.737C314.303 341.338 313.488 341.676 312.638 341.676C311.788 341.676 310.973 341.338 310.372 340.737C309.771 340.136 309.434 339.321 309.434 338.471V331.475ZM311.547 338.597C311.547 339.549 311.966 339.913 312.638 339.913C313.31 339.913 313.73 339.549 313.73 338.597V331.349C313.73 330.383 313.31 330.019 312.638 330.019C311.966 330.019 311.547 330.383 311.547 331.349V338.597Z",
    fill: "url(#paint219_linear_2204_11443)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M317.074 331.475C317.074 330.625 317.412 329.81 318.013 329.209C318.614 328.608 319.429 328.27 320.279 328.27C321.129 328.27 321.944 328.608 322.545 329.209C323.146 329.81 323.483 330.625 323.483 331.475V338.471C323.483 339.321 323.146 340.136 322.545 340.737C321.944 341.338 321.129 341.676 320.279 341.676C319.429 341.676 318.614 341.338 318.013 340.737C317.412 340.136 317.074 339.321 317.074 338.471V331.475ZM319.187 338.597C319.187 339.549 319.607 339.913 320.279 339.913C320.95 339.913 321.37 339.549 321.37 338.597V331.349C321.37 330.383 320.95 330.019 320.279 330.019C319.607 330.019 319.187 330.383 319.187 331.349V338.597Z",
    fill: "url(#paint220_linear_2204_11443)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M324.63 331.475C324.601 331.037 324.662 330.598 324.81 330.185C324.957 329.772 325.188 329.393 325.488 329.073C325.788 328.753 326.15 328.498 326.552 328.323C326.955 328.149 327.389 328.058 327.828 328.058C328.266 328.058 328.7 328.149 329.103 328.323C329.505 328.498 329.867 328.753 330.167 329.073C330.467 329.393 330.698 329.772 330.845 330.185C330.993 330.598 331.054 331.037 331.025 331.475V338.471C331.054 338.909 330.993 339.348 330.845 339.761C330.698 340.174 330.467 340.553 330.167 340.873C329.867 341.193 329.505 341.448 329.103 341.623C328.7 341.797 328.266 341.888 327.828 341.888C327.389 341.888 326.955 341.797 326.552 341.623C326.15 341.448 325.788 341.193 325.488 340.873C325.188 340.553 324.957 340.174 324.81 339.761C324.662 339.348 324.601 338.909 324.63 338.471V331.475ZM326.729 338.597C326.729 339.549 327.149 339.913 327.821 339.913C328.492 339.913 328.912 339.549 328.912 338.597V331.349C328.912 330.383 328.492 330.019 327.821 330.019C327.149 330.019 326.729 330.383 326.729 331.349V338.597Z",
    fill: "url(#paint221_linear_2204_11443)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M332.215 331.475C332.215 330.625 332.552 329.81 333.153 329.209C333.754 328.608 334.569 328.27 335.419 328.27C336.269 328.27 337.084 328.608 337.685 329.209C338.286 329.81 338.624 330.625 338.624 331.475V338.471C338.624 339.321 338.286 340.136 337.685 340.737C337.084 341.338 336.269 341.676 335.419 341.676C334.569 341.676 333.754 341.338 333.153 340.737C332.552 340.136 332.215 339.321 332.215 338.471V331.475ZM334.328 338.597C334.328 339.549 334.748 339.913 335.419 339.913C336.091 339.913 336.511 339.549 336.511 338.597V331.349C336.511 330.383 336.091 330.019 335.419 330.019C334.748 330.019 334.328 330.383 334.328 331.349V338.597Z",
    fill: "url(#paint222_linear_2204_11443)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M339.814 331.475C339.785 331.037 339.846 330.598 339.993 330.185C340.141 329.772 340.372 329.393 340.672 329.073C340.971 328.753 341.334 328.498 341.736 328.323C342.139 328.149 342.573 328.058 343.011 328.058C343.45 328.058 343.884 328.149 344.286 328.323C344.689 328.498 345.051 328.753 345.351 329.073C345.65 329.393 345.881 329.772 346.029 330.185C346.176 330.598 346.238 331.037 346.209 331.475V338.471C346.238 338.909 346.176 339.348 346.029 339.761C345.881 340.174 345.65 340.553 345.351 340.873C345.051 341.193 344.689 341.448 344.286 341.623C343.884 341.797 343.45 341.888 343.011 341.888C342.573 341.888 342.139 341.797 341.736 341.623C341.334 341.448 340.971 341.193 340.672 340.873C340.372 340.553 340.141 340.174 339.993 339.761C339.846 339.348 339.785 338.909 339.814 338.471V331.475ZM341.913 338.597C341.913 339.549 342.346 339.913 343.018 339.913C343.69 339.913 344.11 339.549 344.11 338.597V331.349C344.11 330.383 343.676 330.019 343.018 330.019C342.36 330.019 341.913 330.383 341.913 331.349V338.597Z",
    fill: "url(#paint223_linear_2204_11443)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M347.398 331.475C347.398 330.625 347.736 329.81 348.337 329.209C348.938 328.608 349.753 328.27 350.603 328.27C351.453 328.27 352.268 328.608 352.869 329.209C353.47 329.81 353.807 330.625 353.807 331.475V338.471C353.807 339.321 353.47 340.136 352.869 340.737C352.268 341.338 351.453 341.676 350.603 341.676C349.753 341.676 348.938 341.338 348.337 340.737C347.736 340.136 347.398 339.321 347.398 338.471V331.475ZM349.511 338.597C349.511 339.549 349.931 339.913 350.603 339.913C351.275 339.913 351.694 339.549 351.694 338.597V331.349C351.694 330.383 351.275 330.019 350.603 330.019C349.931 330.019 349.511 330.383 349.511 331.349V338.597Z",
    fill: "url(#paint224_linear_2204_11443)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M354.997 331.475C354.968 331.037 355.029 330.598 355.177 330.185C355.325 329.772 355.555 329.393 355.855 329.073C356.155 328.753 356.517 328.498 356.92 328.323C357.322 328.149 357.756 328.058 358.195 328.058C358.633 328.058 359.067 328.149 359.47 328.323C359.872 328.498 360.235 328.753 360.534 329.073C360.834 329.393 361.065 329.772 361.212 330.185C361.36 330.598 361.421 331.037 361.392 331.475V338.471C361.421 338.909 361.36 339.348 361.212 339.761C361.065 340.174 360.834 340.553 360.534 340.873C360.235 341.193 359.872 341.448 359.47 341.623C359.067 341.797 358.633 341.888 358.195 341.888C357.756 341.888 357.322 341.797 356.92 341.623C356.517 341.448 356.155 341.193 355.855 340.873C355.555 340.553 355.325 340.174 355.177 339.761C355.029 339.348 354.968 338.909 354.997 338.471V331.475ZM357.11 338.597C357.11 339.549 357.53 339.913 358.202 339.913C358.873 339.913 359.293 339.549 359.293 338.597V331.349C359.293 330.383 358.873 330.019 358.202 330.019C357.53 330.019 357.11 330.383 357.11 331.349V338.597Z",
    fill: "url(#paint225_linear_2204_11443)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M367.031 329.949C367.562 330.019 368.099 329.882 368.531 329.567C368.964 329.252 369.258 328.783 369.354 328.256H370.753V341.676H368.64V331.447H367.031V329.949Z",
    fill: "url(#paint226_linear_2204_11443)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M374.629 329.949C375.159 330.016 375.694 329.877 376.126 329.563C376.558 329.248 376.853 328.781 376.952 328.256H378.352V341.676H376.238V331.447H374.615L374.629 329.949Z",
    fill: "url(#paint227_linear_2204_11443)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M382.227 329.949C382.756 330.019 383.291 329.881 383.721 329.566C384.152 329.251 384.443 328.781 384.536 328.256H385.935V341.676H383.822V331.447H382.199L382.227 329.949Z",
    fill: "url(#paint228_linear_2204_11443)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M389.84 329.949C390.37 330.019 390.907 329.882 391.34 329.567C391.772 329.252 392.067 328.783 392.163 328.256H393.562V341.676H391.463V331.447H389.84V329.949Z",
    fill: "url(#paint229_linear_2204_11443)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M397.41 329.949C397.94 330.016 398.476 329.877 398.907 329.563C399.339 329.248 399.634 328.781 399.733 328.256H401.133V341.676H399.02V331.447H397.396L397.41 329.949Z",
    fill: "url(#paint230_linear_2204_11443)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M409.431 331.475C409.402 331.037 409.463 330.598 409.611 330.185C409.758 329.772 409.989 329.393 410.289 329.073C410.589 328.753 410.951 328.498 411.353 328.323C411.756 328.149 412.19 328.058 412.628 328.058C413.067 328.058 413.501 328.149 413.903 328.323C414.306 328.498 414.668 328.753 414.968 329.073C415.268 329.393 415.498 329.772 415.646 330.185C415.794 330.598 415.855 331.037 415.826 331.475V338.471C415.855 338.909 415.794 339.348 415.646 339.761C415.498 340.174 415.268 340.553 414.968 340.873C414.668 341.193 414.306 341.448 413.903 341.623C413.501 341.797 413.067 341.888 412.628 341.888C412.19 341.888 411.756 341.797 411.353 341.623C410.951 341.448 410.589 341.193 410.289 340.873C409.989 340.553 409.758 340.174 409.611 339.761C409.463 339.348 409.402 338.909 409.431 338.471V331.475ZM411.53 338.597C411.53 339.549 411.95 339.913 412.621 339.913C413.293 339.913 413.713 339.549 413.713 338.597V331.349C413.713 330.383 413.293 330.019 412.621 330.019C411.95 330.019 411.53 330.383 411.53 331.349V338.597Z",
    fill: "url(#paint231_linear_2204_11443)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M417.057 331.475C417.057 330.625 417.394 329.81 417.995 329.209C418.596 328.608 419.411 328.27 420.261 328.27C421.111 328.27 421.926 328.608 422.527 329.209C423.128 329.81 423.466 330.625 423.466 331.475V338.471C423.466 339.321 423.128 340.136 422.527 340.737C421.926 341.338 421.111 341.676 420.261 341.676C419.411 341.676 418.596 341.338 417.995 340.737C417.394 340.136 417.057 339.321 417.057 338.471V331.475ZM419.226 338.611C419.226 339.563 419.645 339.927 420.317 339.927C420.989 339.927 421.409 339.563 421.409 338.611V331.363C421.409 330.397 420.989 330.033 420.317 330.033C419.645 330.033 419.226 330.397 419.226 331.363V338.611Z",
    fill: "url(#paint232_linear_2204_11443)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M424.657 331.475C424.628 331.037 424.69 330.598 424.837 330.185C424.985 329.772 425.216 329.393 425.515 329.073C425.815 328.753 426.177 328.498 426.58 328.323C426.982 328.149 427.416 328.058 427.855 328.058C428.294 328.058 428.728 328.149 429.13 328.323C429.532 328.498 429.895 328.753 430.194 329.073C430.494 329.393 430.725 329.772 430.873 330.185C431.02 330.598 431.081 331.037 431.052 331.475V338.471C431.081 338.909 431.02 339.348 430.873 339.761C430.725 340.174 430.494 340.553 430.194 340.873C429.895 341.193 429.532 341.448 429.13 341.623C428.728 341.797 428.294 341.888 427.855 341.888C427.416 341.888 426.982 341.797 426.58 341.623C426.177 341.448 425.815 341.193 425.515 340.873C425.216 340.553 424.985 340.174 424.837 339.761C424.69 339.348 424.628 338.909 424.657 338.471V331.475ZM426.756 338.597C426.756 339.549 427.19 339.913 427.862 339.913C428.534 339.913 428.953 339.549 428.953 338.597V331.349C428.953 330.383 428.52 330.019 427.862 330.019C427.204 330.019 426.756 330.383 426.756 331.349V338.597Z",
    fill: "url(#paint233_linear_2204_11443)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M432.24 331.475C432.24 330.625 432.578 329.81 433.179 329.209C433.78 328.608 434.595 328.27 435.445 328.27C436.295 328.27 437.11 328.608 437.711 329.209C438.312 329.81 438.649 330.625 438.649 331.475V338.471C438.649 339.321 438.312 340.136 437.711 340.737C437.11 341.338 436.295 341.676 435.445 341.676C434.595 341.676 433.78 341.338 433.179 340.737C432.578 340.136 432.24 339.321 432.24 338.471V331.475ZM434.353 338.597C434.353 339.549 434.773 339.913 435.445 339.913C436.116 339.913 436.536 339.549 436.536 338.597V331.349C436.536 330.383 436.116 330.019 435.445 330.019C434.773 330.019 434.353 330.383 434.353 331.349V338.597Z",
    fill: "url(#paint234_linear_2204_11443)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M439.838 331.475C439.838 331.054 439.921 330.637 440.082 330.248C440.243 329.86 440.479 329.506 440.776 329.209C441.074 328.911 441.427 328.675 441.816 328.514C442.205 328.353 442.622 328.27 443.042 328.27C443.463 328.27 443.88 328.353 444.269 328.514C444.657 328.675 445.011 328.911 445.308 329.209C445.606 329.506 445.842 329.86 446.003 330.248C446.164 330.637 446.247 331.054 446.247 331.475V338.471C446.247 338.892 446.164 339.309 446.003 339.698C445.842 340.087 445.606 340.44 445.308 340.737C445.011 341.035 444.657 341.271 444.269 341.432C443.88 341.593 443.463 341.676 443.042 341.676C442.622 341.676 442.205 341.593 441.816 341.432C441.427 341.271 441.074 341.035 440.776 340.737C440.479 340.44 440.243 340.087 440.082 339.698C439.921 339.309 439.838 338.892 439.838 338.471V331.475ZM441.951 338.597C441.951 339.549 442.371 339.913 443.042 339.913C443.714 339.913 444.134 339.549 444.134 338.597V331.349C444.134 330.383 443.714 330.019 443.042 330.019C442.371 330.019 441.951 330.383 441.951 331.349V338.597Z",
    fill: "url(#paint235_linear_2204_11443)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M447.437 331.475C447.408 331.037 447.469 330.598 447.616 330.185C447.764 329.772 447.995 329.393 448.295 329.073C448.594 328.753 448.957 328.498 449.359 328.323C449.762 328.149 450.196 328.058 450.634 328.058C451.073 328.058 451.507 328.149 451.909 328.323C452.312 328.498 452.674 328.753 452.974 329.073C453.273 329.393 453.504 329.772 453.652 330.185C453.799 330.598 453.861 331.037 453.832 331.475V338.471C453.861 338.909 453.799 339.348 453.652 339.761C453.504 340.174 453.273 340.553 452.974 340.873C452.674 341.193 452.312 341.448 451.909 341.623C451.507 341.797 451.073 341.888 450.634 341.888C450.196 341.888 449.762 341.797 449.359 341.623C448.957 341.448 448.594 341.193 448.295 340.873C447.995 340.553 447.764 340.174 447.616 339.761C447.469 339.348 447.408 338.909 447.437 338.471V331.475ZM449.536 338.597C449.536 339.549 449.956 339.913 450.627 339.913C451.299 339.913 451.719 339.549 451.719 338.597V331.349C451.719 330.383 451.299 330.019 450.627 330.019C449.956 330.019 449.536 330.383 449.536 331.349V338.597Z",
    fill: "url(#paint236_linear_2204_11443)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M460.969 331.475C460.969 330.625 461.306 329.81 461.907 329.209C462.508 328.608 463.323 328.27 464.173 328.27C465.023 328.27 465.838 328.608 466.439 329.209C467.04 329.81 467.378 330.625 467.378 331.475V338.471C467.378 339.321 467.04 340.136 466.439 340.737C465.838 341.338 465.023 341.676 464.173 341.676C463.323 341.676 462.508 341.338 461.907 340.737C461.306 340.136 460.969 339.321 460.969 338.471V331.475ZM463.082 338.597C463.082 339.549 463.502 339.913 464.173 339.913C464.845 339.913 465.265 339.549 465.265 338.597V331.349C465.265 330.383 464.845 330.019 464.173 330.019C463.502 330.019 463.082 330.383 463.082 331.349V338.597Z",
    fill: "url(#paint237_linear_2204_11443)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M470.037 329.949C470.574 330.027 471.12 329.894 471.56 329.579C472.001 329.263 472.303 328.789 472.402 328.256H473.801V341.676H471.688V331.447H470.065L470.037 329.949Z",
    fill: "url(#paint238_linear_2204_11443)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M476.152 331.475C476.152 330.625 476.49 329.81 477.091 329.209C477.692 328.608 478.507 328.27 479.357 328.27C480.207 328.27 481.022 328.608 481.623 329.209C482.224 329.81 482.561 330.625 482.561 331.475V338.471C482.561 339.321 482.224 340.136 481.623 340.737C481.022 341.338 480.207 341.676 479.357 341.676C478.507 341.676 477.692 341.338 477.091 340.737C476.49 340.136 476.152 339.321 476.152 338.471V331.475ZM478.265 338.597C478.265 339.549 478.685 339.913 479.357 339.913C480.029 339.913 480.448 339.549 480.448 338.597V331.349C480.448 330.383 480.029 330.019 479.357 330.019C478.685 330.019 478.265 330.383 478.265 331.349V338.597Z",
    fill: "url(#paint239_linear_2204_11443)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M485.219 329.949C485.75 330.019 486.287 329.882 486.719 329.567C487.151 329.252 487.446 328.783 487.542 328.256H488.941V341.676H486.842V331.447H485.205L485.219 329.949Z",
    fill: "url(#paint240_linear_2204_11443)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M491.336 331.475C491.336 330.625 491.674 329.81 492.275 329.209C492.875 328.608 493.691 328.27 494.54 328.27C495.39 328.27 496.205 328.608 496.806 329.209C497.407 329.81 497.745 330.625 497.745 331.475V338.471C497.745 339.321 497.407 340.136 496.806 340.737C496.205 341.338 495.39 341.676 494.54 341.676C493.691 341.676 492.875 341.338 492.275 340.737C491.674 340.136 491.336 339.321 491.336 338.471V331.475ZM493.393 338.611C493.393 339.563 493.813 339.927 494.484 339.927C495.156 339.927 495.576 339.563 495.576 338.611V331.363C495.576 330.397 495.156 330.033 494.484 330.033C493.813 330.033 493.393 330.397 493.393 331.363V338.611Z",
    fill: "url(#paint241_linear_2204_11443)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M500.389 329.949C500.919 330.019 501.456 329.882 501.889 329.567C502.321 329.252 502.616 328.783 502.712 328.256H504.111V341.676H502.012V331.447H500.389V329.949Z",
    fill: "url(#paint242_linear_2204_11443)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M506.518 331.475C506.518 330.625 506.855 329.81 507.456 329.209C508.057 328.608 508.872 328.27 509.722 328.27C510.572 328.27 511.387 328.608 511.988 329.209C512.589 329.81 512.927 330.625 512.927 331.475V338.471C512.927 339.321 512.589 340.136 511.988 340.737C511.387 341.338 510.572 341.676 509.722 341.676C508.872 341.676 508.057 341.338 507.456 340.737C506.855 340.136 506.518 339.321 506.518 338.471V331.475ZM508.631 338.597C508.631 339.549 509.05 339.913 509.722 339.913C510.394 339.913 510.814 339.549 510.814 338.597V331.349C510.814 330.383 510.394 330.019 509.722 330.019C509.05 330.019 508.631 330.383 508.631 331.349V338.597Z",
    fill: "url(#paint243_linear_2204_11443)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M145.697 354.494C145.697 353.644 146.035 352.829 146.636 352.228C147.237 351.627 148.052 351.289 148.902 351.289C149.752 351.289 150.567 351.627 151.168 352.228C151.769 352.829 152.106 353.644 152.106 354.494V361.491C152.106 362.341 151.769 363.156 151.168 363.757C150.567 364.358 149.752 364.695 148.902 364.695C148.052 364.695 147.237 364.358 146.636 363.757C146.035 363.156 145.697 362.341 145.697 361.491V354.494ZM147.81 361.603C147.81 362.554 148.23 362.918 148.902 362.918C149.573 362.918 149.993 362.554 149.993 361.603V354.354C149.993 353.402 149.573 353.025 148.902 353.025C148.23 353.025 147.81 353.402 147.81 354.354V361.603Z",
    fill: "url(#paint244_linear_2204_11443)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M154.75 352.955C155.28 353.024 155.817 352.888 156.25 352.572C156.682 352.257 156.977 351.788 157.073 351.261H158.472V364.681H156.373V354.452H154.75V352.955Z",
    fill: "url(#paint245_linear_2204_11443)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M160.879 354.494C160.879 353.644 161.217 352.829 161.817 352.228C162.418 351.627 163.234 351.289 164.083 351.289C164.933 351.289 165.748 351.627 166.349 352.228C166.95 352.829 167.288 353.644 167.288 354.494V361.491C167.288 362.341 166.95 363.156 166.349 363.757C165.748 364.358 164.933 364.695 164.083 364.695C163.234 364.695 162.418 364.358 161.817 363.757C161.217 363.156 160.879 362.341 160.879 361.491V354.494ZM162.992 361.603C162.992 362.554 163.412 362.918 164.083 362.918C164.755 362.918 165.175 362.554 165.175 361.603V354.354C165.175 353.402 164.755 353.025 164.083 353.025C163.412 353.025 162.992 353.402 162.992 354.354V361.603Z",
    fill: "url(#paint246_linear_2204_11443)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M169.946 352.955C170.477 353.024 171.014 352.888 171.446 352.572C171.879 352.257 172.173 351.788 172.269 351.261H173.669V364.681H171.542V354.452H169.904L169.946 352.955Z",
    fill: "url(#paint247_linear_2204_11443)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M176.077 354.494C176.048 354.056 176.11 353.617 176.257 353.204C176.405 352.791 176.635 352.413 176.935 352.092C177.235 351.772 177.597 351.517 178 351.342C178.402 351.168 178.836 351.078 179.275 351.078C179.713 351.078 180.147 351.168 180.55 351.342C180.952 351.517 181.315 351.772 181.614 352.092C181.914 352.413 182.145 352.791 182.293 353.204C182.44 353.617 182.501 354.056 182.472 354.494V361.491C182.501 361.928 182.44 362.367 182.293 362.78C182.145 363.193 181.914 363.572 181.614 363.892C181.315 364.212 180.952 364.468 180.55 364.642C180.147 364.817 179.713 364.907 179.275 364.907C178.836 364.907 178.402 364.817 178 364.642C177.597 364.468 177.235 364.212 176.935 363.892C176.635 363.572 176.405 363.193 176.257 362.78C176.11 362.367 176.048 361.928 176.077 361.491V354.494ZM178.176 361.603C178.176 362.554 178.596 362.918 179.268 362.918C179.94 362.918 180.359 362.554 180.359 361.603V354.354C180.359 353.402 179.94 353.025 179.268 353.025C178.596 353.025 178.176 353.402 178.176 354.354V361.603Z",
    fill: "url(#paint248_linear_2204_11443)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M185.143 352.955C185.672 353.024 186.207 352.887 186.637 352.571C187.068 352.256 187.359 351.787 187.452 351.261H188.851V364.681H186.738V354.452H185.115L185.143 352.955Z",
    fill: "url(#paint249_linear_2204_11443)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M192.729 352.955C193.268 353.023 193.812 352.878 194.246 352.552C194.679 352.225 194.969 351.742 195.052 351.205H196.451V364.625H194.352V354.396H192.715L192.729 352.955Z",
    fill: "url(#paint250_linear_2204_11443)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M200.327 352.955C200.856 353.021 201.392 352.883 201.823 352.568C202.255 352.254 202.55 351.786 202.649 351.261H204.049V364.681H201.936V354.452H200.312L200.327 352.955Z",
    fill: "url(#paint251_linear_2204_11443)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M207.926 352.955C208.456 353.024 208.993 352.888 209.426 352.572C209.858 352.257 210.153 351.788 210.249 351.261H211.648V364.681H209.535V354.452H207.926V352.955Z",
    fill: "url(#paint252_linear_2204_11443)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M215.51 352.955C216.04 353.021 216.575 352.883 217.007 352.568C217.438 352.254 217.734 351.786 217.833 351.261H219.232V364.681H217.119V354.452H215.496L215.51 352.955Z",
    fill: "url(#paint253_linear_2204_11443)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M223.108 352.955C223.645 353.023 224.187 352.878 224.619 352.551C225.05 352.224 225.337 351.741 225.417 351.205H226.816V364.625H224.717V354.396H223.094L223.108 352.955Z",
    fill: "url(#paint254_linear_2204_11443)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M230.692 352.955C231.222 353.024 231.759 352.888 232.192 352.572C232.624 352.257 232.919 351.788 233.015 351.261H234.414V364.681H232.315V354.452H230.678L230.692 352.955Z",
    fill: "url(#paint255_linear_2204_11443)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M236.807 354.494C236.807 353.644 237.144 352.829 237.745 352.228C238.346 351.627 239.161 351.289 240.011 351.289C240.861 351.289 241.676 351.627 242.277 352.228C242.878 352.829 243.216 353.644 243.216 354.494V361.491C243.216 362.341 242.878 363.156 242.277 363.757C241.676 364.358 240.861 364.695 240.011 364.695C239.161 364.695 238.346 364.358 237.745 363.757C237.144 363.156 236.807 362.341 236.807 361.491V354.494ZM238.92 361.603C238.92 362.554 239.339 362.918 240.011 362.918C240.683 362.918 241.103 362.554 241.103 361.603V354.354C241.103 353.402 240.683 353.025 240.011 353.025C239.339 353.025 238.92 353.402 238.92 354.354V361.603Z",
    fill: "url(#paint256_linear_2204_11443)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M245.875 352.955C246.406 353.024 246.943 352.888 247.375 352.572C247.808 352.257 248.102 351.788 248.198 351.261H249.598V364.681H247.499V354.452H245.861L245.875 352.955Z",
    fill: "url(#paint257_linear_2204_11443)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M256.442 352.955C256.972 353.024 257.509 352.888 257.942 352.572C258.374 352.257 258.669 351.788 258.765 351.261H260.164V364.681H258.065V354.452H256.428L256.442 352.955Z",
    fill: "url(#paint258_linear_2204_11443)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M262.5 354.494C262.5 353.644 262.838 352.829 263.439 352.228C264.04 351.627 264.855 351.289 265.705 351.289C266.554 351.289 267.369 351.627 267.97 352.228C268.571 352.829 268.909 353.644 268.909 354.494V361.491C268.909 362.341 268.571 363.156 267.97 363.757C267.369 364.358 266.554 364.695 265.705 364.695C264.855 364.695 264.04 364.358 263.439 363.757C262.838 363.156 262.5 362.341 262.5 361.491V354.494ZM264.613 361.603C264.613 362.554 265.033 362.918 265.705 362.918C266.376 362.918 266.796 362.554 266.796 361.603V354.354C266.796 353.402 266.376 353.025 265.705 353.025C265.033 353.025 264.613 353.402 264.613 354.354V361.603Z",
    fill: "url(#paint259_linear_2204_11443)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M271.624 352.955C272.154 353.024 272.691 352.888 273.124 352.572C273.556 352.257 273.851 351.788 273.947 351.261H275.346V364.681H273.233V354.452H271.596L271.624 352.955Z",
    fill: "url(#paint260_linear_2204_11443)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M282.188 352.955C282.719 353.024 283.256 352.888 283.688 352.572C284.12 352.257 284.415 351.788 284.511 351.261H285.91V364.681H283.797V354.452H282.16L282.188 352.955Z",
    fill: "url(#paint261_linear_2204_11443)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M291.284 354.494C291.255 354.056 291.317 353.617 291.464 353.204C291.612 352.791 291.843 352.413 292.142 352.092C292.442 351.772 292.804 351.517 293.207 351.342C293.609 351.168 294.043 351.078 294.482 351.078C294.921 351.078 295.354 351.168 295.757 351.342C296.159 351.517 296.522 351.772 296.821 352.092C297.121 352.413 297.352 352.791 297.5 353.204C297.647 353.617 297.708 354.056 297.679 354.494V361.491C297.708 361.928 297.647 362.367 297.5 362.78C297.352 363.193 297.121 363.572 296.821 363.892C296.522 364.212 296.159 364.468 295.757 364.642C295.354 364.817 294.921 364.907 294.482 364.907C294.043 364.907 293.609 364.817 293.207 364.642C292.804 364.468 292.442 364.212 292.142 363.892C291.843 363.572 291.612 363.193 291.464 362.78C291.317 362.367 291.255 361.928 291.284 361.491V354.494ZM293.397 361.603C293.397 362.554 293.817 362.918 294.489 362.918C295.161 362.918 295.58 362.554 295.58 361.603V354.354C295.58 353.402 295.161 353.025 294.489 353.025C293.817 353.025 293.397 353.402 293.397 354.354V361.603Z",
    fill: "url(#paint262_linear_2204_11443)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M300.352 352.955C300.882 353.021 301.417 352.883 301.849 352.568C302.28 352.254 302.576 351.786 302.675 351.261H304.074V364.681H301.961V354.452H300.338L300.352 352.955Z",
    fill: "url(#paint263_linear_2204_11443)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M307.95 352.955C308.479 353.024 309.014 352.887 309.444 352.571C309.874 352.256 310.166 351.787 310.259 351.261H311.658V364.681H309.545V354.452H307.922L307.95 352.955Z",
    fill: "url(#paint264_linear_2204_11443)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M315.535 352.955C316.066 353.024 316.603 352.888 317.035 352.572C317.467 352.257 317.762 351.788 317.858 351.261H319.257V364.681H317.158V354.452H315.535V352.955Z",
    fill: "url(#paint265_linear_2204_11443)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M323.133 352.955C323.674 353.031 324.224 352.889 324.662 352.562C325.1 352.234 325.39 351.746 325.47 351.205H326.869V364.625H324.756V354.396H323.133V352.955Z",
    fill: "url(#paint266_linear_2204_11443)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M330.717 352.955C331.248 353.024 331.785 352.888 332.217 352.572C332.649 352.257 332.944 351.788 333.04 351.261H334.439V364.681H332.34V354.452H330.703L330.717 352.955Z",
    fill: "url(#paint267_linear_2204_11443)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M336.832 354.494C336.832 354.073 336.915 353.656 337.076 353.268C337.237 352.879 337.473 352.526 337.771 352.228C338.068 351.93 338.421 351.694 338.81 351.533C339.199 351.372 339.616 351.289 340.037 351.289C340.457 351.289 340.874 351.372 341.263 351.533C341.652 351.694 342.005 351.93 342.302 352.228C342.6 352.526 342.836 352.879 342.997 353.268C343.158 353.656 343.241 354.073 343.241 354.494V361.491C343.241 361.912 343.158 362.328 342.997 362.717C342.836 363.106 342.6 363.459 342.302 363.757C342.005 364.054 341.652 364.29 341.263 364.451C340.874 364.612 340.457 364.695 340.037 364.695C339.616 364.695 339.199 364.612 338.81 364.451C338.421 364.29 338.068 364.054 337.771 363.757C337.473 363.459 337.237 363.106 337.076 362.717C336.915 362.328 336.832 361.912 336.832 361.491V354.494ZM338.945 361.603C338.945 362.554 339.365 362.918 340.037 362.918C340.708 362.918 341.128 362.554 341.128 361.603V354.354C341.128 353.402 340.708 353.025 340.037 353.025C339.365 353.025 338.945 353.402 338.945 354.354V361.603Z",
    fill: "url(#paint268_linear_2204_11443)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M345.9 352.955C346.431 353.024 346.968 352.888 347.4 352.572C347.833 352.257 348.127 351.788 348.223 351.261H349.623V364.681H347.51V354.452H345.9V352.955Z",
    fill: "url(#paint269_linear_2204_11443)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M352.058 354.494C352.029 354.056 352.09 353.617 352.238 353.204C352.385 352.791 352.616 352.413 352.916 352.092C353.215 351.772 353.578 351.517 353.98 351.342C354.383 351.168 354.817 351.078 355.255 351.078C355.694 351.078 356.128 351.168 356.53 351.342C356.933 351.517 357.295 351.772 357.595 352.092C357.895 352.413 358.125 352.791 358.273 353.204C358.421 353.617 358.482 354.056 358.453 354.494V361.491C358.482 361.928 358.421 362.367 358.273 362.78C358.125 363.193 357.895 363.572 357.595 363.892C357.295 364.212 356.933 364.468 356.53 364.642C356.128 364.817 355.694 364.907 355.255 364.907C354.817 364.907 354.383 364.817 353.98 364.642C353.578 364.468 353.215 364.212 352.916 363.892C352.616 363.572 352.385 363.193 352.238 362.78C352.09 362.367 352.029 361.928 352.058 361.491V354.494ZM354.157 361.603C354.157 362.554 354.577 362.918 355.248 362.918C355.92 362.918 356.34 362.554 356.34 361.603V354.354C356.34 353.402 355.92 353.025 355.248 353.025C354.577 353.025 354.157 353.402 354.157 354.354V361.603Z",
    fill: "url(#paint270_linear_2204_11443)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M361.098 352.955C361.627 353.024 362.162 352.887 362.592 352.571C363.023 352.256 363.314 351.787 363.407 351.261H364.807V364.681H362.694V354.452H361.07L361.098 352.955Z",
    fill: "url(#paint271_linear_2204_11443)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M367.212 354.494C367.183 354.056 367.244 353.617 367.392 353.204C367.539 352.791 367.77 352.413 368.07 352.092C368.37 351.772 368.732 351.517 369.135 351.342C369.537 351.168 369.971 351.078 370.41 351.078C370.848 351.078 371.282 351.168 371.685 351.342C372.087 351.517 372.449 351.772 372.749 352.092C373.049 352.413 373.28 352.791 373.427 353.204C373.575 353.617 373.636 354.056 373.607 354.494V361.491C373.636 361.928 373.575 362.367 373.427 362.78C373.28 363.193 373.049 363.572 372.749 363.892C372.449 364.212 372.087 364.468 371.685 364.642C371.282 364.817 370.848 364.907 370.41 364.907C369.971 364.907 369.537 364.817 369.135 364.642C368.732 364.468 368.37 364.212 368.07 363.892C367.77 363.572 367.539 363.193 367.392 362.78C367.244 362.367 367.183 361.928 367.212 361.491V354.494ZM369.311 361.603C369.311 362.554 369.745 362.918 370.417 362.918C371.088 362.918 371.508 362.554 371.508 361.603V354.354C371.508 353.402 371.074 353.025 370.417 353.025C369.759 353.025 369.311 353.402 369.311 354.354V361.603Z",
    fill: "url(#paint272_linear_2204_11443)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M376.279 352.955C376.824 353.031 377.377 352.891 377.819 352.564C378.262 352.236 378.558 351.749 378.644 351.205H380.044V364.625H377.931V354.396H376.307L376.279 352.955Z",
    fill: "url(#paint273_linear_2204_11443)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M391.311 354.494C391.311 353.644 391.648 352.829 392.249 352.228C392.85 351.627 393.665 351.289 394.515 351.289C395.365 351.289 396.18 351.627 396.781 352.228C397.382 352.829 397.72 353.644 397.72 354.494V361.491C397.72 362.341 397.382 363.156 396.781 363.757C396.18 364.358 395.365 364.695 394.515 364.695C393.665 364.695 392.85 364.358 392.249 363.757C391.648 363.156 391.311 362.341 391.311 361.491V354.494ZM393.424 361.603C393.424 362.554 393.843 362.918 394.515 362.918C395.187 362.918 395.607 362.554 395.607 361.603V354.354C395.607 353.402 395.187 353.025 394.515 353.025C393.843 353.025 393.424 353.402 393.424 354.354V361.603Z",
    fill: "url(#paint274_linear_2204_11443)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M400.377 352.955C400.908 353.024 401.445 352.888 401.877 352.572C402.31 352.257 402.604 351.788 402.7 351.261H404.1V364.681H402.001V354.452H400.363L400.377 352.955Z",
    fill: "url(#paint275_linear_2204_11443)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M406.492 354.494C406.492 353.644 406.83 352.829 407.431 352.228C408.032 351.627 408.847 351.289 409.697 351.289C410.547 351.289 411.362 351.627 411.963 352.228C412.564 352.829 412.901 353.644 412.901 354.494V361.491C412.901 362.341 412.564 363.156 411.963 363.757C411.362 364.358 410.547 364.695 409.697 364.695C408.847 364.695 408.032 364.358 407.431 363.757C406.83 363.156 406.492 362.341 406.492 361.491V354.494ZM408.605 361.603C408.605 362.554 409.025 362.918 409.697 362.918C410.368 362.918 410.788 362.554 410.788 361.603V354.354C410.788 353.402 410.368 353.025 409.697 353.025C409.025 353.025 408.605 353.402 408.605 354.354V361.603Z",
    fill: "url(#paint276_linear_2204_11443)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M415.56 352.955C416.09 353.008 416.62 352.856 417.041 352.531C417.463 352.205 417.744 351.731 417.827 351.205H419.227V364.625H417.127V354.396H415.49L415.56 352.955Z",
    fill: "url(#paint277_linear_2204_11443)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M423.16 352.955C423.69 353.021 424.225 352.883 424.657 352.568C425.089 352.254 425.384 351.786 425.483 351.261H426.882V364.681H424.825V354.452H423.202L423.16 352.955Z",
    fill: "url(#paint278_linear_2204_11443)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M430.744 352.955C431.275 353.024 431.812 352.888 432.244 352.572C432.676 352.257 432.971 351.788 433.067 351.261H434.466V364.681H432.381V354.452H430.744V352.955Z",
    fill: "url(#paint279_linear_2204_11443)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M436.872 354.494C436.843 354.056 436.904 353.617 437.052 353.204C437.2 352.791 437.43 352.413 437.73 352.092C438.03 351.772 438.392 351.517 438.795 351.342C439.197 351.168 439.631 351.078 440.07 351.078C440.508 351.078 440.942 351.168 441.345 351.342C441.747 351.517 442.11 351.772 442.409 352.092C442.709 352.413 442.94 352.791 443.087 353.204C443.235 353.617 443.296 354.056 443.267 354.494V361.491C443.296 361.928 443.235 362.367 443.087 362.78C442.94 363.193 442.709 363.572 442.409 363.892C442.11 364.212 441.747 364.468 441.345 364.642C440.942 364.817 440.508 364.907 440.07 364.907C439.631 364.907 439.197 364.817 438.795 364.642C438.392 364.468 438.03 364.212 437.73 363.892C437.43 363.572 437.2 363.193 437.052 362.78C436.904 362.367 436.843 361.928 436.872 361.491V354.494ZM438.971 361.603C438.971 362.554 439.391 362.918 440.063 362.918C440.734 362.918 441.154 362.554 441.154 361.603V354.354C441.154 353.402 440.734 353.025 440.063 353.025C439.391 353.025 438.971 353.402 438.971 354.354V361.603Z",
    fill: "url(#paint280_linear_2204_11443)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M445.94 352.955C446.469 353.024 447.004 352.887 447.434 352.571C447.864 352.256 448.156 351.787 448.249 351.261H449.648V364.681H447.535V354.452H445.912L445.94 352.955Z",
    fill: "url(#paint281_linear_2204_11443)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M453.524 352.955C454.055 353.024 454.592 352.888 455.024 352.572C455.456 352.257 455.751 351.788 455.847 351.261H457.246V364.681H455.133V354.452H453.496L453.524 352.955Z",
    fill: "url(#paint282_linear_2204_11443)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M461.123 352.955C461.661 353.019 462.203 352.873 462.636 352.547C463.069 352.221 463.36 351.741 463.446 351.205H464.845V364.625H462.746V354.396H461.123V352.955Z",
    fill: "url(#paint283_linear_2204_11443)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M468.708 352.955C469.243 353.015 469.78 352.867 470.207 352.541C470.635 352.215 470.92 351.737 471.003 351.205H472.403V364.625H470.29V354.396H468.652L468.708 352.955Z",
    fill: "url(#paint284_linear_2204_11443)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M476.307 352.955C476.837 353.021 477.372 352.883 477.803 352.568C478.235 352.254 478.53 351.786 478.63 351.261H480.029V364.681H478V354.452H476.377L476.307 352.955Z",
    fill: "url(#paint285_linear_2204_11443)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M483.905 352.955C484.434 353.024 484.969 352.887 485.399 352.571C485.829 352.256 486.121 351.787 486.214 351.261H487.613V364.681H485.5V354.452H483.877L483.905 352.955Z",
    fill: "url(#paint286_linear_2204_11443)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M492.986 354.494C492.986 353.644 493.324 352.829 493.925 352.228C494.526 351.627 495.341 351.289 496.191 351.289C497.041 351.289 497.856 351.627 498.457 352.228C499.058 352.829 499.395 353.644 499.395 354.494V361.491C499.395 362.341 499.058 363.156 498.457 363.757C497.856 364.358 497.041 364.695 496.191 364.695C495.341 364.695 494.526 364.358 493.925 363.757C493.324 363.156 492.986 362.341 492.986 361.491V354.494ZM495.099 361.603C495.099 362.554 495.519 362.918 496.191 362.918C496.863 362.918 497.282 362.554 497.282 361.603V354.354C497.282 353.402 496.863 353.025 496.191 353.025C495.519 353.025 495.099 353.402 495.099 354.354V361.603Z",
    fill: "url(#paint287_linear_2204_11443)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M502.055 352.955C502.586 353.024 503.123 352.888 503.555 352.572C503.987 352.257 504.282 351.788 504.378 351.261H505.777V364.681H503.678V354.452H502.041L502.055 352.955Z",
    fill: "url(#paint288_linear_2204_11443)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M509.653 352.955C510.182 353.024 510.717 352.887 511.147 352.571C511.577 352.256 511.869 351.787 511.962 351.261H513.361V364.681H511.248V354.452H509.625L509.653 352.955Z",
    fill: "url(#paint289_linear_2204_11443)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M145.697 378.129C145.697 377.279 146.035 376.464 146.636 375.863C147.237 375.262 148.052 374.924 148.902 374.924C149.752 374.924 150.567 375.262 151.168 375.863C151.769 376.464 152.106 377.279 152.106 378.129V385.126C152.106 385.976 151.769 386.791 151.168 387.392C150.567 387.993 149.752 388.33 148.902 388.33C148.052 388.33 147.237 387.993 146.636 387.392C146.035 386.791 145.697 385.976 145.697 385.126V378.129ZM147.81 385.238C147.81 386.189 148.23 386.553 148.902 386.553C149.573 386.553 149.993 386.189 149.993 385.238V377.989C149.993 377.037 149.573 376.66 148.902 376.66C148.23 376.66 147.81 377.037 147.81 377.989V385.238Z",
    fill: "url(#paint290_linear_2204_11443)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M153.351 378.129C153.322 377.691 153.383 377.252 153.531 376.839C153.678 376.426 153.909 376.048 154.209 375.727C154.508 375.407 154.871 375.152 155.273 374.977C155.676 374.803 156.11 374.713 156.548 374.713C156.987 374.713 157.421 374.803 157.823 374.977C158.226 375.152 158.588 375.407 158.888 375.727C159.188 376.048 159.418 376.426 159.566 376.839C159.714 377.252 159.775 377.691 159.746 378.129V385.126C159.775 385.563 159.714 386.002 159.566 386.415C159.418 386.828 159.188 387.207 158.888 387.527C158.588 387.847 158.226 388.103 157.823 388.277C157.421 388.452 156.987 388.542 156.548 388.542C156.11 388.542 155.676 388.452 155.273 388.277C154.871 388.103 154.508 387.847 154.209 387.527C153.909 387.207 153.678 386.828 153.531 386.415C153.383 386.002 153.322 385.563 153.351 385.126V378.129ZM155.45 385.238C155.45 386.189 155.884 386.553 156.555 386.553C157.227 386.553 157.647 386.189 157.647 385.238V377.989C157.647 377.037 157.213 376.66 156.555 376.66C155.898 376.66 155.45 377.037 155.45 377.989V385.238Z",
    fill: "url(#paint291_linear_2204_11443)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M160.879 378.129C160.879 377.279 161.217 376.464 161.817 375.863C162.418 375.262 163.234 374.924 164.083 374.924C164.933 374.924 165.748 375.262 166.349 375.863C166.95 376.464 167.288 377.279 167.288 378.129V385.126C167.288 385.976 166.95 386.791 166.349 387.392C165.748 387.993 164.933 388.33 164.083 388.33C163.234 388.33 162.418 387.993 161.817 387.392C161.217 386.791 160.879 385.976 160.879 385.126V378.129ZM162.992 385.238C162.992 386.189 163.412 386.553 164.083 386.553C164.755 386.553 165.175 386.189 165.175 385.238V377.989C165.175 377.037 164.755 376.66 164.083 376.66C163.412 376.66 162.992 377.037 162.992 377.989V385.238Z",
    fill: "url(#paint292_linear_2204_11443)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M169.946 376.59C170.477 376.659 171.014 376.523 171.446 376.207C171.879 375.892 172.173 375.423 172.269 374.896H173.669V388.316H171.542V378.087H169.904L169.946 376.59Z",
    fill: "url(#paint293_linear_2204_11443)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M180.51 376.59C181.041 376.659 181.578 376.523 182.01 376.207C182.443 375.892 182.737 375.423 182.833 374.896H184.233V388.316H182.12V378.087H180.482L180.51 376.59Z",
    fill: "url(#paint294_linear_2204_11443)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M188.111 376.59C188.641 376.656 189.177 376.518 189.608 376.203C190.04 375.888 190.335 375.421 190.434 374.896H191.834V388.316H189.735V378.087H188.111V376.59Z",
    fill: "url(#paint295_linear_2204_11443)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M195.71 376.59C196.238 376.659 196.774 376.522 197.204 376.206C197.634 375.891 197.926 375.422 198.019 374.896H199.418V388.316H197.305V378.087H195.682L195.71 376.59Z",
    fill: "url(#paint296_linear_2204_11443)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M203.293 376.59C203.824 376.659 204.361 376.523 204.793 376.207C205.226 375.892 205.52 375.423 205.616 374.896H207.016V388.316H204.917V378.087H203.279L203.293 376.59Z",
    fill: "url(#paint297_linear_2204_11443)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M210.893 376.59C211.423 376.656 211.958 376.518 212.39 376.203C212.821 375.888 213.117 375.421 213.216 374.896H214.615V388.316H212.502V378.087H210.879L210.893 376.59Z",
    fill: "url(#paint298_linear_2204_11443)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M219.973 378.129C219.973 377.279 220.31 376.464 220.911 375.863C221.512 375.262 222.327 374.924 223.177 374.924C224.027 374.924 224.842 375.262 225.443 375.863C226.044 376.464 226.382 377.279 226.382 378.129V385.126C226.382 385.976 226.044 386.791 225.443 387.392C224.842 387.993 224.027 388.33 223.177 388.33C222.327 388.33 221.512 387.993 220.911 387.392C220.31 386.791 219.973 385.976 219.973 385.126V378.129ZM222.086 385.238C222.086 386.189 222.505 386.553 223.177 386.553C223.849 386.553 224.269 386.189 224.269 385.238V377.989C224.269 377.037 223.849 376.66 223.177 376.66C222.505 376.66 222.086 377.037 222.086 377.989V385.238Z",
    fill: "url(#paint299_linear_2204_11443)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M227.517 378.129C227.488 377.691 227.549 377.252 227.697 376.839C227.844 376.426 228.075 376.048 228.375 375.727C228.674 375.407 229.037 375.152 229.439 374.977C229.842 374.803 230.276 374.713 230.714 374.713C231.153 374.713 231.587 374.803 231.989 374.977C232.392 375.152 232.754 375.407 233.054 375.727C233.354 376.048 233.584 376.426 233.732 376.839C233.88 377.252 233.941 377.691 233.912 378.129V385.126C233.941 385.563 233.88 386.002 233.732 386.415C233.584 386.828 233.354 387.207 233.054 387.527C232.754 387.847 232.392 388.103 231.989 388.277C231.587 388.452 231.153 388.542 230.714 388.542C230.276 388.542 229.842 388.452 229.439 388.277C229.037 388.103 228.674 387.847 228.375 387.527C228.075 387.207 227.844 386.828 227.697 386.415C227.549 386.002 227.488 385.563 227.517 385.126V378.129ZM229.616 385.238C229.616 386.189 230.05 386.553 230.721 386.553C231.393 386.553 231.813 386.189 231.813 385.238V377.989C231.813 377.037 231.393 376.66 230.721 376.66C230.05 376.66 229.616 377.037 229.616 377.989V385.238Z",
    fill: "url(#paint300_linear_2204_11443)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M235.156 378.129C235.156 377.279 235.494 376.464 236.095 375.863C236.696 375.262 237.511 374.924 238.361 374.924C239.211 374.924 240.026 375.262 240.627 375.863C241.228 376.464 241.565 377.279 241.565 378.129V385.126C241.565 385.976 241.228 386.791 240.627 387.392C240.026 387.993 239.211 388.33 238.361 388.33C237.511 388.33 236.696 387.993 236.095 387.392C235.494 386.791 235.156 385.976 235.156 385.126V378.129ZM237.269 385.238C237.269 386.189 237.689 386.553 238.361 386.553C239.032 386.553 239.452 386.189 239.452 385.238V377.989C239.452 377.037 239.032 376.66 238.361 376.66C237.689 376.66 237.269 377.037 237.269 377.989V385.238Z",
    fill: "url(#paint301_linear_2204_11443)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M242.756 378.129C242.756 377.279 243.093 376.464 243.694 375.863C244.295 375.262 245.11 374.924 245.96 374.924C246.81 374.924 247.625 375.262 248.226 375.863C248.827 376.464 249.165 377.279 249.165 378.129V385.126C249.165 385.976 248.827 386.791 248.226 387.392C247.625 387.993 246.81 388.33 245.96 388.33C245.11 388.33 244.295 387.993 243.694 387.392C243.093 386.791 242.756 385.976 242.756 385.126V378.129ZM244.869 385.238C244.869 386.189 245.289 386.553 245.96 386.553C246.632 386.553 247.052 386.189 247.052 385.238V377.989C247.052 377.037 246.632 376.66 245.96 376.66C245.289 376.66 244.869 377.037 244.869 377.989V385.238Z",
    fill: "url(#paint302_linear_2204_11443)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M250.353 378.129C250.324 377.691 250.385 377.252 250.532 376.839C250.68 376.426 250.911 376.048 251.211 375.727C251.51 375.407 251.873 375.152 252.275 374.977C252.678 374.803 253.112 374.713 253.55 374.713C253.989 374.713 254.423 374.803 254.825 374.977C255.228 375.152 255.59 375.407 255.89 375.727C256.19 376.048 256.42 376.426 256.568 376.839C256.715 377.252 256.777 377.691 256.748 378.129V385.126C256.777 385.563 256.715 386.002 256.568 386.415C256.42 386.828 256.19 387.207 255.89 387.527C255.59 387.847 255.228 388.103 254.825 388.277C254.423 388.452 253.989 388.542 253.55 388.542C253.112 388.542 252.678 388.452 252.275 388.277C251.873 388.103 251.51 387.847 251.211 387.527C250.911 387.207 250.68 386.828 250.532 386.415C250.385 386.002 250.324 385.563 250.353 385.126V378.129ZM252.452 385.238C252.452 386.189 252.872 386.553 253.543 386.553C254.215 386.553 254.635 386.189 254.635 385.238V377.989C254.635 377.037 254.215 376.66 253.543 376.66C252.872 376.66 252.452 377.037 252.452 377.989V385.238Z",
    fill: "url(#paint303_linear_2204_11443)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M265.299 376.59C265.829 376.659 266.366 376.523 266.799 376.207C267.231 375.892 267.526 375.423 267.622 374.896H269.021V388.316H266.908V378.087H265.299V376.59Z",
    fill: "url(#paint304_linear_2204_11443)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M272.952 376.59C273.481 376.656 274.017 376.518 274.448 376.203C274.88 375.888 275.175 375.421 275.274 374.896H276.674V388.316H274.561V378.087H272.938L272.952 376.59Z",
    fill: "url(#paint305_linear_2204_11443)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M280.553 376.59C281.082 376.659 281.617 376.522 282.047 376.206C282.477 375.891 282.769 375.422 282.862 374.896H284.261V388.316H282.148V378.087H280.553V376.59Z",
    fill: "url(#paint306_linear_2204_11443)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M288.137 376.59C288.668 376.659 289.205 376.523 289.637 376.207C290.069 375.892 290.364 375.423 290.46 374.896H291.859V388.316H289.76V378.087H288.123L288.137 376.59Z",
    fill: "url(#paint307_linear_2204_11443)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M295.735 376.59C296.265 376.656 296.8 376.518 297.231 376.203C297.663 375.888 297.959 375.421 298.058 374.896H299.457V388.316H297.344V378.087H295.721L295.735 376.59Z",
    fill: "url(#paint308_linear_2204_11443)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M303.319 376.59C303.849 376.659 304.386 376.523 304.819 376.207C305.251 375.892 305.546 375.423 305.642 374.896H307.041V388.316H304.942V378.087H303.305L303.319 376.59Z",
    fill: "url(#paint309_linear_2204_11443)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M309.434 378.129C309.434 377.279 309.771 376.464 310.372 375.863C310.973 375.262 311.788 374.924 312.638 374.924C313.488 374.924 314.303 375.262 314.904 375.863C315.505 376.464 315.843 377.279 315.843 378.129V385.126C315.843 385.976 315.505 386.791 314.904 387.392C314.303 387.993 313.488 388.33 312.638 388.33C311.788 388.33 310.973 387.993 310.372 387.392C309.771 386.791 309.434 385.976 309.434 385.126V378.129ZM311.547 385.238C311.547 386.189 311.966 386.553 312.638 386.553C313.31 386.553 313.73 386.189 313.73 385.238V377.989C313.73 377.037 313.31 376.66 312.638 376.66C311.966 376.66 311.547 377.037 311.547 377.989V385.238Z",
    fill: "url(#paint310_linear_2204_11443)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M317.074 378.129C317.074 377.279 317.412 376.464 318.013 375.863C318.614 375.262 319.429 374.924 320.279 374.924C321.129 374.924 321.944 375.262 322.545 375.863C323.146 376.464 323.483 377.279 323.483 378.129V385.126C323.483 385.976 323.146 386.791 322.545 387.392C321.944 387.993 321.129 388.33 320.279 388.33C319.429 388.33 318.614 387.993 318.013 387.392C317.412 386.791 317.074 385.976 317.074 385.126V378.129ZM319.187 385.238C319.187 386.189 319.607 386.553 320.279 386.553C320.95 386.553 321.37 386.189 321.37 385.238V377.989C321.37 377.037 320.95 376.66 320.279 376.66C319.607 376.66 319.187 377.037 319.187 377.989V385.238Z",
    fill: "url(#paint311_linear_2204_11443)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M324.63 378.129C324.601 377.691 324.662 377.252 324.81 376.839C324.957 376.426 325.188 376.048 325.488 375.727C325.788 375.407 326.15 375.152 326.552 374.977C326.955 374.803 327.389 374.713 327.828 374.713C328.266 374.713 328.7 374.803 329.103 374.977C329.505 375.152 329.867 375.407 330.167 375.727C330.467 376.048 330.698 376.426 330.845 376.839C330.993 377.252 331.054 377.691 331.025 378.129V385.126C331.054 385.563 330.993 386.002 330.845 386.415C330.698 386.828 330.467 387.207 330.167 387.527C329.867 387.847 329.505 388.103 329.103 388.277C328.7 388.452 328.266 388.542 327.828 388.542C327.389 388.542 326.955 388.452 326.552 388.277C326.15 388.103 325.788 387.847 325.488 387.527C325.188 387.207 324.957 386.828 324.81 386.415C324.662 386.002 324.601 385.563 324.63 385.126V378.129ZM326.729 385.238C326.729 386.189 327.149 386.553 327.821 386.553C328.492 386.553 328.912 386.189 328.912 385.238V377.989C328.912 377.037 328.492 376.66 327.821 376.66C327.149 376.66 326.729 377.037 326.729 377.989V385.238Z",
    fill: "url(#paint312_linear_2204_11443)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M332.215 378.129C332.215 377.279 332.552 376.464 333.153 375.863C333.754 375.262 334.569 374.924 335.419 374.924C336.269 374.924 337.084 375.262 337.685 375.863C338.286 376.464 338.624 377.279 338.624 378.129V385.126C338.624 385.976 338.286 386.791 337.685 387.392C337.084 387.993 336.269 388.33 335.419 388.33C334.569 388.33 333.754 387.993 333.153 387.392C332.552 386.791 332.215 385.976 332.215 385.126V378.129ZM334.328 385.238C334.328 386.189 334.748 386.553 335.419 386.553C336.091 386.553 336.511 386.189 336.511 385.238V377.989C336.511 377.037 336.091 376.66 335.419 376.66C334.748 376.66 334.328 377.037 334.328 377.989V385.238Z",
    fill: "url(#paint313_linear_2204_11443)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M339.814 378.129C339.785 377.691 339.846 377.252 339.993 376.839C340.141 376.426 340.372 376.048 340.672 375.727C340.971 375.407 341.334 375.152 341.736 374.977C342.139 374.803 342.573 374.713 343.011 374.713C343.45 374.713 343.884 374.803 344.286 374.977C344.689 375.152 345.051 375.407 345.351 375.727C345.65 376.048 345.881 376.426 346.029 376.839C346.176 377.252 346.238 377.691 346.209 378.129V385.126C346.238 385.563 346.176 386.002 346.029 386.415C345.881 386.828 345.65 387.207 345.351 387.527C345.051 387.847 344.689 388.103 344.286 388.277C343.884 388.452 343.45 388.542 343.011 388.542C342.573 388.542 342.139 388.452 341.736 388.277C341.334 388.103 340.971 387.847 340.672 387.527C340.372 387.207 340.141 386.828 339.993 386.415C339.846 386.002 339.785 385.563 339.814 385.126V378.129ZM341.913 385.238C341.913 386.189 342.346 386.553 343.018 386.553C343.69 386.553 344.11 386.189 344.11 385.238V377.989C344.11 377.037 343.676 376.66 343.018 376.66C342.36 376.66 341.913 377.037 341.913 377.989V385.238Z",
    fill: "url(#paint314_linear_2204_11443)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M347.398 378.129C347.398 377.279 347.736 376.464 348.337 375.863C348.938 375.262 349.753 374.924 350.603 374.924C351.453 374.924 352.268 375.262 352.869 375.863C353.47 376.464 353.807 377.279 353.807 378.129V385.126C353.807 385.976 353.47 386.791 352.869 387.392C352.268 387.993 351.453 388.33 350.603 388.33C349.753 388.33 348.938 387.993 348.337 387.392C347.736 386.791 347.398 385.976 347.398 385.126V378.129ZM349.511 385.238C349.511 386.189 349.931 386.553 350.603 386.553C351.275 386.553 351.694 386.189 351.694 385.238V377.989C351.694 377.037 351.275 376.66 350.603 376.66C349.931 376.66 349.511 377.037 349.511 377.989V385.238Z",
    fill: "url(#paint315_linear_2204_11443)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M354.997 378.129C354.968 377.691 355.029 377.252 355.177 376.839C355.325 376.426 355.555 376.048 355.855 375.727C356.155 375.407 356.517 375.152 356.92 374.977C357.322 374.803 357.756 374.713 358.195 374.713C358.633 374.713 359.067 374.803 359.47 374.977C359.872 375.152 360.235 375.407 360.534 375.727C360.834 376.048 361.065 376.426 361.212 376.839C361.36 377.252 361.421 377.691 361.392 378.129V385.126C361.421 385.563 361.36 386.002 361.212 386.415C361.065 386.828 360.834 387.207 360.534 387.527C360.235 387.847 359.872 388.103 359.47 388.277C359.067 388.452 358.633 388.542 358.195 388.542C357.756 388.542 357.322 388.452 356.92 388.277C356.517 388.103 356.155 387.847 355.855 387.527C355.555 387.207 355.325 386.828 355.177 386.415C355.029 386.002 354.968 385.563 354.997 385.126V378.129ZM357.11 385.238C357.11 386.189 357.53 386.553 358.202 386.553C358.873 386.553 359.293 386.189 359.293 385.238V377.989C359.293 377.037 358.873 376.66 358.202 376.66C357.53 376.66 357.11 377.037 357.11 377.989V385.238Z",
    fill: "url(#paint316_linear_2204_11443)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M367.031 376.59C367.562 376.659 368.099 376.523 368.531 376.207C368.964 375.892 369.258 375.423 369.354 374.896H370.753V388.316H368.64V378.087H367.031V376.59Z",
    fill: "url(#paint317_linear_2204_11443)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M374.629 376.59C375.159 376.656 375.694 376.518 376.126 376.203C376.558 375.888 376.853 375.421 376.952 374.896H378.352V388.316H376.238V378.087H374.615L374.629 376.59Z",
    fill: "url(#paint318_linear_2204_11443)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M382.227 376.59C382.756 376.659 383.291 376.522 383.721 376.206C384.152 375.891 384.443 375.422 384.536 374.896H385.935V388.316H383.822V378.087H382.199L382.227 376.59Z",
    fill: "url(#paint319_linear_2204_11443)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M389.84 376.59C390.37 376.659 390.907 376.523 391.34 376.207C391.772 375.892 392.067 375.423 392.163 374.896H393.562V388.316H391.463V378.087H389.84V376.59Z",
    fill: "url(#paint320_linear_2204_11443)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M397.41 376.59C397.94 376.656 398.476 376.518 398.907 376.203C399.339 375.888 399.634 375.421 399.733 374.896H401.133V388.316H399.02V378.087H397.396L397.41 376.59Z",
    fill: "url(#paint321_linear_2204_11443)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M409.431 378.129C409.402 377.691 409.463 377.252 409.611 376.839C409.758 376.426 409.989 376.048 410.289 375.727C410.589 375.407 410.951 375.152 411.353 374.977C411.756 374.803 412.19 374.713 412.628 374.713C413.067 374.713 413.501 374.803 413.903 374.977C414.306 375.152 414.668 375.407 414.968 375.727C415.268 376.048 415.498 376.426 415.646 376.839C415.794 377.252 415.855 377.691 415.826 378.129V385.126C415.855 385.563 415.794 386.002 415.646 386.415C415.498 386.828 415.268 387.207 414.968 387.527C414.668 387.847 414.306 388.103 413.903 388.277C413.501 388.452 413.067 388.542 412.628 388.542C412.19 388.542 411.756 388.452 411.353 388.277C410.951 388.103 410.589 387.847 410.289 387.527C409.989 387.207 409.758 386.828 409.611 386.415C409.463 386.002 409.402 385.563 409.431 385.126V378.129ZM411.53 385.238C411.53 386.189 411.95 386.553 412.621 386.553C413.293 386.553 413.713 386.189 413.713 385.238V377.989C413.713 377.037 413.293 376.66 412.621 376.66C411.95 376.66 411.53 377.037 411.53 377.989V385.238Z",
    fill: "url(#paint322_linear_2204_11443)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M417.057 378.129C417.057 377.279 417.394 376.464 417.995 375.863C418.596 375.262 419.411 374.924 420.261 374.924C421.111 374.924 421.926 375.262 422.527 375.863C423.128 376.464 423.466 377.279 423.466 378.129V385.126C423.466 385.976 423.128 386.791 422.527 387.392C421.926 387.993 421.111 388.33 420.261 388.33C419.411 388.33 418.596 387.993 417.995 387.392C417.394 386.791 417.057 385.976 417.057 385.126V378.129ZM419.17 385.238C419.17 386.189 419.589 386.553 420.261 386.553C420.933 386.553 421.353 386.189 421.353 385.238V377.989C421.353 377.037 420.933 376.66 420.261 376.66C419.589 376.66 419.17 377.037 419.17 377.989V385.238Z",
    fill: "url(#paint323_linear_2204_11443)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M424.657 378.129C424.628 377.691 424.69 377.252 424.837 376.839C424.985 376.426 425.216 376.048 425.515 375.727C425.815 375.407 426.177 375.152 426.58 374.977C426.982 374.803 427.416 374.713 427.855 374.713C428.294 374.713 428.728 374.803 429.13 374.977C429.532 375.152 429.895 375.407 430.194 375.727C430.494 376.048 430.725 376.426 430.873 376.839C431.02 377.252 431.081 377.691 431.052 378.129V385.126C431.081 385.563 431.02 386.002 430.873 386.415C430.725 386.828 430.494 387.207 430.194 387.527C429.895 387.847 429.532 388.103 429.13 388.277C428.728 388.452 428.294 388.542 427.855 388.542C427.416 388.542 426.982 388.452 426.58 388.277C426.177 388.103 425.815 387.847 425.515 387.527C425.216 387.207 424.985 386.828 424.837 386.415C424.69 386.002 424.628 385.563 424.657 385.126V378.129ZM426.756 385.238C426.756 386.189 427.19 386.553 427.862 386.553C428.534 386.553 428.953 386.189 428.953 385.238V377.989C428.953 377.037 428.52 376.66 427.862 376.66C427.204 376.66 426.756 377.037 426.756 377.989V385.238Z",
    fill: "url(#paint324_linear_2204_11443)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M432.24 378.129C432.24 377.279 432.578 376.464 433.179 375.863C433.78 375.262 434.595 374.924 435.445 374.924C436.295 374.924 437.11 375.262 437.711 375.863C438.312 376.464 438.649 377.279 438.649 378.129V385.126C438.649 385.976 438.312 386.791 437.711 387.392C437.11 387.993 436.295 388.33 435.445 388.33C434.595 388.33 433.78 387.993 433.179 387.392C432.578 386.791 432.24 385.976 432.24 385.126V378.129ZM434.353 385.238C434.353 386.189 434.773 386.553 435.445 386.553C436.116 386.553 436.536 386.189 436.536 385.238V377.989C436.536 377.037 436.116 376.66 435.445 376.66C434.773 376.66 434.353 377.037 434.353 377.989V385.238Z",
    fill: "url(#paint325_linear_2204_11443)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M439.838 378.129C439.838 377.708 439.921 377.291 440.082 376.903C440.243 376.514 440.479 376.161 440.776 375.863C441.074 375.565 441.427 375.329 441.816 375.168C442.205 375.007 442.622 374.924 443.042 374.924C443.463 374.924 443.88 375.007 444.269 375.168C444.657 375.329 445.011 375.565 445.308 375.863C445.606 376.161 445.842 376.514 446.003 376.903C446.164 377.291 446.247 377.708 446.247 378.129V385.126C446.247 385.546 446.164 385.963 446.003 386.352C445.842 386.741 445.606 387.094 445.308 387.392C445.011 387.689 444.657 387.925 444.269 388.086C443.88 388.247 443.463 388.33 443.042 388.33C442.622 388.33 442.205 388.247 441.816 388.086C441.427 387.925 441.074 387.689 440.776 387.392C440.479 387.094 440.243 386.741 440.082 386.352C439.921 385.963 439.838 385.546 439.838 385.126V378.129ZM441.951 385.238C441.951 386.189 442.371 386.553 443.042 386.553C443.714 386.553 444.134 386.189 444.134 385.238V377.989C444.134 377.037 443.714 376.66 443.042 376.66C442.371 376.66 441.951 377.037 441.951 377.989V385.238Z",
    fill: "url(#paint326_linear_2204_11443)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M447.437 378.129C447.408 377.691 447.469 377.252 447.616 376.839C447.764 376.426 447.995 376.048 448.295 375.727C448.594 375.407 448.957 375.152 449.359 374.977C449.762 374.803 450.196 374.713 450.634 374.713C451.073 374.713 451.507 374.803 451.909 374.977C452.312 375.152 452.674 375.407 452.974 375.727C453.273 376.048 453.504 376.426 453.652 376.839C453.799 377.252 453.861 377.691 453.832 378.129V385.126C453.861 385.563 453.799 386.002 453.652 386.415C453.504 386.828 453.273 387.207 452.974 387.527C452.674 387.847 452.312 388.103 451.909 388.277C451.507 388.452 451.073 388.542 450.634 388.542C450.196 388.542 449.762 388.452 449.359 388.277C448.957 388.103 448.594 387.847 448.295 387.527C447.995 387.207 447.764 386.828 447.616 386.415C447.469 386.002 447.408 385.563 447.437 385.126V378.129ZM449.536 385.238C449.536 386.189 449.956 386.553 450.627 386.553C451.299 386.553 451.719 386.189 451.719 385.238V377.989C451.719 377.037 451.299 376.66 450.627 376.66C449.956 376.66 449.536 377.037 449.536 377.989V385.238Z",
    fill: "url(#paint327_linear_2204_11443)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M460.969 378.129C460.969 377.279 461.306 376.464 461.907 375.863C462.508 375.262 463.323 374.924 464.173 374.924C465.023 374.924 465.838 375.262 466.439 375.863C467.04 376.464 467.378 377.279 467.378 378.129V385.126C467.378 385.976 467.04 386.791 466.439 387.392C465.838 387.993 465.023 388.33 464.173 388.33C463.323 388.33 462.508 387.993 461.907 387.392C461.306 386.791 460.969 385.976 460.969 385.126V378.129ZM463.082 385.238C463.082 386.189 463.502 386.553 464.173 386.553C464.845 386.553 465.265 386.189 465.265 385.238V377.989C465.265 377.037 464.845 376.66 464.173 376.66C463.502 376.66 463.082 377.037 463.082 377.989V385.238Z",
    fill: "url(#paint328_linear_2204_11443)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M470.037 376.59C470.567 376.656 471.103 376.518 471.534 376.203C471.966 375.888 472.261 375.421 472.36 374.896H473.76V388.316H471.647V378.087H470.023L470.037 376.59Z",
    fill: "url(#paint329_linear_2204_11443)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M476.152 378.129C476.152 377.279 476.49 376.464 477.091 375.863C477.692 375.262 478.507 374.924 479.357 374.924C480.207 374.924 481.022 375.262 481.623 375.863C482.224 376.464 482.561 377.279 482.561 378.129V385.126C482.561 385.976 482.224 386.791 481.623 387.392C481.022 387.993 480.207 388.33 479.357 388.33C478.507 388.33 477.692 387.993 477.091 387.392C476.49 386.791 476.152 385.976 476.152 385.126V378.129ZM478.265 385.238C478.265 386.189 478.685 386.553 479.357 386.553C480.029 386.553 480.448 386.189 480.448 385.238V377.989C480.448 377.037 480.029 376.66 479.357 376.66C478.685 376.66 478.265 377.037 478.265 377.989V385.238Z",
    fill: "url(#paint330_linear_2204_11443)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M485.219 376.59C485.75 376.659 486.287 376.523 486.719 376.207C487.151 375.892 487.446 375.423 487.542 374.896H488.941V388.316H486.842V378.087H485.205L485.219 376.59Z",
    fill: "url(#paint331_linear_2204_11443)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M491.336 378.129C491.336 377.279 491.674 376.464 492.275 375.863C492.875 375.262 493.691 374.924 494.54 374.924C495.39 374.924 496.205 375.262 496.806 375.863C497.407 376.464 497.745 377.279 497.745 378.129V385.126C497.745 385.976 497.407 386.791 496.806 387.392C496.205 387.993 495.39 388.33 494.54 388.33C493.691 388.33 492.875 387.993 492.275 387.392C491.674 386.791 491.336 385.976 491.336 385.126V378.129ZM493.449 385.238C493.449 386.189 493.869 386.553 494.54 386.553C495.212 386.553 495.632 386.189 495.632 385.238V377.989C495.632 377.037 495.212 376.66 494.54 376.66C493.869 376.66 493.449 377.037 493.449 377.989V385.238Z",
    fill: "url(#paint332_linear_2204_11443)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M500.389 376.59C500.919 376.659 501.456 376.523 501.889 376.207C502.321 375.892 502.616 375.423 502.712 374.896H504.111V388.316H502.012V378.087H500.389V376.59Z",
    fill: "url(#paint333_linear_2204_11443)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M506.518 378.129C506.518 377.279 506.855 376.464 507.456 375.863C508.057 375.262 508.872 374.924 509.722 374.924C510.572 374.924 511.387 375.262 511.988 375.863C512.589 376.464 512.927 377.279 512.927 378.129V385.126C512.927 385.976 512.589 386.791 511.988 387.392C511.387 387.993 510.572 388.33 509.722 388.33C508.872 388.33 508.057 387.993 507.456 387.392C506.855 386.791 506.518 385.976 506.518 385.126V378.129ZM508.631 385.238C508.631 386.189 509.05 386.553 509.722 386.553C510.394 386.553 510.814 386.189 510.814 385.238V377.989C510.814 377.037 510.394 376.66 509.722 376.66C509.05 376.66 508.631 377.037 508.631 377.989V385.238Z",
    fill: "url(#paint334_linear_2204_11443)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M145.697 401.134C145.697 400.284 146.035 399.469 146.636 398.868C147.237 398.267 148.052 397.93 148.902 397.93C149.752 397.93 150.567 398.267 151.168 398.868C151.769 399.469 152.106 400.284 152.106 401.134V408.131C152.106 408.981 151.769 409.796 151.168 410.397C150.567 410.998 149.752 411.335 148.902 411.335C148.052 411.335 147.237 410.998 146.636 410.397C146.035 409.796 145.697 408.981 145.697 408.131V401.134ZM147.81 408.243C147.81 409.208 148.23 409.572 148.902 409.572C149.573 409.572 149.993 409.208 149.993 408.243V400.994C149.993 400.043 149.573 399.679 148.902 399.679C148.23 399.679 147.81 400.043 147.81 400.994V408.243Z",
    fill: "url(#paint335_linear_2204_11443)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M154.75 399.595C155.278 399.665 155.814 399.53 156.246 399.218C156.678 398.906 156.974 398.44 157.073 397.916H158.472V411.377H156.373V401.134H154.75V399.595Z",
    fill: "url(#paint336_linear_2204_11443)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M160.879 401.134C160.879 400.284 161.217 399.469 161.817 398.868C162.418 398.267 163.234 397.93 164.083 397.93C164.933 397.93 165.748 398.267 166.349 398.868C166.95 399.469 167.288 400.284 167.288 401.134V408.131C167.288 408.981 166.95 409.796 166.349 410.397C165.748 410.998 164.933 411.335 164.083 411.335C163.234 411.335 162.418 410.998 161.817 410.397C161.217 409.796 160.879 408.981 160.879 408.131V401.134ZM162.992 408.243C162.992 409.208 163.412 409.572 164.083 409.572C164.755 409.572 165.175 409.208 165.175 408.243V400.994C165.175 400.043 164.755 399.679 164.083 399.679C163.412 399.679 162.992 400.043 162.992 400.994V408.243Z",
    fill: "url(#paint337_linear_2204_11443)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M169.946 399.595C170.475 399.665 171.01 399.53 171.442 399.218C171.874 398.906 172.17 398.44 172.269 397.916H173.669V411.377H171.542V401.134H169.904L169.946 399.595Z",
    fill: "url(#paint338_linear_2204_11443)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M176.077 401.134C176.048 400.697 176.11 400.258 176.257 399.845C176.405 399.431 176.635 399.053 176.935 398.733C177.235 398.413 177.597 398.157 178 397.983C178.402 397.808 178.836 397.718 179.275 397.718C179.713 397.718 180.147 397.808 180.55 397.983C180.952 398.157 181.315 398.413 181.614 398.733C181.914 399.053 182.145 399.431 182.293 399.845C182.44 400.258 182.501 400.697 182.472 401.134V408.131C182.501 408.569 182.44 409.008 182.293 409.421C182.145 409.834 181.914 410.212 181.614 410.532C181.315 410.853 180.952 411.108 180.55 411.283C180.147 411.457 179.713 411.547 179.275 411.547C178.836 411.547 178.402 411.457 178 411.283C177.597 411.108 177.235 410.853 176.935 410.532C176.635 410.212 176.405 409.834 176.257 409.421C176.11 409.008 176.048 408.569 176.077 408.131V401.134ZM178.176 408.243C178.176 409.209 178.596 409.572 179.268 409.572C179.94 409.572 180.359 409.209 180.359 408.243V400.994C180.359 400.043 179.94 399.679 179.268 399.679C178.596 399.679 178.176 400.043 178.176 400.994V408.243Z",
    fill: "url(#paint339_linear_2204_11443)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M185.143 399.595C185.67 399.665 186.203 399.529 186.633 399.217C187.063 398.904 187.356 398.438 187.452 397.916H188.851V411.377H186.738V401.134H185.115L185.143 399.595Z",
    fill: "url(#paint340_linear_2204_11443)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M192.729 399.595C193.257 399.665 193.793 399.53 194.225 399.218C194.657 398.906 194.953 398.44 195.052 397.916H196.451V411.377H194.352V401.134H192.715L192.729 399.595Z",
    fill: "url(#paint341_linear_2204_11443)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M200.327 399.595C200.854 399.662 201.388 399.525 201.819 399.214C202.25 398.902 202.547 398.438 202.649 397.916H204.049V411.377H201.936V401.134H200.312L200.327 399.595Z",
    fill: "url(#paint342_linear_2204_11443)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M207.926 399.595C208.454 399.665 208.989 399.53 209.422 399.218C209.854 398.906 210.15 398.44 210.249 397.916H211.648V411.377H209.535V401.134H207.926V399.595Z",
    fill: "url(#paint343_linear_2204_11443)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M215.51 399.595C216.038 399.662 216.572 399.525 217.003 399.214C217.434 398.902 217.731 398.438 217.833 397.916H219.232V411.377H217.119V401.134H215.496L215.51 399.595Z",
    fill: "url(#paint344_linear_2204_11443)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M223.108 399.595C223.635 399.665 224.168 399.529 224.598 399.217C225.028 398.904 225.321 398.438 225.417 397.916H226.816V411.377H224.717V401.134H223.094L223.108 399.595Z",
    fill: "url(#paint345_linear_2204_11443)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M230.692 399.595C231.22 399.665 231.755 399.53 232.187 399.218C232.62 398.906 232.916 398.44 233.015 397.916H234.414V411.377H232.315V401.134H230.678L230.692 399.595Z",
    fill: "url(#paint346_linear_2204_11443)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M236.807 401.134C236.807 400.284 237.144 399.469 237.745 398.868C238.346 398.267 239.161 397.93 240.011 397.93C240.861 397.93 241.676 398.267 242.277 398.868C242.878 399.469 243.216 400.284 243.216 401.134V408.131C243.216 408.981 242.878 409.796 242.277 410.397C241.676 410.998 240.861 411.335 240.011 411.335C239.161 411.335 238.346 410.998 237.745 410.397C237.144 409.796 236.807 408.981 236.807 408.131V401.134ZM238.92 408.243C238.92 409.208 239.339 409.572 240.011 409.572C240.683 409.572 241.103 409.208 241.103 408.243V400.994C241.103 400.043 240.683 399.679 240.011 399.679C239.339 399.679 238.92 400.043 238.92 400.994V408.243Z",
    fill: "url(#paint347_linear_2204_11443)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M245.875 399.595C246.404 399.665 246.939 399.53 247.371 399.218C247.803 398.906 248.099 398.44 248.198 397.916H249.598V411.377H247.499V401.134H245.861L245.875 399.595Z",
    fill: "url(#paint348_linear_2204_11443)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M256.442 399.595C256.97 399.665 257.505 399.53 257.937 399.218C258.37 398.906 258.665 398.44 258.765 397.916H260.164V411.377H258.065V401.134H256.428L256.442 399.595Z",
    fill: "url(#paint349_linear_2204_11443)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M262.5 401.134C262.5 400.284 262.838 399.469 263.439 398.868C264.04 398.267 264.855 397.93 265.705 397.93C266.554 397.93 267.369 398.267 267.97 398.868C268.571 399.469 268.909 400.284 268.909 401.134V408.131C268.909 408.981 268.571 409.796 267.97 410.397C267.369 410.998 266.554 411.335 265.705 411.335C264.855 411.335 264.04 410.998 263.439 410.397C262.838 409.796 262.5 408.981 262.5 408.131V401.134ZM264.613 408.243C264.613 409.208 265.033 409.572 265.705 409.572C266.376 409.572 266.796 409.208 266.796 408.243V400.994C266.796 400.043 266.376 399.679 265.705 399.679C265.033 399.679 264.613 400.043 264.613 400.994V408.243Z",
    fill: "url(#paint350_linear_2204_11443)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M271.624 399.595C272.152 399.665 272.687 399.53 273.119 399.218C273.551 398.906 273.847 398.44 273.947 397.916H275.346V411.377H273.233V401.134H271.596L271.624 399.595Z",
    fill: "url(#paint351_linear_2204_11443)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M282.188 399.595C282.717 399.665 283.252 399.53 283.684 399.218C284.116 398.906 284.412 398.44 284.511 397.916H285.91V411.377H283.797V401.134H282.16L282.188 399.595Z",
    fill: "url(#paint352_linear_2204_11443)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M291.284 401.134C291.255 400.697 291.317 400.258 291.464 399.845C291.612 399.431 291.843 399.053 292.142 398.733C292.442 398.413 292.804 398.157 293.207 397.983C293.609 397.808 294.043 397.718 294.482 397.718C294.921 397.718 295.354 397.808 295.757 397.983C296.159 398.157 296.522 398.413 296.821 398.733C297.121 399.053 297.352 399.431 297.5 399.845C297.647 400.258 297.708 400.697 297.679 401.134V408.131C297.708 408.569 297.647 409.008 297.5 409.421C297.352 409.834 297.121 410.212 296.821 410.532C296.522 410.853 296.159 411.108 295.757 411.283C295.354 411.457 294.921 411.547 294.482 411.547C294.043 411.547 293.609 411.457 293.207 411.283C292.804 411.108 292.442 410.853 292.142 410.532C291.843 410.212 291.612 409.834 291.464 409.421C291.317 409.008 291.255 408.569 291.284 408.131V401.134ZM293.397 408.243C293.397 409.209 293.817 409.572 294.489 409.572C295.161 409.572 295.58 409.209 295.58 408.243V400.994C295.58 400.043 295.161 399.679 294.489 399.679C293.817 399.679 293.397 400.043 293.397 400.994V408.243Z",
    fill: "url(#paint353_linear_2204_11443)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M300.352 399.595C300.88 399.662 301.413 399.525 301.845 399.214C302.276 398.902 302.573 398.438 302.675 397.916H304.074V411.377H301.961V401.134H300.338L300.352 399.595Z",
    fill: "url(#paint354_linear_2204_11443)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M307.95 399.595C308.477 399.665 309.01 399.529 309.44 399.217C309.87 398.904 310.163 398.438 310.259 397.916H311.658V411.377H309.545V401.134H307.922L307.95 399.595Z",
    fill: "url(#paint355_linear_2204_11443)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M315.535 399.595C316.064 399.665 316.599 399.53 317.031 399.218C317.463 398.906 317.759 398.44 317.858 397.916H319.257V411.377H317.158V401.134H315.535V399.595Z",
    fill: "url(#paint356_linear_2204_11443)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M323.133 399.595C323.66 399.665 324.194 399.529 324.623 399.217C325.053 398.904 325.346 398.438 325.442 397.916H326.842V411.377H324.729V401.134H323.105L323.133 399.595Z",
    fill: "url(#paint357_linear_2204_11443)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M330.717 399.595C331.246 399.665 331.781 399.53 332.213 399.218C332.645 398.906 332.941 398.44 333.04 397.916H334.439V411.377H332.34V401.134H330.703L330.717 399.595Z",
    fill: "url(#paint358_linear_2204_11443)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M336.832 401.134C336.832 400.713 336.915 400.297 337.076 399.908C337.237 399.519 337.473 399.166 337.771 398.868C338.068 398.571 338.421 398.335 338.81 398.174C339.199 398.013 339.616 397.93 340.037 397.93C340.457 397.93 340.874 398.013 341.263 398.174C341.652 398.335 342.005 398.571 342.302 398.868C342.6 399.166 342.836 399.519 342.997 399.908C343.158 400.297 343.241 400.713 343.241 401.134V408.131C343.241 408.552 343.158 408.968 342.997 409.357C342.836 409.746 342.6 410.099 342.302 410.397C342.005 410.694 341.652 410.931 341.263 411.092C340.874 411.253 340.457 411.335 340.037 411.335C339.616 411.335 339.199 411.253 338.81 411.092C338.421 410.931 338.068 410.694 337.771 410.397C337.473 410.099 337.237 409.746 337.076 409.357C336.915 408.968 336.832 408.552 336.832 408.131V401.134ZM338.945 408.243C338.945 409.208 339.365 409.572 340.037 409.572C340.708 409.572 341.128 409.208 341.128 408.243V400.994C341.128 400.043 340.708 399.679 340.037 399.679C339.365 399.679 338.945 400.043 338.945 400.994V408.243Z",
    fill: "url(#paint359_linear_2204_11443)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M345.9 399.595C346.429 399.665 346.964 399.53 347.396 399.218C347.828 398.906 348.124 398.44 348.223 397.916H349.623V411.377H347.51V401.134H345.9V399.595Z",
    fill: "url(#paint360_linear_2204_11443)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M352.058 401.134C352.029 400.697 352.09 400.258 352.238 399.845C352.385 399.431 352.616 399.053 352.916 398.733C353.215 398.413 353.578 398.157 353.98 397.983C354.383 397.808 354.817 397.718 355.255 397.718C355.694 397.718 356.128 397.808 356.53 397.983C356.933 398.157 357.295 398.413 357.595 398.733C357.895 399.053 358.125 399.431 358.273 399.845C358.421 400.258 358.482 400.697 358.453 401.134V408.131C358.482 408.569 358.421 409.008 358.273 409.421C358.125 409.834 357.895 410.212 357.595 410.532C357.295 410.853 356.933 411.108 356.53 411.283C356.128 411.457 355.694 411.547 355.255 411.547C354.817 411.547 354.383 411.457 353.98 411.283C353.578 411.108 353.215 410.853 352.916 410.532C352.616 410.212 352.385 409.834 352.238 409.421C352.09 409.008 352.029 408.569 352.058 408.131V401.134ZM354.157 408.243C354.157 409.209 354.577 409.572 355.248 409.572C355.92 409.572 356.34 409.209 356.34 408.243V400.994C356.34 400.043 355.92 399.679 355.248 399.679C354.577 399.679 354.157 400.043 354.157 400.994V408.243Z",
    fill: "url(#paint361_linear_2204_11443)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M361.098 399.595C361.625 399.665 362.159 399.529 362.588 399.217C363.018 398.904 363.311 398.438 363.407 397.916H364.807V411.377H362.694V401.134H361.07L361.098 399.595Z",
    fill: "url(#paint362_linear_2204_11443)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M367.212 401.134C367.183 400.697 367.244 400.258 367.392 399.845C367.539 399.431 367.77 399.053 368.07 398.733C368.37 398.413 368.732 398.157 369.135 397.983C369.537 397.808 369.971 397.718 370.41 397.718C370.848 397.718 371.282 397.808 371.685 397.983C372.087 398.157 372.449 398.413 372.749 398.733C373.049 399.053 373.28 399.431 373.427 399.845C373.575 400.258 373.636 400.697 373.607 401.134V408.131C373.636 408.569 373.575 409.008 373.427 409.421C373.28 409.834 373.049 410.212 372.749 410.532C372.449 410.853 372.087 411.108 371.685 411.283C371.282 411.457 370.848 411.547 370.41 411.547C369.971 411.547 369.537 411.457 369.135 411.283C368.732 411.108 368.37 410.853 368.07 410.532C367.77 410.212 367.539 409.834 367.392 409.421C367.244 409.008 367.183 408.569 367.212 408.131V401.134ZM369.311 408.243C369.311 409.209 369.745 409.572 370.417 409.572C371.088 409.572 371.508 409.209 371.508 408.243V400.994C371.508 400.043 371.074 399.679 370.417 399.679C369.759 399.679 369.311 400.043 369.311 400.994V408.243Z",
    fill: "url(#paint363_linear_2204_11443)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M376.28 399.595C376.808 399.662 377.341 399.525 377.772 399.214C378.204 398.902 378.5 398.438 378.603 397.916H380.002V411.377H377.889V401.134H376.266L376.28 399.595Z",
    fill: "url(#paint364_linear_2204_11443)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M391.311 401.134C391.311 400.284 391.648 399.469 392.249 398.868C392.85 398.267 393.665 397.93 394.515 397.93C395.365 397.93 396.18 398.267 396.781 398.868C397.382 399.469 397.72 400.284 397.72 401.134V408.131C397.72 408.981 397.382 409.796 396.781 410.397C396.18 410.998 395.365 411.335 394.515 411.335C393.665 411.335 392.85 410.998 392.249 410.397C391.648 409.796 391.311 408.981 391.311 408.131V401.134ZM393.424 408.243C393.424 409.208 393.843 409.572 394.515 409.572C395.187 409.572 395.607 409.208 395.607 408.243V400.994C395.607 400.043 395.187 399.679 394.515 399.679C393.843 399.679 393.424 400.043 393.424 400.994V408.243Z",
    fill: "url(#paint365_linear_2204_11443)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M400.377 399.595C400.906 399.665 401.441 399.53 401.873 399.218C402.305 398.906 402.601 398.44 402.7 397.916H404.1V411.377H402.001V401.134H400.363L400.377 399.595Z",
    fill: "url(#paint366_linear_2204_11443)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M406.492 401.134C406.492 400.284 406.83 399.469 407.431 398.868C408.032 398.267 408.847 397.93 409.697 397.93C410.547 397.93 411.362 398.267 411.963 398.868C412.564 399.469 412.901 400.284 412.901 401.134V408.131C412.901 408.981 412.564 409.796 411.963 410.397C411.362 410.998 410.547 411.335 409.697 411.335C408.847 411.335 408.032 410.998 407.431 410.397C406.83 409.796 406.492 408.981 406.492 408.131V401.134ZM408.605 408.243C408.605 409.208 409.025 409.572 409.697 409.572C410.368 409.572 410.788 409.208 410.788 408.243V400.994C410.788 400.043 410.368 399.679 409.697 399.679C409.025 399.679 408.605 400.043 408.605 400.994V408.243Z",
    fill: "url(#paint367_linear_2204_11443)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M415.559 399.595C416.087 399.665 416.623 399.53 417.055 399.218C417.487 398.906 417.783 398.44 417.882 397.916H419.281V411.377H417.182V401.134H415.545L415.559 399.595Z",
    fill: "url(#paint368_linear_2204_11443)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M423.16 399.595C423.688 399.662 424.222 399.525 424.653 399.214C425.084 398.902 425.381 398.438 425.483 397.916H426.882V411.377H424.825V401.134H423.202L423.16 399.595Z",
    fill: "url(#paint369_linear_2204_11443)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M430.744 399.595C431.273 399.665 431.808 399.53 432.24 399.218C432.672 398.906 432.968 398.44 433.067 397.916H434.466V411.377H432.381V401.134H430.744V399.595Z",
    fill: "url(#paint370_linear_2204_11443)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M436.872 401.134C436.843 400.697 436.904 400.258 437.052 399.845C437.2 399.431 437.43 399.053 437.73 398.733C438.03 398.413 438.392 398.157 438.795 397.983C439.197 397.808 439.631 397.718 440.07 397.718C440.508 397.718 440.942 397.808 441.345 397.983C441.747 398.157 442.11 398.413 442.409 398.733C442.709 399.053 442.94 399.431 443.087 399.845C443.235 400.258 443.296 400.697 443.267 401.134V408.131C443.296 408.569 443.235 409.008 443.087 409.421C442.94 409.834 442.709 410.212 442.409 410.532C442.11 410.853 441.747 411.108 441.345 411.283C440.942 411.457 440.508 411.547 440.07 411.547C439.631 411.547 439.197 411.457 438.795 411.283C438.392 411.108 438.03 410.853 437.73 410.532C437.43 410.212 437.2 409.834 437.052 409.421C436.904 409.008 436.843 408.569 436.872 408.131V401.134ZM438.971 408.243C438.971 409.209 439.391 409.572 440.063 409.572C440.734 409.572 441.154 409.209 441.154 408.243V400.994C441.154 400.043 440.734 399.679 440.063 399.679C439.391 399.679 438.971 400.043 438.971 400.994V408.243Z",
    fill: "url(#paint371_linear_2204_11443)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M445.94 399.595C446.467 399.665 447 399.529 447.43 399.217C447.86 398.904 448.153 398.438 448.249 397.916H449.648V411.377H447.535V401.134H445.912L445.94 399.595Z",
    fill: "url(#paint372_linear_2204_11443)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M453.524 399.595C454.053 399.665 454.588 399.53 455.02 399.218C455.452 398.906 455.748 398.44 455.847 397.916H457.246V411.377H455.133V401.134H453.496L453.524 399.595Z",
    fill: "url(#paint373_linear_2204_11443)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M461.123 399.595C461.651 399.662 462.185 399.525 462.616 399.214C463.047 398.902 463.344 398.438 463.446 397.916H464.845V411.377H462.746V401.134H461.123V399.595Z",
    fill: "url(#paint374_linear_2204_11443)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M468.708 399.595C469.236 399.665 469.771 399.53 470.203 399.218C470.635 398.906 470.931 398.44 471.031 397.916H472.43V411.377H470.317V401.134H468.68L468.708 399.595Z",
    fill: "url(#paint375_linear_2204_11443)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M476.307 399.595C476.835 399.662 477.368 399.525 477.799 399.214C478.231 398.902 478.527 398.438 478.63 397.916H480.029V411.377H478V401.134H476.377L476.307 399.595Z",
    fill: "url(#paint376_linear_2204_11443)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M483.905 399.595C484.432 399.665 484.965 399.529 485.395 399.217C485.825 398.904 486.118 398.438 486.214 397.916H487.613V411.377H485.5V401.134H483.877L483.905 399.595Z",
    fill: "url(#paint377_linear_2204_11443)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M492.986 401.134C492.986 400.284 493.324 399.469 493.925 398.868C494.526 398.267 495.341 397.93 496.191 397.93C497.041 397.93 497.856 398.267 498.457 398.868C499.058 399.469 499.395 400.284 499.395 401.134V408.131C499.395 408.981 499.058 409.796 498.457 410.397C497.856 410.998 497.041 411.335 496.191 411.335C495.341 411.335 494.526 410.998 493.925 410.397C493.324 409.796 492.986 408.981 492.986 408.131V401.134ZM495.099 408.243C495.099 409.208 495.519 409.572 496.191 409.572C496.863 409.572 497.282 409.208 497.282 408.243V400.994C497.282 400.043 496.863 399.679 496.191 399.679C495.519 399.679 495.099 400.043 495.099 400.994V408.243Z",
    fill: "url(#paint378_linear_2204_11443)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M502.055 399.595C502.583 399.665 503.119 399.53 503.551 399.218C503.983 398.906 504.279 398.44 504.378 397.916H505.777V411.377H503.678V401.134H502.041L502.055 399.595Z",
    fill: "url(#paint379_linear_2204_11443)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M509.653 399.595C510.18 399.665 510.713 399.529 511.143 399.217C511.573 398.904 511.866 398.438 511.962 397.916H513.361V411.377H511.248V401.134H509.625L509.653 399.595Z",
    fill: "url(#paint380_linear_2204_11443)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M145.697 424.769C145.697 423.919 146.035 423.104 146.636 422.503C147.237 421.902 148.052 421.565 148.902 421.565C149.752 421.565 150.567 421.902 151.168 422.503C151.769 423.104 152.106 423.919 152.106 424.769V431.766C152.106 432.616 151.769 433.431 151.168 434.032C150.567 434.633 149.752 434.97 148.902 434.97C148.052 434.97 147.237 434.633 146.636 434.032C146.035 433.431 145.697 432.616 145.697 431.766V424.769ZM147.81 431.878C147.81 432.843 148.23 433.277 148.902 433.277C149.573 433.277 149.993 432.913 149.993 431.878V424.629C149.993 423.678 149.573 423.314 148.902 423.314C148.23 423.314 147.81 423.678 147.81 424.629V431.878Z",
    fill: "url(#paint381_linear_2204_11443)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M153.351 424.769C153.322 424.331 153.383 423.893 153.531 423.479C153.678 423.066 153.909 422.688 154.209 422.368C154.508 422.047 154.871 421.792 155.273 421.618C155.676 421.443 156.11 421.353 156.548 421.353C156.987 421.353 157.421 421.443 157.823 421.618C158.226 421.792 158.588 422.047 158.888 422.368C159.188 422.688 159.418 423.066 159.566 423.479C159.714 423.893 159.775 424.331 159.746 424.769V431.766C159.775 432.204 159.714 432.643 159.566 433.056C159.418 433.469 159.188 433.847 158.888 434.167C158.588 434.488 158.226 434.743 157.823 434.918C157.421 435.092 156.987 435.182 156.548 435.182C156.11 435.182 155.676 435.092 155.273 434.918C154.871 434.743 154.508 434.488 154.209 434.167C153.909 433.847 153.678 433.469 153.531 433.056C153.383 432.643 153.322 432.204 153.351 431.766V424.769ZM155.45 431.878C155.45 432.843 155.884 433.277 156.555 433.277C157.227 433.277 157.647 432.913 157.647 431.878V424.629C157.647 423.678 157.213 423.314 156.555 423.314C155.898 423.314 155.45 423.678 155.45 424.629V431.878Z",
    fill: "url(#paint382_linear_2204_11443)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M160.879 424.769C160.879 423.919 161.217 423.104 161.817 422.503C162.418 421.902 163.234 421.565 164.083 421.565C164.933 421.565 165.748 421.902 166.349 422.503C166.95 423.104 167.288 423.919 167.288 424.769V431.766C167.288 432.616 166.95 433.431 166.349 434.032C165.748 434.633 164.933 434.97 164.083 434.97C163.234 434.97 162.418 434.633 161.817 434.032C161.217 433.431 160.879 432.616 160.879 431.766V424.769ZM162.992 431.878C162.992 432.843 163.412 433.277 164.083 433.277C164.755 433.277 165.175 432.913 165.175 431.878V424.629C165.175 423.678 164.755 423.314 164.083 423.314C163.412 423.314 162.992 423.678 162.992 424.629V431.878Z",
    fill: "url(#paint383_linear_2204_11443)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M169.946 423.23C170.475 423.3 171.01 423.165 171.442 422.853C171.874 422.54 172.17 422.074 172.269 421.551H173.669V434.97H171.542V424.727H169.904L169.946 423.23Z",
    fill: "url(#paint384_linear_2204_11443)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M180.51 423.23C181.039 423.3 181.574 423.165 182.006 422.853C182.438 422.54 182.734 422.074 182.833 421.551H184.233V434.97H182.12V424.727H180.482L180.51 423.23Z",
    fill: "url(#paint385_linear_2204_11443)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M188.111 423.23C188.639 423.297 189.173 423.16 189.604 422.848C190.035 422.537 190.332 422.073 190.434 421.551H191.834V434.97H189.735V424.727H188.111V423.23Z",
    fill: "url(#paint386_linear_2204_11443)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M195.71 423.23C196.236 423.3 196.77 423.164 197.2 422.852C197.629 422.539 197.923 422.073 198.019 421.551H199.418V434.97H197.305V424.727H195.682L195.71 423.23Z",
    fill: "url(#paint387_linear_2204_11443)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M203.293 423.23C203.822 423.3 204.357 423.165 204.789 422.853C205.221 422.54 205.517 422.074 205.616 421.551H207.016V434.97H204.917V424.727H203.279L203.293 423.23Z",
    fill: "url(#paint388_linear_2204_11443)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M210.893 423.23C211.421 423.297 211.954 423.16 212.386 422.848C212.817 422.537 213.114 422.073 213.216 421.551H214.615V434.97H212.502V424.727H210.879L210.893 423.23Z",
    fill: "url(#paint389_linear_2204_11443)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M219.973 424.769C219.973 423.919 220.31 423.104 220.911 422.503C221.512 421.902 222.327 421.565 223.177 421.565C224.027 421.565 224.842 421.902 225.443 422.503C226.044 423.104 226.382 423.919 226.382 424.769V431.766C226.382 432.616 226.044 433.431 225.443 434.032C224.842 434.633 224.027 434.97 223.177 434.97C222.327 434.97 221.512 434.633 220.911 434.032C220.31 433.431 219.973 432.616 219.973 431.766V424.769ZM222.086 431.878C222.086 432.843 222.505 433.277 223.177 433.277C223.849 433.277 224.269 432.913 224.269 431.878V424.629C224.269 423.678 223.849 423.314 223.177 423.314C222.505 423.314 222.086 423.678 222.086 424.629V431.878Z",
    fill: "url(#paint390_linear_2204_11443)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M227.517 424.769C227.488 424.331 227.549 423.893 227.697 423.479C227.844 423.066 228.075 422.688 228.375 422.368C228.674 422.047 229.037 421.792 229.439 421.618C229.842 421.443 230.276 421.353 230.714 421.353C231.153 421.353 231.587 421.443 231.989 421.618C232.392 421.792 232.754 422.047 233.054 422.368C233.354 422.688 233.584 423.066 233.732 423.479C233.88 423.893 233.941 424.331 233.912 424.769V431.766C233.941 432.204 233.88 432.643 233.732 433.056C233.584 433.469 233.354 433.847 233.054 434.167C232.754 434.488 232.392 434.743 231.989 434.918C231.587 435.092 231.153 435.182 230.714 435.182C230.276 435.182 229.842 435.092 229.439 434.918C229.037 434.743 228.674 434.488 228.375 434.167C228.075 433.847 227.844 433.469 227.697 433.056C227.549 432.643 227.488 432.204 227.517 431.766V424.769ZM229.616 431.878C229.616 432.843 230.05 433.277 230.721 433.277C231.393 433.277 231.813 432.913 231.813 431.878V424.629C231.813 423.678 231.393 423.314 230.721 423.314C230.05 423.314 229.616 423.678 229.616 424.629V431.878Z",
    fill: "url(#paint391_linear_2204_11443)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M235.156 424.769C235.156 423.919 235.494 423.104 236.095 422.503C236.696 421.902 237.511 421.565 238.361 421.565C239.211 421.565 240.026 421.902 240.627 422.503C241.228 423.104 241.565 423.919 241.565 424.769V431.766C241.565 432.616 241.228 433.431 240.627 434.032C240.026 434.633 239.211 434.97 238.361 434.97C237.511 434.97 236.696 434.633 236.095 434.032C235.494 433.431 235.156 432.616 235.156 431.766V424.769ZM237.269 431.878C237.269 432.843 237.689 433.277 238.361 433.277C239.032 433.277 239.452 432.913 239.452 431.878V424.629C239.452 423.678 239.032 423.314 238.361 423.314C237.689 423.314 237.269 423.678 237.269 424.629V431.878Z",
    fill: "url(#paint392_linear_2204_11443)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M242.756 424.769C242.756 423.919 243.093 423.104 243.694 422.503C244.295 421.902 245.11 421.565 245.96 421.565C246.81 421.565 247.625 421.902 248.226 422.503C248.827 423.104 249.165 423.919 249.165 424.769V431.766C249.165 432.616 248.827 433.431 248.226 434.032C247.625 434.633 246.81 434.97 245.96 434.97C245.11 434.97 244.295 434.633 243.694 434.032C243.093 433.431 242.756 432.616 242.756 431.766V424.769ZM244.869 431.878C244.869 432.843 245.289 433.277 245.96 433.277C246.632 433.277 247.052 432.913 247.052 431.878V424.629C247.052 423.678 246.632 423.314 245.96 423.314C245.289 423.314 244.869 423.678 244.869 424.629V431.878Z",
    fill: "url(#paint393_linear_2204_11443)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M250.353 424.769C250.324 424.331 250.385 423.893 250.532 423.479C250.68 423.066 250.911 422.688 251.211 422.368C251.51 422.047 251.873 421.792 252.275 421.618C252.678 421.443 253.112 421.353 253.55 421.353C253.989 421.353 254.423 421.443 254.825 421.618C255.228 421.792 255.59 422.047 255.89 422.368C256.19 422.688 256.42 423.066 256.568 423.479C256.715 423.893 256.777 424.331 256.748 424.769V431.766C256.777 432.204 256.715 432.643 256.568 433.056C256.42 433.469 256.19 433.847 255.89 434.167C255.59 434.488 255.228 434.743 254.825 434.918C254.423 435.092 253.989 435.182 253.55 435.182C253.112 435.182 252.678 435.092 252.275 434.918C251.873 434.743 251.51 434.488 251.211 434.167C250.911 433.847 250.68 433.469 250.532 433.056C250.385 432.643 250.324 432.204 250.353 431.766V424.769ZM252.452 431.878C252.452 432.843 252.872 433.277 253.543 433.277C254.215 433.277 254.635 432.913 254.635 431.878V424.629C254.635 423.678 254.215 423.314 253.543 423.314C252.872 423.314 252.452 423.678 252.452 424.629V431.878Z",
    fill: "url(#paint394_linear_2204_11443)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M265.299 423.23C265.827 423.3 266.363 423.165 266.795 422.853C267.227 422.54 267.523 422.074 267.622 421.551H269.021V434.97H266.908V424.727H265.299V423.23Z",
    fill: "url(#paint395_linear_2204_11443)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M272.952 423.23C273.479 423.297 274.013 423.16 274.444 422.848C274.875 422.537 275.172 422.073 275.274 421.551H276.674V434.97H274.561V424.727H272.938L272.952 423.23Z",
    fill: "url(#paint396_linear_2204_11443)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M280.553 423.23C281.08 423.3 281.613 423.164 282.043 422.852C282.473 422.539 282.766 422.073 282.862 421.551H284.261V434.97H282.148V424.727H280.553V423.23Z",
    fill: "url(#paint397_linear_2204_11443)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M288.137 423.23C288.666 423.3 289.201 423.165 289.633 422.853C290.065 422.54 290.361 422.074 290.46 421.551H291.859V434.97H289.76V424.727H288.123L288.137 423.23Z",
    fill: "url(#paint398_linear_2204_11443)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M295.735 423.23C296.263 423.297 296.796 423.16 297.227 422.848C297.659 422.537 297.955 422.073 298.058 421.551H299.457V434.97H297.344V424.727H295.721L295.735 423.23Z",
    fill: "url(#paint399_linear_2204_11443)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M303.319 423.23C303.847 423.3 304.382 423.165 304.814 422.853C305.246 422.54 305.542 422.074 305.642 421.551H307.041V434.97H304.942V424.727H303.305L303.319 423.23Z",
    fill: "url(#paint400_linear_2204_11443)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M309.434 424.769C309.434 423.919 309.771 423.104 310.372 422.503C310.973 421.902 311.788 421.565 312.638 421.565C313.488 421.565 314.303 421.902 314.904 422.503C315.505 423.104 315.843 423.919 315.843 424.769V431.766C315.843 432.616 315.505 433.431 314.904 434.032C314.303 434.633 313.488 434.97 312.638 434.97C311.788 434.97 310.973 434.633 310.372 434.032C309.771 433.431 309.434 432.616 309.434 431.766V424.769ZM311.547 431.878C311.547 432.843 311.966 433.277 312.638 433.277C313.31 433.277 313.73 432.913 313.73 431.878V424.629C313.73 423.678 313.31 423.314 312.638 423.314C311.966 423.314 311.547 423.678 311.547 424.629V431.878Z",
    fill: "url(#paint401_linear_2204_11443)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M317.074 424.769C317.074 423.919 317.412 423.104 318.013 422.503C318.614 421.902 319.429 421.565 320.279 421.565C321.129 421.565 321.944 421.902 322.545 422.503C323.146 423.104 323.483 423.919 323.483 424.769V431.766C323.483 432.616 323.146 433.431 322.545 434.032C321.944 434.633 321.129 434.97 320.279 434.97C319.429 434.97 318.614 434.633 318.013 434.032C317.412 433.431 317.074 432.616 317.074 431.766V424.769ZM319.187 431.878C319.187 432.843 319.607 433.277 320.279 433.277C320.95 433.277 321.37 432.913 321.37 431.878V424.629C321.37 423.678 320.95 423.314 320.279 423.314C319.607 423.314 319.187 423.678 319.187 424.629V431.878Z",
    fill: "url(#paint402_linear_2204_11443)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M324.63 424.769C324.601 424.331 324.662 423.893 324.81 423.479C324.957 423.066 325.188 422.688 325.488 422.368C325.788 422.047 326.15 421.792 326.552 421.618C326.955 421.443 327.389 421.353 327.828 421.353C328.266 421.353 328.7 421.443 329.103 421.618C329.505 421.792 329.867 422.047 330.167 422.368C330.467 422.688 330.698 423.066 330.845 423.479C330.993 423.893 331.054 424.331 331.025 424.769V431.766C331.054 432.204 330.993 432.643 330.845 433.056C330.698 433.469 330.467 433.847 330.167 434.167C329.867 434.488 329.505 434.743 329.103 434.918C328.7 435.092 328.266 435.182 327.828 435.182C327.389 435.182 326.955 435.092 326.552 434.918C326.15 434.743 325.788 434.488 325.488 434.167C325.188 433.847 324.957 433.469 324.81 433.056C324.662 432.643 324.601 432.204 324.63 431.766V424.769ZM326.729 431.878C326.729 432.843 327.149 433.277 327.821 433.277C328.492 433.277 328.912 432.913 328.912 431.878V424.629C328.912 423.678 328.492 423.314 327.821 423.314C327.149 423.314 326.729 423.678 326.729 424.629V431.878Z",
    fill: "url(#paint403_linear_2204_11443)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M332.215 424.769C332.215 423.919 332.552 423.104 333.153 422.503C333.754 421.902 334.569 421.565 335.419 421.565C336.269 421.565 337.084 421.902 337.685 422.503C338.286 423.104 338.624 423.919 338.624 424.769V431.766C338.624 432.616 338.286 433.431 337.685 434.032C337.084 434.633 336.269 434.97 335.419 434.97C334.569 434.97 333.754 434.633 333.153 434.032C332.552 433.431 332.215 432.616 332.215 431.766V424.769ZM334.328 431.878C334.328 432.843 334.748 433.277 335.419 433.277C336.091 433.277 336.511 432.913 336.511 431.878V424.629C336.511 423.678 336.091 423.314 335.419 423.314C334.748 423.314 334.328 423.678 334.328 424.629V431.878Z",
    fill: "url(#paint404_linear_2204_11443)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M339.814 424.769C339.785 424.331 339.846 423.893 339.993 423.479C340.141 423.066 340.372 422.688 340.672 422.368C340.971 422.047 341.334 421.792 341.736 421.618C342.139 421.443 342.573 421.353 343.011 421.353C343.45 421.353 343.884 421.443 344.286 421.618C344.689 421.792 345.051 422.047 345.351 422.368C345.65 422.688 345.881 423.066 346.029 423.479C346.176 423.893 346.238 424.331 346.209 424.769V431.766C346.238 432.204 346.176 432.643 346.029 433.056C345.881 433.469 345.65 433.847 345.351 434.167C345.051 434.488 344.689 434.743 344.286 434.918C343.884 435.092 343.45 435.182 343.011 435.182C342.573 435.182 342.139 435.092 341.736 434.918C341.334 434.743 340.971 434.488 340.672 434.167C340.372 433.847 340.141 433.469 339.993 433.056C339.846 432.643 339.785 432.204 339.814 431.766V424.769ZM341.913 431.878C341.913 432.843 342.346 433.277 343.018 433.277C343.69 433.277 344.11 432.913 344.11 431.878V424.629C344.11 423.678 343.676 423.314 343.018 423.314C342.36 423.314 341.913 423.678 341.913 424.629V431.878Z",
    fill: "url(#paint405_linear_2204_11443)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M347.398 424.769C347.398 423.919 347.736 423.104 348.337 422.503C348.938 421.902 349.753 421.565 350.603 421.565C351.453 421.565 352.268 421.902 352.869 422.503C353.47 423.104 353.807 423.919 353.807 424.769V431.766C353.807 432.616 353.47 433.431 352.869 434.032C352.268 434.633 351.453 434.97 350.603 434.97C349.753 434.97 348.938 434.633 348.337 434.032C347.736 433.431 347.398 432.616 347.398 431.766V424.769ZM349.511 431.878C349.511 432.843 349.931 433.277 350.603 433.277C351.275 433.277 351.694 432.913 351.694 431.878V424.629C351.694 423.678 351.275 423.314 350.603 423.314C349.931 423.314 349.511 423.678 349.511 424.629V431.878Z",
    fill: "url(#paint406_linear_2204_11443)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M354.997 424.769C354.968 424.331 355.029 423.893 355.177 423.479C355.325 423.066 355.555 422.688 355.855 422.368C356.155 422.047 356.517 421.792 356.92 421.618C357.322 421.443 357.756 421.353 358.195 421.353C358.633 421.353 359.067 421.443 359.47 421.618C359.872 421.792 360.235 422.047 360.534 422.368C360.834 422.688 361.065 423.066 361.212 423.479C361.36 423.893 361.421 424.331 361.392 424.769V431.766C361.421 432.204 361.36 432.643 361.212 433.056C361.065 433.469 360.834 433.847 360.534 434.167C360.235 434.488 359.872 434.743 359.47 434.918C359.067 435.092 358.633 435.182 358.195 435.182C357.756 435.182 357.322 435.092 356.92 434.918C356.517 434.743 356.155 434.488 355.855 434.167C355.555 433.847 355.325 433.469 355.177 433.056C355.029 432.643 354.968 432.204 354.997 431.766V424.769ZM357.11 431.878C357.11 432.843 357.53 433.277 358.202 433.277C358.873 433.277 359.293 432.913 359.293 431.878V424.629C359.293 423.678 358.873 423.314 358.202 423.314C357.53 423.314 357.11 423.678 357.11 424.629V431.878Z",
    fill: "url(#paint407_linear_2204_11443)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M367.031 423.23C367.56 423.3 368.095 423.165 368.527 422.853C368.959 422.54 369.255 422.074 369.354 421.551H370.753V434.97H368.64V424.727H367.031V423.23Z",
    fill: "url(#paint408_linear_2204_11443)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M374.629 423.23C375.157 423.297 375.691 423.16 376.122 422.848C376.553 422.537 376.85 422.073 376.952 421.551H378.352V434.97H376.238V424.727H374.615L374.629 423.23Z",
    fill: "url(#paint409_linear_2204_11443)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M382.227 423.23C382.754 423.3 383.287 423.164 383.717 422.852C384.147 422.539 384.44 422.073 384.536 421.551H385.935V434.97H383.822V424.727H382.199L382.227 423.23Z",
    fill: "url(#paint410_linear_2204_11443)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M389.84 423.23C390.368 423.3 390.904 423.165 391.336 422.853C391.768 422.54 392.064 422.074 392.163 421.551H393.562V434.97H391.463V424.727H389.84V423.23Z",
    fill: "url(#paint411_linear_2204_11443)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M397.41 423.23C397.938 423.297 398.472 423.16 398.903 422.848C399.334 422.537 399.631 422.073 399.733 421.551H401.133V434.97H399.02V424.727H397.396L397.41 423.23Z",
    fill: "url(#paint412_linear_2204_11443)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M409.431 424.769C409.402 424.331 409.463 423.893 409.611 423.479C409.758 423.066 409.989 422.688 410.289 422.368C410.589 422.047 410.951 421.792 411.353 421.618C411.756 421.443 412.19 421.353 412.628 421.353C413.067 421.353 413.501 421.443 413.903 421.618C414.306 421.792 414.668 422.047 414.968 422.368C415.268 422.688 415.498 423.066 415.646 423.479C415.794 423.893 415.855 424.331 415.826 424.769V431.766C415.855 432.204 415.794 432.643 415.646 433.056C415.498 433.469 415.268 433.847 414.968 434.167C414.668 434.488 414.306 434.743 413.903 434.918C413.501 435.092 413.067 435.182 412.628 435.182C412.19 435.182 411.756 435.092 411.353 434.918C410.951 434.743 410.589 434.488 410.289 434.167C409.989 433.847 409.758 433.469 409.611 433.056C409.463 432.643 409.402 432.204 409.431 431.766V424.769ZM411.53 431.878C411.53 432.843 411.95 433.277 412.621 433.277C413.293 433.277 413.713 432.913 413.713 431.878V424.629C413.713 423.678 413.293 423.314 412.621 423.314C411.95 423.314 411.53 423.678 411.53 424.629V431.878Z",
    fill: "url(#paint413_linear_2204_11443)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M417.057 424.769C417.057 423.919 417.394 423.104 417.995 422.503C418.596 421.902 419.411 421.565 420.261 421.565C421.111 421.565 421.926 421.902 422.527 422.503C423.128 423.104 423.466 423.919 423.466 424.769V431.766C423.466 432.616 423.128 433.431 422.527 434.032C421.926 434.633 421.111 434.97 420.261 434.97C419.411 434.97 418.596 434.633 417.995 434.032C417.394 433.431 417.057 432.616 417.057 431.766V424.769ZM419.17 431.878C419.17 432.843 419.589 433.277 420.261 433.277C420.933 433.277 421.353 432.913 421.353 431.878V424.629C421.353 423.678 420.933 423.314 420.261 423.314C419.589 423.314 419.17 423.678 419.17 424.629V431.878Z",
    fill: "url(#paint414_linear_2204_11443)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M424.657 424.769C424.628 424.331 424.69 423.893 424.837 423.479C424.985 423.066 425.216 422.688 425.515 422.368C425.815 422.047 426.177 421.792 426.58 421.618C426.982 421.443 427.416 421.353 427.855 421.353C428.294 421.353 428.728 421.443 429.13 421.618C429.532 421.792 429.895 422.047 430.194 422.368C430.494 422.688 430.725 423.066 430.873 423.479C431.02 423.893 431.081 424.331 431.052 424.769V431.766C431.081 432.204 431.02 432.643 430.873 433.056C430.725 433.469 430.494 433.847 430.194 434.167C429.895 434.488 429.532 434.743 429.13 434.918C428.728 435.092 428.294 435.182 427.855 435.182C427.416 435.182 426.982 435.092 426.58 434.918C426.177 434.743 425.815 434.488 425.515 434.167C425.216 433.847 424.985 433.469 424.837 433.056C424.69 432.643 424.628 432.204 424.657 431.766V424.769ZM426.756 431.878C426.756 432.843 427.19 433.277 427.862 433.277C428.534 433.277 428.953 432.913 428.953 431.878V424.629C428.953 423.678 428.52 423.314 427.862 423.314C427.204 423.314 426.756 423.678 426.756 424.629V431.878Z",
    fill: "url(#paint415_linear_2204_11443)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M432.24 424.769C432.24 423.919 432.578 423.104 433.179 422.503C433.78 421.902 434.595 421.565 435.445 421.565C436.295 421.565 437.11 421.902 437.711 422.503C438.312 423.104 438.649 423.919 438.649 424.769V431.766C438.649 432.616 438.312 433.431 437.711 434.032C437.11 434.633 436.295 434.97 435.445 434.97C434.595 434.97 433.78 434.633 433.179 434.032C432.578 433.431 432.24 432.616 432.24 431.766V424.769ZM434.353 431.878C434.353 432.843 434.773 433.277 435.445 433.277C436.116 433.277 436.536 432.913 436.536 431.878V424.629C436.536 423.678 436.116 423.314 435.445 423.314C434.773 423.314 434.353 423.678 434.353 424.629V431.878Z",
    fill: "url(#paint416_linear_2204_11443)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M439.838 424.769C439.838 424.348 439.921 423.932 440.082 423.543C440.243 423.154 440.479 422.801 440.776 422.503C441.074 422.206 441.427 421.97 441.816 421.809C442.205 421.648 442.622 421.565 443.042 421.565C443.463 421.565 443.88 421.648 444.269 421.809C444.657 421.97 445.011 422.206 445.308 422.503C445.606 422.801 445.842 423.154 446.003 423.543C446.164 423.932 446.247 424.348 446.247 424.769V431.766C446.247 432.187 446.164 432.603 446.003 432.992C445.842 433.381 445.606 433.734 445.308 434.032C445.011 434.329 444.657 434.566 444.269 434.727C443.88 434.888 443.463 434.97 443.042 434.97C442.622 434.97 442.205 434.888 441.816 434.727C441.427 434.566 441.074 434.329 440.776 434.032C440.479 433.734 440.243 433.381 440.082 432.992C439.921 432.603 439.838 432.187 439.838 431.766V424.769ZM441.951 431.878C441.951 432.843 442.371 433.277 443.042 433.277C443.714 433.277 444.134 432.913 444.134 431.878V424.629C444.134 423.678 443.714 423.314 443.042 423.314C442.371 423.314 441.951 423.678 441.951 424.629V431.878Z",
    fill: "url(#paint417_linear_2204_11443)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M447.437 424.769C447.408 424.331 447.469 423.893 447.616 423.479C447.764 423.066 447.995 422.688 448.295 422.368C448.594 422.047 448.957 421.792 449.359 421.618C449.762 421.443 450.196 421.353 450.634 421.353C451.073 421.353 451.507 421.443 451.909 421.618C452.312 421.792 452.674 422.047 452.974 422.368C453.273 422.688 453.504 423.066 453.652 423.479C453.799 423.893 453.861 424.331 453.832 424.769V431.766C453.861 432.204 453.799 432.643 453.652 433.056C453.504 433.469 453.273 433.847 452.974 434.167C452.674 434.488 452.312 434.743 451.909 434.918C451.507 435.092 451.073 435.182 450.634 435.182C450.196 435.182 449.762 435.092 449.359 434.918C448.957 434.743 448.594 434.488 448.295 434.167C447.995 433.847 447.764 433.469 447.616 433.056C447.469 432.643 447.408 432.204 447.437 431.766V424.769ZM449.536 431.878C449.536 432.843 449.956 433.277 450.627 433.277C451.299 433.277 451.719 432.913 451.719 431.878V424.629C451.719 423.678 451.299 423.314 450.627 423.314C449.956 423.314 449.536 423.678 449.536 424.629V431.878Z",
    fill: "url(#paint418_linear_2204_11443)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M460.969 424.769C460.969 423.919 461.306 423.104 461.907 422.503C462.508 421.902 463.323 421.565 464.173 421.565C465.023 421.565 465.838 421.902 466.439 422.503C467.04 423.104 467.378 423.919 467.378 424.769V431.766C467.378 432.616 467.04 433.431 466.439 434.032C465.838 434.633 465.023 434.97 464.173 434.97C463.323 434.97 462.508 434.633 461.907 434.032C461.306 433.431 460.969 432.616 460.969 431.766V424.769ZM463.082 431.878C463.082 432.843 463.502 433.277 464.173 433.277C464.845 433.277 465.265 432.913 465.265 431.878V424.629C465.265 423.678 464.845 423.314 464.173 423.314C463.502 423.314 463.082 423.678 463.082 424.629V431.878Z",
    fill: "url(#paint419_linear_2204_11443)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M470.037 423.23C470.565 423.297 471.099 423.16 471.53 422.848C471.961 422.537 472.258 422.073 472.36 421.551H473.76V434.97H471.647V424.727H470.023L470.037 423.23Z",
    fill: "url(#paint420_linear_2204_11443)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M476.152 424.769C476.152 423.919 476.49 423.104 477.091 422.503C477.692 421.902 478.507 421.565 479.357 421.565C480.207 421.565 481.022 421.902 481.623 422.503C482.224 423.104 482.561 423.919 482.561 424.769V431.766C482.561 432.616 482.224 433.431 481.623 434.032C481.022 434.633 480.207 434.97 479.357 434.97C478.507 434.97 477.692 434.633 477.091 434.032C476.49 433.431 476.152 432.616 476.152 431.766V424.769ZM478.265 431.878C478.265 432.843 478.685 433.277 479.357 433.277C480.029 433.277 480.448 432.913 480.448 431.878V424.629C480.448 423.678 480.029 423.314 479.357 423.314C478.685 423.314 478.265 423.678 478.265 424.629V431.878Z",
    fill: "url(#paint421_linear_2204_11443)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M485.219 423.23C485.748 423.3 486.283 423.165 486.715 422.853C487.147 422.54 487.443 422.074 487.542 421.551H488.941V434.97H486.842V424.727H485.205L485.219 423.23Z",
    fill: "url(#paint422_linear_2204_11443)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M491.336 424.769C491.336 423.919 491.674 423.104 492.275 422.503C492.875 421.902 493.691 421.565 494.54 421.565C495.39 421.565 496.205 421.902 496.806 422.503C497.407 423.104 497.745 423.919 497.745 424.769V431.766C497.745 432.616 497.407 433.431 496.806 434.032C496.205 434.633 495.39 434.97 494.54 434.97C493.691 434.97 492.875 434.633 492.275 434.032C491.674 433.431 491.336 432.616 491.336 431.766V424.769ZM493.449 431.878C493.449 432.843 493.869 433.277 494.54 433.277C495.212 433.277 495.632 432.913 495.632 431.878V424.629C495.632 423.678 495.212 423.314 494.54 423.314C493.869 423.314 493.449 423.678 493.449 424.629V431.878Z",
    fill: "url(#paint423_linear_2204_11443)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M500.389 423.23C500.917 423.3 501.452 423.165 501.884 422.853C502.316 422.54 502.612 422.074 502.712 421.551H504.111V434.97H502.012V424.727H500.389V423.23Z",
    fill: "url(#paint424_linear_2204_11443)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M506.518 424.769C506.518 423.919 506.855 423.104 507.456 422.503C508.057 421.902 508.872 421.565 509.722 421.565C510.572 421.565 511.387 421.902 511.988 422.503C512.589 423.104 512.927 423.919 512.927 424.769V431.766C512.927 432.616 512.589 433.431 511.988 434.032C511.387 434.633 510.572 434.97 509.722 434.97C508.872 434.97 508.057 434.633 507.456 434.032C506.855 433.431 506.518 432.616 506.518 431.766V424.769ZM508.631 431.878C508.631 432.843 509.05 433.277 509.722 433.277C510.394 433.277 510.814 432.913 510.814 431.878V424.629C510.814 423.678 510.394 423.314 509.722 423.314C509.05 423.314 508.631 423.678 508.631 424.629V431.878Z",
    fill: "url(#paint425_linear_2204_11443)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M145.697 447.76C145.697 446.911 146.035 446.096 146.636 445.495C147.237 444.894 148.052 444.556 148.902 444.556C149.752 444.556 150.567 444.894 151.168 445.495C151.769 446.096 152.106 446.911 152.106 447.76V454.757C152.106 455.607 151.769 456.422 151.168 457.023C150.567 457.624 149.752 457.962 148.902 457.962C148.052 457.962 147.237 457.624 146.636 457.023C146.035 456.422 145.697 455.607 145.697 454.757V447.76ZM147.81 454.869C147.81 455.835 148.23 456.269 148.902 456.269C149.573 456.269 149.993 455.905 149.993 454.869V447.621C149.993 446.669 149.573 446.305 148.902 446.305C148.23 446.305 147.81 446.669 147.81 447.621V454.869Z",
    fill: "url(#paint426_linear_2204_11443)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M154.75 446.235C155.278 446.305 155.814 446.17 156.246 445.858C156.678 445.546 156.974 445.08 157.073 444.556H158.472V457.976H156.373V447.76H154.75V446.235Z",
    fill: "url(#paint427_linear_2204_11443)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M160.879 447.76C160.879 446.911 161.217 446.096 161.817 445.495C162.418 444.894 163.234 444.556 164.083 444.556C164.933 444.556 165.748 444.894 166.349 445.495C166.95 446.096 167.288 446.911 167.288 447.76V454.757C167.288 455.607 166.95 456.422 166.349 457.023C165.748 457.624 164.933 457.962 164.083 457.962C163.234 457.962 162.418 457.624 161.817 457.023C161.217 456.422 160.879 455.607 160.879 454.757V447.76ZM162.992 454.869C162.992 455.835 163.412 456.269 164.083 456.269C164.755 456.269 165.175 455.905 165.175 454.869V447.621C165.175 446.669 164.755 446.305 164.083 446.305C163.412 446.305 162.992 446.669 162.992 447.621V454.869Z",
    fill: "url(#paint428_linear_2204_11443)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M169.946 446.235C170.475 446.305 171.01 446.17 171.442 445.858C171.874 445.546 172.17 445.08 172.269 444.556H173.669V457.976H171.542V447.76H169.904L169.946 446.235Z",
    fill: "url(#paint429_linear_2204_11443)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M176.077 447.76C176.048 447.323 176.11 446.884 176.257 446.471C176.405 446.058 176.635 445.679 176.935 445.359C177.235 445.039 177.597 444.783 178 444.609C178.402 444.434 178.836 444.344 179.275 444.344C179.713 444.344 180.147 444.434 180.55 444.609C180.952 444.783 181.315 445.039 181.614 445.359C181.914 445.679 182.145 446.058 182.293 446.471C182.44 446.884 182.501 447.323 182.472 447.76V454.757C182.501 455.195 182.44 455.634 182.293 456.047C182.145 456.46 181.914 456.838 181.614 457.159C181.315 457.479 180.952 457.734 180.55 457.909C180.147 458.083 179.713 458.173 179.275 458.173C178.836 458.173 178.402 458.083 178 457.909C177.597 457.734 177.235 457.479 176.935 457.159C176.635 456.838 176.405 456.46 176.257 456.047C176.11 455.634 176.048 455.195 176.077 454.757V447.76ZM178.176 454.869C178.176 455.835 178.596 456.268 179.268 456.268C179.94 456.268 180.359 455.905 180.359 454.869V447.621C180.359 446.669 179.94 446.305 179.268 446.305C178.596 446.305 178.176 446.669 178.176 447.621V454.869Z",
    fill: "url(#paint430_linear_2204_11443)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M185.143 446.235C185.67 446.305 186.203 446.17 186.633 445.857C187.063 445.544 187.356 445.079 187.452 444.556H188.851V457.976H186.738V447.76H185.115L185.143 446.235Z",
    fill: "url(#paint431_linear_2204_11443)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M192.729 446.235C193.257 446.305 193.793 446.17 194.225 445.858C194.657 445.546 194.953 445.08 195.052 444.556H196.451V457.976H194.352V447.76H192.715L192.729 446.235Z",
    fill: "url(#paint432_linear_2204_11443)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M200.327 446.235C200.854 446.302 201.388 446.166 201.819 445.854C202.25 445.542 202.547 445.078 202.649 444.556H204.049V457.976H201.936V447.76H200.312L200.327 446.235Z",
    fill: "url(#paint433_linear_2204_11443)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M207.926 446.235C208.454 446.305 208.989 446.17 209.422 445.858C209.854 445.546 210.15 445.08 210.249 444.556H211.648V457.976H209.535V447.76H207.926V446.235Z",
    fill: "url(#paint434_linear_2204_11443)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M215.51 446.235C216.038 446.302 216.572 446.166 217.003 445.854C217.434 445.542 217.731 445.078 217.833 444.556H219.232V457.976H217.119V447.76H215.496L215.51 446.235Z",
    fill: "url(#paint435_linear_2204_11443)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M223.108 446.235C223.635 446.305 224.168 446.17 224.598 445.857C225.028 445.544 225.321 445.079 225.417 444.556H226.816V457.976H224.717V447.76H223.094L223.108 446.235Z",
    fill: "url(#paint436_linear_2204_11443)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M230.692 446.235C231.22 446.305 231.755 446.17 232.187 445.858C232.62 445.546 232.916 445.08 233.015 444.556H234.414V457.976H232.315V447.76H230.678L230.692 446.235Z",
    fill: "url(#paint437_linear_2204_11443)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M236.807 447.76C236.807 446.911 237.144 446.096 237.745 445.495C238.346 444.894 239.161 444.556 240.011 444.556C240.861 444.556 241.676 444.894 242.277 445.495C242.878 446.096 243.216 446.911 243.216 447.76V454.757C243.216 455.607 242.878 456.422 242.277 457.023C241.676 457.624 240.861 457.962 240.011 457.962C239.161 457.962 238.346 457.624 237.745 457.023C237.144 456.422 236.807 455.607 236.807 454.757V447.76ZM238.92 454.869C238.92 455.835 239.339 456.269 240.011 456.269C240.683 456.269 241.103 455.905 241.103 454.869V447.621C241.103 446.669 240.683 446.305 240.011 446.305C239.339 446.305 238.92 446.669 238.92 447.621V454.869Z",
    fill: "url(#paint438_linear_2204_11443)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M245.875 446.235C246.404 446.305 246.939 446.17 247.371 445.858C247.803 445.546 248.099 445.08 248.198 444.556H249.598V457.976H247.499V447.76H245.861L245.875 446.235Z",
    fill: "url(#paint439_linear_2204_11443)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M256.442 446.235C256.97 446.305 257.505 446.17 257.937 445.858C258.37 445.546 258.665 445.08 258.765 444.556H260.164V457.976H258.065V447.76H256.428L256.442 446.235Z",
    fill: "url(#paint440_linear_2204_11443)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M262.5 447.76C262.5 446.911 262.838 446.096 263.439 445.495C264.04 444.894 264.855 444.556 265.705 444.556C266.554 444.556 267.369 444.894 267.97 445.495C268.571 446.096 268.909 446.911 268.909 447.76V454.757C268.909 455.607 268.571 456.422 267.97 457.023C267.369 457.624 266.554 457.962 265.705 457.962C264.855 457.962 264.04 457.624 263.439 457.023C262.838 456.422 262.5 455.607 262.5 454.757V447.76ZM264.613 454.869C264.613 455.835 265.033 456.269 265.705 456.269C266.376 456.269 266.796 455.905 266.796 454.869V447.621C266.796 446.669 266.376 446.305 265.705 446.305C265.033 446.305 264.613 446.669 264.613 447.621V454.869Z",
    fill: "url(#paint441_linear_2204_11443)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M271.624 446.235C272.152 446.305 272.687 446.17 273.119 445.858C273.551 445.546 273.847 445.08 273.947 444.556H275.346V457.976H273.233V447.76H271.596L271.624 446.235Z",
    fill: "url(#paint442_linear_2204_11443)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M282.188 446.235C282.717 446.305 283.252 446.17 283.684 445.858C284.116 445.546 284.412 445.08 284.511 444.556H285.91V457.976H283.797V447.76H282.16L282.188 446.235Z",
    fill: "url(#paint443_linear_2204_11443)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M291.284 447.76C291.255 447.323 291.317 446.884 291.464 446.471C291.612 446.058 291.843 445.679 292.142 445.359C292.442 445.039 292.804 444.783 293.207 444.609C293.609 444.434 294.043 444.344 294.482 444.344C294.921 444.344 295.354 444.434 295.757 444.609C296.159 444.783 296.522 445.039 296.821 445.359C297.121 445.679 297.352 446.058 297.5 446.471C297.647 446.884 297.708 447.323 297.679 447.76V454.757C297.708 455.195 297.647 455.634 297.5 456.047C297.352 456.46 297.121 456.838 296.821 457.159C296.522 457.479 296.159 457.734 295.757 457.909C295.354 458.083 294.921 458.173 294.482 458.173C294.043 458.173 293.609 458.083 293.207 457.909C292.804 457.734 292.442 457.479 292.142 457.159C291.843 456.838 291.612 456.46 291.464 456.047C291.317 455.634 291.255 455.195 291.284 454.757V447.76ZM293.397 454.869C293.397 455.835 293.817 456.268 294.489 456.268C295.161 456.268 295.58 455.905 295.58 454.869V447.621C295.58 446.669 295.161 446.305 294.489 446.305C293.817 446.305 293.397 446.669 293.397 447.621V454.869Z",
    fill: "url(#paint444_linear_2204_11443)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M300.352 446.235C300.88 446.302 301.413 446.166 301.845 445.854C302.276 445.542 302.573 445.078 302.675 444.556H304.074V457.976H301.961V447.76H300.338L300.352 446.235Z",
    fill: "url(#paint445_linear_2204_11443)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M307.95 446.235C308.477 446.305 309.01 446.17 309.44 445.857C309.87 445.544 310.163 445.079 310.259 444.556H311.658V457.976H309.545V447.76H307.922L307.95 446.235Z",
    fill: "url(#paint446_linear_2204_11443)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M315.535 446.235C316.064 446.305 316.599 446.17 317.031 445.858C317.463 445.546 317.759 445.08 317.858 444.556H319.257V457.976H317.158V447.76H315.535V446.235Z",
    fill: "url(#paint447_linear_2204_11443)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M323.133 446.235C323.66 446.305 324.194 446.17 324.623 445.857C325.053 445.544 325.346 445.079 325.442 444.556H326.842V457.976H324.729V447.76H323.105L323.133 446.235Z",
    fill: "url(#paint448_linear_2204_11443)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M330.717 446.235C331.246 446.305 331.781 446.17 332.213 445.858C332.645 445.546 332.941 445.08 333.04 444.556H334.439V457.976H332.34V447.76H330.703L330.717 446.235Z",
    fill: "url(#paint449_linear_2204_11443)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M336.832 447.76C336.832 447.34 336.915 446.923 337.076 446.534C337.237 446.145 337.473 445.792 337.771 445.495C338.068 445.197 338.421 444.961 338.81 444.8C339.199 444.639 339.616 444.556 340.037 444.556C340.457 444.556 340.874 444.639 341.263 444.8C341.652 444.961 342.005 445.197 342.302 445.495C342.6 445.792 342.836 446.145 342.997 446.534C343.158 446.923 343.241 447.34 343.241 447.76V454.757C343.241 455.178 343.158 455.595 342.997 455.984C342.836 456.372 342.6 456.726 342.302 457.023C342.005 457.321 341.652 457.557 341.263 457.718C340.874 457.879 340.457 457.962 340.037 457.962C339.616 457.962 339.199 457.879 338.81 457.718C338.421 457.557 338.068 457.321 337.771 457.023C337.473 456.726 337.237 456.372 337.076 455.984C336.915 455.595 336.832 455.178 336.832 454.757V447.76ZM338.945 454.869C338.945 455.835 339.365 456.269 340.037 456.269C340.708 456.269 341.128 455.905 341.128 454.869V447.621C341.128 446.669 340.708 446.305 340.037 446.305C339.365 446.305 338.945 446.669 338.945 447.621V454.869Z",
    fill: "url(#paint450_linear_2204_11443)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M345.9 446.235C346.429 446.305 346.964 446.17 347.396 445.858C347.828 445.546 348.124 445.08 348.223 444.556H349.623V457.976H347.51V447.76H345.9V446.235Z",
    fill: "url(#paint451_linear_2204_11443)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M352.058 447.76C352.029 447.323 352.09 446.884 352.238 446.471C352.385 446.058 352.616 445.679 352.916 445.359C353.215 445.039 353.578 444.783 353.98 444.609C354.383 444.434 354.817 444.344 355.255 444.344C355.694 444.344 356.128 444.434 356.53 444.609C356.933 444.783 357.295 445.039 357.595 445.359C357.895 445.679 358.125 446.058 358.273 446.471C358.421 446.884 358.482 447.323 358.453 447.76V454.757C358.482 455.195 358.421 455.634 358.273 456.047C358.125 456.46 357.895 456.838 357.595 457.159C357.295 457.479 356.933 457.734 356.53 457.909C356.128 458.083 355.694 458.173 355.255 458.173C354.817 458.173 354.383 458.083 353.98 457.909C353.578 457.734 353.215 457.479 352.916 457.159C352.616 456.838 352.385 456.46 352.238 456.047C352.09 455.634 352.029 455.195 352.058 454.757V447.76ZM354.157 454.869C354.157 455.835 354.577 456.268 355.248 456.268C355.92 456.268 356.34 455.905 356.34 454.869V447.621C356.34 446.669 355.92 446.305 355.248 446.305C354.577 446.305 354.157 446.669 354.157 447.621V454.869Z",
    fill: "url(#paint452_linear_2204_11443)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M361.098 446.235C361.625 446.305 362.159 446.17 362.588 445.857C363.018 445.544 363.311 445.079 363.407 444.556H364.807V457.976H362.694V447.76H361.07L361.098 446.235Z",
    fill: "url(#paint453_linear_2204_11443)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M367.212 447.76C367.183 447.323 367.244 446.884 367.392 446.471C367.539 446.058 367.77 445.679 368.07 445.359C368.37 445.039 368.732 444.783 369.135 444.609C369.537 444.434 369.971 444.344 370.41 444.344C370.848 444.344 371.282 444.434 371.685 444.609C372.087 444.783 372.449 445.039 372.749 445.359C373.049 445.679 373.28 446.058 373.427 446.471C373.575 446.884 373.636 447.323 373.607 447.76V454.757C373.636 455.195 373.575 455.634 373.427 456.047C373.28 456.46 373.049 456.838 372.749 457.159C372.449 457.479 372.087 457.734 371.685 457.909C371.282 458.083 370.848 458.173 370.41 458.173C369.971 458.173 369.537 458.083 369.135 457.909C368.732 457.734 368.37 457.479 368.07 457.159C367.77 456.838 367.539 456.46 367.392 456.047C367.244 455.634 367.183 455.195 367.212 454.757V447.76ZM369.311 454.869C369.311 455.835 369.745 456.268 370.417 456.268C371.088 456.268 371.508 455.905 371.508 454.869V447.621C371.508 446.669 371.074 446.305 370.417 446.305C369.759 446.305 369.311 446.669 369.311 447.621V454.869Z",
    fill: "url(#paint454_linear_2204_11443)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M376.28 446.235C376.808 446.302 377.341 446.166 377.772 445.854C378.204 445.542 378.5 445.078 378.603 444.556H380.002V457.976H377.889V447.76H376.266L376.28 446.235Z",
    fill: "url(#paint455_linear_2204_11443)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M391.311 447.76C391.311 446.911 391.648 446.096 392.249 445.495C392.85 444.894 393.665 444.556 394.515 444.556C395.365 444.556 396.18 444.894 396.781 445.495C397.382 446.096 397.72 446.911 397.72 447.76V454.757C397.72 455.607 397.382 456.422 396.781 457.023C396.18 457.624 395.365 457.962 394.515 457.962C393.665 457.962 392.85 457.624 392.249 457.023C391.648 456.422 391.311 455.607 391.311 454.757V447.76ZM393.424 454.869C393.424 455.835 393.843 456.269 394.515 456.269C395.187 456.269 395.607 455.905 395.607 454.869V447.621C395.607 446.669 395.187 446.305 394.515 446.305C393.843 446.305 393.424 446.669 393.424 447.621V454.869Z",
    fill: "url(#paint456_linear_2204_11443)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M400.377 446.235C400.906 446.305 401.441 446.17 401.873 445.858C402.305 445.546 402.601 445.08 402.7 444.556H404.1V457.976H402.001V447.76H400.363L400.377 446.235Z",
    fill: "url(#paint457_linear_2204_11443)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M406.492 447.76C406.492 446.911 406.83 446.096 407.431 445.495C408.032 444.894 408.847 444.556 409.697 444.556C410.547 444.556 411.362 444.894 411.963 445.495C412.564 446.096 412.901 446.911 412.901 447.76V454.757C412.901 455.607 412.564 456.422 411.963 457.023C411.362 457.624 410.547 457.962 409.697 457.962C408.847 457.962 408.032 457.624 407.431 457.023C406.83 456.422 406.492 455.607 406.492 454.757V447.76ZM408.605 454.869C408.605 455.835 409.025 456.269 409.697 456.269C410.368 456.269 410.788 455.905 410.788 454.869V447.621C410.788 446.669 410.368 446.305 409.697 446.305C409.025 446.305 408.605 446.669 408.605 447.621V454.869Z",
    fill: "url(#paint458_linear_2204_11443)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M415.559 446.235C416.087 446.305 416.623 446.17 417.055 445.858C417.487 445.546 417.783 445.08 417.882 444.556H419.281V457.976H417.182V447.76H415.545L415.559 446.235Z",
    fill: "url(#paint459_linear_2204_11443)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M423.16 446.235C423.688 446.302 424.222 446.166 424.653 445.854C425.084 445.542 425.381 445.078 425.483 444.556H426.882V457.976H424.825V447.76H423.202L423.16 446.235Z",
    fill: "url(#paint460_linear_2204_11443)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M430.744 446.235C431.273 446.305 431.808 446.17 432.24 445.858C432.672 445.546 432.968 445.08 433.067 444.556H434.466V457.976H432.381V447.76H430.744V446.235Z",
    fill: "url(#paint461_linear_2204_11443)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M436.872 447.76C436.843 447.323 436.904 446.884 437.052 446.471C437.2 446.058 437.43 445.679 437.73 445.359C438.03 445.039 438.392 444.783 438.795 444.609C439.197 444.434 439.631 444.344 440.07 444.344C440.508 444.344 440.942 444.434 441.345 444.609C441.747 444.783 442.11 445.039 442.409 445.359C442.709 445.679 442.94 446.058 443.087 446.471C443.235 446.884 443.296 447.323 443.267 447.76V454.757C443.296 455.195 443.235 455.634 443.087 456.047C442.94 456.46 442.709 456.838 442.409 457.159C442.11 457.479 441.747 457.734 441.345 457.909C440.942 458.083 440.508 458.173 440.07 458.173C439.631 458.173 439.197 458.083 438.795 457.909C438.392 457.734 438.03 457.479 437.73 457.159C437.43 456.838 437.2 456.46 437.052 456.047C436.904 455.634 436.843 455.195 436.872 454.757V447.76ZM438.971 454.869C438.971 455.835 439.391 456.268 440.063 456.268C440.734 456.268 441.154 455.905 441.154 454.869V447.621C441.154 446.669 440.734 446.305 440.063 446.305C439.391 446.305 438.971 446.669 438.971 447.621V454.869Z",
    fill: "url(#paint462_linear_2204_11443)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M445.94 446.235C446.467 446.305 447 446.17 447.43 445.857C447.86 445.544 448.153 445.079 448.249 444.556H449.648V457.976H447.535V447.76H445.912L445.94 446.235Z",
    fill: "url(#paint463_linear_2204_11443)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M453.524 446.235C454.053 446.305 454.588 446.17 455.02 445.858C455.452 445.546 455.748 445.08 455.847 444.556H457.246V457.976H455.133V447.76H453.496L453.524 446.235Z",
    fill: "url(#paint464_linear_2204_11443)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M461.123 446.235C461.651 446.302 462.185 446.166 462.616 445.854C463.047 445.542 463.344 445.078 463.446 444.556H464.845V457.976H462.746V447.76H461.123V446.235Z",
    fill: "url(#paint465_linear_2204_11443)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M468.708 446.235C469.236 446.305 469.771 446.17 470.203 445.858C470.635 445.546 470.931 445.08 471.031 444.556H472.43V457.976H470.317V447.76H468.68L468.708 446.235Z",
    fill: "url(#paint466_linear_2204_11443)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M476.307 446.235C476.835 446.302 477.368 446.166 477.799 445.854C478.231 445.542 478.527 445.078 478.63 444.556H480.029V457.976H478V447.76H476.377L476.307 446.235Z",
    fill: "url(#paint467_linear_2204_11443)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M483.905 446.235C484.432 446.305 484.965 446.17 485.395 445.857C485.825 445.544 486.118 445.079 486.214 444.556H487.613V457.976H485.5V447.76H483.877L483.905 446.235Z",
    fill: "url(#paint468_linear_2204_11443)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M492.986 447.76C492.986 446.911 493.324 446.096 493.925 445.495C494.526 444.894 495.341 444.556 496.191 444.556C497.041 444.556 497.856 444.894 498.457 445.495C499.058 446.096 499.395 446.911 499.395 447.76V454.757C499.395 455.607 499.058 456.422 498.457 457.023C497.856 457.624 497.041 457.962 496.191 457.962C495.341 457.962 494.526 457.624 493.925 457.023C493.324 456.422 492.986 455.607 492.986 454.757V447.76ZM495.099 454.869C495.099 455.835 495.519 456.269 496.191 456.269C496.863 456.269 497.282 455.905 497.282 454.869V447.621C497.282 446.669 496.863 446.305 496.191 446.305C495.519 446.305 495.099 446.669 495.099 447.621V454.869Z",
    fill: "url(#paint469_linear_2204_11443)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M502.055 446.235C502.583 446.305 503.119 446.17 503.551 445.858C503.983 445.546 504.279 445.08 504.378 444.556H505.777V457.976H503.678V447.76H502.041L502.055 446.235Z",
    fill: "url(#paint470_linear_2204_11443)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M509.653 446.235C510.18 446.305 510.713 446.17 511.143 445.857C511.573 445.544 511.866 445.079 511.962 444.556H513.361V457.976H511.248V447.76H509.625L509.653 446.235Z",
    fill: "url(#paint471_linear_2204_11443)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M145.697 471.409C145.697 470.56 146.035 469.745 146.636 469.144C147.237 468.543 148.052 468.205 148.902 468.205C149.752 468.205 150.567 468.543 151.168 469.144C151.769 469.745 152.106 470.56 152.106 471.409V478.406C152.106 479.256 151.769 480.071 151.168 480.672C150.567 481.273 149.752 481.611 148.902 481.611C148.052 481.611 147.237 481.273 146.636 480.672C146.035 480.071 145.697 479.256 145.697 478.406V471.409ZM147.754 478.546C147.754 479.512 148.174 479.876 148.846 479.876C149.517 479.876 149.937 479.512 149.937 478.546V471.27C149.937 470.318 149.517 469.954 148.846 469.954C148.174 469.954 147.754 470.318 147.754 471.27V478.546Z",
    fill: "url(#paint472_linear_2204_11443)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M153.351 471.41C153.322 470.972 153.383 470.533 153.531 470.12C153.678 469.707 153.909 469.328 154.209 469.008C154.508 468.688 154.871 468.432 155.273 468.258C155.676 468.083 156.11 467.993 156.548 467.993C156.987 467.993 157.421 468.083 157.823 468.258C158.226 468.432 158.588 468.688 158.888 469.008C159.188 469.328 159.418 469.707 159.566 470.12C159.714 470.533 159.775 470.972 159.746 471.41V478.406C159.775 478.844 159.714 479.283 159.566 479.696C159.418 480.109 159.188 480.487 158.888 480.808C158.588 481.128 158.226 481.383 157.823 481.558C157.421 481.732 156.987 481.822 156.548 481.822C156.11 481.822 155.676 481.732 155.273 481.558C154.871 481.383 154.508 481.128 154.209 480.808C153.909 480.487 153.678 480.109 153.531 479.696C153.383 479.283 153.322 478.844 153.351 478.406V471.41ZM155.45 478.518C155.45 479.484 155.884 479.848 156.555 479.848C157.227 479.848 157.647 479.484 157.647 478.518V471.27C157.647 470.318 157.213 469.954 156.555 469.954C155.898 469.954 155.45 470.318 155.45 471.27V478.518Z",
    fill: "url(#paint473_linear_2204_11443)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M160.879 471.409C160.879 470.56 161.217 469.745 161.817 469.144C162.418 468.543 163.234 468.205 164.083 468.205C164.933 468.205 165.748 468.543 166.349 469.144C166.95 469.745 167.288 470.56 167.288 471.409V478.406C167.288 479.256 166.95 480.071 166.349 480.672C165.748 481.273 164.933 481.611 164.083 481.611C163.234 481.611 162.418 481.273 161.817 480.672C161.217 480.071 160.879 479.256 160.879 478.406V471.409ZM162.992 478.518C162.992 479.484 163.412 479.848 164.083 479.848C164.755 479.848 165.175 479.484 165.175 478.518V471.27C165.175 470.318 164.755 469.954 164.083 469.954C163.412 469.954 162.992 470.318 162.992 471.27V478.518Z",
    fill: "url(#paint474_linear_2204_11443)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M169.946 469.87C170.475 469.94 171.01 469.805 171.442 469.493C171.874 469.181 172.17 468.715 172.269 468.191H173.669V481.611H171.542V471.367H169.904L169.946 469.87Z",
    fill: "url(#paint475_linear_2204_11443)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M180.51 469.87C181.039 469.94 181.574 469.805 182.006 469.493C182.438 469.181 182.734 468.715 182.833 468.191H184.233V481.611H182.12V471.367H180.482L180.51 469.87Z",
    fill: "url(#paint476_linear_2204_11443)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M188.111 469.87C188.639 469.937 189.173 469.801 189.604 469.489C190.035 469.177 190.332 468.713 190.434 468.191H191.834V481.611H189.735V471.367H188.111V469.87Z",
    fill: "url(#paint477_linear_2204_11443)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M195.71 469.87C196.236 469.94 196.77 469.805 197.2 469.492C197.629 469.179 197.923 468.714 198.019 468.191H199.418V481.611H197.305V471.367H195.682L195.71 469.87Z",
    fill: "url(#paint478_linear_2204_11443)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M203.293 469.87C203.822 469.94 204.357 469.805 204.789 469.493C205.221 469.181 205.517 468.715 205.616 468.191H207.016V481.611H204.917V471.367H203.279L203.293 469.87Z",
    fill: "url(#paint479_linear_2204_11443)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M210.893 469.87C211.421 469.937 211.954 469.801 212.386 469.489C212.817 469.177 213.114 468.713 213.216 468.191H214.615V481.611H212.502V471.367H210.879L210.893 469.87Z",
    fill: "url(#paint480_linear_2204_11443)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M219.973 471.409C219.973 470.56 220.31 469.745 220.911 469.144C221.512 468.543 222.327 468.205 223.177 468.205C224.027 468.205 224.842 468.543 225.443 469.144C226.044 469.745 226.382 470.56 226.382 471.409V478.406C226.382 479.256 226.044 480.071 225.443 480.672C224.842 481.273 224.027 481.611 223.177 481.611C222.327 481.611 221.512 481.273 220.911 480.672C220.31 480.071 219.973 479.256 219.973 478.406V471.409ZM222.086 478.518C222.086 479.484 222.505 479.848 223.177 479.848C223.849 479.848 224.269 479.484 224.269 478.518V471.27C224.269 470.318 223.849 469.954 223.177 469.954C222.505 469.954 222.086 470.318 222.086 471.27V478.518Z",
    fill: "url(#paint481_linear_2204_11443)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M227.517 471.41C227.488 470.972 227.549 470.533 227.697 470.12C227.844 469.707 228.075 469.328 228.375 469.008C228.674 468.688 229.037 468.432 229.439 468.258C229.842 468.083 230.276 467.993 230.714 467.993C231.153 467.993 231.587 468.083 231.989 468.258C232.392 468.432 232.754 468.688 233.054 469.008C233.354 469.328 233.584 469.707 233.732 470.12C233.88 470.533 233.941 470.972 233.912 471.41V478.406C233.941 478.844 233.88 479.283 233.732 479.696C233.584 480.109 233.354 480.487 233.054 480.808C232.754 481.128 232.392 481.383 231.989 481.558C231.587 481.732 231.153 481.822 230.714 481.822C230.276 481.822 229.842 481.732 229.439 481.558C229.037 481.383 228.674 481.128 228.375 480.808C228.075 480.487 227.844 480.109 227.697 479.696C227.549 479.283 227.488 478.844 227.517 478.406V471.41ZM229.616 478.518C229.616 479.484 230.05 479.848 230.721 479.848C231.393 479.848 231.813 479.484 231.813 478.518V471.27C231.813 470.318 231.393 469.954 230.721 469.954C230.05 469.954 229.616 470.318 229.616 471.27V478.518Z",
    fill: "url(#paint482_linear_2204_11443)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M235.156 471.409C235.156 470.56 235.494 469.745 236.095 469.144C236.696 468.543 237.511 468.205 238.361 468.205C239.211 468.205 240.026 468.543 240.627 469.144C241.228 469.745 241.565 470.56 241.565 471.409V478.406C241.565 479.256 241.228 480.071 240.627 480.672C240.026 481.273 239.211 481.611 238.361 481.611C237.511 481.611 236.696 481.273 236.095 480.672C235.494 480.071 235.156 479.256 235.156 478.406V471.409ZM237.311 478.546C237.311 479.512 237.731 479.876 238.403 479.876C239.074 479.876 239.494 479.512 239.494 478.546V471.27C239.494 470.318 239.074 469.954 238.403 469.954C237.731 469.954 237.311 470.318 237.311 471.27V478.546Z",
    fill: "url(#paint483_linear_2204_11443)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M242.756 471.409C242.756 470.56 243.093 469.745 243.694 469.144C244.295 468.543 245.11 468.205 245.96 468.205C246.81 468.205 247.625 468.543 248.226 469.144C248.827 469.745 249.165 470.56 249.165 471.409V478.406C249.165 479.256 248.827 480.071 248.226 480.672C247.625 481.273 246.81 481.611 245.96 481.611C245.11 481.611 244.295 481.273 243.694 480.672C243.093 480.071 242.756 479.256 242.756 478.406V471.409ZM244.869 478.546C244.869 479.512 245.289 479.876 245.96 479.876C246.632 479.876 247.052 479.512 247.052 478.546V471.27C247.052 470.318 246.632 469.954 245.96 469.954C245.289 469.954 244.869 470.318 244.869 471.27V478.546Z",
    fill: "url(#paint484_linear_2204_11443)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M250.353 471.41C250.324 470.972 250.385 470.533 250.532 470.12C250.68 469.707 250.911 469.328 251.211 469.008C251.51 468.688 251.873 468.432 252.275 468.258C252.678 468.083 253.112 467.993 253.55 467.993C253.989 467.993 254.423 468.083 254.825 468.258C255.228 468.432 255.59 468.688 255.89 469.008C256.19 469.328 256.42 469.707 256.568 470.12C256.715 470.533 256.777 470.972 256.748 471.41V478.406C256.777 478.844 256.715 479.283 256.568 479.696C256.42 480.109 256.19 480.487 255.89 480.808C255.59 481.128 255.228 481.383 254.825 481.558C254.423 481.732 253.989 481.822 253.55 481.822C253.112 481.822 252.678 481.732 252.275 481.558C251.873 481.383 251.51 481.128 251.211 480.808C250.911 480.487 250.68 480.109 250.532 479.696C250.385 479.283 250.324 478.844 250.353 478.406V471.41ZM252.452 478.518C252.452 479.484 252.872 479.848 253.543 479.848C254.215 479.848 254.635 479.484 254.635 478.518V471.27C254.635 470.318 254.215 469.954 253.543 469.954C252.872 469.954 252.452 470.318 252.452 471.27V478.518Z",
    fill: "url(#paint485_linear_2204_11443)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M265.299 469.87C265.827 469.94 266.363 469.805 266.795 469.493C267.227 469.181 267.523 468.715 267.622 468.191H269.021V481.611H266.908V471.367H265.299V469.87Z",
    fill: "url(#paint486_linear_2204_11443)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M272.952 469.87C273.479 469.937 274.013 469.801 274.444 469.489C274.875 469.177 275.172 468.713 275.274 468.191H276.674V481.611H274.561V471.367H272.938L272.952 469.87Z",
    fill: "url(#paint487_linear_2204_11443)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M280.553 469.87C281.08 469.94 281.613 469.805 282.043 469.492C282.473 469.179 282.766 468.714 282.862 468.191H284.261V481.611H282.148V471.367H280.553V469.87Z",
    fill: "url(#paint488_linear_2204_11443)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M288.137 469.87C288.666 469.94 289.201 469.805 289.633 469.493C290.065 469.181 290.361 468.715 290.46 468.191H291.859V481.611H289.76V471.367H288.123L288.137 469.87Z",
    fill: "url(#paint489_linear_2204_11443)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M295.735 469.87C296.263 469.937 296.796 469.801 297.227 469.489C297.659 469.177 297.955 468.713 298.058 468.191H299.457V481.611H297.344V471.367H295.721L295.735 469.87Z",
    fill: "url(#paint490_linear_2204_11443)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M303.319 469.87C303.847 469.94 304.382 469.805 304.814 469.493C305.246 469.181 305.542 468.715 305.642 468.191H307.041V481.611H304.942V471.367H303.305L303.319 469.87Z",
    fill: "url(#paint491_linear_2204_11443)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M309.434 471.409C309.434 470.56 309.771 469.745 310.372 469.144C310.973 468.543 311.788 468.205 312.638 468.205C313.488 468.205 314.303 468.543 314.904 469.144C315.505 469.745 315.843 470.56 315.843 471.409V478.406C315.843 479.256 315.505 480.071 314.904 480.672C314.303 481.273 313.488 481.611 312.638 481.611C311.788 481.611 310.973 481.273 310.372 480.672C309.771 480.071 309.434 479.256 309.434 478.406V471.409ZM311.547 478.518C311.547 479.484 311.966 479.848 312.638 479.848C313.31 479.848 313.73 479.484 313.73 478.518V471.27C313.73 470.318 313.31 469.954 312.638 469.954C311.966 469.954 311.547 470.318 311.547 471.27V478.518Z",
    fill: "url(#paint492_linear_2204_11443)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M317.074 471.409C317.074 470.56 317.412 469.745 318.013 469.144C318.614 468.543 319.429 468.205 320.279 468.205C321.129 468.205 321.944 468.543 322.545 469.144C323.146 469.745 323.483 470.56 323.483 471.409V478.406C323.483 479.256 323.146 480.071 322.545 480.672C321.944 481.273 321.129 481.611 320.279 481.611C319.429 481.611 318.614 481.273 318.013 480.672C317.412 480.071 317.074 479.256 317.074 478.406V471.409ZM319.187 478.518C319.187 479.484 319.607 479.848 320.279 479.848C320.95 479.848 321.37 479.484 321.37 478.518V471.27C321.37 470.318 320.95 469.954 320.279 469.954C319.607 469.954 319.187 470.318 319.187 471.27V478.518Z",
    fill: "url(#paint493_linear_2204_11443)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M324.63 471.41C324.601 470.972 324.662 470.533 324.81 470.12C324.957 469.707 325.188 469.328 325.488 469.008C325.788 468.688 326.15 468.432 326.552 468.258C326.955 468.083 327.389 467.993 327.828 467.993C328.266 467.993 328.7 468.083 329.103 468.258C329.505 468.432 329.867 468.688 330.167 469.008C330.467 469.328 330.698 469.707 330.845 470.12C330.993 470.533 331.054 470.972 331.025 471.41V478.406C331.054 478.844 330.993 479.283 330.845 479.696C330.698 480.109 330.467 480.487 330.167 480.808C329.867 481.128 329.505 481.383 329.103 481.558C328.7 481.732 328.266 481.822 327.828 481.822C327.389 481.822 326.955 481.732 326.552 481.558C326.15 481.383 325.788 481.128 325.488 480.808C325.188 480.487 324.957 480.109 324.81 479.696C324.662 479.283 324.601 478.844 324.63 478.406V471.41ZM326.729 478.518C326.729 479.484 327.149 479.848 327.821 479.848C328.492 479.848 328.912 479.484 328.912 478.518V471.27C328.912 470.318 328.492 469.954 327.821 469.954C327.149 469.954 326.729 470.318 326.729 471.27V478.518Z",
    fill: "url(#paint494_linear_2204_11443)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M332.215 471.409C332.215 470.56 332.552 469.745 333.153 469.144C333.754 468.543 334.569 468.205 335.419 468.205C336.269 468.205 337.084 468.543 337.685 469.144C338.286 469.745 338.624 470.56 338.624 471.409V478.406C338.624 479.256 338.286 480.071 337.685 480.672C337.084 481.273 336.269 481.611 335.419 481.611C334.569 481.611 333.754 481.273 333.153 480.672C332.552 480.071 332.215 479.256 332.215 478.406V471.409ZM334.328 478.518C334.328 479.484 334.748 479.848 335.419 479.848C336.091 479.848 336.511 479.484 336.511 478.518V471.27C336.511 470.318 336.091 469.954 335.419 469.954C334.748 469.954 334.328 470.318 334.328 471.27V478.518Z",
    fill: "url(#paint495_linear_2204_11443)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M339.814 471.41C339.785 470.972 339.846 470.533 339.993 470.12C340.141 469.707 340.372 469.328 340.672 469.008C340.971 468.688 341.334 468.432 341.736 468.258C342.139 468.083 342.573 467.993 343.011 467.993C343.45 467.993 343.884 468.083 344.286 468.258C344.689 468.432 345.051 468.688 345.351 469.008C345.65 469.328 345.881 469.707 346.029 470.12C346.176 470.533 346.238 470.972 346.209 471.41V478.406C346.238 478.844 346.176 479.283 346.029 479.696C345.881 480.109 345.65 480.487 345.351 480.808C345.051 481.128 344.689 481.383 344.286 481.558C343.884 481.732 343.45 481.822 343.011 481.822C342.573 481.822 342.139 481.732 341.736 481.558C341.334 481.383 340.971 481.128 340.672 480.808C340.372 480.487 340.141 480.109 339.993 479.696C339.846 479.283 339.785 478.844 339.814 478.406V471.41ZM341.913 478.518C341.913 479.484 342.346 479.848 343.018 479.848C343.69 479.848 344.11 479.484 344.11 478.518V471.27C344.11 470.318 343.676 469.954 343.018 469.954C342.36 469.954 341.913 470.318 341.913 471.27V478.518Z",
    fill: "url(#paint496_linear_2204_11443)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M347.398 471.409C347.398 470.56 347.736 469.745 348.337 469.144C348.938 468.543 349.753 468.205 350.603 468.205C351.453 468.205 352.268 468.543 352.869 469.144C353.47 469.745 353.807 470.56 353.807 471.409V478.406C353.807 479.256 353.47 480.071 352.869 480.672C352.268 481.273 351.453 481.611 350.603 481.611C349.753 481.611 348.938 481.273 348.337 480.672C347.736 480.071 347.398 479.256 347.398 478.406V471.409ZM349.511 478.518C349.511 479.484 349.931 479.848 350.603 479.848C351.275 479.848 351.694 479.484 351.694 478.518V471.27C351.694 470.318 351.275 469.954 350.603 469.954C349.931 469.954 349.511 470.318 349.511 471.27V478.518Z",
    fill: "url(#paint497_linear_2204_11443)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M354.997 471.41C354.968 470.972 355.029 470.533 355.177 470.12C355.325 469.707 355.555 469.328 355.855 469.008C356.155 468.688 356.517 468.432 356.92 468.258C357.322 468.083 357.756 467.993 358.195 467.993C358.633 467.993 359.067 468.083 359.47 468.258C359.872 468.432 360.235 468.688 360.534 469.008C360.834 469.328 361.065 469.707 361.212 470.12C361.36 470.533 361.421 470.972 361.392 471.41V478.406C361.421 478.844 361.36 479.283 361.212 479.696C361.065 480.109 360.834 480.487 360.534 480.808C360.235 481.128 359.872 481.383 359.47 481.558C359.067 481.732 358.633 481.822 358.195 481.822C357.756 481.822 357.322 481.732 356.92 481.558C356.517 481.383 356.155 481.128 355.855 480.808C355.555 480.487 355.325 480.109 355.177 479.696C355.029 479.283 354.968 478.844 354.997 478.406V471.41ZM357.11 478.518C357.11 479.484 357.53 479.848 358.202 479.848C358.873 479.848 359.293 479.484 359.293 478.518V471.27C359.293 470.318 358.873 469.954 358.202 469.954C357.53 469.954 357.11 470.318 357.11 471.27V478.518Z",
    fill: "url(#paint498_linear_2204_11443)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M367.031 469.87C367.56 469.94 368.095 469.805 368.527 469.493C368.959 469.181 369.255 468.715 369.354 468.191H370.753V481.611H368.64V471.367H367.031V469.87Z",
    fill: "url(#paint499_linear_2204_11443)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M374.629 469.87C375.157 469.937 375.691 469.801 376.122 469.489C376.553 469.177 376.85 468.713 376.952 468.191H378.352V481.611H376.238V471.367H374.615L374.629 469.87Z",
    fill: "url(#paint500_linear_2204_11443)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M382.227 469.87C382.754 469.94 383.287 469.805 383.717 469.492C384.147 469.179 384.44 468.714 384.536 468.191H385.935V481.611H383.822V471.367H382.199L382.227 469.87Z",
    fill: "url(#paint501_linear_2204_11443)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M389.84 469.87C390.368 469.94 390.904 469.805 391.336 469.493C391.768 469.181 392.064 468.715 392.163 468.191H393.562V481.611H391.463V471.367H389.84V469.87Z",
    fill: "url(#paint502_linear_2204_11443)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M397.41 469.87C397.938 469.937 398.472 469.801 398.903 469.489C399.334 469.177 399.631 468.713 399.733 468.191H401.133V481.611H399.02V471.367H397.396L397.41 469.87Z",
    fill: "url(#paint503_linear_2204_11443)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M409.431 471.41C409.402 470.972 409.463 470.533 409.611 470.12C409.758 469.707 409.989 469.328 410.289 469.008C410.589 468.688 410.951 468.432 411.353 468.258C411.756 468.083 412.19 467.993 412.628 467.993C413.067 467.993 413.501 468.083 413.903 468.258C414.306 468.432 414.668 468.688 414.968 469.008C415.268 469.328 415.498 469.707 415.646 470.12C415.794 470.533 415.855 470.972 415.826 471.41V478.406C415.855 478.844 415.794 479.283 415.646 479.696C415.498 480.109 415.268 480.487 414.968 480.808C414.668 481.128 414.306 481.383 413.903 481.558C413.501 481.732 413.067 481.822 412.628 481.822C412.19 481.822 411.756 481.732 411.353 481.558C410.951 481.383 410.589 481.128 410.289 480.808C409.989 480.487 409.758 480.109 409.611 479.696C409.463 479.283 409.402 478.844 409.431 478.406V471.41ZM411.53 478.518C411.53 479.484 411.95 479.848 412.621 479.848C413.293 479.848 413.713 479.484 413.713 478.518V471.27C413.713 470.318 413.293 469.954 412.621 469.954C411.95 469.954 411.53 470.318 411.53 471.27V478.518Z",
    fill: "url(#paint504_linear_2204_11443)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M417.057 471.409C417.057 470.56 417.394 469.745 417.995 469.144C418.596 468.543 419.411 468.205 420.261 468.205C421.111 468.205 421.926 468.543 422.527 469.144C423.128 469.745 423.466 470.56 423.466 471.409V478.406C423.466 479.256 423.128 480.071 422.527 480.672C421.926 481.273 421.111 481.611 420.261 481.611C419.411 481.611 418.596 481.273 417.995 480.672C417.394 480.071 417.057 479.256 417.057 478.406V471.409ZM419.226 478.546C419.226 479.512 419.645 479.876 420.317 479.876C420.989 479.876 421.409 479.512 421.409 478.546V471.27C421.409 470.318 420.989 469.954 420.317 469.954C419.645 469.954 419.226 470.318 419.226 471.27V478.546Z",
    fill: "url(#paint505_linear_2204_11443)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M424.657 471.41C424.628 470.972 424.69 470.533 424.837 470.12C424.985 469.707 425.216 469.328 425.515 469.008C425.815 468.688 426.177 468.432 426.58 468.258C426.982 468.083 427.416 467.993 427.855 467.993C428.294 467.993 428.728 468.083 429.13 468.258C429.532 468.432 429.895 468.688 430.194 469.008C430.494 469.328 430.725 469.707 430.873 470.12C431.02 470.533 431.081 470.972 431.052 471.41V478.406C431.081 478.844 431.02 479.283 430.873 479.696C430.725 480.109 430.494 480.487 430.194 480.808C429.895 481.128 429.532 481.383 429.13 481.558C428.728 481.732 428.294 481.822 427.855 481.822C427.416 481.822 426.982 481.732 426.58 481.558C426.177 481.383 425.815 481.128 425.515 480.808C425.216 480.487 424.985 480.109 424.837 479.696C424.69 479.283 424.628 478.844 424.657 478.406V471.41ZM426.756 478.518C426.756 479.484 427.19 479.848 427.862 479.848C428.534 479.848 428.953 479.484 428.953 478.518V471.27C428.953 470.318 428.52 469.954 427.862 469.954C427.204 469.954 426.756 470.318 426.756 471.27V478.518Z",
    fill: "url(#paint506_linear_2204_11443)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M432.24 471.409C432.24 470.56 432.578 469.745 433.179 469.144C433.78 468.543 434.595 468.205 435.445 468.205C436.295 468.205 437.11 468.543 437.711 469.144C438.312 469.745 438.649 470.56 438.649 471.409V478.406C438.649 479.256 438.312 480.071 437.711 480.672C437.11 481.273 436.295 481.611 435.445 481.611C434.595 481.611 433.78 481.273 433.179 480.672C432.578 480.071 432.24 479.256 432.24 478.406V471.409ZM434.353 478.518C434.353 479.484 434.773 479.848 435.445 479.848C436.116 479.848 436.536 479.484 436.536 478.518V471.27C436.536 470.318 436.116 469.954 435.445 469.954C434.773 469.954 434.353 470.318 434.353 471.27V478.518Z",
    fill: "url(#paint507_linear_2204_11443)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M439.838 471.409C439.838 470.989 439.921 470.572 440.082 470.183C440.243 469.794 440.479 469.441 440.776 469.144C441.074 468.846 441.427 468.61 441.816 468.449C442.205 468.288 442.622 468.205 443.042 468.205C443.463 468.205 443.88 468.288 444.269 468.449C444.657 468.61 445.011 468.846 445.308 469.144C445.606 469.441 445.842 469.794 446.003 470.183C446.164 470.572 446.247 470.989 446.247 471.409V478.406C446.247 478.827 446.164 479.244 446.003 479.633C445.842 480.021 445.606 480.375 445.308 480.672C445.011 480.97 444.657 481.206 444.269 481.367C443.88 481.528 443.463 481.611 443.042 481.611C442.622 481.611 442.205 481.528 441.816 481.367C441.427 481.206 441.074 480.97 440.776 480.672C440.479 480.375 440.243 480.021 440.082 479.633C439.921 479.244 439.838 478.827 439.838 478.406V471.409ZM441.951 478.518C441.951 479.484 442.371 479.848 443.042 479.848C443.714 479.848 444.134 479.484 444.134 478.518V471.27C444.134 470.318 443.714 469.954 443.042 469.954C442.371 469.954 441.951 470.318 441.951 471.27V478.518Z",
    fill: "url(#paint508_linear_2204_11443)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M447.437 471.41C447.408 470.972 447.469 470.533 447.616 470.12C447.764 469.707 447.995 469.328 448.295 469.008C448.594 468.688 448.957 468.432 449.359 468.258C449.762 468.083 450.196 467.993 450.634 467.993C451.073 467.993 451.507 468.083 451.909 468.258C452.312 468.432 452.674 468.688 452.974 469.008C453.273 469.328 453.504 469.707 453.652 470.12C453.799 470.533 453.861 470.972 453.832 471.41V478.406C453.861 478.844 453.799 479.283 453.652 479.696C453.504 480.109 453.273 480.487 452.974 480.808C452.674 481.128 452.312 481.383 451.909 481.558C451.507 481.732 451.073 481.822 450.634 481.822C450.196 481.822 449.762 481.732 449.359 481.558C448.957 481.383 448.594 481.128 448.295 480.808C447.995 480.487 447.764 480.109 447.616 479.696C447.469 479.283 447.408 478.844 447.437 478.406V471.41ZM449.536 478.518C449.536 479.484 449.956 479.848 450.627 479.848C451.299 479.848 451.719 479.484 451.719 478.518V471.27C451.719 470.318 451.299 469.954 450.627 469.954C449.956 469.954 449.536 470.318 449.536 471.27V478.518Z",
    fill: "url(#paint509_linear_2204_11443)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M460.969 471.409C460.969 470.56 461.306 469.745 461.907 469.144C462.508 468.543 463.323 468.205 464.173 468.205C465.023 468.205 465.838 468.543 466.439 469.144C467.04 469.745 467.378 470.56 467.378 471.409V478.406C467.378 479.256 467.04 480.071 466.439 480.672C465.838 481.273 465.023 481.611 464.173 481.611C463.323 481.611 462.508 481.273 461.907 480.672C461.306 480.071 460.969 479.256 460.969 478.406V471.409ZM463.082 478.518C463.082 479.484 463.502 479.848 464.173 479.848C464.845 479.848 465.265 479.484 465.265 478.518V471.27C465.265 470.318 464.845 469.954 464.173 469.954C463.502 469.954 463.082 470.318 463.082 471.27V478.518Z",
    fill: "url(#paint510_linear_2204_11443)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M470.037 469.87C470.565 469.937 471.099 469.801 471.53 469.489C471.961 469.177 472.258 468.713 472.36 468.191H473.76V481.611H471.647V471.367H470.023L470.037 469.87Z",
    fill: "url(#paint511_linear_2204_11443)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M476.152 471.409C476.152 470.56 476.49 469.745 477.091 469.144C477.692 468.543 478.507 468.205 479.357 468.205C480.207 468.205 481.022 468.543 481.623 469.144C482.224 469.745 482.561 470.56 482.561 471.409V478.406C482.561 479.256 482.224 480.071 481.623 480.672C481.022 481.273 480.207 481.611 479.357 481.611C478.507 481.611 477.692 481.273 477.091 480.672C476.49 480.071 476.152 479.256 476.152 478.406V471.409ZM478.265 478.518C478.265 479.484 478.685 479.848 479.357 479.848C480.029 479.848 480.448 479.484 480.448 478.518V471.27C480.448 470.318 480.029 469.954 479.357 469.954C478.685 469.954 478.265 470.318 478.265 471.27V478.518Z",
    fill: "url(#paint512_linear_2204_11443)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M485.219 469.87C485.748 469.94 486.283 469.805 486.715 469.493C487.147 469.181 487.443 468.715 487.542 468.191H488.941V481.611H486.842V471.367H485.205L485.219 469.87Z",
    fill: "url(#paint513_linear_2204_11443)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M491.336 471.409C491.336 470.56 491.674 469.745 492.275 469.144C492.875 468.543 493.691 468.205 494.54 468.205C495.39 468.205 496.205 468.543 496.806 469.144C497.407 469.745 497.745 470.56 497.745 471.409V478.406C497.745 479.256 497.407 480.071 496.806 480.672C496.205 481.273 495.39 481.611 494.54 481.611C493.691 481.611 492.875 481.273 492.275 480.672C491.674 480.071 491.336 479.256 491.336 478.406V471.409ZM493.393 478.546C493.393 479.512 493.813 479.876 494.484 479.876C495.156 479.876 495.576 479.512 495.576 478.546V471.27C495.576 470.318 495.156 469.954 494.484 469.954C493.813 469.954 493.393 470.318 493.393 471.27V478.546Z",
    fill: "url(#paint514_linear_2204_11443)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M500.389 469.87C500.917 469.94 501.452 469.805 501.884 469.493C502.316 469.181 502.612 468.715 502.712 468.191H504.111V481.611H502.012V471.367H500.389V469.87Z",
    fill: "url(#paint515_linear_2204_11443)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M506.518 471.409C506.518 470.56 506.855 469.745 507.456 469.144C508.057 468.543 508.872 468.205 509.722 468.205C510.572 468.205 511.387 468.543 511.988 469.144C512.589 469.745 512.927 470.56 512.927 471.409V478.406C512.927 479.256 512.589 480.071 511.988 480.672C511.387 481.273 510.572 481.611 509.722 481.611C508.872 481.611 508.057 481.273 507.456 480.672C506.855 480.071 506.518 479.256 506.518 478.406V471.409ZM508.631 478.518C508.631 479.484 509.05 479.848 509.722 479.848C510.394 479.848 510.814 479.484 510.814 478.518V471.27C510.814 470.318 510.394 469.954 509.722 469.954C509.05 469.954 508.631 470.318 508.631 471.27V478.518Z",
    fill: "url(#paint516_linear_2204_11443)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M145.697 494.415C145.697 493.565 146.035 492.75 146.636 492.149C147.237 491.548 148.052 491.21 148.902 491.21C149.752 491.21 150.567 491.548 151.168 492.149C151.769 492.75 152.106 493.565 152.106 494.415V501.412C152.106 502.261 151.769 503.077 151.168 503.677C150.567 504.278 149.752 504.616 148.902 504.616C148.052 504.616 147.237 504.278 146.636 503.677C146.035 503.077 145.697 502.261 145.697 501.412V494.415ZM147.81 501.537C147.81 502.489 148.23 502.853 148.902 502.853C149.573 502.853 149.993 502.489 149.993 501.537V494.289C149.993 493.323 149.573 492.959 148.902 492.959C148.23 492.959 147.81 493.323 147.81 494.289V501.537Z",
    fill: "url(#paint517_linear_2204_11443)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M154.75 492.89C155.28 492.959 155.817 492.822 156.25 492.507C156.682 492.192 156.977 491.723 157.073 491.196H158.472V504.616H156.373V494.387H154.75V492.89Z",
    fill: "url(#paint518_linear_2204_11443)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M160.879 494.415C160.879 493.565 161.217 492.75 161.817 492.149C162.418 491.548 163.234 491.21 164.083 491.21C164.933 491.21 165.748 491.548 166.349 492.149C166.95 492.75 167.288 493.565 167.288 494.415V501.412C167.288 502.261 166.95 503.077 166.349 503.677C165.748 504.278 164.933 504.616 164.083 504.616C163.234 504.616 162.418 504.278 161.817 503.677C161.217 503.077 160.879 502.261 160.879 501.412V494.415ZM162.992 501.537C162.992 502.489 163.412 502.853 164.083 502.853C164.755 502.853 165.175 502.489 165.175 501.537V494.289C165.175 493.323 164.755 492.959 164.083 492.959C163.412 492.959 162.992 493.323 162.992 494.289V501.537Z",
    fill: "url(#paint519_linear_2204_11443)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M169.946 492.89C170.477 492.959 171.014 492.822 171.446 492.507C171.879 492.192 172.173 491.723 172.269 491.196H173.669V504.616H171.542V494.387H169.904L169.946 492.89Z",
    fill: "url(#paint520_linear_2204_11443)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M176.077 494.415C176.048 493.977 176.11 493.538 176.257 493.125C176.405 492.712 176.635 492.334 176.935 492.013C177.235 491.693 177.597 491.438 178 491.263C178.402 491.089 178.836 490.999 179.275 490.999C179.713 490.999 180.147 491.089 180.55 491.263C180.952 491.438 181.315 491.693 181.614 492.013C181.914 492.334 182.145 492.712 182.293 493.125C182.44 493.538 182.501 493.977 182.472 494.415V501.412C182.501 501.849 182.44 502.288 182.293 502.701C182.145 503.114 181.914 503.493 181.614 503.813C181.315 504.133 180.952 504.389 180.55 504.563C180.147 504.738 179.713 504.828 179.275 504.828C178.836 504.828 178.402 504.738 178 504.563C177.597 504.389 177.235 504.133 176.935 503.813C176.635 503.493 176.405 503.114 176.257 502.701C176.11 502.288 176.048 501.849 176.077 501.412V494.415ZM178.176 501.538C178.176 502.489 178.596 502.853 179.268 502.853C179.94 502.853 180.359 502.489 180.359 501.538V494.289C180.359 493.323 179.94 492.959 179.268 492.959C178.596 492.959 178.176 493.323 178.176 494.289V501.538Z",
    fill: "url(#paint521_linear_2204_11443)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M185.143 492.89C185.672 492.959 186.207 492.822 186.637 492.506C187.068 492.191 187.359 491.722 187.452 491.196H188.851V504.616H186.738V494.387H185.115L185.143 492.89Z",
    fill: "url(#paint522_linear_2204_11443)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M192.729 492.89C193.268 492.958 193.812 492.813 194.246 492.487C194.679 492.16 194.969 491.677 195.052 491.14H196.451V504.56H194.352V494.331H192.715L192.729 492.89Z",
    fill: "url(#paint523_linear_2204_11443)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M200.327 492.89C200.856 492.956 201.392 492.818 201.823 492.503C202.255 492.188 202.55 491.721 202.649 491.196H204.049V504.616H201.936V494.387H200.312L200.327 492.89Z",
    fill: "url(#paint524_linear_2204_11443)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M207.926 492.89C208.456 492.959 208.993 492.822 209.426 492.507C209.858 492.192 210.153 491.723 210.249 491.196H211.648V504.616H209.535V494.387H207.926V492.89Z",
    fill: "url(#paint525_linear_2204_11443)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M215.51 492.89C216.04 492.956 216.575 492.818 217.007 492.503C217.438 492.188 217.734 491.721 217.833 491.196H219.232V504.616H217.119V494.387H215.496L215.51 492.89Z",
    fill: "url(#paint526_linear_2204_11443)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M223.108 492.89C223.645 492.958 224.187 492.813 224.619 492.486C225.05 492.159 225.337 491.676 225.417 491.14H226.816V504.56H224.717V494.331H223.094L223.108 492.89Z",
    fill: "url(#paint527_linear_2204_11443)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M230.692 492.89C231.222 492.959 231.759 492.822 232.192 492.507C232.624 492.192 232.919 491.723 233.015 491.196H234.414V504.616H232.315V494.387H230.678L230.692 492.89Z",
    fill: "url(#paint528_linear_2204_11443)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M236.807 494.415C236.807 493.565 237.144 492.75 237.745 492.149C238.346 491.548 239.161 491.21 240.011 491.21C240.861 491.21 241.676 491.548 242.277 492.149C242.878 492.75 243.216 493.565 243.216 494.415V501.412C243.216 502.261 242.878 503.077 242.277 503.677C241.676 504.278 240.861 504.616 240.011 504.616C239.161 504.616 238.346 504.278 237.745 503.677C237.144 503.077 236.807 502.261 236.807 501.412V494.415ZM238.92 501.537C238.92 502.489 239.339 502.853 240.011 502.853C240.683 502.853 241.103 502.489 241.103 501.537V494.289C241.103 493.323 240.683 492.959 240.011 492.959C239.339 492.959 238.92 493.323 238.92 494.289V501.537Z",
    fill: "url(#paint529_linear_2204_11443)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M245.875 492.89C246.406 492.959 246.943 492.822 247.375 492.507C247.808 492.192 248.102 491.723 248.198 491.196H249.598V504.616H247.499V494.387H245.861L245.875 492.89Z",
    fill: "url(#paint530_linear_2204_11443)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M256.442 492.89C256.972 492.959 257.509 492.822 257.942 492.507C258.374 492.192 258.669 491.723 258.765 491.196H260.164V504.616H258.065V494.387H256.428L256.442 492.89Z",
    fill: "url(#paint531_linear_2204_11443)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M262.5 494.415C262.5 493.565 262.838 492.75 263.439 492.149C264.04 491.548 264.855 491.21 265.705 491.21C266.554 491.21 267.369 491.548 267.97 492.149C268.571 492.75 268.909 493.565 268.909 494.415V501.412C268.909 502.261 268.571 503.077 267.97 503.677C267.369 504.278 266.554 504.616 265.705 504.616C264.855 504.616 264.04 504.278 263.439 503.677C262.838 503.077 262.5 502.261 262.5 501.412V494.415ZM264.613 501.537C264.613 502.489 265.033 502.853 265.705 502.853C266.376 502.853 266.796 502.489 266.796 501.537V494.289C266.796 493.323 266.376 492.959 265.705 492.959C265.033 492.959 264.613 493.323 264.613 494.289V501.537Z",
    fill: "url(#paint532_linear_2204_11443)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M271.624 492.89C272.154 492.959 272.691 492.822 273.124 492.507C273.556 492.192 273.851 491.723 273.947 491.196H275.346V504.616H273.233V494.387H271.596L271.624 492.89Z",
    fill: "url(#paint533_linear_2204_11443)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M282.188 492.89C282.719 492.959 283.256 492.822 283.688 492.507C284.12 492.192 284.415 491.723 284.511 491.196H285.91V504.616H283.797V494.387H282.16L282.188 492.89Z",
    fill: "url(#paint534_linear_2204_11443)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M291.284 494.415C291.255 493.977 291.317 493.538 291.464 493.125C291.612 492.712 291.843 492.334 292.142 492.013C292.442 491.693 292.804 491.438 293.207 491.263C293.609 491.089 294.043 490.999 294.482 490.999C294.921 490.999 295.354 491.089 295.757 491.263C296.159 491.438 296.522 491.693 296.821 492.013C297.121 492.334 297.352 492.712 297.5 493.125C297.647 493.538 297.708 493.977 297.679 494.415V501.412C297.708 501.849 297.647 502.288 297.5 502.701C297.352 503.114 297.121 503.493 296.821 503.813C296.522 504.133 296.159 504.389 295.757 504.563C295.354 504.738 294.921 504.828 294.482 504.828C294.043 504.828 293.609 504.738 293.207 504.563C292.804 504.389 292.442 504.133 292.142 503.813C291.843 503.493 291.612 503.114 291.464 502.701C291.317 502.288 291.255 501.849 291.284 501.412V494.415ZM293.397 501.538C293.397 502.489 293.817 502.853 294.489 502.853C295.161 502.853 295.58 502.489 295.58 501.538V494.289C295.58 493.323 295.161 492.959 294.489 492.959C293.817 492.959 293.397 493.323 293.397 494.289V501.538Z",
    fill: "url(#paint535_linear_2204_11443)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M300.352 492.89C300.882 492.956 301.417 492.818 301.849 492.503C302.28 492.188 302.576 491.721 302.675 491.196H304.074V504.616H301.961V494.387H300.338L300.352 492.89Z",
    fill: "url(#paint536_linear_2204_11443)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M307.95 492.89C308.479 492.959 309.014 492.822 309.444 492.506C309.874 492.191 310.166 491.722 310.259 491.196H311.658V504.616H309.545V494.387H307.922L307.95 492.89Z",
    fill: "url(#paint537_linear_2204_11443)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M315.535 492.89C316.066 492.959 316.603 492.822 317.035 492.507C317.467 492.192 317.762 491.723 317.858 491.196H319.257V504.616H317.158V494.387H315.535V492.89Z",
    fill: "url(#paint538_linear_2204_11443)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M323.133 492.89C323.674 492.966 324.224 492.824 324.662 492.497C325.1 492.169 325.39 491.681 325.47 491.14H326.869V504.56H324.756V494.331H323.133V492.89Z",
    fill: "url(#paint539_linear_2204_11443)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M330.717 492.89C331.248 492.959 331.785 492.822 332.217 492.507C332.649 492.192 332.944 491.723 333.04 491.196H334.439V504.616H332.34V494.387H330.703L330.717 492.89Z",
    fill: "url(#paint540_linear_2204_11443)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M336.832 494.415C336.832 493.994 336.915 493.577 337.076 493.188C337.237 492.8 337.473 492.446 337.771 492.149C338.068 491.851 338.421 491.615 338.81 491.454C339.199 491.293 339.616 491.21 340.037 491.21C340.457 491.21 340.874 491.293 341.263 491.454C341.652 491.615 342.005 491.851 342.302 492.149C342.6 492.446 342.836 492.8 342.997 493.188C343.158 493.577 343.241 493.994 343.241 494.415V501.412C343.241 501.832 343.158 502.249 342.997 502.638C342.836 503.027 342.6 503.38 342.302 503.677C342.005 503.975 341.652 504.211 341.263 504.372C340.874 504.533 340.457 504.616 340.037 504.616C339.616 504.616 339.199 504.533 338.81 504.372C338.421 504.211 338.068 503.975 337.771 503.677C337.473 503.38 337.237 503.027 337.076 502.638C336.915 502.249 336.832 501.832 336.832 501.412V494.415ZM338.945 501.537C338.945 502.489 339.365 502.853 340.037 502.853C340.708 502.853 341.128 502.489 341.128 501.537V494.289C341.128 493.323 340.708 492.959 340.037 492.959C339.365 492.959 338.945 493.323 338.945 494.289V501.537Z",
    fill: "url(#paint541_linear_2204_11443)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M345.9 492.89C346.431 492.959 346.968 492.822 347.4 492.507C347.833 492.192 348.127 491.723 348.223 491.196H349.623V504.616H347.51V494.387H345.9V492.89Z",
    fill: "url(#paint542_linear_2204_11443)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M352.058 494.415C352.029 493.977 352.09 493.538 352.238 493.125C352.385 492.712 352.616 492.334 352.916 492.013C353.215 491.693 353.578 491.438 353.98 491.263C354.383 491.089 354.817 490.999 355.255 490.999C355.694 490.999 356.128 491.089 356.53 491.263C356.933 491.438 357.295 491.693 357.595 492.013C357.895 492.334 358.125 492.712 358.273 493.125C358.421 493.538 358.482 493.977 358.453 494.415V501.412C358.482 501.849 358.421 502.288 358.273 502.701C358.125 503.114 357.895 503.493 357.595 503.813C357.295 504.133 356.933 504.389 356.53 504.563C356.128 504.738 355.694 504.828 355.255 504.828C354.817 504.828 354.383 504.738 353.98 504.563C353.578 504.389 353.215 504.133 352.916 503.813C352.616 503.493 352.385 503.114 352.238 502.701C352.09 502.288 352.029 501.849 352.058 501.412V494.415ZM354.157 501.538C354.157 502.489 354.577 502.853 355.248 502.853C355.92 502.853 356.34 502.489 356.34 501.538V494.289C356.34 493.323 355.92 492.959 355.248 492.959C354.577 492.959 354.157 493.323 354.157 494.289V501.538Z",
    fill: "url(#paint543_linear_2204_11443)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M361.098 492.89C361.627 492.959 362.162 492.822 362.592 492.506C363.023 492.191 363.314 491.722 363.407 491.196H364.807V504.616H362.694V494.387H361.07L361.098 492.89Z",
    fill: "url(#paint544_linear_2204_11443)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M367.212 494.415C367.183 493.977 367.244 493.538 367.392 493.125C367.539 492.712 367.77 492.334 368.07 492.013C368.37 491.693 368.732 491.438 369.135 491.263C369.537 491.089 369.971 490.999 370.41 490.999C370.848 490.999 371.282 491.089 371.685 491.263C372.087 491.438 372.449 491.693 372.749 492.013C373.049 492.334 373.28 492.712 373.427 493.125C373.575 493.538 373.636 493.977 373.607 494.415V501.412C373.636 501.849 373.575 502.288 373.427 502.701C373.28 503.114 373.049 503.493 372.749 503.813C372.449 504.133 372.087 504.389 371.685 504.563C371.282 504.738 370.848 504.828 370.41 504.828C369.971 504.828 369.537 504.738 369.135 504.563C368.732 504.389 368.37 504.133 368.07 503.813C367.77 503.493 367.539 503.114 367.392 502.701C367.244 502.288 367.183 501.849 367.212 501.412V494.415ZM369.311 501.538C369.311 502.489 369.745 502.853 370.417 502.853C371.088 502.853 371.508 502.489 371.508 501.538V494.289C371.508 493.323 371.074 492.959 370.417 492.959C369.759 492.959 369.311 493.323 369.311 494.289V501.538Z",
    fill: "url(#paint545_linear_2204_11443)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M376.279 492.89C376.824 492.966 377.377 492.826 377.819 492.499C378.262 492.171 378.558 491.684 378.644 491.14H380.044V504.56H377.931V494.331H376.307L376.279 492.89Z",
    fill: "url(#paint546_linear_2204_11443)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M391.311 494.415C391.311 493.565 391.648 492.75 392.249 492.149C392.85 491.548 393.665 491.21 394.515 491.21C395.365 491.21 396.18 491.548 396.781 492.149C397.382 492.75 397.72 493.565 397.72 494.415V501.412C397.72 502.261 397.382 503.077 396.781 503.677C396.18 504.278 395.365 504.616 394.515 504.616C393.665 504.616 392.85 504.278 392.249 503.677C391.648 503.077 391.311 502.261 391.311 501.412V494.415ZM393.424 501.537C393.424 502.489 393.843 502.853 394.515 502.853C395.187 502.853 395.607 502.489 395.607 501.537V494.289C395.607 493.323 395.187 492.959 394.515 492.959C393.843 492.959 393.424 493.323 393.424 494.289V501.537Z",
    fill: "url(#paint547_linear_2204_11443)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M400.377 492.89C400.908 492.959 401.445 492.822 401.877 492.507C402.31 492.192 402.604 491.723 402.7 491.196H404.1V504.616H402.001V494.387H400.363L400.377 492.89Z",
    fill: "url(#paint548_linear_2204_11443)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M406.492 494.415C406.492 493.565 406.83 492.75 407.431 492.149C408.032 491.548 408.847 491.21 409.697 491.21C410.547 491.21 411.362 491.548 411.963 492.149C412.564 492.75 412.901 493.565 412.901 494.415V501.412C412.901 502.261 412.564 503.077 411.963 503.677C411.362 504.278 410.547 504.616 409.697 504.616C408.847 504.616 408.032 504.278 407.431 503.677C406.83 503.077 406.492 502.261 406.492 501.412V494.415ZM408.605 501.537C408.605 502.489 409.025 502.853 409.697 502.853C410.368 502.853 410.788 502.489 410.788 501.537V494.289C410.788 493.323 410.368 492.959 409.697 492.959C409.025 492.959 408.605 493.323 408.605 494.289V501.537Z",
    fill: "url(#paint549_linear_2204_11443)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M415.56 492.89C416.09 492.943 416.62 492.791 417.041 492.466C417.463 492.14 417.744 491.666 417.827 491.14H419.227V504.56H417.127V494.331H415.49L415.56 492.89Z",
    fill: "url(#paint550_linear_2204_11443)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M423.16 492.89C423.69 492.956 424.225 492.818 424.657 492.503C425.089 492.188 425.384 491.721 425.483 491.196H426.882V504.616H424.825V494.387H423.202L423.16 492.89Z",
    fill: "url(#paint551_linear_2204_11443)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M430.744 492.89C431.275 492.959 431.812 492.822 432.244 492.507C432.676 492.192 432.971 491.723 433.067 491.196H434.466V504.616H432.381V494.387H430.744V492.89Z",
    fill: "url(#paint552_linear_2204_11443)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M436.872 494.415C436.843 493.977 436.904 493.538 437.052 493.125C437.2 492.712 437.43 492.334 437.73 492.013C438.03 491.693 438.392 491.438 438.795 491.263C439.197 491.089 439.631 490.999 440.07 490.999C440.508 490.999 440.942 491.089 441.345 491.263C441.747 491.438 442.11 491.693 442.409 492.013C442.709 492.334 442.94 492.712 443.087 493.125C443.235 493.538 443.296 493.977 443.267 494.415V501.412C443.296 501.849 443.235 502.288 443.087 502.701C442.94 503.114 442.709 503.493 442.409 503.813C442.11 504.133 441.747 504.389 441.345 504.563C440.942 504.738 440.508 504.828 440.07 504.828C439.631 504.828 439.197 504.738 438.795 504.563C438.392 504.389 438.03 504.133 437.73 503.813C437.43 503.493 437.2 503.114 437.052 502.701C436.904 502.288 436.843 501.849 436.872 501.412V494.415ZM438.971 501.538C438.971 502.489 439.391 502.853 440.063 502.853C440.734 502.853 441.154 502.489 441.154 501.538V494.289C441.154 493.323 440.734 492.959 440.063 492.959C439.391 492.959 438.971 493.323 438.971 494.289V501.538Z",
    fill: "url(#paint553_linear_2204_11443)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M445.94 492.89C446.469 492.959 447.004 492.822 447.434 492.506C447.864 492.191 448.156 491.722 448.249 491.196H449.648V504.616H447.535V494.387H445.912L445.94 492.89Z",
    fill: "url(#paint554_linear_2204_11443)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M453.524 492.89C454.055 492.959 454.592 492.822 455.024 492.507C455.456 492.192 455.751 491.723 455.847 491.196H457.246V504.616H455.133V494.387H453.496L453.524 492.89Z",
    fill: "url(#paint555_linear_2204_11443)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M461.123 492.89C461.661 492.954 462.203 492.808 462.636 492.482C463.069 492.156 463.36 491.675 463.446 491.14H464.845V504.56H462.746V494.331H461.123V492.89Z",
    fill: "url(#paint556_linear_2204_11443)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M468.708 492.89C469.243 492.95 469.78 492.802 470.207 492.476C470.635 492.15 470.92 491.672 471.003 491.14H472.403V504.56H470.29V494.331H468.652L468.708 492.89Z",
    fill: "url(#paint557_linear_2204_11443)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M476.307 492.89C476.837 492.956 477.372 492.818 477.803 492.503C478.235 492.188 478.53 491.721 478.63 491.196H480.029V504.616H478V494.387H476.377L476.307 492.89Z",
    fill: "url(#paint558_linear_2204_11443)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M483.905 492.89C484.434 492.959 484.969 492.822 485.399 492.506C485.829 492.191 486.121 491.722 486.214 491.196H487.613V504.616H485.5V494.387H483.877L483.905 492.89Z",
    fill: "url(#paint559_linear_2204_11443)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M492.986 494.415C492.986 493.565 493.324 492.75 493.925 492.149C494.526 491.548 495.341 491.21 496.191 491.21C497.041 491.21 497.856 491.548 498.457 492.149C499.058 492.75 499.395 493.565 499.395 494.415V501.412C499.395 502.261 499.058 503.077 498.457 503.677C497.856 504.278 497.041 504.616 496.191 504.616C495.341 504.616 494.526 504.278 493.925 503.677C493.324 503.077 492.986 502.261 492.986 501.412V494.415ZM495.099 501.537C495.099 502.489 495.519 502.853 496.191 502.853C496.863 502.853 497.282 502.489 497.282 501.537V494.289C497.282 493.323 496.863 492.959 496.191 492.959C495.519 492.959 495.099 493.323 495.099 494.289V501.537Z",
    fill: "url(#paint560_linear_2204_11443)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M502.055 492.89C502.586 492.959 503.123 492.822 503.555 492.507C503.987 492.192 504.282 491.723 504.378 491.196H505.777V504.616H503.678V494.387H502.041L502.055 492.89Z",
    fill: "url(#paint561_linear_2204_11443)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M509.653 492.89C510.182 492.959 510.717 492.822 511.147 492.506C511.577 492.191 511.869 491.722 511.962 491.196H513.361V504.616H511.248V494.387H509.625L509.653 492.89Z",
    fill: "url(#paint562_linear_2204_11443)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M321.594 316.222H337.224C337.926 316.222 338.598 316.5 339.094 316.996C339.59 317.492 339.869 318.165 339.869 318.867V344.88H318.879V318.825C318.884 318.475 318.959 318.13 319.099 317.809C319.239 317.488 319.441 317.199 319.693 316.957C319.945 316.714 320.243 316.525 320.57 316.399C320.896 316.273 321.244 316.212 321.594 316.222Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M307.11 317.803C306.634 317.801 306.174 317.636 305.805 317.335C305.435 317.035 305.18 316.617 305.081 316.152L300.072 292.503C299.99 291.976 300.113 291.439 300.415 291C300.718 290.561 301.176 290.255 301.697 290.144C302.218 290.033 302.762 290.126 303.217 290.403C303.672 290.68 304.004 291.121 304.144 291.635L309.153 315.298C309.265 315.838 309.159 316.4 308.857 316.862C308.556 317.323 308.083 317.647 307.544 317.761C307.401 317.789 307.256 317.803 307.11 317.803Z",
    fill: "#263238"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M320.77 324.954C320.583 324.955 320.4 324.907 320.238 324.814L306.58 316.614C306.345 316.471 306.176 316.24 306.11 315.972C306.044 315.705 306.088 315.422 306.231 315.186C306.374 314.951 306.604 314.781 306.872 314.716C307.14 314.65 307.422 314.693 307.658 314.836L321.302 323.023C321.528 323.167 321.69 323.392 321.755 323.653C321.82 323.913 321.783 324.188 321.651 324.422C321.564 324.58 321.436 324.712 321.281 324.805C321.127 324.898 320.95 324.95 320.77 324.954Z",
    fill: "#263238"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M282.469 349.218C281.877 349.046 281.243 349.083 280.675 349.323C280.107 349.562 279.639 349.99 279.348 350.534L264.641 378.185C264.475 378.496 264.371 378.838 264.337 379.189C264.303 379.54 264.338 379.895 264.44 380.233C264.543 380.571 264.711 380.885 264.935 381.158C265.159 381.431 265.435 381.657 265.747 381.823C266.058 381.99 266.399 382.093 266.751 382.127C267.102 382.162 267.457 382.127 267.795 382.024C268.133 381.921 268.447 381.753 268.72 381.529C268.993 381.305 269.219 381.029 269.385 380.718L284.106 353.067C284.272 352.754 284.375 352.412 284.408 352.06C284.442 351.708 284.406 351.353 284.302 351.015C284.198 350.677 284.028 350.363 283.802 350.09C283.577 349.818 283.299 349.593 282.987 349.428C282.826 349.332 282.651 349.261 282.469 349.218Z",
    fill: "#263238"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M302.031 345.202C301.797 345.141 301.551 345.141 301.317 345.202L281.377 350.492C281.161 350.49 280.947 350.537 280.753 350.631C280.558 350.726 280.388 350.863 280.256 351.034C280.124 351.205 280.033 351.404 279.99 351.615C279.948 351.827 279.955 352.046 280.011 352.254C280.067 352.463 280.171 352.656 280.313 352.817C280.456 352.979 280.635 353.106 280.835 353.187C281.035 353.269 281.251 353.303 281.466 353.287C281.682 353.27 281.89 353.205 282.076 353.095L302.003 347.805C302.264 347.702 302.488 347.523 302.646 347.291C302.804 347.058 302.888 346.784 302.888 346.504C302.888 346.223 302.804 345.949 302.646 345.717C302.488 345.485 302.264 345.305 302.003 345.202H302.031Z",
    fill: "#263238"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M277.892 378.493C277.268 378.442 276.646 378.612 276.135 378.972C275.623 379.333 275.255 379.861 275.093 380.466L266.837 410.692C266.745 411.033 266.721 411.388 266.767 411.738C266.812 412.088 266.926 412.426 267.102 412.732C267.278 413.038 267.513 413.306 267.793 413.522C268.073 413.737 268.392 413.895 268.733 413.987C269.074 414.079 269.429 414.103 269.78 414.057C270.13 414.012 270.467 413.898 270.773 413.722C271.079 413.546 271.348 413.311 271.563 413.031C271.778 412.751 271.936 412.432 272.028 412.091L280.285 381.879C280.473 381.189 280.38 380.452 280.026 379.83C279.672 379.208 279.085 378.752 278.395 378.563C278.229 378.528 278.061 378.505 277.892 378.493Z",
    fill: "#263238"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M296.083 370.279C295.842 370.264 295.601 370.312 295.384 370.418L277.122 379.99C276.909 380.032 276.708 380.124 276.537 380.258C276.365 380.391 276.227 380.563 276.133 380.759C276.039 380.955 275.992 381.17 275.996 381.388C276 381.605 276.055 381.819 276.156 382.011C276.257 382.204 276.401 382.371 276.577 382.498C276.754 382.625 276.958 382.709 277.172 382.744C277.387 382.779 277.607 382.763 277.814 382.698C278.022 382.633 278.211 382.52 278.368 382.369L296.643 372.811C296.949 372.635 297.176 372.349 297.28 372.012C297.384 371.674 297.356 371.31 297.203 370.992C297.096 370.785 296.936 370.609 296.74 370.484C296.543 370.358 296.317 370.288 296.083 370.279Z",
    fill: "#263238"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M290.696 395.327C290.074 395.282 289.455 395.453 288.944 395.813C288.434 396.173 288.064 396.698 287.898 397.3L279.641 427.526C279.456 428.214 279.551 428.948 279.907 429.566C280.263 430.184 280.849 430.636 281.538 430.821C282.226 431.007 282.96 430.911 283.578 430.556C284.196 430.2 284.647 429.614 284.833 428.925L293.089 398.713C293.278 398.023 293.185 397.286 292.831 396.664C292.477 396.042 291.89 395.587 291.2 395.397L290.696 395.327Z",
    fill: "#263238"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M308.888 387.113C308.647 387.098 308.406 387.146 308.189 387.253L289.913 396.824C289.7 396.867 289.499 396.958 289.328 397.092C289.156 397.225 289.018 397.397 288.924 397.593C288.83 397.789 288.783 398.005 288.787 398.222C288.791 398.439 288.846 398.653 288.947 398.846C289.048 399.038 289.192 399.205 289.368 399.332C289.545 399.459 289.749 399.543 289.963 399.578C290.178 399.613 290.398 399.597 290.605 399.532C290.813 399.467 291.002 399.354 291.159 399.203L309.434 389.646C309.74 389.469 309.967 389.183 310.071 388.846C310.175 388.508 310.147 388.144 309.994 387.826C309.89 387.62 309.732 387.445 309.538 387.32C309.344 387.194 309.119 387.123 308.888 387.113Z",
    fill: "#263238"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M375.259 349.218C375.851 349.044 376.486 349.079 377.055 349.319C377.623 349.559 378.092 349.988 378.38 350.534L393.101 378.185C393.296 378.499 393.424 378.85 393.477 379.215C393.531 379.581 393.509 379.954 393.413 380.31C393.316 380.667 393.148 381 392.918 381.29C392.687 381.579 392.4 381.817 392.074 381.991C391.748 382.165 391.39 382.269 391.021 382.299C390.653 382.329 390.282 382.282 389.933 382.163C389.583 382.044 389.262 381.854 388.988 381.605C388.715 381.357 388.495 381.055 388.343 380.718L373.622 353.067C373.291 352.435 373.222 351.698 373.432 351.017C373.642 350.335 374.112 349.764 374.742 349.428C374.904 349.335 375.078 349.264 375.259 349.218Z",
    fill: "#263238"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M355.697 345.202C355.935 345.138 356.186 345.138 356.425 345.202L376.351 350.492C376.689 350.596 376.975 350.824 377.152 351.13C377.328 351.437 377.382 351.799 377.303 352.143C377.199 352.478 376.973 352.762 376.67 352.938C376.366 353.114 376.008 353.17 375.666 353.095L355.725 347.805C355.464 347.702 355.24 347.523 355.082 347.291C354.924 347.059 354.84 346.784 354.84 346.504C354.84 346.223 354.924 345.949 355.082 345.717C355.24 345.485 355.464 345.305 355.725 345.202H355.697Z",
    fill: "#263238"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M379.779 378.493C380.401 378.447 381.02 378.619 381.531 378.979C382.041 379.339 382.411 379.864 382.577 380.466L390.833 410.692C390.925 411.033 390.949 411.388 390.904 411.738C390.858 412.089 390.744 412.426 390.568 412.732C390.392 413.038 390.157 413.307 389.877 413.522C389.598 413.737 389.278 413.895 388.937 413.987C388.596 414.079 388.241 414.103 387.891 414.057C387.541 414.012 387.203 413.898 386.897 413.722C386.591 413.546 386.323 413.311 386.107 413.031C385.892 412.751 385.734 412.432 385.642 412.091L377.386 381.879C377.196 381.191 377.287 380.455 377.639 379.834C377.99 379.213 378.573 378.755 379.261 378.563L379.779 378.493Z",
    fill: "#263238"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M361.587 370.279C361.829 370.264 362.07 370.312 362.287 370.418L380.563 379.99C380.868 380.167 381.096 380.452 381.199 380.79C381.303 381.127 381.276 381.491 381.122 381.809C380.946 382.111 380.663 382.336 380.328 382.44C379.994 382.543 379.634 382.518 379.317 382.369L361.042 372.811C360.734 372.637 360.503 372.352 360.397 372.015C360.29 371.677 360.316 371.312 360.468 370.992C360.574 370.785 360.734 370.609 360.931 370.484C361.128 370.358 361.354 370.288 361.587 370.279Z",
    fill: "#263238"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M367.045 395.327C367.669 395.276 368.291 395.446 368.802 395.806C369.313 396.167 369.682 396.696 369.844 397.3L378.1 427.526C378.192 427.867 378.216 428.222 378.17 428.573C378.125 428.923 378.011 429.26 377.834 429.566C377.479 430.184 376.892 430.636 376.204 430.821C375.863 430.913 375.507 430.937 375.157 430.892C374.807 430.846 374.469 430.732 374.163 430.556C373.545 430.2 373.094 429.614 372.908 428.925L364.652 398.783C364.464 398.093 364.556 397.356 364.911 396.734C365.265 396.112 365.851 395.657 366.541 395.467C366.706 395.409 366.874 395.362 367.045 395.327Z",
    fill: "#263238"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M348.852 387.113C349.094 387.098 349.335 387.146 349.552 387.253L367.813 396.824C368.027 396.867 368.227 396.958 368.399 397.092C368.57 397.225 368.709 397.397 368.803 397.593C368.896 397.789 368.943 398.005 368.939 398.222C368.935 398.439 368.881 398.653 368.78 398.846C368.679 399.038 368.535 399.205 368.358 399.332C368.182 399.459 367.978 399.543 367.763 399.578C367.549 399.613 367.329 399.597 367.121 399.532C366.914 399.467 366.724 399.354 366.568 399.203L348.292 389.646C347.987 389.469 347.759 389.183 347.656 388.846C347.552 388.508 347.579 388.144 347.733 387.826C347.839 387.619 347.999 387.443 348.196 387.318C348.392 387.193 348.619 387.122 348.852 387.113Z",
    fill: "#263238"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M353.066 317.803H352.632C352.365 317.747 352.112 317.638 351.888 317.483C351.663 317.329 351.471 317.132 351.323 316.903C351.175 316.674 351.073 316.418 351.024 316.15C350.975 315.882 350.979 315.607 351.037 315.34L356.032 291.677C356.173 291.163 356.504 290.722 356.959 290.445C357.414 290.168 357.958 290.075 358.479 290.186C359 290.297 359.459 290.603 359.761 291.042C360.063 291.481 360.186 292.018 360.105 292.545L355.109 316.222C354.996 316.677 354.732 317.08 354.362 317.367C353.991 317.654 353.535 317.807 353.066 317.803Z",
    fill: "#263238"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M339.463 324.954C339.283 324.954 339.106 324.907 338.95 324.819C338.793 324.731 338.661 324.604 338.568 324.45C338.434 324.215 338.397 323.938 338.465 323.676C338.533 323.415 338.7 323.19 338.932 323.051L352.575 314.864C352.81 314.731 353.087 314.694 353.349 314.762C353.61 314.83 353.835 314.997 353.975 315.228C354.043 315.344 354.087 315.472 354.106 315.605C354.124 315.738 354.117 315.873 354.083 316.003C354.049 316.133 353.99 316.255 353.909 316.362C353.828 316.47 353.727 316.56 353.611 316.628L339.967 324.828C339.812 324.911 339.639 324.955 339.463 324.954Z",
    fill: "#263238"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M329.403 401.26C348.245 401.26 363.519 385.986 363.519 367.144C363.519 348.302 348.245 333.028 329.403 333.028C310.561 333.028 295.287 348.302 295.287 367.144C295.287 385.986 310.561 401.26 329.403 401.26Z",
    fill: "url(#paint563_linear_2204_11443)",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M344.781 376.016V358.272L329.402 349.4L314.037 358.272V376.016L329.402 384.888L344.781 376.016Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M329.402 349.4V333.014",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeMiterlimit: 10
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M329.402 384.888V401.26",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeMiterlimit: 10
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M295.287 367.144H363.533",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeMiterlimit: 10
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M516.412 655.032H146.424L163.202 608.546H499.633L516.412 655.032Z",
    fill: "#474747",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M494.344 614.017H168.492L169.318 611.624H493.519L494.344 614.017Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M176.552 620.286H165.525L166.911 616.284H177.84L176.552 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M206.847 620.286H195.834L196.967 616.284H207.896L206.847 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M220.421 620.286H209.395L210.416 616.284H221.345L220.421 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M233.982 620.286H222.969L223.878 616.284H234.807L233.982 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M247.542 620.286H236.529L237.327 616.284H248.256L247.542 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M273.835 620.286H262.809L263.382 616.284H274.311L273.835 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M287.394 620.286H276.381L276.843 616.284H287.772L287.394 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M300.968 620.286H289.941L290.291 616.284H301.22L300.968 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M314.527 620.286H303.5L303.738 616.284H314.667L314.527 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M457.611 626.807H446.444L445.465 622.693H456.548L457.611 626.807Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M471.366 626.807H460.185L459.094 622.693H470.177L471.366 626.807Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M485.109 626.807H473.942L472.738 622.693H483.807L485.109 626.807Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M498.863 626.807H487.697L486.367 622.693H497.436L498.863 626.807Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M459.164 632.754H447.857L446.85 628.528H458.058L459.164 632.754Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M473.075 632.754H461.768L460.648 628.528H471.857L473.075 632.754Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M486.997 632.754H475.691L474.445 628.528H485.668L486.997 632.754Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M460.746 638.842H449.299L448.264 634.518H459.626L460.746 638.842Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M474.836 638.842H463.39L462.242 634.518H473.591L474.836 638.842Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M488.929 638.842H477.482L476.209 634.518H487.558L488.929 638.842Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M488.242 628.528L488.998 630.865L489.614 632.754L491.573 638.842H503.019L500.92 632.754L500.263 630.865L499.465 628.528H488.242Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M462.369 645.069H450.782L449.732 640.647H461.221L462.369 645.069Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M476.641 645.069H465.041L463.865 640.647H475.354L476.641 645.069Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M490.916 645.069H479.315L478.014 640.647H489.502L490.916 645.069Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M471.242 646.93H465.546H451.217L452.294 651.478H466.75H472.501H478.49L477.175 646.93H471.242Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M492.943 651.478H481.203L479.859 646.93H491.502L492.943 651.478Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M492.16 640.647L494.175 646.93L494.581 648.161L495.645 651.478H507.385L506.252 648.161L505.818 646.93L503.649 640.647H492.16Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M340.808 620.286H329.795L329.809 616.284H340.738L340.808 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M354.381 620.286H343.354L343.256 616.284H354.185L354.381 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M367.94 620.286H356.913L356.703 616.284H367.632L367.94 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M381.501 620.286H370.488L370.152 616.284H381.081L381.501 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M340.934 626.359H329.768L329.782 622.259H340.85L340.934 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M354.673 626.359H343.507L343.395 622.259H354.463L354.673 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M368.094 622.259H367.479H357.025L357.235 626.359H367.8H368.402H382.144L381.71 622.259H368.094Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M285.475 626.359H274.309L274.798 622.259H285.867L285.475 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M299.218 626.359H288.051L288.415 622.259H299.483L299.218 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M312.96 626.359H301.793L302.045 622.259H313.114L312.96 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M326.688 626.359H315.535L315.661 622.259H326.73L326.688 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M230.02 626.359H218.867L219.819 622.259H230.888L230.02 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M243.762 626.359H232.609L233.449 622.259H244.504L243.762 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M257.505 626.359H246.338L247.066 622.259H258.134L257.505 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M271.245 626.359H260.078L260.68 622.259H271.749L271.245 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M174.579 626.359H163.412L164.839 622.259H175.908L174.579 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M188.321 626.359H177.154L178.456 622.259H189.525L188.321 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M202.047 626.359H190.895L192.084 622.259H203.153L202.047 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M215.788 626.359H204.621L205.699 622.259H216.767L215.788 626.359Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M341.045 632.363H329.752L329.766 628.151H340.961L341.045 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M354.955 632.363H343.663L343.551 628.151H354.76L354.955 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M368.543 628.151H367.927H357.334L357.558 632.363H368.249H368.865H382.774L382.326 628.151H368.543Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M284.904 632.363H273.611L274.115 628.151H285.31L284.904 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M298.814 632.363H287.521L287.899 628.151H299.094L298.814 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M312.722 632.363H301.43L301.682 628.151H312.89L312.722 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M326.631 632.363H315.338L315.478 628.151H326.673L326.631 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M228.775 632.363H217.469L218.448 628.151H229.657L228.775 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M242.686 632.363H231.379L232.247 628.151H243.441L242.686 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M256.596 632.363H245.289L246.031 628.151H257.239L256.596 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M270.488 632.363H259.195L259.811 628.151H271.02L270.488 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M172.633 632.363H161.34L162.795 628.151H174.004L172.633 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M186.543 632.363H175.25L176.579 628.151H187.788L186.543 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M200.453 632.363H189.146L190.378 628.151H201.573L200.453 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M214.363 632.363H203.057L204.162 628.151H215.371L214.363 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M341.171 638.492H329.725L329.739 634.182H341.087L341.171 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M355.25 638.492H343.817L343.705 634.182H355.04L355.25 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M369.005 634.182H368.389H357.656L357.894 638.492H368.711H369.327H383.418L382.956 634.182H369.005Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M284.329 638.492H272.883L273.401 634.182H284.735L284.329 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M298.407 638.492H286.975L287.352 634.182H298.701L298.407 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M312.499 638.492H301.053L301.319 634.182H312.653L312.499 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M326.576 638.492H315.129L315.269 634.182H326.618L326.576 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M227.488 638.492H216.041L217.049 634.182H228.397L227.488 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M241.565 638.492H230.133L231.014 634.182H242.349L241.565 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M255.656 638.492H244.209L244.965 634.182H256.313L255.656 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M269.734 638.492H258.287L258.931 634.182H270.266L269.734 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M170.646 638.492H159.199L160.697 634.182H172.045L170.646 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M184.724 638.492H173.291L174.662 634.182H186.011L184.724 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M198.816 638.492H187.369L188.629 634.182H199.963L198.816 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M212.892 638.492H201.445L202.579 634.182H213.927L212.892 638.492Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M341.298 644.789H329.711L329.725 640.367H341.2L341.298 644.789Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M369.479 640.367H368.85H357.991H343.857L343.969 644.789H358.229H362.833H369.186H369.815H384.075L383.613 640.367H369.479Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M283.727 644.789H272.141L272.658 640.367H284.147L283.727 644.789Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M297.987 644.789H286.4L286.806 640.367H298.281L297.987 644.789Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M312.247 644.789H300.66L300.94 640.367H312.415L312.247 644.789Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M326.505 644.789H314.918L315.072 640.367H326.547L326.505 644.789Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M226.173 644.789H214.586L215.607 640.367H227.096L226.173 644.789Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M240.432 644.789H228.846L229.741 640.367H241.23L240.432 644.789Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M254.692 644.789H243.105L243.875 640.367H255.364L254.692 644.789Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M268.95 644.789H257.363L258.021 640.367H269.496L268.95 644.789Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M170.044 640.367H164.824H158.555L157.016 644.789H163.341H168.602H182.862L184.177 640.367H170.044Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M197.124 644.789H185.537L186.825 640.367H198.313L197.124 644.789Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M211.382 644.789H199.795L200.956 640.367H212.445L211.382 644.789Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M341.422 651.254H329.682L329.696 646.706H341.324L341.422 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M355.864 651.254H344.124L344.012 646.706H355.64L355.864 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M369.941 651.254H358.201L357.963 646.706H369.591L369.941 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M384.004 651.254H372.278L371.914 646.706H383.543L384.004 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M283.113 651.254H271.387L271.918 646.706H283.547L283.113 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M297.567 651.254H285.826L286.232 646.706H297.861L297.567 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M312.01 651.254H300.27L300.549 646.706H312.178L312.01 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M224.815 651.254H213.074L214.138 646.706H225.766L224.815 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M239.256 651.254H227.516L228.453 646.706H240.082L239.256 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M253.697 651.254H241.971L242.768 646.706H254.397L253.697 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M268.153 651.254H256.412L257.084 646.706H268.712L268.153 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M166.518 651.254H154.777L156.359 646.706H167.987L166.518 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M180.959 651.254H169.219L170.674 646.706H182.303L180.959 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M195.401 651.254H183.66L184.976 646.706H196.618L195.401 651.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M317.2 646.706H314.863H199.305L198.115 651.254H314.709H317.074H326.45L326.491 646.706H317.2Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M407.793 620.286H396.766L396.221 616.284H407.15L407.793 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M421.354 620.286H410.328L409.67 616.284H420.599L421.354 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M434.914 620.286H423.901L423.117 616.284H434.046L434.914 620.286Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M408.803 626.597H397.636L397.076 622.497H408.145L408.803 626.597Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M422.544 626.597H411.377L410.691 622.497H421.774L422.544 626.597Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M436.285 626.597H425.118L424.32 622.497H435.403L436.285 626.597Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M409.712 632.363H398.419L397.846 628.151H409.04L409.712 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M423.621 632.363H412.329L411.629 628.151H422.838L423.621 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M437.53 632.363H426.238L425.412 628.151H436.621L437.53 632.363Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M410.663 638.254H399.217L398.629 633.93H409.964L410.663 638.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M424.74 638.254H413.294L412.58 633.93H423.929L424.74 638.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M438.805 638.254H427.372L426.547 633.93H437.882L438.805 638.254Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M426.112 645.558H414.511L413.77 641.123H425.272L426.112 645.558Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M427.16 651.156H415.433L414.678 646.622H426.306L427.16 651.156Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M441.239 651.156H429.498L428.631 646.622H440.259L441.239 651.156Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M412.427 651.156H400.686L400.07 646.622H411.699L412.427 651.156Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M516.454 655.032H146.424V659.58H516.454V655.032Z",
    fill: "#6E6E6E",
    stroke: "#263238",
    strokeWidth: 0.962681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M673.547 263.284L538.37 360.595C533.331 358.073 527.592 357.314 522.07 358.438C516.549 359.563 511.564 362.506 507.912 366.798C504.261 371.089 502.154 376.482 501.928 382.112C501.703 387.742 503.372 393.286 506.669 397.856C509.965 402.426 514.699 405.758 520.113 407.321C525.527 408.883 531.308 408.585 536.533 406.474C541.757 404.363 546.123 400.561 548.932 395.676C551.741 390.791 552.831 385.106 552.027 379.528L687.204 282.232C691.362 284.333 696.021 285.24 700.664 284.852C705.306 284.464 709.75 282.796 713.502 280.034C717.253 277.271 720.165 273.523 721.913 269.205C723.662 264.887 724.178 260.168 723.406 255.574L721.489 253.657L705.088 268.784L692.102 250.83L710.56 237.522C709.872 236.939 709.235 236.297 708.657 235.605C708.657 235.605 691.417 233.66 683.706 239.258C679.981 241.954 677.065 245.618 675.274 249.853C673.483 254.089 672.886 258.734 673.547 263.284ZM520.346 398.07L510.775 384.79L517.491 369.873L533.766 368.221L543.337 381.487L536.635 396.404L520.346 398.07Z",
    fill: "#37474F",
    stroke: "#263238",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M671.629 261.381L536.452 358.678C531.413 356.156 525.674 355.397 520.152 356.521C514.631 357.645 509.646 360.589 505.994 364.881C502.343 369.172 500.236 374.565 500.01 380.195C499.785 385.825 501.454 391.369 504.751 395.939C508.047 400.509 512.781 403.841 518.195 405.403C523.609 406.966 529.39 406.668 534.615 404.557C539.839 402.446 544.205 398.644 547.014 393.759C549.823 388.874 550.913 383.188 550.109 377.611L685.287 280.314C689.444 282.416 694.103 283.323 698.746 282.935C703.388 282.547 707.832 280.879 711.584 278.117C715.335 275.354 718.247 271.606 719.995 267.288C721.744 262.969 722.26 258.251 721.488 253.657L703.156 266.881L690.212 248.913L708.67 235.605C704.558 233.343 699.896 232.275 695.209 232.521C690.522 232.767 685.998 234.317 682.145 236.997C678.293 239.677 675.265 243.38 673.405 247.688C671.544 251.997 670.924 256.739 671.615 261.381H671.629ZM518.442 396.152L508.871 382.887L515.574 367.998L531.848 366.346L541.419 379.612L534.717 394.543L518.442 396.152Z",
    fill: "#37474F",
    stroke: "#263238",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M603.799 504.56H635.014V530.75",
    stroke: "#37474F",
    strokeWidth: 6.79386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M602.044 504.56H580.338V530.75",
    stroke: "#37474F",
    strokeWidth: 6.79386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M548.528 530.75H646.407C648.619 530.75 650.809 531.185 652.853 532.032C654.896 532.878 656.753 534.119 658.317 535.683C659.881 537.247 661.122 539.104 661.968 541.147C662.814 543.191 663.25 545.381 663.25 547.593V628.51H535.148V544.034C535.148 542.282 535.495 540.547 536.169 538.929C536.842 537.311 537.829 535.842 539.073 534.607C540.317 533.372 541.792 532.396 543.415 531.734C545.038 531.072 546.775 530.737 548.528 530.75Z",
    fill: "#20252A",
    stroke: "#263238",
    strokeWidth: 1.69846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M571.798 530.75H646.406C648.617 530.75 650.808 531.185 652.851 532.032C654.895 532.878 656.751 534.119 658.315 535.683C659.879 537.247 661.12 539.104 661.966 541.147C662.813 543.191 663.248 545.381 663.248 547.593V628.51H558.514V544.034C558.514 540.511 559.913 537.132 562.405 534.641C564.896 532.149 568.275 530.75 571.798 530.75Z",
    fill: "#41525B",
    stroke: "#41525B",
    strokeWidth: 1.69846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M610.896 608.37C626.775 608.37 639.648 595.497 639.648 579.618C639.648 563.739 626.775 550.867 610.896 550.867C595.017 550.867 582.145 563.739 582.145 579.618C582.145 595.497 595.017 608.37 610.896 608.37Z",
    stroke: "url(#paint564_linear_2204_11443)",
    strokeWidth: 1.69846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M610.896 603.957C624.338 603.957 635.235 593.06 635.235 579.618C635.235 566.176 624.338 555.279 610.896 555.279C597.454 555.279 586.557 566.176 586.557 579.618C586.557 593.06 597.454 603.957 610.896 603.957Z",
    fill: "#37474F",
    stroke: "#263238",
    strokeWidth: 1.69846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M611.463 564.981H611.606C612.392 564.981 613.146 565.294 613.702 565.85C614.259 566.406 614.571 567.16 614.571 567.947V573.284H608.498V567.947C608.498 567.16 608.81 566.406 609.367 565.85C609.923 565.294 610.677 564.981 611.463 564.981Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.69846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M605.061 565.432C604.922 565.435 604.787 565.389 604.679 565.302C604.57 565.215 604.496 565.094 604.468 564.958L603.021 558.102C603.003 558.025 603.001 557.946 603.014 557.869C603.028 557.792 603.056 557.718 603.098 557.652C603.14 557.586 603.194 557.529 603.258 557.484C603.323 557.439 603.395 557.407 603.472 557.39C603.548 557.373 603.627 557.37 603.704 557.384C603.781 557.397 603.855 557.425 603.921 557.467C603.987 557.509 604.045 557.564 604.09 557.628C604.135 557.692 604.166 557.764 604.183 557.841L605.654 564.72C605.682 564.877 605.649 565.039 605.56 565.172C605.472 565.304 605.335 565.398 605.18 565.432H605.061Z",
    fill: "#263238"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M609.022 567.52H608.856L604.894 565.147C604.839 565.09 604.809 565.013 604.809 564.934C604.809 564.854 604.839 564.778 604.894 564.72C604.921 564.694 604.952 564.673 604.987 564.658C605.022 564.644 605.059 564.637 605.096 564.637C605.134 564.637 605.171 564.644 605.205 564.658C605.24 564.673 605.271 564.694 605.298 564.72L609.259 567.093C609.328 567.137 609.378 567.205 609.4 567.283C609.422 567.362 609.414 567.446 609.378 567.52C609.325 567.553 609.263 567.571 609.2 567.571C609.137 567.571 609.075 567.553 609.022 567.52Z",
    fill: "#263238"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M597.921 574.47C597.746 574.428 597.563 574.442 597.397 574.511C597.231 574.579 597.09 574.697 596.996 574.85L592.725 582.892C592.628 583.077 592.608 583.294 592.67 583.494C592.733 583.695 592.872 583.862 593.058 583.959C593.243 584.057 593.46 584.077 593.66 584.014C593.86 583.952 594.028 583.813 594.125 583.627L598.371 575.585C598.421 575.497 598.453 575.399 598.464 575.298C598.475 575.198 598.467 575.096 598.438 574.998C598.409 574.901 598.361 574.81 598.297 574.732C598.232 574.654 598.153 574.589 598.063 574.542L597.921 574.47Z",
    fill: "#263238"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M603.589 573.379C603.518 573.367 603.446 573.367 603.375 573.379L597.587 574.921C597.536 574.932 597.489 574.953 597.447 574.983C597.406 575.014 597.372 575.053 597.347 575.098C597.322 575.143 597.307 575.193 597.304 575.245C597.3 575.296 597.308 575.347 597.326 575.396C597.337 575.446 597.358 575.494 597.388 575.536C597.419 575.578 597.457 575.614 597.501 575.641C597.546 575.667 597.595 575.685 597.647 575.691C597.698 575.698 597.75 575.694 597.8 575.68L603.565 574.138C603.615 574.127 603.663 574.106 603.706 574.076C603.748 574.046 603.783 574.007 603.81 573.963C603.836 573.918 603.854 573.869 603.861 573.817C603.867 573.766 603.864 573.714 603.849 573.664C603.83 573.6 603.796 573.541 603.751 573.492C603.706 573.443 603.65 573.404 603.589 573.379Z",
    fill: "#263238"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M596.592 583.034C596.415 583.023 596.241 583.074 596.098 583.178C595.955 583.282 595.853 583.432 595.809 583.604L593.436 592.381C593.408 592.479 593.4 592.582 593.412 592.683C593.424 592.785 593.456 592.883 593.507 592.972C593.558 593.06 593.626 593.138 593.708 593.199C593.79 593.261 593.883 593.305 593.982 593.33C594.08 593.358 594.183 593.367 594.285 593.355C594.386 593.343 594.484 593.31 594.573 593.259C594.661 593.208 594.739 593.14 594.8 593.058C594.862 592.977 594.906 592.883 594.931 592.784L597.303 584.031C597.332 583.931 597.341 583.827 597.329 583.723C597.317 583.62 597.285 583.521 597.234 583.43C597.183 583.34 597.115 583.26 597.033 583.196C596.951 583.132 596.858 583.085 596.758 583.058L596.592 583.034Z",
    fill: "#263238"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M601.881 580.662C601.811 580.64 601.737 580.64 601.667 580.662L596.377 583.438C596.332 583.461 596.292 583.493 596.259 583.532C596.226 583.571 596.202 583.616 596.186 583.664C596.171 583.713 596.165 583.764 596.169 583.814C596.174 583.865 596.188 583.914 596.211 583.959C596.235 584.005 596.267 584.045 596.306 584.077C596.344 584.11 596.389 584.135 596.438 584.151C596.486 584.166 596.537 584.172 596.588 584.167C596.639 584.163 596.688 584.149 596.733 584.125L602.023 581.35C602.069 581.327 602.11 581.296 602.143 581.257C602.177 581.218 602.202 581.173 602.218 581.124C602.233 581.076 602.239 581.024 602.234 580.973C602.229 580.922 602.214 580.873 602.189 580.828C602.158 580.774 602.113 580.73 602.059 580.701C602.004 580.672 601.943 580.658 601.881 580.662Z",
    fill: "#263238"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M600.293 587.921C600.115 587.913 599.939 587.965 599.793 588.068C599.647 588.171 599.539 588.319 599.487 588.49L597.114 597.268C597.07 597.469 597.105 597.679 597.211 597.855C597.316 598.031 597.486 598.161 597.684 598.217C597.782 598.245 597.885 598.254 597.986 598.241C598.088 598.229 598.186 598.197 598.274 598.146C598.363 598.095 598.44 598.027 598.502 597.945C598.563 597.863 598.608 597.77 598.633 597.671L601.005 588.917C601.057 588.716 601.029 588.503 600.927 588.321C600.826 588.14 600.658 588.005 600.459 587.945L600.293 587.921Z",
    fill: "#263238"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M605.558 585.549C605.497 585.527 605.43 585.527 605.369 585.549L600.055 588.324C599.965 588.379 599.899 588.466 599.872 588.568C599.846 588.67 599.86 588.778 599.913 588.87C599.935 588.916 599.967 588.957 600.005 588.99C600.044 589.023 600.089 589.049 600.138 589.064C600.187 589.08 600.238 589.085 600.289 589.08C600.34 589.075 600.389 589.06 600.434 589.036L605.724 586.26C605.814 586.206 605.881 586.12 605.912 586.019C605.943 585.919 605.935 585.81 605.891 585.715C605.854 585.661 605.804 585.617 605.746 585.588C605.688 585.559 605.623 585.546 605.558 585.549Z",
    fill: "#263238"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M624.823 574.47C624.994 574.426 625.174 574.439 625.337 574.508C625.5 574.577 625.636 574.697 625.724 574.85L629.994 582.892C630.043 582.982 630.073 583.081 630.083 583.182C630.092 583.284 630.081 583.387 630.05 583.485C630.019 583.582 629.969 583.672 629.902 583.75C629.835 583.827 629.754 583.891 629.662 583.936C629.573 583.985 629.476 584.017 629.375 584.028C629.274 584.04 629.172 584.031 629.075 584.002C628.978 583.973 628.887 583.925 628.808 583.861C628.73 583.797 628.665 583.717 628.618 583.627L624.348 575.585C624.299 575.495 624.269 575.397 624.259 575.295C624.25 575.193 624.261 575.09 624.292 574.993C624.323 574.895 624.373 574.805 624.44 574.727C624.507 574.65 624.588 574.587 624.68 574.542L624.823 574.47Z",
    fill: "#263238"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M619.151 573.379C619.221 573.367 619.293 573.367 619.364 573.379L625.129 574.921C625.179 574.934 625.225 574.956 625.267 574.986C625.308 575.017 625.343 575.055 625.369 575.099C625.396 575.143 625.413 575.192 625.421 575.243C625.428 575.294 625.426 575.346 625.413 575.396C625.401 575.445 625.379 575.492 625.348 575.534C625.318 575.575 625.279 575.61 625.235 575.636C625.191 575.663 625.142 575.68 625.091 575.688C625.041 575.695 624.989 575.693 624.939 575.68L619.151 574.138C619.1 574.127 619.052 574.106 619.01 574.076C618.968 574.046 618.932 574.007 618.906 573.963C618.879 573.918 618.862 573.869 618.855 573.817C618.848 573.766 618.852 573.714 618.866 573.664C618.886 573.597 618.923 573.535 618.973 573.486C619.022 573.436 619.083 573.4 619.151 573.379Z",
    fill: "#263238"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M626.124 583.034C626.303 583.022 626.481 583.072 626.628 583.176C626.775 583.279 626.882 583.43 626.93 583.604L629.303 592.381C629.329 592.481 629.336 592.584 629.322 592.687C629.308 592.789 629.275 592.887 629.223 592.977C629.118 593.157 628.946 593.288 628.745 593.342C628.544 593.395 628.33 593.366 628.149 593.262C627.969 593.157 627.838 592.985 627.784 592.784L625.412 584.031C625.36 583.829 625.388 583.616 625.49 583.435C625.591 583.254 625.759 583.119 625.958 583.058L626.124 583.034Z",
    fill: "#263238"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M620.863 580.662C620.924 580.638 620.991 580.638 621.052 580.662L626.366 583.437C626.412 583.46 626.453 583.492 626.486 583.53C626.52 583.569 626.545 583.614 626.56 583.663C626.576 583.712 626.582 583.763 626.577 583.814C626.572 583.865 626.557 583.914 626.532 583.959C626.478 584.049 626.392 584.116 626.291 584.147C626.191 584.177 626.082 584.17 625.987 584.125L620.697 581.35C620.651 581.327 620.61 581.296 620.576 581.257C620.543 581.218 620.518 581.173 620.502 581.124C620.487 581.076 620.481 581.024 620.486 580.973C620.491 580.922 620.506 580.873 620.531 580.828C620.565 580.772 620.615 580.728 620.673 580.698C620.732 580.669 620.797 580.656 620.863 580.662Z",
    fill: "#263238"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M622.428 587.921C622.607 587.909 622.785 587.959 622.932 588.062C623.079 588.166 623.186 588.317 623.234 588.49L625.607 597.268C625.658 597.466 625.629 597.676 625.527 597.853C625.425 598.031 625.258 598.161 625.061 598.217C624.963 598.249 624.859 598.26 624.756 598.249C624.654 598.239 624.554 598.207 624.465 598.155C624.375 598.104 624.298 598.034 624.237 597.951C624.176 597.867 624.134 597.772 624.112 597.671L621.74 588.917C621.711 588.818 621.702 588.713 621.714 588.61C621.726 588.507 621.758 588.407 621.809 588.317C621.86 588.226 621.928 588.147 622.01 588.083C622.092 588.019 622.185 587.972 622.285 587.945L622.428 587.921Z",
    fill: "#263238"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M617.063 585.549C617.133 585.525 617.208 585.525 617.277 585.549L622.567 588.324C622.657 588.379 622.724 588.465 622.755 588.565C622.785 588.666 622.778 588.774 622.733 588.87C622.711 588.916 622.679 588.957 622.64 588.99C622.601 589.023 622.556 589.049 622.508 589.064C622.459 589.08 622.407 589.085 622.357 589.08C622.306 589.075 622.256 589.06 622.211 589.036L617.063 586.332C616.973 586.277 616.907 586.191 616.876 586.091C616.845 585.99 616.853 585.881 616.897 585.786C616.919 585.688 616.979 585.603 617.063 585.549Z",
    fill: "#263238"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M618.393 565.432H618.251C618.099 565.393 617.968 565.297 617.885 565.165C617.801 565.033 617.771 564.874 617.8 564.721L619.247 557.841C619.302 557.707 619.403 557.597 619.532 557.53C619.66 557.463 619.808 557.444 619.949 557.475C620.091 557.506 620.217 557.586 620.305 557.7C620.394 557.815 620.439 557.957 620.433 558.102L618.962 564.981C618.931 565.109 618.858 565.223 618.755 565.304C618.652 565.386 618.524 565.431 618.393 565.432Z",
    fill: "#263238"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M614.431 567.52C614.378 567.525 614.325 567.515 614.278 567.489C614.231 567.464 614.194 567.425 614.17 567.377C614.115 567.32 614.084 567.243 614.084 567.164C614.084 567.084 614.115 567.008 614.17 566.95L618.131 564.578C618.189 564.523 618.265 564.492 618.345 564.492C618.424 564.492 618.501 564.523 618.558 564.578C618.609 564.638 618.636 564.713 618.636 564.792C618.636 564.87 618.609 564.945 618.558 565.005L614.597 567.377L614.431 567.52Z",
    fill: "#263238"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M611.513 589.629C616.977 589.629 621.406 585.2 621.406 579.737C621.406 574.273 616.977 569.844 611.513 569.844C606.05 569.844 601.621 574.273 601.621 579.737C601.621 585.2 606.05 589.629 611.513 589.629Z",
    fill: "url(#paint565_linear_2204_11443)",
    stroke: "#263238",
    strokeWidth: 1.69846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M615.974 582.322V577.175L611.514 574.613L607.055 577.175V582.322L611.514 584.885L615.974 582.322Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.69846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M611.512 574.613V569.844",
    stroke: "#263238",
    strokeWidth: 1.69846,
    strokeMiterlimit: 10
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M611.512 584.884V589.653",
    stroke: "#263238",
    strokeWidth: 1.69846,
    strokeMiterlimit: 10
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M601.621 579.737H621.429",
    stroke: "#263238",
    strokeWidth: 1.69846,
    strokeMiterlimit: 10
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M586.225 593.875L630.823 560.023",
    stroke: "url(#paint566_linear_2204_11443)",
    strokeWidth: 1.69846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2204_11443",
    x1: 99.85,
    y1: 59.3504,
    x2: 154.581,
    y2: 87.7392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2204_11443",
    x1: 77.6854,
    y1: 127.518,
    x2: 132.401,
    y2: 155.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2204_11443",
    x1: 140.703,
    y1: 83.1194,
    x2: 197.161,
    y2: 118.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2204_11443",
    x1: 113.434,
    y1: 169.325,
    x2: 168.941,
    y2: 212.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2204_11443",
    x1: 119.536,
    y1: 246.132,
    x2: 174.27,
    y2: 274.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2204_11443",
    x1: 80.5502,
    y1: 261.661,
    x2: 132.565,
    y2: 283.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2204_11443",
    x1: 104.243,
    y1: 331.039,
    x2: 158.959,
    y2: 359.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2204_11443",
    x1: 112.019,
    y1: 378.891,
    x2: 161.003,
    y2: 397.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2204_11443",
    x1: 37.3726,
    y1: 222.27,
    x2: 70.0133,
    y2: 235.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2204_11443",
    x1: 58.6602,
    y1: 262.597,
    x2: 91.3054,
    y2: 276.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2204_11443",
    x1: 9.97483,
    y1: 247.642,
    x2: 43.9508,
    y2: 277.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2204_11443",
    x1: 34.1462,
    y1: 299.366,
    x2: 64.3736,
    y2: 332.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2204_11443",
    x1: 43.4806,
    y1: 346.914,
    x2: 79.2669,
    y2: 372.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2204_11443",
    x1: 73.3827,
    y1: 347.61,
    x2: 103.48,
    y2: 358.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2204_11443",
    x1: 94.1604,
    y1: 413.579,
    x2: 130.082,
    y2: 436.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2204_11443",
    x1: 62.2338,
    y1: 398.396,
    x2: 98.0192,
    y2: 424.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2204_11443",
    x1: 65.9182,
    y1: 427.751,
    x2: 99.8503,
    y2: 443.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2204_11443",
    x1: 147.32,
    y1: 233.225,
    x2: 156.318,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2204_11443",
    x1: 154.967,
    y1: 232.957,
    x2: 164.042,
    y2: 236.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2204_11443",
    x1: 162.502,
    y1: 233.225,
    x2: 171.499,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2204_11443",
    x1: 170.858,
    y1: 233.209,
    x2: 176.688,
    y2: 234.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2204_11443",
    x1: 181.432,
    y1: 233.209,
    x2: 187.243,
    y2: 234.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2204_11443",
    x1: 189.054,
    y1: 233.209,
    x2: 194.826,
    y2: 234.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2204_11443",
    x1: 196.628,
    y1: 233.209,
    x2: 202.419,
    y2: 234.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2204_11443",
    x1: 204.225,
    y1: 233.209,
    x2: 210.017,
    y2: 234.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2204_11443",
    x1: 211.825,
    y1: 233.209,
    x2: 217.617,
    y2: 234.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2204_11443",
    x1: 221.596,
    y1: 233.225,
    x2: 230.593,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2204_11443",
    x1: 229.133,
    y1: 232.957,
    x2: 238.208,
    y2: 236.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2204_11443",
    x1: 236.779,
    y1: 233.225,
    x2: 245.777,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2204_11443",
    x1: 244.379,
    y1: 233.225,
    x2: 253.376,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2204_11443",
    x1: 251.969,
    y1: 232.957,
    x2: 261.044,
    y2: 236.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2204_11443",
    x1: 266.241,
    y1: 233.209,
    x2: 272.014,
    y2: 234.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2204_11443",
    x1: 273.884,
    y1: 233.209,
    x2: 279.675,
    y2: 234.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2204_11443",
    x1: 281.492,
    y1: 233.209,
    x2: 287.244,
    y2: 234.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2204_11443",
    x1: 289.069,
    y1: 233.209,
    x2: 294.861,
    y2: 234.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2204_11443",
    x1: 296.667,
    y1: 233.209,
    x2: 302.458,
    y2: 234.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2204_11443",
    x1: 304.251,
    y1: 233.209,
    x2: 310.042,
    y2: 234.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2204_11443",
    x1: 311.057,
    y1: 233.225,
    x2: 320.054,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2204_11443",
    x1: 318.697,
    y1: 233.225,
    x2: 327.695,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2204_11443",
    x1: 326.246,
    y1: 232.957,
    x2: 335.322,
    y2: 236.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2204_11443",
    x1: 333.838,
    y1: 233.225,
    x2: 342.835,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2204_11443",
    x1: 341.43,
    y1: 232.957,
    x2: 350.505,
    y2: 236.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2204_11443",
    x1: 349.021,
    y1: 233.225,
    x2: 358.019,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2204_11443",
    x1: 356.613,
    y1: 232.957,
    x2: 365.689,
    y2: 236.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2204_11443",
    x1: 367.974,
    y1: 233.209,
    x2: 373.746,
    y2: 234.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2204_11443",
    x1: 375.561,
    y1: 233.209,
    x2: 381.353,
    y2: 234.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2204_11443",
    x1: 383.145,
    y1: 233.209,
    x2: 388.937,
    y2: 234.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2204_11443",
    x1: 390.782,
    y1: 233.209,
    x2: 396.555,
    y2: 234.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2204_11443",
    x1: 398.343,
    y1: 233.209,
    x2: 404.134,
    y2: 234.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2204_11443",
    x1: 411.047,
    y1: 232.957,
    x2: 420.122,
    y2: 236.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2204_11443",
    x1: 418.68,
    y1: 233.225,
    x2: 427.677,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2204_11443",
    x1: 426.273,
    y1: 232.957,
    x2: 435.349,
    y2: 236.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2204_11443",
    x1: 433.863,
    y1: 233.225,
    x2: 442.861,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2204_11443",
    x1: 441.461,
    y1: 233.225,
    x2: 450.458,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2204_11443",
    x1: 449.053,
    y1: 232.957,
    x2: 458.128,
    y2: 236.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2204_11443",
    x1: 462.592,
    y1: 233.225,
    x2: 471.589,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2204_11443",
    x1: 470.97,
    y1: 233.209,
    x2: 476.761,
    y2: 234.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2204_11443",
    x1: 477.775,
    y1: 233.225,
    x2: 486.773,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2204_11443",
    x1: 486.151,
    y1: 233.209,
    x2: 491.943,
    y2: 234.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2204_11443",
    x1: 492.959,
    y1: 233.225,
    x2: 501.956,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2204_11443",
    x1: 501.331,
    y1: 233.209,
    x2: 507.103,
    y2: 234.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2204_11443",
    x1: 508.141,
    y1: 233.225,
    x2: 517.138,
    y2: 236.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2204_11443",
    x1: 147.32,
    y1: 256.23,
    x2: 156.318,
    y2: 259.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2204_11443",
    x1: 155.693,
    y1: 256.209,
    x2: 161.467,
    y2: 257.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2204_11443",
    x1: 162.502,
    y1: 256.23,
    x2: 171.499,
    y2: 259.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2204_11443",
    x1: 170.858,
    y1: 256.209,
    x2: 176.69,
    y2: 257.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2204_11443",
    x1: 177.693,
    y1: 255.963,
    x2: 186.769,
    y2: 259.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2204_11443",
    x1: 186.061,
    y1: 256.209,
    x2: 191.855,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2204_11443",
    x1: 193.661,
    y1: 256.209,
    x2: 199.454,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2204_11443",
    x1: 201.259,
    y1: 256.209,
    x2: 207.052,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2204_11443",
    x1: 208.868,
    y1: 256.209,
    x2: 214.642,
    y2: 257.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2204_11443",
    x1: 216.442,
    y1: 256.209,
    x2: 222.236,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2204_11443",
    x1: 224.036,
    y1: 256.209,
    x2: 229.81,
    y2: 257.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2204_11443",
    x1: 231.624,
    y1: 256.209,
    x2: 237.417,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2204_11443",
    x1: 238.43,
    y1: 256.23,
    x2: 247.427,
    y2: 259.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2204_11443",
    x1: 246.807,
    y1: 256.209,
    x2: 252.601,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2204_11443",
    x1: 257.374,
    y1: 256.209,
    x2: 263.167,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2204_11443",
    x1: 264.123,
    y1: 256.23,
    x2: 273.12,
    y2: 259.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2204_11443",
    x1: 272.545,
    y1: 256.209,
    x2: 278.358,
    y2: 257.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2204_11443",
    x1: 283.11,
    y1: 256.209,
    x2: 288.923,
    y2: 257.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2204_11443",
    x1: 292.9,
    y1: 255.963,
    x2: 301.976,
    y2: 259.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2204_11443",
    x1: 301.284,
    y1: 256.209,
    x2: 307.077,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2204_11443",
    x1: 308.868,
    y1: 256.209,
    x2: 314.661,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2204_11443",
    x1: 316.478,
    y1: 256.209,
    x2: 322.252,
    y2: 257.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2204_11443",
    x1: 324.052,
    y1: 256.209,
    x2: 329.845,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2204_11443",
    x1: 331.649,
    y1: 256.209,
    x2: 337.443,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2204_11443",
    x1: 338.455,
    y1: 256.23,
    x2: 347.453,
    y2: 259.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2204_11443",
    x1: 346.843,
    y1: 256.209,
    x2: 352.617,
    y2: 257.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2204_11443",
    x1: 353.674,
    y1: 255.963,
    x2: 362.749,
    y2: 259.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2204_11443",
    x1: 362.016,
    y1: 256.209,
    x2: 367.81,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2204_11443",
    x1: 368.828,
    y1: 255.963,
    x2: 377.904,
    y2: 259.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2204_11443",
    x1: 377.212,
    y1: 256.209,
    x2: 383.005,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2204_11443",
    x1: 392.934,
    y1: 256.23,
    x2: 401.931,
    y2: 259.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2204_11443",
    x1: 401.309,
    y1: 256.209,
    x2: 407.103,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2204_11443",
    x1: 408.115,
    y1: 256.23,
    x2: 417.113,
    y2: 259.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2204_11443",
    x1: 416.491,
    y1: 256.209,
    x2: 422.285,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2204_11443",
    x1: 424.103,
    y1: 256.209,
    x2: 429.877,
    y2: 257.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2204_11443",
    x1: 431.687,
    y1: 256.209,
    x2: 437.461,
    y2: 257.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2204_11443",
    x1: 438.488,
    y1: 255.963,
    x2: 447.564,
    y2: 259.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2204_11443",
    x1: 446.858,
    y1: 256.209,
    x2: 452.652,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2204_11443",
    x1: 454.446,
    y1: 256.209,
    x2: 460.259,
    y2: 257.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2204_11443",
    x1: 462.066,
    y1: 256.209,
    x2: 467.84,
    y2: 257.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2204_11443",
    x1: 469.629,
    y1: 256.209,
    x2: 475.442,
    y2: 257.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2204_11443",
    x1: 477.249,
    y1: 256.209,
    x2: 483.023,
    y2: 257.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2204_11443",
    x1: 484.823,
    y1: 256.209,
    x2: 490.616,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2204_11443",
    x1: 494.609,
    y1: 256.23,
    x2: 503.607,
    y2: 259.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2204_11443",
    x1: 502.987,
    y1: 256.209,
    x2: 508.781,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2204_11443",
    x1: 510.571,
    y1: 256.209,
    x2: 516.365,
    y2: 257.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2204_11443",
    x1: 147.32,
    y1: 279.865,
    x2: 156.318,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2204_11443",
    x1: 154.967,
    y1: 279.598,
    x2: 164.042,
    y2: 283.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2204_11443",
    x1: 162.502,
    y1: 279.865,
    x2: 171.499,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2204_11443",
    x1: 170.858,
    y1: 279.849,
    x2: 176.688,
    y2: 281.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2204_11443",
    x1: 181.432,
    y1: 279.849,
    x2: 187.243,
    y2: 281.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2204_11443",
    x1: 189.054,
    y1: 279.849,
    x2: 194.826,
    y2: 281.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2204_11443",
    x1: 196.628,
    y1: 279.849,
    x2: 202.419,
    y2: 281.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2204_11443",
    x1: 204.225,
    y1: 279.849,
    x2: 210.017,
    y2: 281.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2204_11443",
    x1: 211.825,
    y1: 279.849,
    x2: 217.617,
    y2: 281.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2204_11443",
    x1: 221.596,
    y1: 279.865,
    x2: 230.593,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2204_11443",
    x1: 229.133,
    y1: 279.598,
    x2: 238.208,
    y2: 283.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2204_11443",
    x1: 236.779,
    y1: 279.865,
    x2: 245.777,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2204_11443",
    x1: 244.379,
    y1: 279.865,
    x2: 253.376,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2204_11443",
    x1: 251.969,
    y1: 279.598,
    x2: 261.044,
    y2: 283.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2204_11443",
    x1: 266.241,
    y1: 279.849,
    x2: 272.014,
    y2: 281.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2204_11443",
    x1: 273.884,
    y1: 279.849,
    x2: 279.675,
    y2: 281.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2204_11443",
    x1: 281.492,
    y1: 279.849,
    x2: 287.244,
    y2: 281.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2204_11443",
    x1: 289.069,
    y1: 279.849,
    x2: 294.861,
    y2: 281.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2204_11443",
    x1: 296.667,
    y1: 279.849,
    x2: 302.458,
    y2: 281.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2204_11443",
    x1: 304.251,
    y1: 279.849,
    x2: 310.042,
    y2: 281.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2204_11443",
    x1: 311.057,
    y1: 279.865,
    x2: 320.054,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2204_11443",
    x1: 318.697,
    y1: 279.865,
    x2: 327.695,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2204_11443",
    x1: 326.246,
    y1: 279.598,
    x2: 335.322,
    y2: 283.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2204_11443",
    x1: 333.838,
    y1: 279.865,
    x2: 342.835,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2204_11443",
    x1: 341.43,
    y1: 279.598,
    x2: 350.505,
    y2: 283.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2204_11443",
    x1: 349.021,
    y1: 279.865,
    x2: 358.019,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2204_11443",
    x1: 356.613,
    y1: 279.598,
    x2: 365.689,
    y2: 283.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2204_11443",
    x1: 367.974,
    y1: 279.849,
    x2: 373.746,
    y2: 281.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2204_11443",
    x1: 375.561,
    y1: 279.849,
    x2: 381.353,
    y2: 281.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2204_11443",
    x1: 383.145,
    y1: 279.849,
    x2: 388.937,
    y2: 281.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2204_11443",
    x1: 390.782,
    y1: 279.849,
    x2: 396.555,
    y2: 281.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2204_11443",
    x1: 398.343,
    y1: 279.849,
    x2: 404.134,
    y2: 281.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2204_11443",
    x1: 411.047,
    y1: 279.598,
    x2: 420.122,
    y2: 283.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2204_11443",
    x1: 418.68,
    y1: 279.865,
    x2: 427.677,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2204_11443",
    x1: 426.273,
    y1: 279.598,
    x2: 435.349,
    y2: 283.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2204_11443",
    x1: 433.863,
    y1: 279.865,
    x2: 442.861,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2204_11443",
    x1: 441.461,
    y1: 279.865,
    x2: 450.458,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2204_11443",
    x1: 449.053,
    y1: 279.598,
    x2: 458.128,
    y2: 283.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2204_11443",
    x1: 462.592,
    y1: 279.865,
    x2: 471.589,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2204_11443",
    x1: 470.97,
    y1: 279.849,
    x2: 476.761,
    y2: 281.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2204_11443",
    x1: 477.775,
    y1: 279.865,
    x2: 486.773,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2204_11443",
    x1: 486.151,
    y1: 279.849,
    x2: 491.943,
    y2: 281.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2204_11443",
    x1: 492.959,
    y1: 279.865,
    x2: 501.956,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2204_11443",
    x1: 501.331,
    y1: 279.849,
    x2: 507.103,
    y2: 281.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2204_11443",
    x1: 508.141,
    y1: 279.865,
    x2: 517.138,
    y2: 283.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2204_11443",
    x1: 147.32,
    y1: 302.856,
    x2: 156.318,
    y2: 306.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2204_11443",
    x1: 155.693,
    y1: 302.855,
    x2: 161.465,
    y2: 304.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2204_11443",
    x1: 162.502,
    y1: 302.856,
    x2: 171.499,
    y2: 306.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2204_11443",
    x1: 170.858,
    y1: 302.855,
    x2: 176.688,
    y2: 304.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2204_11443",
    x1: 177.693,
    y1: 302.589,
    x2: 186.769,
    y2: 306.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2204_11443",
    x1: 186.061,
    y1: 302.855,
    x2: 191.853,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2204_11443",
    x1: 193.661,
    y1: 302.855,
    x2: 199.452,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2204_11443",
    x1: 201.259,
    y1: 302.855,
    x2: 207.05,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2204_11443",
    x1: 208.868,
    y1: 302.855,
    x2: 214.641,
    y2: 304.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2204_11443",
    x1: 216.442,
    y1: 302.855,
    x2: 222.234,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2204_11443",
    x1: 224.036,
    y1: 302.855,
    x2: 229.808,
    y2: 304.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2204_11443",
    x1: 231.624,
    y1: 302.855,
    x2: 237.415,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2204_11443",
    x1: 238.43,
    y1: 302.856,
    x2: 247.427,
    y2: 306.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2204_11443",
    x1: 246.807,
    y1: 302.855,
    x2: 252.599,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2204_11443",
    x1: 257.374,
    y1: 302.855,
    x2: 263.165,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2204_11443",
    x1: 264.123,
    y1: 302.856,
    x2: 273.12,
    y2: 306.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2204_11443",
    x1: 272.545,
    y1: 302.855,
    x2: 278.356,
    y2: 304.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2204_11443",
    x1: 283.11,
    y1: 302.855,
    x2: 288.921,
    y2: 304.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2204_11443",
    x1: 292.9,
    y1: 302.589,
    x2: 301.976,
    y2: 306.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2204_11443",
    x1: 301.284,
    y1: 302.855,
    x2: 307.075,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2204_11443",
    x1: 308.868,
    y1: 302.855,
    x2: 314.66,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2204_11443",
    x1: 316.478,
    y1: 302.855,
    x2: 322.25,
    y2: 304.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2204_11443",
    x1: 324.052,
    y1: 302.855,
    x2: 329.843,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2204_11443",
    x1: 331.649,
    y1: 302.855,
    x2: 337.441,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2204_11443",
    x1: 338.455,
    y1: 302.856,
    x2: 347.453,
    y2: 306.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2204_11443",
    x1: 346.843,
    y1: 302.855,
    x2: 352.615,
    y2: 304.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2204_11443",
    x1: 353.674,
    y1: 302.589,
    x2: 362.749,
    y2: 306.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2204_11443",
    x1: 362.016,
    y1: 302.855,
    x2: 367.808,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2204_11443",
    x1: 368.828,
    y1: 302.589,
    x2: 377.904,
    y2: 306.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2204_11443",
    x1: 377.212,
    y1: 302.855,
    x2: 383.003,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2204_11443",
    x1: 392.934,
    y1: 302.856,
    x2: 401.931,
    y2: 306.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2204_11443",
    x1: 401.309,
    y1: 302.855,
    x2: 407.101,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2204_11443",
    x1: 408.115,
    y1: 302.856,
    x2: 417.113,
    y2: 306.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2204_11443",
    x1: 416.491,
    y1: 302.855,
    x2: 422.283,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2204_11443",
    x1: 424.103,
    y1: 302.855,
    x2: 429.875,
    y2: 304.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2204_11443",
    x1: 431.687,
    y1: 302.855,
    x2: 437.459,
    y2: 304.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2204_11443",
    x1: 438.488,
    y1: 302.589,
    x2: 447.564,
    y2: 306.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2204_11443",
    x1: 446.858,
    y1: 302.855,
    x2: 452.65,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2204_11443",
    x1: 454.446,
    y1: 302.855,
    x2: 460.257,
    y2: 304.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2204_11443",
    x1: 462.066,
    y1: 302.855,
    x2: 467.838,
    y2: 304.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2204_11443",
    x1: 469.629,
    y1: 302.855,
    x2: 475.44,
    y2: 304.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2204_11443",
    x1: 477.249,
    y1: 302.855,
    x2: 483.021,
    y2: 304.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2204_11443",
    x1: 484.823,
    y1: 302.855,
    x2: 490.615,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2204_11443",
    x1: 494.609,
    y1: 302.856,
    x2: 503.607,
    y2: 306.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2204_11443",
    x1: 502.987,
    y1: 302.855,
    x2: 508.779,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2204_11443",
    x1: 510.571,
    y1: 302.855,
    x2: 516.363,
    y2: 304.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2204_11443",
    x1: 147.32,
    y1: 326.505,
    x2: 156.318,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2204_11443",
    x1: 154.967,
    y1: 326.238,
    x2: 164.042,
    y2: 329.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2204_11443",
    x1: 162.502,
    y1: 326.505,
    x2: 171.499,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2204_11443",
    x1: 170.858,
    y1: 326.49,
    x2: 176.688,
    y2: 327.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2204_11443",
    x1: 181.432,
    y1: 326.49,
    x2: 187.243,
    y2: 327.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_2204_11443",
    x1: 189.054,
    y1: 326.49,
    x2: 194.826,
    y2: 327.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2204_11443",
    x1: 196.628,
    y1: 326.49,
    x2: 202.419,
    y2: 327.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2204_11443",
    x1: 204.225,
    y1: 326.49,
    x2: 210.017,
    y2: 327.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2204_11443",
    x1: 211.825,
    y1: 326.49,
    x2: 217.617,
    y2: 327.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2204_11443",
    x1: 221.596,
    y1: 326.505,
    x2: 230.593,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2204_11443",
    x1: 229.133,
    y1: 326.238,
    x2: 238.208,
    y2: 329.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2204_11443",
    x1: 236.779,
    y1: 326.505,
    x2: 245.777,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2204_11443",
    x1: 244.379,
    y1: 326.505,
    x2: 253.376,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2204_11443",
    x1: 251.969,
    y1: 326.238,
    x2: 261.044,
    y2: 329.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2204_11443",
    x1: 266.241,
    y1: 326.49,
    x2: 272.014,
    y2: 327.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_2204_11443",
    x1: 273.884,
    y1: 326.49,
    x2: 279.675,
    y2: 327.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_2204_11443",
    x1: 281.492,
    y1: 326.49,
    x2: 287.244,
    y2: 327.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_2204_11443",
    x1: 289.086,
    y1: 326.49,
    x2: 294.897,
    y2: 327.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_2204_11443",
    x1: 296.667,
    y1: 326.49,
    x2: 302.458,
    y2: 327.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_2204_11443",
    x1: 304.251,
    y1: 326.49,
    x2: 310.042,
    y2: 327.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_2204_11443",
    x1: 311.057,
    y1: 326.505,
    x2: 320.054,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_2204_11443",
    x1: 318.697,
    y1: 326.505,
    x2: 327.695,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_2204_11443",
    x1: 326.246,
    y1: 326.238,
    x2: 335.322,
    y2: 329.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_2204_11443",
    x1: 333.838,
    y1: 326.505,
    x2: 342.835,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_2204_11443",
    x1: 341.43,
    y1: 326.238,
    x2: 350.505,
    y2: 329.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_2204_11443",
    x1: 349.021,
    y1: 326.505,
    x2: 358.019,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_2204_11443",
    x1: 356.613,
    y1: 326.238,
    x2: 365.689,
    y2: 329.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_2204_11443",
    x1: 367.974,
    y1: 326.49,
    x2: 373.746,
    y2: 327.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_2204_11443",
    x1: 375.561,
    y1: 326.49,
    x2: 381.353,
    y2: 327.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_2204_11443",
    x1: 383.145,
    y1: 326.49,
    x2: 388.937,
    y2: 327.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_2204_11443",
    x1: 390.782,
    y1: 326.49,
    x2: 396.555,
    y2: 327.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_2204_11443",
    x1: 398.343,
    y1: 326.49,
    x2: 404.134,
    y2: 327.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_2204_11443",
    x1: 411.047,
    y1: 326.238,
    x2: 420.122,
    y2: 329.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_2204_11443",
    x1: 418.68,
    y1: 326.505,
    x2: 427.677,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_2204_11443",
    x1: 426.273,
    y1: 326.238,
    x2: 435.349,
    y2: 329.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_2204_11443",
    x1: 433.863,
    y1: 326.505,
    x2: 442.861,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_2204_11443",
    x1: 441.461,
    y1: 326.505,
    x2: 450.458,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_2204_11443",
    x1: 449.053,
    y1: 326.238,
    x2: 458.128,
    y2: 329.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_2204_11443",
    x1: 462.592,
    y1: 326.505,
    x2: 471.589,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_2204_11443",
    x1: 470.99,
    y1: 326.49,
    x2: 476.821,
    y2: 327.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_2204_11443",
    x1: 477.775,
    y1: 326.505,
    x2: 486.773,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_2204_11443",
    x1: 486.151,
    y1: 326.49,
    x2: 491.943,
    y2: 327.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_2204_11443",
    x1: 492.959,
    y1: 326.505,
    x2: 501.956,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_2204_11443",
    x1: 501.331,
    y1: 326.49,
    x2: 507.103,
    y2: 327.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_2204_11443",
    x1: 508.141,
    y1: 326.505,
    x2: 517.138,
    y2: 330.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_2204_11443",
    x1: 147.32,
    y1: 349.525,
    x2: 156.318,
    y2: 353.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_2204_11443",
    x1: 155.693,
    y1: 349.495,
    x2: 161.465,
    y2: 350.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_2204_11443",
    x1: 162.502,
    y1: 349.525,
    x2: 171.499,
    y2: 353.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_2204_11443",
    x1: 170.858,
    y1: 349.495,
    x2: 176.688,
    y2: 350.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_2204_11443",
    x1: 177.693,
    y1: 349.257,
    x2: 186.769,
    y2: 352.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_2204_11443",
    x1: 186.061,
    y1: 349.495,
    x2: 191.853,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_2204_11443",
    x1: 193.661,
    y1: 349.439,
    x2: 199.452,
    y2: 350.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_2204_11443",
    x1: 201.259,
    y1: 349.495,
    x2: 207.05,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_2204_11443",
    x1: 208.868,
    y1: 349.495,
    x2: 214.641,
    y2: 350.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_2204_11443",
    x1: 216.442,
    y1: 349.495,
    x2: 222.234,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_2204_11443",
    x1: 224.036,
    y1: 349.439,
    x2: 229.808,
    y2: 350.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_2204_11443",
    x1: 231.624,
    y1: 349.495,
    x2: 237.415,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_2204_11443",
    x1: 238.43,
    y1: 349.525,
    x2: 247.427,
    y2: 353.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_2204_11443",
    x1: 246.807,
    y1: 349.495,
    x2: 252.599,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_2204_11443",
    x1: 257.374,
    y1: 349.495,
    x2: 263.165,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_2204_11443",
    x1: 264.123,
    y1: 349.525,
    x2: 273.12,
    y2: 353.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_2204_11443",
    x1: 272.545,
    y1: 349.495,
    x2: 278.356,
    y2: 350.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_2204_11443",
    x1: 283.11,
    y1: 349.495,
    x2: 288.921,
    y2: 350.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_2204_11443",
    x1: 292.9,
    y1: 349.257,
    x2: 301.976,
    y2: 352.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_2204_11443",
    x1: 301.284,
    y1: 349.495,
    x2: 307.075,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_2204_11443",
    x1: 308.868,
    y1: 349.495,
    x2: 314.66,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_2204_11443",
    x1: 316.478,
    y1: 349.495,
    x2: 322.25,
    y2: 350.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_2204_11443",
    x1: 324.079,
    y1: 349.439,
    x2: 329.87,
    y2: 350.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_2204_11443",
    x1: 331.649,
    y1: 349.495,
    x2: 337.441,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_2204_11443",
    x1: 338.455,
    y1: 349.525,
    x2: 347.453,
    y2: 353.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_2204_11443",
    x1: 346.843,
    y1: 349.495,
    x2: 352.615,
    y2: 350.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_2204_11443",
    x1: 353.674,
    y1: 349.257,
    x2: 362.749,
    y2: 352.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_2204_11443",
    x1: 362.016,
    y1: 349.495,
    x2: 367.808,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_2204_11443",
    x1: 368.828,
    y1: 349.257,
    x2: 377.904,
    y2: 352.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_2204_11443",
    x1: 377.233,
    y1: 349.439,
    x2: 383.063,
    y2: 350.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_2204_11443",
    x1: 392.934,
    y1: 349.525,
    x2: 401.931,
    y2: 353.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_2204_11443",
    x1: 401.309,
    y1: 349.495,
    x2: 407.101,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_2204_11443",
    x1: 408.115,
    y1: 349.525,
    x2: 417.113,
    y2: 353.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_2204_11443",
    x1: 416.436,
    y1: 349.439,
    x2: 422.228,
    y2: 350.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_2204_11443",
    x1: 424.103,
    y1: 349.495,
    x2: 429.875,
    y2: 350.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_2204_11443",
    x1: 431.687,
    y1: 349.495,
    x2: 437.459,
    y2: 350.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_2204_11443",
    x1: 438.488,
    y1: 349.257,
    x2: 447.564,
    y2: 352.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_2204_11443",
    x1: 446.858,
    y1: 349.495,
    x2: 452.65,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_2204_11443",
    x1: 454.446,
    y1: 349.495,
    x2: 460.257,
    y2: 350.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_2204_11443",
    x1: 462.066,
    y1: 349.439,
    x2: 467.838,
    y2: 350.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_2204_11443",
    x1: 469.602,
    y1: 349.439,
    x2: 475.413,
    y2: 350.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_2204_11443",
    x1: 477.249,
    y1: 349.495,
    x2: 483.021,
    y2: 350.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_2204_11443",
    x1: 484.823,
    y1: 349.495,
    x2: 490.615,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_2204_11443",
    x1: 494.609,
    y1: 349.525,
    x2: 503.607,
    y2: 353.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_2204_11443",
    x1: 502.987,
    y1: 349.495,
    x2: 508.779,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_2204_11443",
    x1: 510.571,
    y1: 349.495,
    x2: 516.363,
    y2: 350.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_2204_11443",
    x1: 147.32,
    y1: 373.16,
    x2: 156.318,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_2204_11443",
    x1: 154.967,
    y1: 372.892,
    x2: 164.042,
    y2: 376.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_2204_11443",
    x1: 162.502,
    y1: 373.16,
    x2: 171.499,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_2204_11443",
    x1: 170.858,
    y1: 373.13,
    x2: 176.688,
    y2: 374.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_2204_11443",
    x1: 181.432,
    y1: 373.13,
    x2: 187.243,
    y2: 374.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_2204_11443",
    x1: 189.054,
    y1: 373.13,
    x2: 194.826,
    y2: 374.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_2204_11443",
    x1: 196.628,
    y1: 373.13,
    x2: 202.419,
    y2: 374.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_2204_11443",
    x1: 204.225,
    y1: 373.13,
    x2: 210.017,
    y2: 374.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_2204_11443",
    x1: 211.825,
    y1: 373.13,
    x2: 217.617,
    y2: 374.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_2204_11443",
    x1: 221.596,
    y1: 373.16,
    x2: 230.593,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_2204_11443",
    x1: 229.133,
    y1: 372.892,
    x2: 238.208,
    y2: 376.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_2204_11443",
    x1: 236.779,
    y1: 373.16,
    x2: 245.777,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_2204_11443",
    x1: 244.379,
    y1: 373.16,
    x2: 253.376,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_2204_11443",
    x1: 251.969,
    y1: 372.892,
    x2: 261.044,
    y2: 376.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_2204_11443",
    x1: 266.241,
    y1: 373.13,
    x2: 272.014,
    y2: 374.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_2204_11443",
    x1: 273.884,
    y1: 373.13,
    x2: 279.675,
    y2: 374.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_2204_11443",
    x1: 281.492,
    y1: 373.13,
    x2: 287.244,
    y2: 374.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_2204_11443",
    x1: 289.069,
    y1: 373.13,
    x2: 294.861,
    y2: 374.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_2204_11443",
    x1: 296.667,
    y1: 373.13,
    x2: 302.458,
    y2: 374.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_2204_11443",
    x1: 304.251,
    y1: 373.13,
    x2: 310.042,
    y2: 374.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_2204_11443",
    x1: 311.057,
    y1: 373.16,
    x2: 320.054,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_2204_11443",
    x1: 318.697,
    y1: 373.16,
    x2: 327.695,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_2204_11443",
    x1: 326.246,
    y1: 372.892,
    x2: 335.322,
    y2: 376.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_2204_11443",
    x1: 333.838,
    y1: 373.16,
    x2: 342.835,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_2204_11443",
    x1: 341.43,
    y1: 372.892,
    x2: 350.505,
    y2: 376.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_2204_11443",
    x1: 349.021,
    y1: 373.16,
    x2: 358.019,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_2204_11443",
    x1: 356.613,
    y1: 372.892,
    x2: 365.689,
    y2: 376.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_2204_11443",
    x1: 367.974,
    y1: 373.13,
    x2: 373.746,
    y2: 374.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_2204_11443",
    x1: 375.561,
    y1: 373.13,
    x2: 381.353,
    y2: 374.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_2204_11443",
    x1: 383.145,
    y1: 373.13,
    x2: 388.937,
    y2: 374.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_2204_11443",
    x1: 390.782,
    y1: 373.13,
    x2: 396.555,
    y2: 374.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_2204_11443",
    x1: 398.343,
    y1: 373.13,
    x2: 404.134,
    y2: 374.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_2204_11443",
    x1: 411.047,
    y1: 372.892,
    x2: 420.122,
    y2: 376.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_2204_11443",
    x1: 418.68,
    y1: 373.16,
    x2: 427.677,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_2204_11443",
    x1: 426.273,
    y1: 372.892,
    x2: 435.349,
    y2: 376.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_2204_11443",
    x1: 433.863,
    y1: 373.16,
    x2: 442.861,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_2204_11443",
    x1: 441.461,
    y1: 373.16,
    x2: 450.458,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_2204_11443",
    x1: 449.053,
    y1: 372.892,
    x2: 458.128,
    y2: 376.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_2204_11443",
    x1: 462.592,
    y1: 373.16,
    x2: 471.589,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_2204_11443",
    x1: 470.97,
    y1: 373.13,
    x2: 476.761,
    y2: 374.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_2204_11443",
    x1: 477.775,
    y1: 373.16,
    x2: 486.773,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_2204_11443",
    x1: 486.151,
    y1: 373.13,
    x2: 491.943,
    y2: 374.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_2204_11443",
    x1: 492.959,
    y1: 373.16,
    x2: 501.956,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_2204_11443",
    x1: 501.331,
    y1: 373.13,
    x2: 507.103,
    y2: 374.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_2204_11443",
    x1: 508.141,
    y1: 373.16,
    x2: 517.138,
    y2: 376.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_2204_11443",
    x1: 147.32,
    y1: 396.165,
    x2: 156.318,
    y2: 399.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_2204_11443",
    x1: 155.693,
    y1: 396.144,
    x2: 161.467,
    y2: 397.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_2204_11443",
    x1: 162.502,
    y1: 396.165,
    x2: 171.499,
    y2: 399.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_2204_11443",
    x1: 170.858,
    y1: 396.144,
    x2: 176.69,
    y2: 397.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_2204_11443",
    x1: 177.693,
    y1: 395.898,
    x2: 186.769,
    y2: 399.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_2204_11443",
    x1: 186.061,
    y1: 396.144,
    x2: 191.855,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_2204_11443",
    x1: 193.661,
    y1: 396.144,
    x2: 199.454,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_2204_11443",
    x1: 201.259,
    y1: 396.144,
    x2: 207.052,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_2204_11443",
    x1: 208.868,
    y1: 396.144,
    x2: 214.642,
    y2: 397.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_2204_11443",
    x1: 216.442,
    y1: 396.144,
    x2: 222.236,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_2204_11443",
    x1: 224.036,
    y1: 396.144,
    x2: 229.81,
    y2: 397.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_2204_11443",
    x1: 231.624,
    y1: 396.144,
    x2: 237.417,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_2204_11443",
    x1: 238.43,
    y1: 396.165,
    x2: 247.427,
    y2: 399.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_2204_11443",
    x1: 246.807,
    y1: 396.144,
    x2: 252.601,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_2204_11443",
    x1: 257.374,
    y1: 396.144,
    x2: 263.167,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_2204_11443",
    x1: 264.123,
    y1: 396.165,
    x2: 273.12,
    y2: 399.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_2204_11443",
    x1: 272.545,
    y1: 396.144,
    x2: 278.358,
    y2: 397.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_2204_11443",
    x1: 283.11,
    y1: 396.144,
    x2: 288.923,
    y2: 397.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_2204_11443",
    x1: 292.9,
    y1: 395.898,
    x2: 301.976,
    y2: 399.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_2204_11443",
    x1: 301.284,
    y1: 396.144,
    x2: 307.077,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_2204_11443",
    x1: 308.868,
    y1: 396.144,
    x2: 314.661,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_2204_11443",
    x1: 316.478,
    y1: 396.144,
    x2: 322.252,
    y2: 397.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_2204_11443",
    x1: 324.052,
    y1: 396.144,
    x2: 329.845,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_2204_11443",
    x1: 331.649,
    y1: 396.144,
    x2: 337.443,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_2204_11443",
    x1: 338.455,
    y1: 396.165,
    x2: 347.453,
    y2: 399.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_2204_11443",
    x1: 346.843,
    y1: 396.144,
    x2: 352.617,
    y2: 397.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_2204_11443",
    x1: 353.674,
    y1: 395.898,
    x2: 362.749,
    y2: 399.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_2204_11443",
    x1: 362.016,
    y1: 396.144,
    x2: 367.81,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_2204_11443",
    x1: 368.828,
    y1: 395.898,
    x2: 377.904,
    y2: 399.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_2204_11443",
    x1: 377.212,
    y1: 396.144,
    x2: 383.005,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_2204_11443",
    x1: 392.934,
    y1: 396.165,
    x2: 401.931,
    y2: 399.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_2204_11443",
    x1: 401.309,
    y1: 396.144,
    x2: 407.103,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_2204_11443",
    x1: 408.115,
    y1: 396.165,
    x2: 417.113,
    y2: 399.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_2204_11443",
    x1: 416.491,
    y1: 396.144,
    x2: 422.285,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_2204_11443",
    x1: 424.103,
    y1: 396.144,
    x2: 429.877,
    y2: 397.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_2204_11443",
    x1: 431.687,
    y1: 396.144,
    x2: 437.461,
    y2: 397.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_2204_11443",
    x1: 438.488,
    y1: 395.898,
    x2: 447.564,
    y2: 399.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_2204_11443",
    x1: 446.858,
    y1: 396.144,
    x2: 452.652,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_2204_11443",
    x1: 454.446,
    y1: 396.144,
    x2: 460.259,
    y2: 397.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_2204_11443",
    x1: 462.066,
    y1: 396.144,
    x2: 467.84,
    y2: 397.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_2204_11443",
    x1: 469.629,
    y1: 396.144,
    x2: 475.442,
    y2: 397.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_2204_11443",
    x1: 477.249,
    y1: 396.144,
    x2: 483.023,
    y2: 397.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_2204_11443",
    x1: 484.823,
    y1: 396.144,
    x2: 490.616,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_2204_11443",
    x1: 494.609,
    y1: 396.165,
    x2: 503.607,
    y2: 399.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_2204_11443",
    x1: 502.987,
    y1: 396.144,
    x2: 508.781,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_2204_11443",
    x1: 510.571,
    y1: 396.144,
    x2: 516.365,
    y2: 397.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_2204_11443",
    x1: 147.32,
    y1: 419.8,
    x2: 156.318,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_2204_11443",
    x1: 154.967,
    y1: 419.533,
    x2: 164.042,
    y2: 423.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_2204_11443",
    x1: 162.502,
    y1: 419.8,
    x2: 171.499,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_2204_11443",
    x1: 170.858,
    y1: 419.784,
    x2: 176.688,
    y2: 421.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_2204_11443",
    x1: 181.432,
    y1: 419.784,
    x2: 187.243,
    y2: 421.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_2204_11443",
    x1: 189.054,
    y1: 419.784,
    x2: 194.826,
    y2: 421.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_2204_11443",
    x1: 196.628,
    y1: 419.784,
    x2: 202.419,
    y2: 421.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_2204_11443",
    x1: 204.225,
    y1: 419.784,
    x2: 210.017,
    y2: 421.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_2204_11443",
    x1: 211.825,
    y1: 419.784,
    x2: 217.617,
    y2: 421.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_2204_11443",
    x1: 221.596,
    y1: 419.8,
    x2: 230.593,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_2204_11443",
    x1: 229.133,
    y1: 419.533,
    x2: 238.208,
    y2: 423.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_2204_11443",
    x1: 236.779,
    y1: 419.8,
    x2: 245.777,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_2204_11443",
    x1: 244.379,
    y1: 419.8,
    x2: 253.376,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_2204_11443",
    x1: 251.969,
    y1: 419.533,
    x2: 261.044,
    y2: 423.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_2204_11443",
    x1: 266.241,
    y1: 419.784,
    x2: 272.014,
    y2: 421.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_2204_11443",
    x1: 273.884,
    y1: 419.784,
    x2: 279.675,
    y2: 421.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_2204_11443",
    x1: 281.492,
    y1: 419.784,
    x2: 287.244,
    y2: 421.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_2204_11443",
    x1: 289.069,
    y1: 419.784,
    x2: 294.861,
    y2: 421.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_2204_11443",
    x1: 296.667,
    y1: 419.784,
    x2: 302.458,
    y2: 421.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_2204_11443",
    x1: 304.251,
    y1: 419.784,
    x2: 310.042,
    y2: 421.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_2204_11443",
    x1: 311.057,
    y1: 419.8,
    x2: 320.054,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_2204_11443",
    x1: 318.697,
    y1: 419.8,
    x2: 327.695,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_2204_11443",
    x1: 326.246,
    y1: 419.533,
    x2: 335.322,
    y2: 423.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_2204_11443",
    x1: 333.838,
    y1: 419.8,
    x2: 342.835,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_2204_11443",
    x1: 341.43,
    y1: 419.533,
    x2: 350.505,
    y2: 423.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_2204_11443",
    x1: 349.021,
    y1: 419.8,
    x2: 358.019,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_2204_11443",
    x1: 356.613,
    y1: 419.533,
    x2: 365.689,
    y2: 423.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_2204_11443",
    x1: 367.974,
    y1: 419.784,
    x2: 373.746,
    y2: 421.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_2204_11443",
    x1: 375.561,
    y1: 419.784,
    x2: 381.353,
    y2: 421.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_2204_11443",
    x1: 383.145,
    y1: 419.784,
    x2: 388.937,
    y2: 421.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_2204_11443",
    x1: 390.782,
    y1: 419.784,
    x2: 396.555,
    y2: 421.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_2204_11443",
    x1: 398.343,
    y1: 419.784,
    x2: 404.134,
    y2: 421.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_2204_11443",
    x1: 411.047,
    y1: 419.533,
    x2: 420.122,
    y2: 423.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_2204_11443",
    x1: 418.68,
    y1: 419.8,
    x2: 427.677,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_2204_11443",
    x1: 426.273,
    y1: 419.533,
    x2: 435.349,
    y2: 423.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_2204_11443",
    x1: 433.863,
    y1: 419.8,
    x2: 442.861,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint417_linear_2204_11443",
    x1: 441.461,
    y1: 419.8,
    x2: 450.458,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint418_linear_2204_11443",
    x1: 449.053,
    y1: 419.533,
    x2: 458.128,
    y2: 423.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint419_linear_2204_11443",
    x1: 462.592,
    y1: 419.8,
    x2: 471.589,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint420_linear_2204_11443",
    x1: 470.97,
    y1: 419.784,
    x2: 476.761,
    y2: 421.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint421_linear_2204_11443",
    x1: 477.775,
    y1: 419.8,
    x2: 486.773,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint422_linear_2204_11443",
    x1: 486.151,
    y1: 419.784,
    x2: 491.943,
    y2: 421.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint423_linear_2204_11443",
    x1: 492.959,
    y1: 419.8,
    x2: 501.956,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint424_linear_2204_11443",
    x1: 501.331,
    y1: 419.784,
    x2: 507.103,
    y2: 421.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint425_linear_2204_11443",
    x1: 508.141,
    y1: 419.8,
    x2: 517.138,
    y2: 423.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint426_linear_2204_11443",
    x1: 147.32,
    y1: 442.791,
    x2: 156.318,
    y2: 446.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint427_linear_2204_11443",
    x1: 155.693,
    y1: 442.789,
    x2: 161.465,
    y2: 444.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint428_linear_2204_11443",
    x1: 162.502,
    y1: 442.791,
    x2: 171.499,
    y2: 446.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint429_linear_2204_11443",
    x1: 170.858,
    y1: 442.789,
    x2: 176.688,
    y2: 444.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint430_linear_2204_11443",
    x1: 177.693,
    y1: 442.524,
    x2: 186.769,
    y2: 446.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint431_linear_2204_11443",
    x1: 186.061,
    y1: 442.789,
    x2: 191.853,
    y2: 444.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint432_linear_2204_11443",
    x1: 193.661,
    y1: 442.789,
    x2: 199.452,
    y2: 444.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint433_linear_2204_11443",
    x1: 201.259,
    y1: 442.789,
    x2: 207.05,
    y2: 444.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint434_linear_2204_11443",
    x1: 208.868,
    y1: 442.789,
    x2: 214.641,
    y2: 444.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint435_linear_2204_11443",
    x1: 216.442,
    y1: 442.789,
    x2: 222.234,
    y2: 444.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint436_linear_2204_11443",
    x1: 224.036,
    y1: 442.789,
    x2: 229.808,
    y2: 444.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint437_linear_2204_11443",
    x1: 231.624,
    y1: 442.789,
    x2: 237.415,
    y2: 444.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint438_linear_2204_11443",
    x1: 238.43,
    y1: 442.791,
    x2: 247.427,
    y2: 446.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint439_linear_2204_11443",
    x1: 246.807,
    y1: 442.789,
    x2: 252.599,
    y2: 444.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint440_linear_2204_11443",
    x1: 257.374,
    y1: 442.789,
    x2: 263.165,
    y2: 444.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint441_linear_2204_11443",
    x1: 264.123,
    y1: 442.791,
    x2: 273.12,
    y2: 446.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint442_linear_2204_11443",
    x1: 272.545,
    y1: 442.789,
    x2: 278.356,
    y2: 444.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint443_linear_2204_11443",
    x1: 283.11,
    y1: 442.789,
    x2: 288.921,
    y2: 444.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint444_linear_2204_11443",
    x1: 292.9,
    y1: 442.524,
    x2: 301.976,
    y2: 446.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint445_linear_2204_11443",
    x1: 301.284,
    y1: 442.789,
    x2: 307.075,
    y2: 444.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint446_linear_2204_11443",
    x1: 308.868,
    y1: 442.789,
    x2: 314.66,
    y2: 444.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint447_linear_2204_11443",
    x1: 316.478,
    y1: 442.789,
    x2: 322.25,
    y2: 444.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint448_linear_2204_11443",
    x1: 324.052,
    y1: 442.789,
    x2: 329.843,
    y2: 444.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint449_linear_2204_11443",
    x1: 331.649,
    y1: 442.789,
    x2: 337.441,
    y2: 444.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint450_linear_2204_11443",
    x1: 338.455,
    y1: 442.791,
    x2: 347.453,
    y2: 446.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint451_linear_2204_11443",
    x1: 346.843,
    y1: 442.789,
    x2: 352.615,
    y2: 444.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint452_linear_2204_11443",
    x1: 353.674,
    y1: 442.524,
    x2: 362.749,
    y2: 446.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint453_linear_2204_11443",
    x1: 362.016,
    y1: 442.789,
    x2: 367.808,
    y2: 444.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint454_linear_2204_11443",
    x1: 368.828,
    y1: 442.524,
    x2: 377.904,
    y2: 446.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint455_linear_2204_11443",
    x1: 377.212,
    y1: 442.789,
    x2: 383.003,
    y2: 444.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint456_linear_2204_11443",
    x1: 392.934,
    y1: 442.791,
    x2: 401.931,
    y2: 446.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint457_linear_2204_11443",
    x1: 401.309,
    y1: 442.789,
    x2: 407.101,
    y2: 444.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint458_linear_2204_11443",
    x1: 408.115,
    y1: 442.791,
    x2: 417.113,
    y2: 446.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint459_linear_2204_11443",
    x1: 416.491,
    y1: 442.789,
    x2: 422.283,
    y2: 444.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint460_linear_2204_11443",
    x1: 424.103,
    y1: 442.789,
    x2: 429.875,
    y2: 444.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint461_linear_2204_11443",
    x1: 431.687,
    y1: 442.789,
    x2: 437.459,
    y2: 444.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint462_linear_2204_11443",
    x1: 438.488,
    y1: 442.524,
    x2: 447.564,
    y2: 446.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint463_linear_2204_11443",
    x1: 446.858,
    y1: 442.789,
    x2: 452.65,
    y2: 444.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint464_linear_2204_11443",
    x1: 454.446,
    y1: 442.789,
    x2: 460.257,
    y2: 444.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint465_linear_2204_11443",
    x1: 462.066,
    y1: 442.789,
    x2: 467.838,
    y2: 444.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint466_linear_2204_11443",
    x1: 469.629,
    y1: 442.789,
    x2: 475.44,
    y2: 444.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint467_linear_2204_11443",
    x1: 477.249,
    y1: 442.789,
    x2: 483.021,
    y2: 444.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint468_linear_2204_11443",
    x1: 484.823,
    y1: 442.789,
    x2: 490.615,
    y2: 444.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint469_linear_2204_11443",
    x1: 494.609,
    y1: 442.791,
    x2: 503.607,
    y2: 446.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint470_linear_2204_11443",
    x1: 502.987,
    y1: 442.789,
    x2: 508.779,
    y2: 444.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint471_linear_2204_11443",
    x1: 510.571,
    y1: 442.789,
    x2: 516.363,
    y2: 444.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint472_linear_2204_11443",
    x1: 147.32,
    y1: 466.44,
    x2: 156.318,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint473_linear_2204_11443",
    x1: 154.967,
    y1: 466.173,
    x2: 164.042,
    y2: 469.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint474_linear_2204_11443",
    x1: 162.502,
    y1: 466.44,
    x2: 171.499,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint475_linear_2204_11443",
    x1: 170.858,
    y1: 466.424,
    x2: 176.688,
    y2: 467.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint476_linear_2204_11443",
    x1: 181.432,
    y1: 466.424,
    x2: 187.243,
    y2: 467.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint477_linear_2204_11443",
    x1: 189.054,
    y1: 466.424,
    x2: 194.826,
    y2: 467.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint478_linear_2204_11443",
    x1: 196.628,
    y1: 466.424,
    x2: 202.419,
    y2: 467.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint479_linear_2204_11443",
    x1: 204.225,
    y1: 466.424,
    x2: 210.017,
    y2: 467.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint480_linear_2204_11443",
    x1: 211.825,
    y1: 466.424,
    x2: 217.617,
    y2: 467.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint481_linear_2204_11443",
    x1: 221.596,
    y1: 466.44,
    x2: 230.593,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint482_linear_2204_11443",
    x1: 229.133,
    y1: 466.173,
    x2: 238.208,
    y2: 469.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint483_linear_2204_11443",
    x1: 236.779,
    y1: 466.44,
    x2: 245.777,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint484_linear_2204_11443",
    x1: 244.379,
    y1: 466.44,
    x2: 253.376,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint485_linear_2204_11443",
    x1: 251.969,
    y1: 466.173,
    x2: 261.044,
    y2: 469.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint486_linear_2204_11443",
    x1: 266.241,
    y1: 466.424,
    x2: 272.014,
    y2: 467.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint487_linear_2204_11443",
    x1: 273.884,
    y1: 466.424,
    x2: 279.675,
    y2: 467.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint488_linear_2204_11443",
    x1: 281.492,
    y1: 466.424,
    x2: 287.244,
    y2: 467.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint489_linear_2204_11443",
    x1: 289.069,
    y1: 466.424,
    x2: 294.861,
    y2: 467.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint490_linear_2204_11443",
    x1: 296.667,
    y1: 466.424,
    x2: 302.458,
    y2: 467.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint491_linear_2204_11443",
    x1: 304.251,
    y1: 466.424,
    x2: 310.042,
    y2: 467.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint492_linear_2204_11443",
    x1: 311.057,
    y1: 466.44,
    x2: 320.054,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint493_linear_2204_11443",
    x1: 318.697,
    y1: 466.44,
    x2: 327.695,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint494_linear_2204_11443",
    x1: 326.246,
    y1: 466.173,
    x2: 335.322,
    y2: 469.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint495_linear_2204_11443",
    x1: 333.838,
    y1: 466.44,
    x2: 342.835,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint496_linear_2204_11443",
    x1: 341.43,
    y1: 466.173,
    x2: 350.505,
    y2: 469.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint497_linear_2204_11443",
    x1: 349.021,
    y1: 466.44,
    x2: 358.019,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint498_linear_2204_11443",
    x1: 356.613,
    y1: 466.173,
    x2: 365.689,
    y2: 469.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint499_linear_2204_11443",
    x1: 367.974,
    y1: 466.424,
    x2: 373.746,
    y2: 467.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint500_linear_2204_11443",
    x1: 375.561,
    y1: 466.424,
    x2: 381.353,
    y2: 467.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint501_linear_2204_11443",
    x1: 383.145,
    y1: 466.424,
    x2: 388.937,
    y2: 467.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint502_linear_2204_11443",
    x1: 390.782,
    y1: 466.424,
    x2: 396.555,
    y2: 467.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint503_linear_2204_11443",
    x1: 398.343,
    y1: 466.424,
    x2: 404.134,
    y2: 467.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint504_linear_2204_11443",
    x1: 411.047,
    y1: 466.173,
    x2: 420.122,
    y2: 469.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint505_linear_2204_11443",
    x1: 418.68,
    y1: 466.44,
    x2: 427.677,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint506_linear_2204_11443",
    x1: 426.273,
    y1: 466.173,
    x2: 435.349,
    y2: 469.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint507_linear_2204_11443",
    x1: 433.863,
    y1: 466.44,
    x2: 442.861,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint508_linear_2204_11443",
    x1: 441.461,
    y1: 466.44,
    x2: 450.458,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint509_linear_2204_11443",
    x1: 449.053,
    y1: 466.173,
    x2: 458.128,
    y2: 469.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint510_linear_2204_11443",
    x1: 462.592,
    y1: 466.44,
    x2: 471.589,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint511_linear_2204_11443",
    x1: 470.97,
    y1: 466.424,
    x2: 476.761,
    y2: 467.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint512_linear_2204_11443",
    x1: 477.775,
    y1: 466.44,
    x2: 486.773,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint513_linear_2204_11443",
    x1: 486.151,
    y1: 466.424,
    x2: 491.943,
    y2: 467.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint514_linear_2204_11443",
    x1: 492.959,
    y1: 466.44,
    x2: 501.956,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint515_linear_2204_11443",
    x1: 501.331,
    y1: 466.424,
    x2: 507.103,
    y2: 467.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint516_linear_2204_11443",
    x1: 508.141,
    y1: 466.44,
    x2: 517.138,
    y2: 470.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint517_linear_2204_11443",
    x1: 147.32,
    y1: 489.446,
    x2: 156.318,
    y2: 493.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint518_linear_2204_11443",
    x1: 155.693,
    y1: 489.43,
    x2: 161.465,
    y2: 490.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint519_linear_2204_11443",
    x1: 162.502,
    y1: 489.446,
    x2: 171.499,
    y2: 493.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint520_linear_2204_11443",
    x1: 170.858,
    y1: 489.43,
    x2: 176.688,
    y2: 490.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint521_linear_2204_11443",
    x1: 177.693,
    y1: 489.178,
    x2: 186.769,
    y2: 492.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint522_linear_2204_11443",
    x1: 186.061,
    y1: 489.43,
    x2: 191.853,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint523_linear_2204_11443",
    x1: 193.661,
    y1: 489.374,
    x2: 199.452,
    y2: 490.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint524_linear_2204_11443",
    x1: 201.259,
    y1: 489.43,
    x2: 207.05,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint525_linear_2204_11443",
    x1: 208.868,
    y1: 489.43,
    x2: 214.641,
    y2: 490.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint526_linear_2204_11443",
    x1: 216.442,
    y1: 489.43,
    x2: 222.234,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint527_linear_2204_11443",
    x1: 224.036,
    y1: 489.374,
    x2: 229.808,
    y2: 490.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint528_linear_2204_11443",
    x1: 231.624,
    y1: 489.43,
    x2: 237.415,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint529_linear_2204_11443",
    x1: 238.43,
    y1: 489.446,
    x2: 247.427,
    y2: 493.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint530_linear_2204_11443",
    x1: 246.807,
    y1: 489.43,
    x2: 252.599,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint531_linear_2204_11443",
    x1: 257.374,
    y1: 489.43,
    x2: 263.165,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint532_linear_2204_11443",
    x1: 264.123,
    y1: 489.446,
    x2: 273.12,
    y2: 493.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint533_linear_2204_11443",
    x1: 272.545,
    y1: 489.43,
    x2: 278.356,
    y2: 490.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint534_linear_2204_11443",
    x1: 283.11,
    y1: 489.43,
    x2: 288.921,
    y2: 490.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint535_linear_2204_11443",
    x1: 292.9,
    y1: 489.178,
    x2: 301.976,
    y2: 492.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint536_linear_2204_11443",
    x1: 301.284,
    y1: 489.43,
    x2: 307.075,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint537_linear_2204_11443",
    x1: 308.868,
    y1: 489.43,
    x2: 314.66,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint538_linear_2204_11443",
    x1: 316.478,
    y1: 489.43,
    x2: 322.25,
    y2: 490.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint539_linear_2204_11443",
    x1: 324.079,
    y1: 489.374,
    x2: 329.87,
    y2: 490.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint540_linear_2204_11443",
    x1: 331.649,
    y1: 489.43,
    x2: 337.441,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint541_linear_2204_11443",
    x1: 338.455,
    y1: 489.446,
    x2: 347.453,
    y2: 493.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint542_linear_2204_11443",
    x1: 346.843,
    y1: 489.43,
    x2: 352.615,
    y2: 490.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint543_linear_2204_11443",
    x1: 353.674,
    y1: 489.178,
    x2: 362.749,
    y2: 492.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint544_linear_2204_11443",
    x1: 362.016,
    y1: 489.43,
    x2: 367.808,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint545_linear_2204_11443",
    x1: 368.828,
    y1: 489.178,
    x2: 377.904,
    y2: 492.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint546_linear_2204_11443",
    x1: 377.233,
    y1: 489.374,
    x2: 383.063,
    y2: 490.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint547_linear_2204_11443",
    x1: 392.934,
    y1: 489.446,
    x2: 401.931,
    y2: 493.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint548_linear_2204_11443",
    x1: 401.309,
    y1: 489.43,
    x2: 407.101,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint549_linear_2204_11443",
    x1: 408.115,
    y1: 489.446,
    x2: 417.113,
    y2: 493.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint550_linear_2204_11443",
    x1: 416.436,
    y1: 489.374,
    x2: 422.228,
    y2: 490.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint551_linear_2204_11443",
    x1: 424.103,
    y1: 489.43,
    x2: 429.875,
    y2: 490.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint552_linear_2204_11443",
    x1: 431.687,
    y1: 489.43,
    x2: 437.459,
    y2: 490.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint553_linear_2204_11443",
    x1: 438.488,
    y1: 489.178,
    x2: 447.564,
    y2: 492.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint554_linear_2204_11443",
    x1: 446.858,
    y1: 489.43,
    x2: 452.65,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint555_linear_2204_11443",
    x1: 454.446,
    y1: 489.43,
    x2: 460.257,
    y2: 490.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint556_linear_2204_11443",
    x1: 462.066,
    y1: 489.374,
    x2: 467.838,
    y2: 490.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint557_linear_2204_11443",
    x1: 469.602,
    y1: 489.374,
    x2: 475.413,
    y2: 490.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint558_linear_2204_11443",
    x1: 477.249,
    y1: 489.43,
    x2: 483.021,
    y2: 490.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint559_linear_2204_11443",
    x1: 484.823,
    y1: 489.43,
    x2: 490.615,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint560_linear_2204_11443",
    x1: 494.609,
    y1: 489.446,
    x2: 503.607,
    y2: 493.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint561_linear_2204_11443",
    x1: 502.987,
    y1: 489.43,
    x2: 508.779,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint562_linear_2204_11443",
    x1: 510.571,
    y1: 489.43,
    x2: 516.363,
    y2: 490.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint563_linear_2204_11443",
    x1: 312.566,
    y1: 324.046,
    x2: 377.214,
    y2: 379.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint564_linear_2204_11443",
    x1: 596.706,
    y1: 543.297,
    x2: 651.189,
    y2: 589.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint565_linear_2204_11443",
    x1: 606.631,
    y1: 567.24,
    x2: 625.377,
    y2: 583.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint566_linear_2204_11443",
    x1: 597.519,
    y1: 555.567,
    x2: 629.774,
    y2: 591.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2);
export default __webpack_public_path__ + "static/media/Image 2.75e984b73a5bfa97df7005ec5f5fad05.svg";
export { ForwardRef as ReactComponent };